import axios from './axiosHttp'
import storage from "./storage"
import qs from 'qs';
let build = new Build();
function Build() {
    /**
     * @param json
     * @returns {Array}
     */
    this.buildArray=function (json,func) {
        let result = [];
        if(json==null) {
            return result;
        }
        for (let k = 0, length = json.length; k < length; k++) {
            result[k] = func(json[k]);
        }
        return result;
    };
    /**
     * @param json
     * @returns {boolean}
     */
    this.buildBoolean=function (json) {
        if(json==null) return false;
        if(json=='1'||json=='true'||json==1||json==true) return true;
        return false;
    };
    /**
     * @param json
     * @returns {int}
     */
    this.buildNumber=function (json) {
        if(json==null) return 0;
        return json
    };
    /**
     * @param json
     * @returns {string}
     */
    this.buildString=function(json) {
        if(json==null) return "";
        return String(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupTaskPatientExceptionInfos}
     */
    this.buildHttpResult_FollowupTaskPatientExceptionInfos=function (json) {
        return new HttpResult_FollowupTaskPatientExceptionInfos(json);
    };
    /**
     * @param json
     * @returns {QuestionNumbersOptionsList}
     */
    this.buildQuestionNumbersOptionsList=function (json) {
        return new QuestionNumbersOptionsList(json);
    };
    /**
     * @param json
     * @returns {CallTaskStatistics}
     */
    this.buildCallTaskStatistics=function (json) {
        return new CallTaskStatistics(json);
    };
    /**
     * @param json
     * @returns {FollowupTag}
     */
    this.buildFollowupTag=function (json) {
        return new FollowupTag(json);
    };
    /**
     * @param json
     * @returns {ContactInformationContent}
     */
    this.buildContactInformationContent=function (json) {
        return new ContactInformationContent(json);
    };
    /**
     * @param json
     * @returns {TaskStatisticsOfUserId}
     */
    this.buildTaskStatisticsOfUserId=function (json) {
        return new TaskStatisticsOfUserId(json);
    };
    /**
     * @param json
     * @returns {FollowupDeliveryRemark}
     */
    this.buildFollowupDeliveryRemark=function (json) {
        return new FollowupDeliveryRemark(json);
    };
    /**
     * @param json
     * @returns {FollowupTaskPatientExceptionInfo}
     */
    this.buildFollowupTaskPatientExceptionInfo=function (json) {
        return new FollowupTaskPatientExceptionInfo(json);
    };
    /**
     * @param json
     * @returns {TPatientQuestionnaireAnswerResp}
     */
    this.buildTPatientQuestionnaireAnswerResp=function (json) {
        return new TPatientQuestionnaireAnswerResp(json);
    };
    /**
     * @param json
     * @returns {TFollowUpPeopleTaskResp}
     */
    this.buildTFollowUpPeopleTaskResp=function (json) {
        return new TFollowUpPeopleTaskResp(json);
    };
    /**
     * @param json
     * @returns {FinalStatisticsResult}
     */
    this.buildFinalStatisticsResult=function (json) {
        return new FinalStatisticsResult(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SeatIndexRanks}
     */
    this.buildHttpResult_SeatIndexRanks=function (json) {
        return new HttpResult_SeatIndexRanks(json);
    };
    /**
     * @param json
     * @returns {ManagerPatientOfAccountInfo}
     */
    this.buildManagerPatientOfAccountInfo=function (json) {
        return new ManagerPatientOfAccountInfo(json);
    };
    /**
     * @param json
     * @returns {SeatTaskInfo}
     */
    this.buildSeatTaskInfo=function (json) {
        return new SeatTaskInfo(json);
    };
    /**
     * @param json
     * @returns {MistakeAnnotationInfo}
     */
    this.buildMistakeAnnotationInfo=function (json) {
        return new MistakeAnnotationInfo(json);
    };
    /**
     * @param json
     * @returns {UserManagerInfo}
     */
    this.buildUserManagerInfo=function (json) {
        return new UserManagerInfo(json);
    };
    /**
     * @param json
     * @returns {ALiYunRoles}
     */
    this.buildALiYunRoles=function (json) {
        return new ALiYunRoles(json);
    };
    /**
     * @param json
     * @returns {HttpResult_QuestionDetailInfos}
     */
    this.buildHttpResult_QuestionDetailInfos=function (json) {
        return new HttpResult_QuestionDetailInfos(json);
    };
    /**
     * @param json
     * @returns {FollowupInfoKV}
     */
    this.buildFollowupInfoKV=function (json) {
        return new FollowupInfoKV(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupList}
     */
    this.buildFollowupGroupList=function (json) {
        return new FollowupGroupList(json);
    };
    /**
     * @param json
     * @returns {NewQuestionnaireInfo}
     */
    this.buildNewQuestionnaireInfo=function (json) {
        return new NewQuestionnaireInfo(json);
    };
    /**
     * @param json
     * @returns {AllRecommendKey}
     */
    this.buildAllRecommendKey=function (json) {
        return new AllRecommendKey(json);
    };
    /**
     * @param json
     * @returns {ManagerPatientDetail}
     */
    this.buildManagerPatientDetail=function (json) {
        return new ManagerPatientDetail(json);
    };
    /**
     * @param json
     * @returns {MedicalRecordDetailed}
     */
    this.buildMedicalRecordDetailed=function (json) {
        return new MedicalRecordDetailed(json);
    };
    /**
     * @param json
     * @returns {FollowUpTaskPatientCallRecord}
     */
    this.buildFollowUpTaskPatientCallRecord=function (json) {
        return new FollowUpTaskPatientCallRecord(json);
    };
    /**
     * @param json
     * @returns {HttpResult_NewMessageMangerInfo}
     */
    this.buildHttpResult_NewMessageMangerInfo=function (json) {
        return new HttpResult_NewMessageMangerInfo(json);
    };
    /**
     * @param json
     * @returns {TaskTag}
     */
    this.buildTaskTag=function (json) {
        return new TaskTag(json);
    };
    /**
     * @param json
     * @returns {SeatUserInfos}
     */
    this.buildSeatUserInfos=function (json) {
        return new SeatUserInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallCenterJumpParams}
     */
    this.buildHttpResult_CallCenterJumpParams=function (json) {
        return new HttpResult_CallCenterJumpParams(json);
    };
    /**
     * @param json
     * @returns {FollowupDeliveryQuestion}
     */
    this.buildFollowupDeliveryQuestion=function (json) {
        return new FollowupDeliveryQuestion(json);
    };
    /**
     * @param json
     * @returns {PhoneNumbersRelationship}
     */
    this.buildPhoneNumbersRelationship=function (json) {
        return new PhoneNumbersRelationship(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupReferenceInfo}
     */
    this.buildHttpResult_FollowupReferenceInfo=function (json) {
        return new HttpResult_FollowupReferenceInfo(json);
    };
    /**
     * @param json
     * @returns {PhoneRecordInfo}
     */
    this.buildPhoneRecordInfo=function (json) {
        return new PhoneRecordInfo(json);
    };
    /**
     * @param json
     * @returns {BestRecordInfo}
     */
    this.buildBestRecordInfo=function (json) {
        return new BestRecordInfo(json);
    };
    /**
     * @param json
     * @returns {QuestionOpt}
     */
    this.buildQuestionOpt=function (json) {
        return new QuestionOpt(json);
    };
    /**
     * @param json
     * @returns {HttpResult_ConfirmInformation}
     */
    this.buildHttpResult_ConfirmInformation=function (json) {
        return new HttpResult_ConfirmInformation(json);
    };
    /**
     * @param json
     * @returns {TodayFollowUpCount}
     */
    this.buildTodayFollowUpCount=function (json) {
        return new TodayFollowUpCount(json);
    };
    /**
     * @param json
     * @returns {NumericTypeConfigInfo}
     */
    this.buildNumericTypeConfigInfo=function (json) {
        return new NumericTypeConfigInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupTaskStatisticsInfo}
     */
    this.buildHttpResult_FollowupTaskStatisticsInfo=function (json) {
        return new HttpResult_FollowupTaskStatisticsInfo(json);
    };
    /**
     * @param json
     * @returns {PatientAllFollowupList}
     */
    this.buildPatientAllFollowupList=function (json) {
        return new PatientAllFollowupList(json);
    };
    /**
     * @param json
     * @returns {SeatMistakeInfo}
     */
    this.buildSeatMistakeInfo=function (json) {
        return new SeatMistakeInfo(json);
    };
    /**
     * @param json
     * @returns {QuestionDetailInfo}
     */
    this.buildQuestionDetailInfo=function (json) {
        return new QuestionDetailInfo(json);
    };
    /**
     * @param json
     * @returns {SystemOrganName}
     */
    this.buildSystemOrganName=function (json) {
        return new SystemOrganName(json);
    };
    /**
     * @param json
     * @returns {HttpResult_BestRecordInfos}
     */
    this.buildHttpResult_BestRecordInfos=function (json) {
        return new HttpResult_BestRecordInfos(json);
    };
    /**
     * @param json
     * @returns {QuestionnaireQualityRule}
     */
    this.buildQuestionnaireQualityRule=function (json) {
        return new QuestionnaireQualityRule(json);
    };
    /**
     * @param json
     * @returns {HttpResult_QualityControlToDoInfos}
     */
    this.buildHttpResult_QualityControlToDoInfos=function (json) {
        return new HttpResult_QualityControlToDoInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TodayFollowUpCounts}
     */
    this.buildHttpResult_TodayFollowUpCounts=function (json) {
        return new HttpResult_TodayFollowUpCounts(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TimeSectionStatisticsInfo}
     */
    this.buildHttpResult_TimeSectionStatisticsInfo=function (json) {
        return new HttpResult_TimeSectionStatisticsInfo(json);
    };
    /**
     * @param json
     * @returns {WeekStar}
     */
    this.buildWeekStar=function (json) {
        return new WeekStar(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TaskTags}
     */
    this.buildHttpResult_TaskTags=function (json) {
        return new HttpResult_TaskTags(json);
    };
    /**
     * @param json
     * @returns {Retention}
     */
    this.buildRetention=function (json) {
        return new Retention(json);
    };
    /**
     * @param json
     * @returns {FollowupPatientTag}
     */
    this.buildFollowupPatientTag=function (json) {
        return new FollowupPatientTag(json);
    };
    /**
     * @param json
     * @returns {ManagerDiseaseClassification}
     */
    this.buildManagerDiseaseClassification=function (json) {
        return new ManagerDiseaseClassification(json);
    };
    /**
     * @param json
     * @returns {ALiYunResponseRecording}
     */
    this.buildALiYunResponseRecording=function (json) {
        return new ALiYunResponseRecording(json);
    };
    /**
     * @param json
     * @returns {ConsultOrderDetailInfo}
     */
    this.buildConsultOrderDetailInfo=function (json) {
        return new ConsultOrderDetailInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_MessageManageInfo}
     */
    this.buildHttpResult_MessageManageInfo=function (json) {
        return new HttpResult_MessageManageInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_OperationPlatformTaskDatas}
     */
    this.buildHttpResult_OperationPlatformTaskDatas=function (json) {
        return new HttpResult_OperationPlatformTaskDatas(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SeatMonthQuotaInfos}
     */
    this.buildHttpResult_SeatMonthQuotaInfos=function (json) {
        return new HttpResult_SeatMonthQuotaInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_GroupInfoLists}
     */
    this.buildHttpResult_GroupInfoLists=function (json) {
        return new HttpResult_GroupInfoLists(json);
    };
    /**
     * @param json
     * @returns {FollowupTaskStatisticsInfo}
     */
    this.buildFollowupTaskStatisticsInfo=function (json) {
        return new FollowupTaskStatisticsInfo(json);
    };
    /**
     * @param json
     * @returns {CallCenterFollowUpTaskTagNew}
     */
    this.buildCallCenterFollowUpTaskTagNew=function (json) {
        return new CallCenterFollowUpTaskTagNew(json);
    };
    /**
     * @param json
     * @returns {Question}
     */
    this.buildQuestion=function (json) {
        return new Question(json);
    };
    /**
     * @param json
     * @returns {FileOperationRecordInfo}
     */
    this.buildFileOperationRecordInfo=function (json) {
        return new FileOperationRecordInfo(json);
    };
    /**
     * @param json
     * @returns {RoleModuleRelationInfo}
     */
    this.buildRoleModuleRelationInfo=function (json) {
        return new RoleModuleRelationInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_ParameterLists}
     */
    this.buildHttpResult_ParameterLists=function (json) {
        return new HttpResult_ParameterLists(json);
    };
    /**
     * @param json
     * @returns {HttpResult_OperationPlatformTaskData}
     */
    this.buildHttpResult_OperationPlatformTaskData=function (json) {
        return new HttpResult_OperationPlatformTaskData(json);
    };
    /**
     * @param json
     * @returns {FollowUpTaskSpotCheckPatient}
     */
    this.buildFollowUpTaskSpotCheckPatient=function (json) {
        return new FollowUpTaskSpotCheckPatient(json);
    };
    /**
     * @param json
     * @returns {HttpResult_MainOfControllerInfo}
     */
    this.buildHttpResult_MainOfControllerInfo=function (json) {
        return new HttpResult_MainOfControllerInfo(json);
    };
    /**
     * @param json
     * @returns {TQuestionInfoRespAndStatus}
     */
    this.buildTQuestionInfoRespAndStatus=function (json) {
        return new TQuestionInfoRespAndStatus(json);
    };
    /**
     * @param json
     * @returns {PassFailFeedBack}
     */
    this.buildPassFailFeedBack=function (json) {
        return new PassFailFeedBack(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallTaskCenterInfos}
     */
    this.buildHttpResult_CallTaskCenterInfos=function (json) {
        return new HttpResult_CallTaskCenterInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupSpotCheckRemarkss}
     */
    this.buildHttpResult_FollowupSpotCheckRemarkss=function (json) {
        return new HttpResult_FollowupSpotCheckRemarkss(json);
    };
    /**
     * @param json
     * @returns {HttpResult_ManagerDiseaseClassifications}
     */
    this.buildHttpResult_ManagerDiseaseClassifications=function (json) {
        return new HttpResult_ManagerDiseaseClassifications(json);
    };
    /**
     * @param json
     * @returns {UnitSlots}
     */
    this.buildUnitSlots=function (json) {
        return new UnitSlots(json);
    };
    /**
     * @param json
     * @returns {HttpResult_string}
     */
    this.buildHttpResult_string=function (json) {
        return new HttpResult_string(json);
    };
    /**
     * @param json
     * @returns {PatientUserStatistics}
     */
    this.buildPatientUserStatistics=function (json) {
        return new PatientUserStatistics(json);
    };
    /**
     * @param json
     * @returns {QualityRule}
     */
    this.buildQualityRule=function (json) {
        return new QualityRule(json);
    };
    /**
     * @param json
     * @returns {BuyerOrderCount}
     */
    this.buildBuyerOrderCount=function (json) {
        return new BuyerOrderCount(json);
    };
    /**
     * @param json
     * @returns {FollowupSpotCheckRemarks}
     */
    this.buildFollowupSpotCheckRemarks=function (json) {
        return new FollowupSpotCheckRemarks(json);
    };
    /**
     * @param json
     * @returns {NurseInfo}
     */
    this.buildNurseInfo=function (json) {
        return new NurseInfo(json);
    };
    /**
     * @param json
     * @returns {TelephoneFollowupIncomingCallPatient}
     */
    this.buildTelephoneFollowupIncomingCallPatient=function (json) {
        return new TelephoneFollowupIncomingCallPatient(json);
    };
    /**
     * @param json
     * @returns {CallPatientVisitingRecord}
     */
    this.buildCallPatientVisitingRecord=function (json) {
        return new CallPatientVisitingRecord(json);
    };
    /**
     * @param json
     * @returns {MenuAndRoleInfo}
     */
    this.buildMenuAndRoleInfo=function (json) {
        return new MenuAndRoleInfo(json);
    };
    /**
     * @param json
     * @returns {Relationship}
     */
    this.buildRelationship=function (json) {
        return new Relationship(json);
    };
    /**
     * @param json
     * @returns {CallTaskRecordDetail}
     */
    this.buildCallTaskRecordDetail=function (json) {
        return new CallTaskRecordDetail(json);
    };
    /**
     * @param json
     * @returns {SurgeryRecordInfo}
     */
    this.buildSurgeryRecordInfo=function (json) {
        return new SurgeryRecordInfo(json);
    };
    /**
     * @param json
     * @returns {TaskCenterSimpleInfo}
     */
    this.buildTaskCenterSimpleInfo=function (json) {
        return new TaskCenterSimpleInfo(json);
    };
    /**
     * @param json
     * @returns {ALiYunRequest}
     */
    this.buildALiYunRequest=function (json) {
        return new ALiYunRequest(json);
    };
    /**
     * @param json
     * @returns {QuestionNumbersOptions}
     */
    this.buildQuestionNumbersOptions=function (json) {
        return new QuestionNumbersOptions(json);
    };
    /**
     * @param json
     * @returns {UpdateTipInfo}
     */
    this.buildUpdateTipInfo=function (json) {
        return new UpdateTipInfo(json);
    };
    /**
     * @param json
     * @returns {MessageContent}
     */
    this.buildMessageContent=function (json) {
        return new MessageContent(json);
    };
    /**
     * @param json
     * @returns {InspectionReportDetailed}
     */
    this.buildInspectionReportDetailed=function (json) {
        return new InspectionReportDetailed(json);
    };
    /**
     * @param json
     * @returns {CallCenterJumpParams}
     */
    this.buildCallCenterJumpParams=function (json) {
        return new CallCenterJumpParams(json);
    };
    /**
     * @param json
     * @returns {StudySpotCheckInfo}
     */
    this.buildStudySpotCheckInfo=function (json) {
        return new StudySpotCheckInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowUpTaskSpotCheckStatistics}
     */
    this.buildHttpResult_FollowUpTaskSpotCheckStatistics=function (json) {
        return new HttpResult_FollowUpTaskSpotCheckStatistics(json);
    };
    /**
     * @param json
     * @returns {TaskNameInfo}
     */
    this.buildTaskNameInfo=function (json) {
        return new TaskNameInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_String}
     */
    this.buildHttpResult_String=function (json) {
        return new HttpResult_String(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowUpTaskSpotCheckPatients}
     */
    this.buildHttpResult_FollowUpTaskSpotCheckPatients=function (json) {
        return new HttpResult_FollowUpTaskSpotCheckPatients(json);
    };
    /**
     * @param json
     * @returns {HttpResult_PhoneRecordInfos}
     */
    this.buildHttpResult_PhoneRecordInfos=function (json) {
        return new HttpResult_PhoneRecordInfos(json);
    };
    /**
     * @param json
     * @returns {MainOfControllerInfo}
     */
    this.buildMainOfControllerInfo=function (json) {
        return new MainOfControllerInfo(json);
    };
    /**
     * @param json
     * @returns {PatientReferenceFieldGroupInfo}
     */
    this.buildPatientReferenceFieldGroupInfo=function (json) {
        return new PatientReferenceFieldGroupInfo(json);
    };
    /**
     * @param json
     * @returns {SeatDayIndexDetail}
     */
    this.buildSeatDayIndexDetail=function (json) {
        return new SeatDayIndexDetail(json);
    };
    /**
     * @param json
     * @returns {PatientPhoneNumber}
     */
    this.buildPatientPhoneNumber=function (json) {
        return new PatientPhoneNumber(json);
    };
    /**
     * @param json
     * @returns {HttpResult_int}
     */
    this.buildHttpResult_int=function (json) {
        return new HttpResult_int(json);
    };
    /**
     * @param json
     * @returns {PatientVisitingInfo}
     */
    this.buildPatientVisitingInfo=function (json) {
        return new PatientVisitingInfo(json);
    };
    /**
     * @param json
     * @returns {FollowupTaskPatientInfo}
     */
    this.buildFollowupTaskPatientInfo=function (json) {
        return new FollowupTaskPatientInfo(json);
    };
    /**
     * @param json
     * @returns {PatientFollowUpQuestionnaireRecord}
     */
    this.buildPatientFollowUpQuestionnaireRecord=function (json) {
        return new PatientFollowUpQuestionnaireRecord(json);
    };
    /**
     * @param json
     * @returns {CallRecord}
     */
    this.buildCallRecord=function (json) {
        return new CallRecord(json);
    };
    /**
     * @param json
     * @returns {UserLogin}
     */
    this.buildUserLogin=function (json) {
        return new UserLogin(json);
    };
    /**
     * @param json
     * @returns {HttpResult_UserTaskSpotCheckStatisticss}
     */
    this.buildHttpResult_UserTaskSpotCheckStatisticss=function (json) {
        return new HttpResult_UserTaskSpotCheckStatisticss(json);
    };
    /**
     * @param json
     * @returns {ColorTips}
     */
    this.buildColorTips=function (json) {
        return new ColorTips(json);
    };
    /**
     * @param json
     * @returns {HttpResult_longs}
     */
    this.buildHttpResult_longs=function (json) {
        return new HttpResult_longs(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TPatientQuestionnaireAnswerResp}
     */
    this.buildHttpResult_TPatientQuestionnaireAnswerResp=function (json) {
        return new HttpResult_TPatientQuestionnaireAnswerResp(json);
    };
    /**
     * @param json
     * @returns {GroupInfo}
     */
    this.buildGroupInfo=function (json) {
        return new GroupInfo(json);
    };
    /**
     * @param json
     * @returns {EditFollowupGroup}
     */
    this.buildEditFollowupGroup=function (json) {
        return new EditFollowupGroup(json);
    };
    /**
     * @param json
     * @returns {SeatQuotaInfoResp}
     */
    this.buildSeatQuotaInfoResp=function (json) {
        return new SeatQuotaInfoResp(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SeatPatientFileRelationships}
     */
    this.buildHttpResult_SeatPatientFileRelationships=function (json) {
        return new HttpResult_SeatPatientFileRelationships(json);
    };
    /**
     * @param json
     * @returns {RelationshipLevel}
     */
    this.buildRelationshipLevel=function (json) {
        return new RelationshipLevel(json);
    };
    /**
     * @param json
     * @returns {FollowupGroup}
     */
    this.buildFollowupGroup=function (json) {
        return new FollowupGroup(json);
    };
    /**
     * @param json
     * @returns {QaTaskInfo}
     */
    this.buildQaTaskInfo=function (json) {
        return new QaTaskInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_bool}
     */
    this.buildHttpResult_bool=function (json) {
        return new HttpResult_bool(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallPatientInspectionReports}
     */
    this.buildHttpResult_CallPatientInspectionReports=function (json) {
        return new HttpResult_CallPatientInspectionReports(json);
    };
    /**
     * @param json
     * @returns {SdrAsyncPushParam}
     */
    this.buildSdrAsyncPushParam=function (json) {
        return new SdrAsyncPushParam(json);
    };
    /**
     * @param json
     * @returns {HttpResult_StudyInfos}
     */
    this.buildHttpResult_StudyInfos=function (json) {
        return new HttpResult_StudyInfos(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupInterval}
     */
    this.buildFollowupGroupInterval=function (json) {
        return new FollowupGroupInterval(json);
    };
    /**
     * @param json
     * @returns {CallTaskSpotCheck}
     */
    this.buildCallTaskSpotCheck=function (json) {
        return new CallTaskSpotCheck(json);
    };
    /**
     * @param json
     * @returns {OperationPlatformTaskFollowupData}
     */
    this.buildOperationPlatformTaskFollowupData=function (json) {
        return new OperationPlatformTaskFollowupData(json);
    };
    /**
     * @param json
     * @returns {HttpResult_PatientReferenceFieldGroupInfos}
     */
    this.buildHttpResult_PatientReferenceFieldGroupInfos=function (json) {
        return new HttpResult_PatientReferenceFieldGroupInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupAwardInfos}
     */
    this.buildHttpResult_FollowupAwardInfos=function (json) {
        return new HttpResult_FollowupAwardInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowUpTaskPatientCallRecords}
     */
    this.buildHttpResult_FollowUpTaskPatientCallRecords=function (json) {
        return new HttpResult_FollowUpTaskPatientCallRecords(json);
    };
    /**
     * @param json
     * @returns {CallPeriodicStatistics}
     */
    this.buildCallPeriodicStatistics=function (json) {
        return new CallPeriodicStatistics(json);
    };
    /**
     * @param json
     * @returns {DeliveryHeadOptionList}
     */
    this.buildDeliveryHeadOptionList=function (json) {
        return new DeliveryHeadOptionList(json);
    };
    /**
     * @param json
     * @returns {HttpResult_WeekStars}
     */
    this.buildHttpResult_WeekStars=function (json) {
        return new HttpResult_WeekStars(json);
    };
    /**
     * @param json
     * @returns {QualityRuleResp}
     */
    this.buildQualityRuleResp=function (json) {
        return new QualityRuleResp(json);
    };
    /**
     * @param json
     * @returns {QuestionnaireAnswerInfoNew}
     */
    this.buildQuestionnaireAnswerInfoNew=function (json) {
        return new QuestionnaireAnswerInfoNew(json);
    };
    /**
     * @param json
     * @returns {CallPatientInspectionReport}
     */
    this.buildCallPatientInspectionReport=function (json) {
        return new CallPatientInspectionReport(json);
    };
    /**
     * @param json
     * @returns {UserInfo}
     */
    this.buildUserInfo=function (json) {
        return new UserInfo(json);
    };
    /**
     * @param json
     * @returns {AdmissionAnswerInfo}
     */
    this.buildAdmissionAnswerInfo=function (json) {
        return new AdmissionAnswerInfo(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupPatientEachRecordAppDetail}
     */
    this.buildFollowupGroupPatientEachRecordAppDetail=function (json) {
        return new FollowupGroupPatientEachRecordAppDetail(json);
    };
    /**
     * @param json
     * @returns {MedicalSurgeryRecord}
     */
    this.buildMedicalSurgeryRecord=function (json) {
        return new MedicalSurgeryRecord(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallCenterUser}
     */
    this.buildHttpResult_CallCenterUser=function (json) {
        return new HttpResult_CallCenterUser(json);
    };
    /**
     * @param json
     * @returns {TTaskAndSmsRelationshipResp}
     */
    this.buildTTaskAndSmsRelationshipResp=function (json) {
        return new TTaskAndSmsRelationshipResp(json);
    };
    /**
     * @param json
     * @returns {DeliveryHeadList}
     */
    this.buildDeliveryHeadList=function (json) {
        return new DeliveryHeadList(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TQuestionPageResps}
     */
    this.buildHttpResult_TQuestionPageResps=function (json) {
        return new HttpResult_TQuestionPageResps(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupTags}
     */
    this.buildHttpResult_FollowupTags=function (json) {
        return new HttpResult_FollowupTags(json);
    };
    /**
     * @param json
     * @returns {SendBatchResponse}
     */
    this.buildSendBatchResponse=function (json) {
        return new SendBatchResponse(json);
    };
    /**
     * @param json
     * @returns {UnitSchema}
     */
    this.buildUnitSchema=function (json) {
        return new UnitSchema(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupPatient}
     */
    this.buildFollowupGroupPatient=function (json) {
        return new FollowupGroupPatient(json);
    };
    /**
     * @param json
     * @returns {PatientSubmitFollowUpQuestionnaire}
     */
    this.buildPatientSubmitFollowUpQuestionnaire=function (json) {
        return new PatientSubmitFollowUpQuestionnaire(json);
    };
    /**
     * @param json
     * @returns {QuestionOption}
     */
    this.buildQuestionOption=function (json) {
        return new QuestionOption(json);
    };
    /**
     * @param json
     * @returns {HttpResult_PatientAllFollowupLists}
     */
    this.buildHttpResult_PatientAllFollowupLists=function (json) {
        return new HttpResult_PatientAllFollowupLists(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupPatientEachRecord}
     */
    this.buildFollowupGroupPatientEachRecord=function (json) {
        return new FollowupGroupPatientEachRecord(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TQuestionInfoResps}
     */
    this.buildHttpResult_TQuestionInfoResps=function (json) {
        return new HttpResult_TQuestionInfoResps(json);
    };
    /**
     * @param json
     * @returns {TFollowupSmsSendRecordResp}
     */
    this.buildTFollowupSmsSendRecordResp=function (json) {
        return new TFollowupSmsSendRecordResp(json);
    };
    /**
     * @param json
     * @returns {LabIndex}
     */
    this.buildLabIndex=function (json) {
        return new LabIndex(json);
    };
    /**
     * @param json
     * @returns {CallCenterUser}
     */
    this.buildCallCenterUser=function (json) {
        return new CallCenterUser(json);
    };
    /**
     * @param json
     * @returns {TNewFollowupCallRecordResp}
     */
    this.buildTNewFollowupCallRecordResp=function (json) {
        return new TNewFollowupCallRecordResp(json);
    };
    /**
     * @param json
     * @returns {VisitingTaskInfo}
     */
    this.buildVisitingTaskInfo=function (json) {
        return new VisitingTaskInfo(json);
    };
    /**
     * @param json
     * @returns {Answer}
     */
    this.buildAnswer=function (json) {
        return new Answer(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupTaskCurrentInfo}
     */
    this.buildHttpResult_FollowupTaskCurrentInfo=function (json) {
        return new HttpResult_FollowupTaskCurrentInfo(json);
    };
    /**
     * @param json
     * @returns {CreateFollowupGroupInterval}
     */
    this.buildCreateFollowupGroupInterval=function (json) {
        return new CreateFollowupGroupInterval(json);
    };
    /**
     * @param json
     * @returns {HttpResult_Relationships}
     */
    this.buildHttpResult_Relationships=function (json) {
        return new HttpResult_Relationships(json);
    };
    /**
     * @param json
     * @returns {CallRecordingInfo}
     */
    this.buildCallRecordingInfo=function (json) {
        return new CallRecordingInfo(json);
    };
    /**
     * @param json
     * @returns {UnitAction}
     */
    this.buildUnitAction=function (json) {
        return new UnitAction(json);
    };
    /**
     * @param json
     * @returns {SeatQuotaTableInfo}
     */
    this.buildSeatQuotaTableInfo=function (json) {
        return new SeatQuotaTableInfo(json);
    };
    /**
     * @param json
     * @returns {CallCenterQuestionnaireDetails}
     */
    this.buildCallCenterQuestionnaireDetails=function (json) {
        return new CallCenterQuestionnaireDetails(json);
    };
    /**
     * @param json
     * @returns {NewMessageMangerInfo}
     */
    this.buildNewMessageMangerInfo=function (json) {
        return new NewMessageMangerInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_InspectionReportDetailed}
     */
    this.buildHttpResult_InspectionReportDetailed=function (json) {
        return new HttpResult_InspectionReportDetailed(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupPatientEachRecordAndGroupName}
     */
    this.buildFollowupGroupPatientEachRecordAndGroupName=function (json) {
        return new FollowupGroupPatientEachRecordAndGroupName(json);
    };
    /**
     * @param json
     * @returns {BestCaseInfo}
     */
    this.buildBestCaseInfo=function (json) {
        return new BestCaseInfo(json);
    };
    /**
     * @param json
     * @returns {SeatPatientFileRelationship}
     */
    this.buildSeatPatientFileRelationship=function (json) {
        return new SeatPatientFileRelationship(json);
    };
    /**
     * @param json
     * @returns {GoodsDetail}
     */
    this.buildGoodsDetail=function (json) {
        return new GoodsDetail(json);
    };
    /**
     * @param json
     * @returns {AggReplyListMoney}
     */
    this.buildAggReplyListMoney=function (json) {
        return new AggReplyListMoney(json);
    };
    /**
     * @param json
     * @returns {HuiZhuoRegisterState}
     */
    this.buildHuiZhuoRegisterState=function (json) {
        return new HuiZhuoRegisterState(json);
    };
    /**
     * @param json
     * @returns {SeatMonthQuotaInfo}
     */
    this.buildSeatMonthQuotaInfo=function (json) {
        return new SeatMonthQuotaInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SmsTemplate}
     */
    this.buildHttpResult_SmsTemplate=function (json) {
        return new HttpResult_SmsTemplate(json);
    };
    /**
     * @param json
     * @returns {HttpResult_ColorTips}
     */
    this.buildHttpResult_ColorTips=function (json) {
        return new HttpResult_ColorTips(json);
    };
    /**
     * @param json
     * @returns {HttpResult_MissedCallResults}
     */
    this.buildHttpResult_MissedCallResults=function (json) {
        return new HttpResult_MissedCallResults(json);
    };
    /**
     * @param json
     * @returns {HQUser}
     */
    this.buildHQUser=function (json) {
        return new HQUser(json);
    };
    /**
     * @param json
     * @returns {QualifiedSpotCheckInfo}
     */
    this.buildQualifiedSpotCheckInfo=function (json) {
        return new QualifiedSpotCheckInfo(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupBasicInfo}
     */
    this.buildFollowupGroupBasicInfo=function (json) {
        return new FollowupGroupBasicInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TodayFollowUpCount}
     */
    this.buildHttpResult_TodayFollowUpCount=function (json) {
        return new HttpResult_TodayFollowUpCount(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupDoctor}
     */
    this.buildFollowupGroupDoctor=function (json) {
        return new FollowupGroupDoctor(json);
    };
    /**
     * @param json
     * @returns {StudyInfo}
     */
    this.buildStudyInfo=function (json) {
        return new StudyInfo(json);
    };
    /**
     * @param json
     * @returns {SeatRank}
     */
    this.buildSeatRank=function (json) {
        return new SeatRank(json);
    };
    /**
     * @param json
     * @returns {HttpResult_LaterCallInfos}
     */
    this.buildHttpResult_LaterCallInfos=function (json) {
        return new HttpResult_LaterCallInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FeedbackInfos}
     */
    this.buildHttpResult_FeedbackInfos=function (json) {
        return new HttpResult_FeedbackInfos(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupRecord}
     */
    this.buildFollowupGroupRecord=function (json) {
        return new FollowupGroupRecord(json);
    };
    /**
     * @param json
     * @returns {FeedbackInfo}
     */
    this.buildFeedbackInfo=function (json) {
        return new FeedbackInfo(json);
    };
    /**
     * @param json
     * @returns {ReplyList}
     */
    this.buildReplyList=function (json) {
        return new ReplyList(json);
    };
    /**
     * @param json
     * @returns {OverDueInfo}
     */
    this.buildOverDueInfo=function (json) {
        return new OverDueInfo(json);
    };
    /**
     * @param json
     * @returns {InspectionReport}
     */
    this.buildInspectionReport=function (json) {
        return new InspectionReport(json);
    };
    /**
     * @param json
     * @returns {OperationPlatformTaskData}
     */
    this.buildOperationPlatformTaskData=function (json) {
        return new OperationPlatformTaskData(json);
    };
    /**
     * @param json
     * @returns {TFollowUpTaskResp}
     */
    this.buildTFollowUpTaskResp=function (json) {
        return new TFollowUpTaskResp(json);
    };
    /**
     * @param json
     * @returns {FollowUpTaskSpotCheckStatistics}
     */
    this.buildFollowUpTaskSpotCheckStatistics=function (json) {
        return new FollowUpTaskSpotCheckStatistics(json);
    };
    /**
     * @param json
     * @returns {TPatientAnswerInfoResp}
     */
    this.buildTPatientAnswerInfoResp=function (json) {
        return new TPatientAnswerInfoResp(json);
    };
    /**
     * @param json
     * @returns {DateTimeTextInfo}
     */
    this.buildDateTimeTextInfo=function (json) {
        return new DateTimeTextInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallPatientVisitingRecords}
     */
    this.buildHttpResult_CallPatientVisitingRecords=function (json) {
        return new HttpResult_CallPatientVisitingRecords(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TPatientAnswerInfoResp}
     */
    this.buildHttpResult_TPatientAnswerInfoResp=function (json) {
        return new HttpResult_TPatientAnswerInfoResp(json);
    };
    /**
     * @param json
     * @returns {ConsultSendMessage}
     */
    this.buildConsultSendMessage=function (json) {
        return new ConsultSendMessage(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SeatQuotaTableInfo}
     */
    this.buildHttpResult_SeatQuotaTableInfo=function (json) {
        return new HttpResult_SeatQuotaTableInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TQuestionInfoRespAndStatus}
     */
    this.buildHttpResult_TQuestionInfoRespAndStatus=function (json) {
        return new HttpResult_TQuestionInfoRespAndStatus(json);
    };
    /**
     * @param json
     * @returns {DateTimeInfo}
     */
    this.buildDateTimeInfo=function (json) {
        return new DateTimeInfo(json);
    };
    /**
     * @param json
     * @returns {DateInfo}
     */
    this.buildDateInfo=function (json) {
        return new DateInfo(json);
    };
    /**
     * @param json
     * @returns {ContactInformationParam}
     */
    this.buildContactInformationParam=function (json) {
        return new ContactInformationParam(json);
    };
    /**
     * @param json
     * @returns {ALiYunMediaDownloadParam}
     */
    this.buildALiYunMediaDownloadParam=function (json) {
        return new ALiYunMediaDownloadParam(json);
    };
    /**
     * @param json
     * @returns {CallCenterGeneralPurposeImportHeaders}
     */
    this.buildCallCenterGeneralPurposeImportHeaders=function (json) {
        return new CallCenterGeneralPurposeImportHeaders(json);
    };
    /**
     * @param json
     * @returns {HttpResult_QualityControlCallRecordInfos}
     */
    this.buildHttpResult_QualityControlCallRecordInfos=function (json) {
        return new HttpResult_QualityControlCallRecordInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FinishAndTodoInfo}
     */
    this.buildHttpResult_FinishAndTodoInfo=function (json) {
        return new HttpResult_FinishAndTodoInfo(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupPatientRecord}
     */
    this.buildFollowupGroupPatientRecord=function (json) {
        return new FollowupGroupPatientRecord(json);
    };
    /**
     * @param json
     * @returns {HttpResult_long}
     */
    this.buildHttpResult_long=function (json) {
        return new HttpResult_long(json);
    };
    /**
     * @param json
     * @returns {HttpResult_UpdateTipInfos}
     */
    this.buildHttpResult_UpdateTipInfos=function (json) {
        return new HttpResult_UpdateTipInfos(json);
    };
    /**
     * @param json
     * @returns {ParameterList}
     */
    this.buildParameterList=function (json) {
        return new ParameterList(json);
    };
    /**
     * @param json
     * @returns {TimeSectionStatisticsInfo}
     */
    this.buildTimeSectionStatisticsInfo=function (json) {
        return new TimeSectionStatisticsInfo(json);
    };
    /**
     * @param json
     * @returns {CallPatient}
     */
    this.buildCallPatient=function (json) {
        return new CallPatient(json);
    };
    /**
     * @param json
     * @returns {PhoneLabel}
     */
    this.buildPhoneLabel=function (json) {
        return new PhoneLabel(json);
    };
    /**
     * @param json
     * @returns {StringMap}
     */
    this.buildStringMap=function (json) {
        return new StringMap(json);
    };
    /**
     * @param json
     * @returns {PushRemind}
     */
    this.buildPushRemind=function (json) {
        return new PushRemind(json);
    };
    /**
     * @param json
     * @returns {HttpResult_VisitingTaskInfos}
     */
    this.buildHttpResult_VisitingTaskInfos=function (json) {
        return new HttpResult_VisitingTaskInfos(json);
    };
    /**
     * @param json
     * @returns {FollowupQuestionnaireData}
     */
    this.buildFollowupQuestionnaireData=function (json) {
        return new FollowupQuestionnaireData(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SurgeryRecords}
     */
    this.buildHttpResult_SurgeryRecords=function (json) {
        return new HttpResult_SurgeryRecords(json);
    };
    /**
     * @param json
     * @returns {HttpResult_PatientMedicalRecords}
     */
    this.buildHttpResult_PatientMedicalRecords=function (json) {
        return new HttpResult_PatientMedicalRecords(json);
    };
    /**
     * @param json
     * @returns {ReportListShow}
     */
    this.buildReportListShow=function (json) {
        return new ReportListShow(json);
    };
    /**
     * @param json
     * @returns {MessageManageInfo}
     */
    this.buildMessageManageInfo=function (json) {
        return new MessageManageInfo(json);
    };
    /**
     * @param json
     * @returns {NewDeliverTableFixedFieldInfo}
     */
    this.buildNewDeliverTableFixedFieldInfo=function (json) {
        return new NewDeliverTableFixedFieldInfo(json);
    };
    /**
     * @param json
     * @returns {SurgeryRecord}
     */
    this.buildSurgeryRecord=function (json) {
        return new SurgeryRecord(json);
    };
    /**
     * @param json
     * @returns {QualityControlCallRecordInfo}
     */
    this.buildQualityControlCallRecordInfo=function (json) {
        return new QualityControlCallRecordInfo(json);
    };
    /**
     * @param json
     * @returns {HomePageDoctorInfo}
     */
    this.buildHomePageDoctorInfo=function (json) {
        return new HomePageDoctorInfo(json);
    };
    /**
     * @param json
     * @returns {QuestionnaireTemplateInfo}
     */
    this.buildQuestionnaireTemplateInfo=function (json) {
        return new QuestionnaireTemplateInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TFollowupSmsSendRecordResps}
     */
    this.buildHttpResult_TFollowupSmsSendRecordResps=function (json) {
        return new HttpResult_TFollowupSmsSendRecordResps(json);
    };
    /**
     * @param json
     * @returns {ReferenceGroupFieldValueInfo}
     */
    this.buildReferenceGroupFieldValueInfo=function (json) {
        return new ReferenceGroupFieldValueInfo(json);
    };
    /**
     * @param json
     * @returns {TQuestionPageResp}
     */
    this.buildTQuestionPageResp=function (json) {
        return new TQuestionPageResp(json);
    };
    /**
     * @param json
     * @returns {HttpResult_RelationshipLevels}
     */
    this.buildHttpResult_RelationshipLevels=function (json) {
        return new HttpResult_RelationshipLevels(json);
    };
    /**
     * @param json
     * @returns {HttpResult_HuiZhuoRegisterState}
     */
    this.buildHttpResult_HuiZhuoRegisterState=function (json) {
        return new HttpResult_HuiZhuoRegisterState(json);
    };
    /**
     * @param json
     * @returns {GroupInfoList}
     */
    this.buildGroupInfoList=function (json) {
        return new GroupInfoList(json);
    };
    /**
     * @param json
     * @returns {HttpResult_Integer}
     */
    this.buildHttpResult_Integer=function (json) {
        return new HttpResult_Integer(json);
    };
    /**
     * @param json
     * @returns {HttpResult_PhoneLabels}
     */
    this.buildHttpResult_PhoneLabels=function (json) {
        return new HttpResult_PhoneLabels(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SeatMistakeInfos}
     */
    this.buildHttpResult_SeatMistakeInfos=function (json) {
        return new HttpResult_SeatMistakeInfos(json);
    };
    /**
     * @param json
     * @returns {FollowUpTaskSwitchMark}
     */
    this.buildFollowUpTaskSwitchMark=function (json) {
        return new FollowUpTaskSwitchMark(json);
    };
    /**
     * @param json
     * @returns {HttpResult_QualityRuleResp}
     */
    this.buildHttpResult_QualityRuleResp=function (json) {
        return new HttpResult_QualityRuleResp(json);
    };
    /**
     * @param json
     * @returns {SdrAsyncPushFollowupParam}
     */
    this.buildSdrAsyncPushFollowupParam=function (json) {
        return new SdrAsyncPushFollowupParam(json);
    };
    /**
     * @param json
     * @returns {PieStatisticsByTaskName}
     */
    this.buildPieStatisticsByTaskName=function (json) {
        return new PieStatisticsByTaskName(json);
    };
    /**
     * @param json
     * @returns {CallCenterAnswerQuestions}
     */
    this.buildCallCenterAnswerQuestions=function (json) {
        return new CallCenterAnswerQuestions(json);
    };
    /**
     * @param json
     * @returns {LaterCallInfo}
     */
    this.buildLaterCallInfo=function (json) {
        return new LaterCallInfo(json);
    };
    /**
     * @param json
     * @returns {SimpleQuestionnaireTemplate}
     */
    this.buildSimpleQuestionnaireTemplate=function (json) {
        return new SimpleQuestionnaireTemplate(json);
    };
    /**
     * @param json
     * @returns {AnswerQuestion}
     */
    this.buildAnswerQuestion=function (json) {
        return new AnswerQuestion(json);
    };
    /**
     * @param json
     * @returns {BatchAddPatientAnswerInfo}
     */
    this.buildBatchAddPatientAnswerInfo=function (json) {
        return new BatchAddPatientAnswerInfo(json);
    };
    /**
     * @param json
     * @returns {PatientDiagnosisInfo}
     */
    this.buildPatientDiagnosisInfo=function (json) {
        return new PatientDiagnosisInfo(json);
    };
    /**
     * @param json
     * @returns {ShowPatientSubmitQuestionAnswer}
     */
    this.buildShowPatientSubmitQuestionAnswer=function (json) {
        return new ShowPatientSubmitQuestionAnswer(json);
    };
    /**
     * @param json
     * @returns {FollowupVoteMonthInfo}
     */
    this.buildFollowupVoteMonthInfo=function (json) {
        return new FollowupVoteMonthInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_qualifiedSpotCheckInfos}
     */
    this.buildHttpResult_qualifiedSpotCheckInfos=function (json) {
        return new HttpResult_qualifiedSpotCheckInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallTaskStatistics}
     */
    this.buildHttpResult_CallTaskStatistics=function (json) {
        return new HttpResult_CallTaskStatistics(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupPatientRecordInfo}
     */
    this.buildFollowupGroupPatientRecordInfo=function (json) {
        return new FollowupGroupPatientRecordInfo(json);
    };
    /**
     * @param json
     * @returns {JumpSetUp}
     */
    this.buildJumpSetUp=function (json) {
        return new JumpSetUp(json);
    };
    /**
     * @param json
     * @returns {FollowupSpotCheckRecordResp}
     */
    this.buildFollowupSpotCheckRecordResp=function (json) {
        return new FollowupSpotCheckRecordResp(json);
    };
    /**
     * @param json
     * @returns {PatientInspectionReport}
     */
    this.buildPatientInspectionReport=function (json) {
        return new PatientInspectionReport(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SeatFiles}
     */
    this.buildHttpResult_SeatFiles=function (json) {
        return new HttpResult_SeatFiles(json);
    };
    /**
     * @param json
     * @returns {HttpResult_NewMessageMangerInfos}
     */
    this.buildHttpResult_NewMessageMangerInfos=function (json) {
        return new HttpResult_NewMessageMangerInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_PassFailFeedBacks}
     */
    this.buildHttpResult_PassFailFeedBacks=function (json) {
        return new HttpResult_PassFailFeedBacks(json);
    };
    /**
     * @param json
     * @returns {HospitalInfo}
     */
    this.buildHospitalInfo=function (json) {
        return new HospitalInfo(json);
    };
    /**
     * @param json
     * @returns {QualityControlProblemRecord}
     */
    this.buildQualityControlProblemRecord=function (json) {
        return new QualityControlProblemRecord(json);
    };
    /**
     * @param json
     * @returns {ManagerPatientSimpleInfo}
     */
    this.buildManagerPatientSimpleInfo=function (json) {
        return new ManagerPatientSimpleInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SeatUserInfoss}
     */
    this.buildHttpResult_SeatUserInfoss=function (json) {
        return new HttpResult_SeatUserInfoss(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallPatient}
     */
    this.buildHttpResult_CallPatient=function (json) {
        return new HttpResult_CallPatient(json);
    };
    /**
     * @param json
     * @returns {PieStatisticsTableByWorkNum}
     */
    this.buildPieStatisticsTableByWorkNum=function (json) {
        return new PieStatisticsTableByWorkNum(json);
    };
    /**
     * @param json
     * @returns {WardInfo}
     */
    this.buildWardInfo=function (json) {
        return new WardInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupSpotCheckRecordResps}
     */
    this.buildHttpResult_FollowupSpotCheckRecordResps=function (json) {
        return new HttpResult_FollowupSpotCheckRecordResps(json);
    };
    /**
     * @param json
     * @returns {HttpResult_MedicalRecordDetailed}
     */
    this.buildHttpResult_MedicalRecordDetailed=function (json) {
        return new HttpResult_MedicalRecordDetailed(json);
    };
    /**
     * @param json
     * @returns {NewQuestionResult}
     */
    this.buildNewQuestionResult=function (json) {
        return new NewQuestionResult(json);
    };
    /**
     * @param json
     * @returns {FollowupAwardInfo}
     */
    this.buildFollowupAwardInfo=function (json) {
        return new FollowupAwardInfo(json);
    };
    /**
     * @param json
     * @returns {TQuestionInfoResp}
     */
    this.buildTQuestionInfoResp=function (json) {
        return new TQuestionInfoResp(json);
    };
    /**
     * @param json
     * @returns {OverTimeDrug}
     */
    this.buildOverTimeDrug=function (json) {
        return new OverTimeDrug(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TFollowUpPeopleTaskResps}
     */
    this.buildHttpResult_TFollowUpPeopleTaskResps=function (json) {
        return new HttpResult_TFollowUpPeopleTaskResps(json);
    };
    /**
     * @param json
     * @returns {FileInfo}
     */
    this.buildFileInfo=function (json) {
        return new FileInfo(json);
    };
    /**
     * @param json
     * @returns {RoleInfo}
     */
    this.buildRoleInfo=function (json) {
        return new RoleInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_QualityTimeStages}
     */
    this.buildHttpResult_QualityTimeStages=function (json) {
        return new HttpResult_QualityTimeStages(json);
    };
    /**
     * @param json
     * @returns {PatientMedicalRecord}
     */
    this.buildPatientMedicalRecord=function (json) {
        return new PatientMedicalRecord(json);
    };
    /**
     * @param json
     * @returns {ScoreAverageStatistics}
     */
    this.buildScoreAverageStatistics=function (json) {
        return new ScoreAverageStatistics(json);
    };
    /**
     * @param json
     * @returns {CallPatientInfo}
     */
    this.buildCallPatientInfo=function (json) {
        return new CallPatientInfo(json);
    };
    /**
     * @param json
     * @returns {SeatFile}
     */
    this.buildSeatFile=function (json) {
        return new SeatFile(json);
    };
    /**
     * @param json
     * @returns {UserTaskSpotCheckStatistics}
     */
    this.buildUserTaskSpotCheckStatistics=function (json) {
        return new UserTaskSpotCheckStatistics(json);
    };
    /**
     * @param json
     * @returns {HttpResult_strings}
     */
    this.buildHttpResult_strings=function (json) {
        return new HttpResult_strings(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupInfoKVs}
     */
    this.buildHttpResult_FollowupInfoKVs=function (json) {
        return new HttpResult_FollowupInfoKVs(json);
    };
    /**
     * @param json
     * @returns {CallTaskCenterInfo}
     */
    this.buildCallTaskCenterInfo=function (json) {
        return new CallTaskCenterInfo(json);
    };
    /**
     * @param json
     * @returns {NewQuestionnaireContentInfo}
     */
    this.buildNewQuestionnaireContentInfo=function (json) {
        return new NewQuestionnaireContentInfo(json);
    };
    /**
     * @param json
     * @returns {QuestionnaireQualityRuleResp}
     */
    this.buildQuestionnaireQualityRuleResp=function (json) {
        return new QuestionnaireQualityRuleResp(json);
    };
    /**
     * @param json
     * @returns {DraftsReport}
     */
    this.buildDraftsReport=function (json) {
        return new DraftsReport(json);
    };
    /**
     * @param json
     * @returns {TOptionsInfoResp}
     */
    this.buildTOptionsInfoResp=function (json) {
        return new TOptionsInfoResp(json);
    };
    /**
     * @param json
     * @returns {HttpResult_StudySpotCheckInfos}
     */
    this.buildHttpResult_StudySpotCheckInfos=function (json) {
        return new HttpResult_StudySpotCheckInfos(json);
    };
    /**
     * @param json
     * @returns {QuestionnaireScoreStatisticInfo}
     */
    this.buildQuestionnaireScoreStatisticInfo=function (json) {
        return new QuestionnaireScoreStatisticInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupVoteMonthInfo}
     */
    this.buildHttpResult_FollowupVoteMonthInfo=function (json) {
        return new HttpResult_FollowupVoteMonthInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupDeliveryQuestions}
     */
    this.buildHttpResult_FollowupDeliveryQuestions=function (json) {
        return new HttpResult_FollowupDeliveryQuestions(json);
    };
    /**
     * @param json
     * @returns {FollowupGroupPatientEachRecordDetail}
     */
    this.buildFollowupGroupPatientEachRecordDetail=function (json) {
        return new FollowupGroupPatientEachRecordDetail(json);
    };
    /**
     * @param json
     * @returns {HttpResult_BestCaseInfos}
     */
    this.buildHttpResult_BestCaseInfos=function (json) {
        return new HttpResult_BestCaseInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_QualityRules}
     */
    this.buildHttpResult_QualityRules=function (json) {
        return new HttpResult_QualityRules(json);
    };
    /**
     * @param json
     * @returns {ManagerPatientVisitingInfo}
     */
    this.buildManagerPatientVisitingInfo=function (json) {
        return new ManagerPatientVisitingInfo(json);
    };
    /**
     * @param json
     * @returns {ModuleInfo}
     */
    this.buildModuleInfo=function (json) {
        return new ModuleInfo(json);
    };
    /**
     * @param json
     * @returns {FollowUpPatientCondition}
     */
    this.buildFollowUpPatientCondition=function (json) {
        return new FollowUpPatientCondition(json);
    };
    /**
     * @param json
     * @returns {SeatIndexRank}
     */
    this.buildSeatIndexRank=function (json) {
        return new SeatIndexRank(json);
    };
    /**
     * @param json
     * @returns {QuestionAndPatientDiagnosisInfo}
     */
    this.buildQuestionAndPatientDiagnosisInfo=function (json) {
        return new QuestionAndPatientDiagnosisInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallPeriodicStatisticss}
     */
    this.buildHttpResult_CallPeriodicStatisticss=function (json) {
        return new HttpResult_CallPeriodicStatisticss(json);
    };
    /**
     * @param json
     * @returns {ConsultChatUserInfo}
     */
    this.buildConsultChatUserInfo=function (json) {
        return new ConsultChatUserInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_StudyInfo}
     */
    this.buildHttpResult_StudyInfo=function (json) {
        return new HttpResult_StudyInfo(json);
    };
    /**
     * @param json
     * @returns {ShowPatientQuestionAnswer}
     */
    this.buildShowPatientQuestionAnswer=function (json) {
        return new ShowPatientQuestionAnswer(json);
    };
    /**
     * @param json
     * @returns {FinalMedicineStatisticsResults}
     */
    this.buildFinalMedicineStatisticsResults=function (json) {
        return new FinalMedicineStatisticsResults(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FeedbackPatientInformations}
     */
    this.buildHttpResult_FeedbackPatientInformations=function (json) {
        return new HttpResult_FeedbackPatientInformations(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowUpPatientCondition}
     */
    this.buildHttpResult_FollowUpPatientCondition=function (json) {
        return new HttpResult_FollowUpPatientCondition(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TelephoneFollowupIncomingCallPatients}
     */
    this.buildHttpResult_TelephoneFollowupIncomingCallPatients=function (json) {
        return new HttpResult_TelephoneFollowupIncomingCallPatients(json);
    };
    /**
     * @param json
     * @returns {SwitchBar}
     */
    this.buildSwitchBar=function (json) {
        return new SwitchBar(json);
    };
    /**
     * @param json
     * @returns {QuestionAndAnswer}
     */
    this.buildQuestionAndAnswer=function (json) {
        return new QuestionAndAnswer(json);
    };
    /**
     * @param json
     * @returns {SdrSpotCheckRemarks}
     */
    this.buildSdrSpotCheckRemarks=function (json) {
        return new SdrSpotCheckRemarks(json);
    };
    /**
     * @param json
     * @returns {TopicScoreInfo}
     */
    this.buildTopicScoreInfo=function (json) {
        return new TopicScoreInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupTaskPatientInfo}
     */
    this.buildHttpResult_FollowupTaskPatientInfo=function (json) {
        return new HttpResult_FollowupTaskPatientInfo(json);
    };
    /**
     * @param json
     * @returns {ALiYunRecordings}
     */
    this.buildALiYunRecordings=function (json) {
        return new ALiYunRecordings(json);
    };
    /**
     * @param json
     * @returns {FollowupInfo}
     */
    this.buildFollowupInfo=function (json) {
        return new FollowupInfo(json);
    };
    /**
     * @param json
     * @returns {UnitResult}
     */
    this.buildUnitResult=function (json) {
        return new UnitResult(json);
    };
    /**
     * @param json
     * @returns {QuestionnairePieStatistics}
     */
    this.buildQuestionnairePieStatistics=function (json) {
        return new QuestionnairePieStatistics(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TodayFollowUpInfos}
     */
    this.buildHttpResult_TodayFollowUpInfos=function (json) {
        return new HttpResult_TodayFollowUpInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TFollowUpTaskResps}
     */
    this.buildHttpResult_TFollowUpTaskResps=function (json) {
        return new HttpResult_TFollowUpTaskResps(json);
    };
    /**
     * @param json
     * @returns {QualityControlToDoInfo}
     */
    this.buildQualityControlToDoInfo=function (json) {
        return new QualityControlToDoInfo(json);
    };
    /**
     * @param json
     * @returns {ConfirmInformation}
     */
    this.buildConfirmInformation=function (json) {
        return new ConfirmInformation(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallTaskSpotChecks}
     */
    this.buildHttpResult_CallTaskSpotChecks=function (json) {
        return new HttpResult_CallTaskSpotChecks(json);
    };
    /**
     * @param json
     * @returns {CallCenterQuestionOption}
     */
    this.buildCallCenterQuestionOption=function (json) {
        return new CallCenterQuestionOption(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallRecord}
     */
    this.buildHttpResult_CallRecord=function (json) {
        return new HttpResult_CallRecord(json);
    };
    /**
     * @param json
     * @returns {ReplyHistoryList}
     */
    this.buildReplyHistoryList=function (json) {
        return new ReplyHistoryList(json);
    };
    /**
     * @param json
     * @returns {FinishAndTodoInfo}
     */
    this.buildFinishAndTodoInfo=function (json) {
        return new FinishAndTodoInfo(json);
    };
    /**
     * @param json
     * @returns {CallFollowupQuestionnaire}
     */
    this.buildCallFollowupQuestionnaire=function (json) {
        return new CallFollowupQuestionnaire(json);
    };
    /**
     * @param json
     * @returns {ContactInfos}
     */
    this.buildContactInfos=function (json) {
        return new ContactInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_CallCenterFollowUpTaskTagNews}
     */
    this.buildHttpResult_CallCenterFollowUpTaskTagNews=function (json) {
        return new HttpResult_CallCenterFollowUpTaskTagNews(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowUpQualityControlResultInfos}
     */
    this.buildHttpResult_FollowUpQualityControlResultInfos=function (json) {
        return new HttpResult_FollowUpQualityControlResultInfos(json);
    };
    /**
     * @param json
     * @returns {HttpResult_SmsTemplates}
     */
    this.buildHttpResult_SmsTemplates=function (json) {
        return new HttpResult_SmsTemplates(json);
    };
    /**
     * @param json
     * @returns {DepartmentInfo}
     */
    this.buildDepartmentInfo=function (json) {
        return new DepartmentInfo(json);
    };
    /**
     * @param json
     * @returns {ReturnDealWithOption}
     */
    this.buildReturnDealWithOption=function (json) {
        return new ReturnDealWithOption(json);
    };
    /**
     * @param json
     * @returns {QuestionnaireMedicineStatisticDetailInfo}
     */
    this.buildQuestionnaireMedicineStatisticDetailInfo=function (json) {
        return new QuestionnaireMedicineStatisticDetailInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FileInfos}
     */
    this.buildHttpResult_FileInfos=function (json) {
        return new HttpResult_FileInfos(json);
    };
    /**
     * @param json
     * @returns {TaskStatisticsOfTaskId}
     */
    this.buildTaskStatisticsOfTaskId=function (json) {
        return new TaskStatisticsOfTaskId(json);
    };
    /**
     * @param json
     * @returns {FollowupTaskCurrentInfo}
     */
    this.buildFollowupTaskCurrentInfo=function (json) {
        return new FollowupTaskCurrentInfo(json);
    };
    /**
     * @param json
     * @returns {QuestionnaireMedicineStatisticInfo}
     */
    this.buildQuestionnaireMedicineStatisticInfo=function (json) {
        return new QuestionnaireMedicineStatisticInfo(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TTaskAndSmsRelationshipResps}
     */
    this.buildHttpResult_TTaskAndSmsRelationshipResps=function (json) {
        return new HttpResult_TTaskAndSmsRelationshipResps(json);
    };
    /**
     * @param json
     * @returns {HttpResult_TimeSectionStatisticsInfos}
     */
    this.buildHttpResult_TimeSectionStatisticsInfos=function (json) {
        return new HttpResult_TimeSectionStatisticsInfos(json);
    };
    /**
     * @param json
     * @returns {FinalMedicineStatisticsResultDetails}
     */
    this.buildFinalMedicineStatisticsResultDetails=function (json) {
        return new FinalMedicineStatisticsResultDetails(json);
    };
    /**
     * @param json
     * @returns {SmsTemplate}
     */
    this.buildSmsTemplate=function (json) {
        return new SmsTemplate(json);
    };
    /**
     * @param json
     * @returns {FollowUpQualityControlResultInfo}
     */
    this.buildFollowUpQualityControlResultInfo=function (json) {
        return new FollowUpQualityControlResultInfo(json);
    };
    /**
     * @param json
     * @returns {FeedbackPatientInformation}
     */
    this.buildFeedbackPatientInformation=function (json) {
        return new FeedbackPatientInformation(json);
    };
    /**
     * @param json
     * @returns {QuestionResultDetail}
     */
    this.buildQuestionResultDetail=function (json) {
        return new QuestionResultDetail(json);
    };
    /**
     * @param json
     * @returns {HttpResult_StringMaps}
     */
    this.buildHttpResult_StringMaps=function (json) {
        return new HttpResult_StringMaps(json);
    };
    /**
     * @param json
     * @returns {ConsultDoctorUser}
     */
    this.buildConsultDoctorUser=function (json) {
        return new ConsultDoctorUser(json);
    };
    /**
     * @param json
     * @returns {HttpResult_PatientPhoneNumbers}
     */
    this.buildHttpResult_PatientPhoneNumbers=function (json) {
        return new HttpResult_PatientPhoneNumbers(json);
    };
    /**
     * @param json
     * @returns {MissedCallResult}
     */
    this.buildMissedCallResult=function (json) {
        return new MissedCallResult(json);
    };
    /**
     * @param json
     * @returns {QualityTimeStage}
     */
    this.buildQualityTimeStage=function (json) {
        return new QualityTimeStage(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupInfos}
     */
    this.buildHttpResult_FollowupInfos=function (json) {
        return new HttpResult_FollowupInfos(json);
    };
    /**
     * @param json
     * @returns {FollowupReferenceInfo}
     */
    this.buildFollowupReferenceInfo=function (json) {
        return new FollowupReferenceInfo(json);
    };
    /**
     * @param json
     * @returns {TodayFollowUpInfo}
     */
    this.buildTodayFollowUpInfo=function (json) {
        return new TodayFollowUpInfo(json);
    };
    /**
     * @param json
     * @returns {CallPatientDetails}
     */
    this.buildCallPatientDetails=function (json) {
        return new CallPatientDetails(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowupPatientTags}
     */
    this.buildHttpResult_FollowupPatientTags=function (json) {
        return new HttpResult_FollowupPatientTags(json);
    };
    /**
     * @param json
     * @returns {ArticleIdAndTitle}
     */
    this.buildArticleIdAndTitle=function (json) {
        return new ArticleIdAndTitle(json);
    };
    /**
     * @param json
     * @returns {HttpResult_FollowUpTaskSwitchMark}
     */
    this.buildHttpResult_FollowUpTaskSwitchMark=function (json) {
        return new HttpResult_FollowUpTaskSwitchMark(json);
    };
}
/** HttpResult **/
function HttpResult_FollowupTaskPatientExceptionInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupTaskPatientExceptionInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupTaskPatientExceptionInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 选项和数目聚合 **/
function QuestionNumbersOptionsList(json=false){
    /**
     * 选项和数目
     * @type {Array.<QuestionNumbersOptions>}
     */
    this.questionNumbersOptions = build.buildArray(json&&(json.questionNumbersOptions!=null)?json.questionNumbersOptions:null,build.buildQuestionNumbersOptions);
}
/** 电话任务统计数 **/
function CallTaskStatistics(json=false){
    /**
     * 随访数
     * @type {Number}
     */
    this.followupNumber = build.buildNumber(json&&(json.followupNumber!=null)?json.followupNumber:null);
    /**
     * 通知数
     * @type {Number}
     */
    this.noticeNumber = build.buildNumber(json&&(json.noticeNumber!=null)?json.noticeNumber:null);
    /**
     * 回访数
     * @type {Number}
     */
    this.returnVisitNumber = build.buildNumber(json&&(json.returnVisitNumber!=null)?json.returnVisitNumber:null);
    /**
     * APP转电话随访数
     * @type {Number}
     */
    this.appTurnCallFollowupNumber = build.buildNumber(json&&(json.appTurnCallFollowupNumber!=null)?json.appTurnCallFollowupNumber:null);
    /**
     * 随访异常数
     * @type {Number}
     */
    this.followupAbnormalNumber = build.buildNumber(json&&(json.followupAbnormalNumber!=null)?json.followupAbnormalNumber:null);
    /**
     * 通知异常数
     * @type {Number}
     */
    this.noticeAbnormalNumber = build.buildNumber(json&&(json.noticeAbnormalNumber!=null)?json.noticeAbnormalNumber:null);
    /**
     * 回访异常数
     * @type {Number}
     */
    this.returnVisitAbnormalNumber = build.buildNumber(json&&(json.returnVisitAbnormalNumber!=null)?json.returnVisitAbnormalNumber:null);
    /**
     * APP转电话异常数
     * @type {Number}
     */
    this.appTurnCallFollowupAbnormalNumber = build.buildNumber(json&&(json.appTurnCallFollowupAbnormalNumber!=null)?json.appTurnCallFollowupAbnormalNumber:null);
    /**
     * 今日呼叫人数
     * @type {Number}
     */
    this.todayCallNumber = build.buildNumber(json&&(json.todayCallNumber!=null)?json.todayCallNumber:null);
    /**
     * 今日电话拨打次数
     * @type {Number}
     */
    this.todayTelephoneDialNumber = build.buildNumber(json&&(json.todayTelephoneDialNumber!=null)?json.todayTelephoneDialNumber:null);
    /**
     * 随访进行中任务数
     * @type {Number}
     */
    this.followupConductNumber = build.buildNumber(json&&(json.followupConductNumber!=null)?json.followupConductNumber:null);
    /**
     * 通知进行中任务数
     * @type {Number}
     */
    this.noticeConductNumber = build.buildNumber(json&&(json.noticeConductNumber!=null)?json.noticeConductNumber:null);
    /**
     * 回访进行中任务数
     * @type {Number}
     */
    this.returnVisitConductNumber = build.buildNumber(json&&(json.returnVisitConductNumber!=null)?json.returnVisitConductNumber:null);
    /**
     * APP转电话进行中任务数
     * @type {Number}
     */
    this.appTurnCallFollowupConductNumber = build.buildNumber(json&&(json.appTurnCallFollowupConductNumber!=null)?json.appTurnCallFollowupConductNumber:null);
    /**
     * 完成随访人数
     * @type {Number}
     */
    this.completeFollowupNumber = build.buildNumber(json&&(json.completeFollowupNumber!=null)?json.completeFollowupNumber:null);
    /**
     * 稍后拨打数
     * @type {Number}
     */
    this.callLaterNumber = build.buildNumber(json&&(json.callLaterNumber!=null)?json.callLaterNumber:null);
    /**
     * 重播数
     * @type {Number}
     */
    this.replayNumber = build.buildNumber(json&&(json.replayNumber!=null)?json.replayNumber:null);
}
/** 随访备注 **/
function FollowupTag(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 数据来源，1：呼叫台，2：管理台
     * @type {Number}
     */
    this.dataSource = build.buildNumber(json&&(json.dataSource!=null)?json.dataSource:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 坐席姓名
     * @type {String}
     */
    this.seatName = build.buildString(json&&(json.seatName!=null)?json.seatName:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.followupTaskId = build.buildNumber(json&&(json.followupTaskId!=null)?json.followupTaskId:null);
    /**
     * 备注
     * @type {String}
     */
    this.remark = build.buildString(json&&(json.remark!=null)?json.remark:null);
    /**
     * 备注类型：1随访备注，2我的（坐席）备注
     * @type {Number}
     */
    this.remarkType = build.buildNumber(json&&(json.remarkType!=null)?json.remarkType:null);
    /**
     * 是否删除:false否true是
     * @type {Boolean}
     */
    this.isDelete = build.buildBoolean(json&&(json.isDelete!=null)?json.isDelete:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 编辑时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 最后修改用户
     * @type {String}
     */
    this.lastUpdateUser = build.buildString(json&&(json.lastUpdateUser!=null)?json.lastUpdateUser:null);
    /**
     * 最后修改平台
     * @type {Number}
     */
    this.lastUpdatePlatform = build.buildNumber(json&&(json.lastUpdatePlatform!=null)?json.lastUpdatePlatform:null);
}
/** 联系方式内容 **/
function ContactInformationContent(json=false){
    /**
     * 联系方式key(和头的key对应)
     * @type {String}
     */
    this.contactKey = build.buildString(json&&(json.contactKey!=null)?json.contactKey:null);
    /**
     * 联系名
     * @type {String}
     */
    this.contactName = build.buildString(json&&(json.contactName!=null)?json.contactName:null);
    /**
     * 电话号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 联系人关系
     * @type {String}
     */
    this.relationshipRemarks = build.buildString(json&&(json.relationshipRemarks!=null)?json.relationshipRemarks:null);
    /**
     * 呼叫状态
     * @type {String}
     */
    this.lastCallState = build.buildString(json&&(json.lastCallState!=null)?json.lastCallState:null);
    /**
     * 呼叫状态优先级-合并取值先后顺序
     * @type {Number}
     */
    this.lastCallStateType = build.buildNumber(json&&(json.lastCallStateType!=null)?json.lastCallStateType:null);
    /**
     * 联系人姓名
     * @type {String}
     */
    this.contactPhoneName = build.buildString(json&&(json.contactPhoneName!=null)?json.contactPhoneName:null);
    /**
     * 数据来源
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 号码类型
     * @type {String}
     */
    this.phoneType = build.buildString(json&&(json.phoneType!=null)?json.phoneType:null);
    /**
     * 联系人等级
     * @type {String}
     */
    this.relationshipLevel = build.buildString(json&&(json.relationshipLevel!=null)?json.relationshipLevel:null);
    /**
     * 配合分数
     * @type {Number}
     */
    this.cooperateScore = build.buildNumber(json&&(json.cooperateScore!=null)?json.cooperateScore:null);
    /**
     * 最后联系状态
     * @type {String}
     */
    this.lastContactStatus = build.buildString(json&&(json.lastContactStatus!=null)?json.lastContactStatus:null);
    /**
     * 最后联系情况
     * @type {String}
     */
    this.lastContactInformation = build.buildString(json&&(json.lastContactInformation!=null)?json.lastContactInformation:null);
}
/** 任務統計 **/
function TaskStatisticsOfUserId(json=false){
    /**
     * 坐席
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * userIds
     * @type {Array.<Number>}
     */
    this.userIds = build.buildArray(json&&(json.userIds!=null)?json.userIds:null,build.buildNumber);
    /**
     * userId
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 任务id集合
     * @type {String}
     */
    this.taskIds = build.buildString(json&&(json.taskIds!=null)?json.taskIds:null);
    /**
     * 任务中心简单信息
     * @type {Array.<TaskCenterSimpleInfo>}
     */
    this.taskCenterSimpleInfos = build.buildArray(json&&(json.taskCenterSimpleInfos!=null)?json.taskCenterSimpleInfos:null,build.buildTaskCenterSimpleInfo);
    /**
     * 每日呼叫人数
     * @type {Number}
     */
    this.dayPeoples = build.buildNumber(json&&(json.dayPeoples!=null)?json.dayPeoples:null);
    /**
     * 成功率
     * @type {String}
     */
    this.successfulRate = build.buildString(json&&(json.successfulRate!=null)?json.successfulRate:null);
    /**
     * 稍后拨打
     * @type {Number}
     */
    this.callLater = build.buildNumber(json&&(json.callLater!=null)?json.callLater:null);
    /**
     * 成功数
     * @type {Number}
     */
    this.successNumber = build.buildNumber(json&&(json.successNumber!=null)?json.successNumber:null);
    /**
     * 停机数
     * @type {Number}
     */
    this.downtimeNumber = build.buildNumber(json&&(json.downtimeNumber!=null)?json.downtimeNumber:null);
    /**
     * 无人接听
     * @type {Number}
     */
    this.noBodyNumber = build.buildNumber(json&&(json.noBodyNumber!=null)?json.noBodyNumber:null);
    /**
     * 挂断
     * @type {Number}
     */
    this.hangUpNumber = build.buildNumber(json&&(json.hangUpNumber!=null)?json.hangUpNumber:null);
    /**
     * 拒聊
     * @type {Number}
     */
    this.refuseNumber = build.buildNumber(json&&(json.refuseNumber!=null)?json.refuseNumber:null);
    /**
     * 错号
     * @type {Number}
     */
    this.wrongNumber = build.buildNumber(json&&(json.wrongNumber!=null)?json.wrongNumber:null);
    /**
     * 空号
     * @type {Number}
     */
    this.emptyNumber = build.buildNumber(json&&(json.emptyNumber!=null)?json.emptyNumber:null);
    /**
     * 关机
     * @type {Number}
     */
    this.shutDownNumber = build.buildNumber(json&&(json.shutDownNumber!=null)?json.shutDownNumber:null);
    /**
     * 拒接
     * @type {Number}
     */
    this.refuseAcceptNumber = build.buildNumber(json&&(json.refuseAcceptNumber!=null)?json.refuseAcceptNumber:null);
}
/** 交付备注 **/
function FollowupDeliveryRemark(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.followupTaskId = build.buildNumber(json&&(json.followupTaskId!=null)?json.followupTaskId:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 坐席姓名
     * @type {String}
     */
    this.seatName = build.buildString(json&&(json.seatName!=null)?json.seatName:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 交付备注问题id
     * @type {Number}
     */
    this.deliveryQuestionId = build.buildNumber(json&&(json.deliveryQuestionId!=null)?json.deliveryQuestionId:null);
    /**
     * 交付备注答案
     * @type {String}
     */
    this.answerInfo = build.buildString(json&&(json.answerInfo!=null)?json.answerInfo:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 编辑时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 异常患者信息 **/
function FollowupTaskPatientExceptionInfo(json=false){
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访任务详情ID
     * @type {Number}
     */
    this.followUpPatientInfoId = build.buildNumber(json&&(json.followUpPatientInfoId!=null)?json.followUpPatientInfoId:null);
    /**
     * 姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 被叫号码
     * @type {String}
     */
    this.calledNumber = build.buildString(json&&(json.calledNumber!=null)?json.calledNumber:null);
    /**
     * 最后呼叫时间
     * @type {String}
     */
    this.followUpDate = build.buildString(json&&(json.followUpDate!=null)?json.followUpDate:null);
    /**
     * 预约时间
     * @type {String}
     */
    this.laterCallTime = build.buildString(json&&(json.laterCallTime!=null)?json.laterCallTime:null);
    /**
     * 已拨叫天数
     * @type {Number}
     */
    this.followUpDays = build.buildNumber(json&&(json.followUpDays!=null)?json.followUpDays:null);
    /**
     * 下标
     * @type {Number}
     */
    this.index = build.buildNumber(json&&(json.index!=null)?json.index:null);
    /**
     * 随访状态
     * @type {String}
     */
    this.followupStatus = build.buildString(json&&(json.followupStatus!=null)?json.followupStatus:null);
    /**
     * 标签分组
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 是否需复核
     * @type {Number}
     */
    this.isReview = build.buildNumber(json&&(json.isReview!=null)?json.isReview:null);
    /**
     * 需复核时间
     * @type {String}
     */
    this.reviewPoolTime = build.buildString(json&&(json.reviewPoolTime!=null)?json.reviewPoolTime:null);
}
/** 患者问卷答题功能Resp **/
function TPatientQuestionnaireAnswerResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * ** 随访患者表id（后台预览为-1）
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 新问卷表主键id
     * @type {Number}
     */
    this.questionnaireNewId = build.buildNumber(json&&(json.questionnaireNewId!=null)?json.questionnaireNewId:null);
    /**
     * 进行到哪一页
     * @type {Number}
     */
    this.pageNumber = build.buildNumber(json&&(json.pageNumber!=null)?json.pageNumber:null);
}
/** 任务坐席信息resp **/
function TFollowUpPeopleTaskResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 坐席表id
     * @type {Number}
     */
    this.callCenterUserId = build.buildNumber(json&&(json.callCenterUserId!=null)?json.callCenterUserId:null);
    /**
     * 坐席名称
     * @type {String}
     */
    this.callCenterUserName = build.buildString(json&&(json.callCenterUserName!=null)?json.callCenterUserName:null);
    /**
     * 坐席姓名
     * @type {String}
     */
    this.callCenterUserRealName = build.buildString(json&&(json.callCenterUserRealName!=null)?json.callCenterUserRealName:null);
    /**
     * 随访任务表id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 完成数量
     * @type {Number}
     */
    this.finishCount = build.buildNumber(json&&(json.finishCount!=null)?json.finishCount:null);
    /**
     * ** 是否开启 0-开启，1-关闭
     * @type {Number}
     */
    this.isOpen = build.buildNumber(json&&(json.isOpen!=null)?json.isOpen:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 质控完成量
     * @type {Number}
     */
    this.controlledCount = build.buildNumber(json&&(json.controlledCount!=null)?json.controlledCount:null);
    /**
     * 是否允许随访：0-不允许，1-允许
     * @type {Boolean}
     */
    this.isFollowup = build.buildBoolean(json&&(json.isFollowup!=null)?json.isFollowup:null);
    /**
     * 是否允许质控：0-不允许，1-允许
     * @type {Boolean}
     */
    this.isController = build.buildBoolean(json&&(json.isController!=null)?json.isController:null);
    /**
     * 是否允许学习：0-不允许，1-允许
     * @type {Boolean}
     */
    this.isStudy = build.buildBoolean(json&&(json.isStudy!=null)?json.isStudy:null);
    /**
     * 是否新手：false-0否 true-1是
     * @type {Boolean}
     */
    this.isNoviceProtection = build.buildBoolean(json&&(json.isNoviceProtection!=null)?json.isNoviceProtection:null);
    /**
     * 新手保护时间
     * @type {Number}
     */
    this.noviceProtectionTime = build.buildNumber(json&&(json.noviceProtectionTime!=null)?json.noviceProtectionTime:null);
    /**
     * 随访异常数量
     * @type {Number}
     */
    this.followupAbnormalNumber = build.buildNumber(json&&(json.followupAbnormalNumber!=null)?json.followupAbnormalNumber:null);
    /**
     * 稍后拨叫数量
     * @type {Number}
     */
    this.callLaterNumber = build.buildNumber(json&&(json.callLaterNumber!=null)?json.callLaterNumber:null);
    /**
     * 未参与天数
     * @type {Number}
     */
    this.notInvolvedDays = build.buildNumber(json&&(json.notInvolvedDays!=null)?json.notInvolvedDays:null);
    /**
     * 占用
     * @type {Number}
     */
    this.occupy = build.buildNumber(json&&(json.occupy!=null)?json.occupy:null);
    /**
     * 该任务坐席下的外呼号码
     * @type {String}
     */
    this.outGoingNumber = build.buildString(json&&(json.outGoingNumber!=null)?json.outGoingNumber:null);
    /**
     * 号码归属地
     * @type {String}
     */
    this.numberHome = build.buildString(json&&(json.numberHome!=null)?json.numberHome:null);
}
/** 最后的统计结果 **/
function FinalStatisticsResult(json=false){
    /**
     * 统计结果
     * @type {Array.<QuestionnaireScoreStatisticInfo>}
     */
    this.questionnaireScoreStatisticInfo = build.buildArray(json&&(json.questionnaireScoreStatisticInfo!=null)?json.questionnaireScoreStatisticInfo:null,build.buildQuestionnaireScoreStatisticInfo);
    /**
     * 横标题
     * @type {Array.<String>}
     */
    this.horizontalTitle = build.buildArray(json&&(json.horizontalTitle!=null)?json.horizontalTitle:null,build.buildString);
    /**
     * 平均分数
     * @type {Array.<ScoreAverageStatistics>}
     */
    this.scoreAverageStatistics = build.buildArray(json&&(json.scoreAverageStatistics!=null)?json.scoreAverageStatistics:null,build.buildScoreAverageStatistics);
}
/** HttpResult **/
function HttpResult_SeatIndexRanks(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SeatIndexRank>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSeatIndexRank);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 账户下的患者信息 **/
function ManagerPatientOfAccountInfo(json=false){
    /**
     * 患者账号
     * @type {Number}
     */
    this.uid = build.buildNumber(json&&(json.uid!=null)?json.uid:null);
    /**
     * 患者Id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 性别
     * @type {Number}
     */
    this.gender = build.buildNumber(json&&(json.gender!=null)?json.gender:null);
    /**
     * 最近一次住院記錄
     * @type {String}
     */
    this.latelyAdmitNo = build.buildString(json&&(json.latelyAdmitNo!=null)?json.latelyAdmitNo:null);
    /**
     * 出生日期
     * @type {String}
     */
    this.userBirth = build.buildString(json&&(json.userBirth!=null)?json.userBirth:null);
    /**
     * 年龄
     * @type {Number}
     */
    this.age = build.buildNumber(json&&(json.age!=null)?json.age:null);
    /**
     * 是否是默认随访人
     * @type {Boolean}
     */
    this.isFollowUp = build.buildBoolean(json&&(json.isFollowUp!=null)?json.isFollowUp:null);
    /**
     * 就诊报告
     * @type {Array.<InspectionReport>}
     */
    this.inspectionReports = build.buildArray(json&&(json.inspectionReports!=null)?json.inspectionReports:null,build.buildInspectionReport);
    /**
     * 就診信息
     * @type {ManagerPatientVisitingInfo}
     */
    this.managerPatientVisitingInfo = build.buildManagerPatientVisitingInfo(json&&(json.managerPatientVisitingInfo!=null)?json.managerPatientVisitingInfo:null);
}
/** 坐席质控的任务 **/
function SeatTaskInfo(json=false){
    /**
     * 任务ID
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 责任人
     * @type {String}
     */
    this.personInCharge = build.buildString(json&&(json.personInCharge!=null)?json.personInCharge:null);
    /**
     * 个人总抽查量
     * @type {String}
     */
    this.allCheckCount = build.buildString(json&&(json.allCheckCount!=null)?json.allCheckCount:null);
    /**
     * 今日抽查量
     * @type {String}
     */
    this.todayCheckCount = build.buildString(json&&(json.todayCheckCount!=null)?json.todayCheckCount:null);
    /**
     * 合格率
     * @type {String}
     */
    this.qualifiedRatio = build.buildString(json&&(json.qualifiedRatio!=null)?json.qualifiedRatio:null);
    /**
     * 总质控数
     * @type {String}
     */
    this.totalQualityCount = build.buildString(json&&(json.totalQualityCount!=null)?json.totalQualityCount:null);
    /**
     * 我的质控数
     * @type {String}
     */
    this.myQualityCount = build.buildString(json&&(json.myQualityCount!=null)?json.myQualityCount:null);
    /**
     * 今日质控数
     * @type {String}
     */
    this.todayQualityCount = build.buildString(json&&(json.todayQualityCount!=null)?json.todayQualityCount:null);
    /**
     * 质控合格率
     * @type {String}
     */
    this.qualitySuccessRatio = build.buildString(json&&(json.qualitySuccessRatio!=null)?json.qualitySuccessRatio:null);
    /**
     * 审核通过率
     * @type {String}
     */
    this.examineSuccessRatio = build.buildString(json&&(json.examineSuccessRatio!=null)?json.examineSuccessRatio:null);
}
/** 错题批注信息 **/
function MistakeAnnotationInfo(json=false){
    /**
     * 批注
     * @type {String}
     */
    this.annotation = build.buildString(json&&(json.annotation!=null)?json.annotation:null);
    /**
     * 随访患者详情id
     * @type {Number}
     */
    this.followUpPatientInfoId = build.buildNumber(json&&(json.followUpPatientInfoId!=null)?json.followUpPatientInfoId:null);
}
/** 用戶管理信息 **/
function UserManagerInfo(json=false){
    /**
     * 用戶Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 用戶名字
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 用戶账号
     * @type {String}
     */
    this.userAccountNumber = build.buildString(json&&(json.userAccountNumber!=null)?json.userAccountNumber:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 用户电话
     * @type {String}
     */
    this.userMobile = build.buildString(json&&(json.userMobile!=null)?json.userMobile:null);
    /**
     * 公司部门账号
     * @type {Number}
     */
    this.companyDeptId = build.buildNumber(json&&(json.companyDeptId!=null)?json.companyDeptId:null);
    /**
     * 公司部门职位
     * @type {String}
     */
    this.userPosition = build.buildString(json&&(json.userPosition!=null)?json.userPosition:null);
    /**
     * 邮箱
     * @type {String}
     */
    this.userEmail = build.buildString(json&&(json.userEmail!=null)?json.userEmail:null);
    /**
     * 最近的登錄時間
     * @type {String}
     */
    this.loginTime = build.buildString(json&&(json.loginTime!=null)?json.loginTime:null);
    /**
     * 状态 0 是不正常 1 是正常
     * @type {Boolean}
     */
    this.state = build.buildBoolean(json&&(json.state!=null)?json.state:null);
    /**
     * 权限Id
     * @type {Number}
     */
    this.roleId = build.buildNumber(json&&(json.roleId!=null)?json.roleId:null);
    /**
     * 角色名称
     * @type {String}
     */
    this.roleName = build.buildString(json&&(json.roleName!=null)?json.roleName:null);
    /**
     * 随访任务数量
     * @type {Number}
     */
    this.followupNumber = build.buildNumber(json&&(json.followupNumber!=null)?json.followupNumber:null);
    /**
     * 权限名称
     * @type {String}
     */
    this.roleExplain = build.buildString(json&&(json.roleExplain!=null)?json.roleExplain:null);
    /**
     * 用户Ip
     * @type {String}
     */
    this.userIp = build.buildString(json&&(json.userIp!=null)?json.userIp:null);
    /**
     * 是否自动绑定
     * @type {Boolean}
     */
    this.isAuto = build.buildBoolean(json&&(json.isAuto!=null)?json.isAuto:null);
    /**
     * 医院id
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室id
     * @type {Number}
     */
    this.departmentId = build.buildNumber(json&&(json.departmentId!=null)?json.departmentId:null);
    /**
     * 科室名称
     * @type {String}
     */
    this.hospitalDepartment = build.buildString(json&&(json.hospitalDepartment!=null)?json.hospitalDepartment:null);
    /**
     * 坐席数
     * @type {Number}
     */
    this.seatNumber = build.buildNumber(json&&(json.seatNumber!=null)?json.seatNumber:null);
    /**
     * 用户权限列表
     * @type {Array.<ModuleInfo>}
     */
    this.moduleInfoList = build.buildArray(json&&(json.moduleInfoList!=null)?json.moduleInfoList:null,build.buildModuleInfo);
    /**
     * 入职日期
     * @type {String}
     */
    this.dateOfEntry = build.buildString(json&&(json.dateOfEntry!=null)?json.dateOfEntry:null);
    /**
     * 用户擅长疾病id集合
     * @type {Array.<Number>}
     */
    this.diseaseIds = build.buildArray(json&&(json.diseaseIds!=null)?json.diseaseIds:null,build.buildNumber);
    /**
     * token
     * @type {String}
     */
    this.jwt = build.buildString(json&&(json.jwt!=null)?json.jwt:null);
    /**
     * 创建人姓名
     * @type {String}
     */
    this.createUserName = build.buildString(json&&(json.createUserName!=null)?json.createUserName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 数据导出权限：1不可导出  2可导出
     * @type {Number}
     */
    this.exportPurview = build.buildNumber(json&&(json.exportPurview!=null)?json.exportPurview:null);
}
/** 角色列表详细 **/
function ALiYunRoles(json=false){
    /**
     * 话务ID
     * @type {String}
     */
    this.instanceId = build.buildString(json&&(json.instanceId!=null)?json.instanceId:null);
    /**
     * 话务类型，参考枚举类型内呼, 外呼, 内部通话
     * @type {String}
     */
    this.roleId = build.buildString(json&&(json.roleId!=null)?json.roleId:null);
    /**
     * 坐席ID,坐席ID等同于该座席的RAM子账户ID
     * @type {String}
     */
    this.roleName = build.buildString(json&&(json.roleName!=null)?json.roleName:null);
    /**
     * 坐席名字
     * @type {String}
     */
    this.roleDescription = build.buildString(json&&(json.roleDescription!=null)?json.roleDescription:null);
}
/** HttpResult **/
function HttpResult_QuestionDetailInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<QuestionDetailInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildQuestionDetailInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 交付表KV **/
function FollowupInfoKV(json=false){
    /**
     * key
     * @type {String}
     */
    this.infoKey = build.buildString(json&&(json.infoKey!=null)?json.infoKey:null);
    /**
     * value
     * @type {String}
     */
    this.infoValue = build.buildString(json&&(json.infoValue!=null)?json.infoValue:null);
}
/** 随访组列表 **/
function FollowupGroupList(json=false){
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访组头像
     * @type {String}
     */
    this.groupImage = build.buildString(json&&(json.groupImage!=null)?json.groupImage:null);
    /**
     * 随访组名称
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 随访患者数量
     * @type {Number}
     */
    this.patientNum = build.buildNumber(json&&(json.patientNum!=null)?json.patientNum:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
}
/** 内容分类 **/
function NewQuestionnaireInfo(json=false){
    /**
     * 内容分类的Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 内容
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 科室Id
     * @type {Number}
     */
    this.deptId = build.buildNumber(json&&(json.deptId!=null)?json.deptId:null);
    /**
     * 医院Id
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 发布状态
     * @type {Number}
     */
    this.publishStatus = build.buildNumber(json&&(json.publishStatus!=null)?json.publishStatus:null);
    /**
     * 科室
     * @type {String}
     */
    this.deptName = build.buildString(json&&(json.deptName!=null)?json.deptName:null);
    /**
     * 医院
     * @type {String}
     */
    this.hospital = build.buildString(json&&(json.hospital!=null)?json.hospital:null);
    /**
     * 问卷题目
     * @type {String}
     */
    this.questionnaireTitle = build.buildString(json&&(json.questionnaireTitle!=null)?json.questionnaireTitle:null);
    /**
     * 问卷类型
     * @type {Number}
     */
    this.questionnaireKind = build.buildNumber(json&&(json.questionnaireKind!=null)?json.questionnaireKind:null);
    /**
     * 疾病Id
     * @type {Number}
     */
    this.diseaseId = build.buildNumber(json&&(json.diseaseId!=null)?json.diseaseId:null);
    /**
     * 疾病名字
     * @type {String}
     */
    this.diseaseName = build.buildString(json&&(json.diseaseName!=null)?json.diseaseName:null);
    /**
     * 模板解释
     * @type {String}
     */
    this.moduleExplain = build.buildString(json&&(json.moduleExplain!=null)?json.moduleExplain:null);
    /**
     * 问卷描述
     * @type {String}
     */
    this.questionnaireDesc = build.buildString(json&&(json.questionnaireDesc!=null)?json.questionnaireDesc:null);
    /**
     * 提交时间
     * @type {String}
     */
    this.summitTime = build.buildString(json&&(json.summitTime!=null)?json.summitTime:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 操作人
     * @type {Number}
     */
    this.operator = build.buildNumber(json&&(json.operator!=null)?json.operator:null);
    /**
     * 填写的分数
     * @type {Number}
     */
    this.fillInCount = build.buildNumber(json&&(json.fillInCount!=null)?json.fillInCount:null);
    /**
     * 是否統計
     * @type {Boolean}
     */
    this.isStatistics = build.buildBoolean(json&&(json.isStatistics!=null)?json.isStatistics:null);
    /**
     * 期限
     * @type {Number}
     */
    this.term = build.buildNumber(json&&(json.term!=null)?json.term:null);
    /**
     * 评分规则配置JSON
     * @type {String}
     */
    this.ruleRating = build.buildString(json&&(json.ruleRating!=null)?json.ruleRating:null);
    /**
     * 问卷背景图片
     * @type {String}
     */
    this.backImageUrl = build.buildString(json&&(json.backImageUrl!=null)?json.backImageUrl:null);
}
/** 首页推荐的keyword **/
function AllRecommendKey(json=false){
    /**
     * 文章key
     * @type {String}
     */
    this.article = build.buildString(json&&(json.article!=null)?json.article:null);
    /**
     * 医生key
     * @type {String}
     */
    this.doctor = build.buildString(json&&(json.doctor!=null)?json.doctor:null);
    /**
     * 问答key
     * @type {String}
     */
    this.problem = build.buildString(json&&(json.problem!=null)?json.problem:null);
}
/** 管理台患者信息 **/
function ManagerPatientDetail(json=false){
    /**
     * 患者账号
     * @type {Number}
     */
    this.uid = build.buildNumber(json&&(json.uid!=null)?json.uid:null);
    /**
     * 患者电话号码
     * @type {String}
     */
    this.mobile = build.buildString(json&&(json.mobile!=null)?json.mobile:null);
    /**
     * 默认随访人名字
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 随访人Id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 登录信息
     * @type {String}
     */
    this.loginInfo = build.buildString(json&&(json.loginInfo!=null)?json.loginInfo:null);
    /**
     * 登录时间
     * @type {String}
     */
    this.loginTime = build.buildString(json&&(json.loginTime!=null)?json.loginTime:null);
    /**
     * 是否解冻
     * @type {Boolean}
     */
    this.isEnable = build.buildBoolean(json&&(json.isEnable!=null)?json.isEnable:null);
    /**
     * 用户账号名称
     * @type {String}
     */
    this.userAccountName = build.buildString(json&&(json.userAccountName!=null)?json.userAccountName:null);
    /**
     * 用户昵称
     * @type {String}
     */
    this.userNickname = build.buildString(json&&(json.userNickname!=null)?json.userNickname:null);
    /**
     * 登录平台
     * @type {String}
     */
    this.loginPlatform = build.buildString(json&&(json.loginPlatform!=null)?json.loginPlatform:null);
    /**
     * 用户积分
     * @type {Number}
     */
    this.userPoints = build.buildNumber(json&&(json.userPoints!=null)?json.userPoints:null);
}
/** 就诊详细 **/
function MedicalRecordDetailed(json=false){
    /**
     * ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 就诊流水号
     * @type {String}
     */
    this.visitingNo = build.buildString(json&&(json.visitingNo!=null)?json.visitingNo:null);
    /**
     * 就诊类型 0门诊 1住院 2体检
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
    /**
     * 报告来源 1同步更新 2手动上传
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 医院ID
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 就诊日期（格式：yyyy-MM-dd）
     * @type {String}
     */
    this.visitingDate = build.buildString(json&&(json.visitingDate!=null)?json.visitingDate:null);
    /**
     * 出院时间（格式：yyyy-MM-dd）
     * @type {String}
     */
    this.dischargeTime = build.buildString(json&&(json.dischargeTime!=null)?json.dischargeTime:null);
    /**
     * 入院時間
     * @type {String}
     */
    this.admissionTime = build.buildString(json&&(json.admissionTime!=null)?json.admissionTime:null);
    /**
     * 手术时间（格式：yyyy-MM-dd）
     * @type {String}
     */
    this.surgeryTime = build.buildString(json&&(json.surgeryTime!=null)?json.surgeryTime:null);
    /**
     * 就诊科室ID
     * @type {Number}
     */
    this.departmentId = build.buildNumber(json&&(json.departmentId!=null)?json.departmentId:null);
    /**
     * 就诊科室名称
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 主诊医生姓名
     * @type {String}
     */
    this.primaryPhysicianName = build.buildString(json&&(json.primaryPhysicianName!=null)?json.primaryPhysicianName:null);
    /**
     * 诊断名
     * @type {String}
     */
    this.diagnosisName = build.buildString(json&&(json.diagnosisName!=null)?json.diagnosisName:null);
    /**
     * 入院报告记录
     * @type {String}
     */
    this.admissionRecord = build.buildString(json&&(json.admissionRecord!=null)?json.admissionRecord:null);
    /**
     * 出院小结
     * @type {String}
     */
    this.dischargeRecord = build.buildString(json&&(json.dischargeRecord!=null)?json.dischargeRecord:null);
    /**
     * 手术报告记录
     * @type {String}
     */
    this.operationRecord = build.buildString(json&&(json.operationRecord!=null)?json.operationRecord:null);
    /**
     * 出院小结图片
     * @type {String}
     */
    this.dischargeRecordImg = build.buildString(json&&(json.dischargeRecordImg!=null)?json.dischargeRecordImg:null);
    /**
     * 医嘱
     * @type {String}
     */
    this.doctorAdvice = build.buildString(json&&(json.doctorAdvice!=null)?json.doctorAdvice:null);
    /**
     * 手术记录图
     * @type {String}
     */
    this.surgeryRecordImg = build.buildString(json&&(json.surgeryRecordImg!=null)?json.surgeryRecordImg:null);
    /**
     * 手术记录列表
     * @type {Array.<MedicalSurgeryRecord>}
     */
    this.medicalSurgeryRecords = build.buildArray(json&&(json.medicalSurgeryRecords!=null)?json.medicalSurgeryRecords:null,build.buildMedicalSurgeryRecord);
    /**
     * 是否有报告
     * @type {Boolean}
     */
    this.isReport = build.buildBoolean(json&&(json.isReport!=null)?json.isReport:null);
    /**
     * 上一条
     * @type {SwitchBar}
     */
    this.theLastOne = build.buildSwitchBar(json&&(json.theLastOne!=null)?json.theLastOne:null);
    /**
     * 下一条
     * @type {SwitchBar}
     */
    this.nextItem = build.buildSwitchBar(json&&(json.nextItem!=null)?json.nextItem:null);
    /**
     * 报告列表
     * @type {Array.<InspectionReport>}
     */
    this.reports = build.buildArray(json&&(json.reports!=null)?json.reports:null,build.buildInspectionReport);
}
/** 随访任务患者呼叫记录 **/
function FollowUpTaskPatientCallRecord(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 手机号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 号码关系备注
     * @type {String}
     */
    this.relationshipRemarks = build.buildString(json&&(json.relationshipRemarks!=null)?json.relationshipRemarks:null);
    /**
     * 呼叫时间
     * @type {String}
     */
    this.callTime = build.buildString(json&&(json.callTime!=null)?json.callTime:null);
    /**
     * 呼叫状态
     * @type {Number}
     */
    this.callState = build.buildNumber(json&&(json.callState!=null)?json.callState:null);
    /**
     * 阿里云录音ID
     * @type {String}
     */
    this.contactId = build.buildString(json&&(json.contactId!=null)?json.contactId:null);
    /**
     * 阿里云录音时长
     * @type {String}
     */
    this.contactTime = build.buildString(json&&(json.contactTime!=null)?json.contactTime:null);
    /**
     * 呼叫坐席id
     * @type {Number}
     */
    this.callSeatId = build.buildNumber(json&&(json.callSeatId!=null)?json.callSeatId:null);
    /**
     * 呼叫坐席名称
     * @type {String}
     */
    this.callSeatName = build.buildString(json&&(json.callSeatName!=null)?json.callSeatName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 是否有效
     * @type {Boolean}
     */
    this.isEffective = build.buildBoolean(json&&(json.isEffective!=null)?json.isEffective:null);
}
/** HttpResult **/
function HttpResult_NewMessageMangerInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {NewMessageMangerInfo}
     */
    this.retValue = build.buildNewMessageMangerInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 任务标签 **/
function TaskTag(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 标签id
     * @type {Number}
     */
    this.tagId = build.buildNumber(json&&(json.tagId!=null)?json.tagId:null);
    /**
     * 标签名
     * @type {String}
     */
    this.tagName = build.buildString(json&&(json.tagName!=null)?json.tagName:null);
    /**
     * 分组：1基础标签，2任务标签，3特殊标签
     * @type {Number}
     */
    this.group = build.buildNumber(json&&(json.group!=null)?json.group:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 操作人姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 操作人账号
     * @type {String}
     */
    this.userAccount = build.buildString(json&&(json.userAccount!=null)?json.userAccount:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 编辑时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 绑定患者数
     * @type {Number}
     */
    this.count = build.buildNumber(json&&(json.count!=null)?json.count:null);
}
/** 坐席用户Info **/
function SeatUserInfos(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * name
     * @type {String}
     */
    this.name = build.buildString(json&&(json.name!=null)?json.name:null);
    /**
     * 分类
     * @type {String}
     */
    this.sort = build.buildString(json&&(json.sort!=null)?json.sort:null);
    /**
     * 姓名
     * @type {String}
     */
    this.realName = build.buildString(json&&(json.realName!=null)?json.realName:null);
}
/** HttpResult **/
function HttpResult_CallCenterJumpParams(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {CallCenterJumpParams}
     */
    this.retValue = build.buildCallCenterJumpParams(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 交付备注问题 **/
function FollowupDeliveryQuestion(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.followupTaskId = build.buildNumber(json&&(json.followupTaskId!=null)?json.followupTaskId:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 序号
     * @type {Number}
     */
    this.serialNumber = build.buildNumber(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * 选项信息
     * @type {String}
     */
    this.optionInfo = build.buildString(json&&(json.optionInfo!=null)?json.optionInfo:null);
    /**
     * 备注问题类型：1单选2问答3日期4地理位置
     * @type {Number}
     */
    this.questionType = build.buildNumber(json&&(json.questionType!=null)?json.questionType:null);
    /**
     * 备注问题类型
     * @type {String}
     */
    this.remarkTypeStr = build.buildString(json&&(json.remarkTypeStr!=null)?json.remarkTypeStr:null);
    /**
     * 备注问题类型选择 时间（1年月日时分，2年月日，3年月，4时分）；地理（5省市，6省市区，7省市区街道，8省市区街道+详细地址)
     * @type {Number}
     */
    this.selectType = build.buildNumber(json&&(json.selectType!=null)?json.selectType:null);
    /**
     * 备注问题类型选择
     * @type {String}
     */
    this.selectTypeStr = build.buildString(json&&(json.selectTypeStr!=null)?json.selectTypeStr:null);
    /**
     * 题目内容
     * @type {String}
     */
    this.questionTitle = build.buildString(json&&(json.questionTitle!=null)?json.questionTitle:null);
    /**
     * 导出表头
     * @type {String}
     */
    this.exportName = build.buildString(json&&(json.exportName!=null)?json.exportName:null);
    /**
     * 数据验证信息json
     * @type {String}
     */
    this.dataVerification = build.buildString(json&&(json.dataVerification!=null)?json.dataVerification:null);
    /**
     * 数据验证信息
     * @type {String}
     */
    this.dataVerificationStr = build.buildString(json&&(json.dataVerificationStr!=null)?json.dataVerificationStr:null);
    /**
     * 问题描述
     * @type {String}
     */
    this.questionDescription = build.buildString(json&&(json.questionDescription!=null)?json.questionDescription:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 编辑时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 交付备注答案
     * @type {FollowupDeliveryRemark}
     */
    this.followupDeliveryRemark = build.buildFollowupDeliveryRemark(json&&(json.followupDeliveryRemark!=null)?json.followupDeliveryRemark:null);
}
/** 手机号码关系 **/
function PhoneNumbersRelationship(json=false){
    /**
     * 手机号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 关系ID
     * @type {Number}
     */
    this.relationshipId = build.buildNumber(json&&(json.relationshipId!=null)?json.relationshipId:null);
    /**
     * 关系名称
     * @type {String}
     */
    this.relationshipName = build.buildString(json&&(json.relationshipName!=null)?json.relationshipName:null);
    /**
     * 关系备注
     * @type {String}
     */
    this.relationshipRemarks = build.buildString(json&&(json.relationshipRemarks!=null)?json.relationshipRemarks:null);
}
/** HttpResult **/
function HttpResult_FollowupReferenceInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowupReferenceInfo}
     */
    this.retValue = build.buildFollowupReferenceInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 电话的通话记录 **/
function PhoneRecordInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 通话id
     * @type {String}
     */
    this.contactId = build.buildString(json&&(json.contactId!=null)?json.contactId:null);
    /**
     * 呼叫状态
     * @type {Number}
     */
    this.callState = build.buildNumber(json&&(json.callState!=null)?json.callState:null);
    /**
     * 电话号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 有无录音
     * @type {Boolean}
     */
    this.isRecording = build.buildBoolean(json&&(json.isRecording!=null)?json.isRecording:null);
    /**
     * 录音地址
     * @type {String}
     */
    this.recording = build.buildString(json&&(json.recording!=null)?json.recording:null);
    /**
     * 分割点
     * @type {String}
     */
    this.splitPoint = build.buildString(json&&(json.splitPoint!=null)?json.splitPoint:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 坐席姓名
     * @type {String}
     */
    this.seatName = build.buildString(json&&(json.seatName!=null)?json.seatName:null);
    /**
     * 联系状态
     * @type {Number}
     */
    this.contactStatus = build.buildNumber(json&&(json.contactStatus!=null)?json.contactStatus:null);
    /**
     * 联系情况
     * @type {Number}
     */
    this.contactInformation = build.buildNumber(json&&(json.contactInformation!=null)?json.contactInformation:null);
}
/** 推送录音信息 **/
function BestRecordInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 案例id
     * @type {Number}
     */
    this.caseId = build.buildNumber(json&&(json.caseId!=null)?json.caseId:null);
    /**
     * 录音id
     * @type {String}
     */
    this.contactId = build.buildString(json&&(json.contactId!=null)?json.contactId:null);
    /**
     * 录音名
     * @type {String}
     */
    this.recordName = build.buildString(json&&(json.recordName!=null)?json.recordName:null);
    /**
     * 阿里云录音地址
     * @type {String}
     */
    this.contactAddress = build.buildString(json&&(json.contactAddress!=null)?json.contactAddress:null);
    /**
     * 推荐时间段
     * @type {String}
     */
    this.timePeriod = build.buildString(json&&(json.timePeriod!=null)?json.timePeriod:null);
}
/** 题目选项 **/
function QuestionOpt(json=false){
    /**
     * 选项ID
     * @type {Number}
     */
    this.optionId = build.buildNumber(json&&(json.optionId!=null)?json.optionId:null);
    /**
     * 选项类型
     * @type {Number}
     */
    this.optionType = build.buildNumber(json&&(json.optionType!=null)?json.optionType:null);
    /**
     * 选项关联题目ID
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 选项图片
     * @type {String}
     */
    this.optionImage = build.buildString(json&&(json.optionImage!=null)?json.optionImage:null);
    /**
     * 选项评分
     * @type {String}
     */
    this.score = build.buildString(json&&(json.score!=null)?json.score:null);
    /**
     * 1.允许加文本框  2.不允许加文本框
     * @type {Number}
     */
    this.allowFill = build.buildNumber(json&&(json.allowFill!=null)?json.allowFill:null);
    /**
     * 选项内容
     * @type {String}
     */
    this.optionString = build.buildString(json&&(json.optionString!=null)?json.optionString:null);
    /**
     * 绑定问题ID
     * @type {String}
     */
    this.optionBoundId = build.buildString(json&&(json.optionBoundId!=null)?json.optionBoundId:null);
    /**
     * 绑定问题ID（-1跳到最后一题）
     * @type {Number}
     */
    this.optionJumpId = build.buildNumber(json&&(json.optionJumpId!=null)?json.optionJumpId:null);
    /**
     * 1.已选中  2.未选中
     * @type {Number}
     */
    this.isSelect = build.buildNumber(json&&(json.isSelect!=null)?json.isSelect:null);
    /**
     * 选项额外文本
     * @type {String}
     */
    this.optionExtraText = build.buildString(json&&(json.optionExtraText!=null)?json.optionExtraText:null);
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
}
/** HttpResult **/
function HttpResult_ConfirmInformation(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {ConfirmInformation}
     */
    this.retValue = build.buildConfirmInformation(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 今日随访数量 **/
function TodayFollowUpCount(json=false){
    /**
     * 随访日期
     * @type {String}
     */
    this.followupDate = build.buildString(json&&(json.followupDate!=null)?json.followupDate:null);
    /**
     * 完成随访人数
     * @type {Number}
     */
    this.success = build.buildNumber(json&&(json.success!=null)?json.success:null);
    /**
     * 失访人数
     * @type {Number}
     */
    this.lost = build.buildNumber(json&&(json.lost!=null)?json.lost:null);
    /**
     * 拒随人数
     * @type {Number}
     */
    this.refuse = build.buildNumber(json&&(json.refuse!=null)?json.refuse:null);
}
/** 数值类型配置信息 **/
function NumericTypeConfigInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 问卷id
     * @type {Number}
     */
    this.questionnaireId = build.buildNumber(json&&(json.questionnaireId!=null)?json.questionnaireId:null);
    /**
     * 问题id
     * @type {Number}
     */
    this.questionInfoId = build.buildNumber(json&&(json.questionInfoId!=null)?json.questionInfoId:null);
    /**
     * 数值类型：1时间点、2数值类
     * @type {Number}
     */
    this.numericType = build.buildNumber(json&&(json.numericType!=null)?json.numericType:null);
    /**
     * 取值规则：1最大值、2最小值、3中间值
     * @type {Number}
     */
    this.valueRule = build.buildNumber(json&&(json.valueRule!=null)?json.valueRule:null);
    /**
     * 是否打开其他答案
     * @type {Boolean}
     */
    this.isOpenOther = build.buildBoolean(json&&(json.isOpenOther!=null)?json.isOpenOther:null);
    /**
     * 单位类型
     * @type {String}
     */
    this.unitType = build.buildString(json&&(json.unitType!=null)?json.unitType:null);
    /**
     * 是否开启频率
     * @type {Boolean}
     */
    this.isOpenFrequency = build.buildBoolean(json&&(json.isOpenFrequency!=null)?json.isOpenFrequency:null);
    /**
     * 频率类型：1每天、2每周、3每月、4每年
     * @type {Number}
     */
    this.frequencyType = build.buildNumber(json&&(json.frequencyType!=null)?json.frequencyType:null);
    /**
     * 是否时间类型
     * @type {Boolean}
     */
    this.isTimeType = build.buildBoolean(json&&(json.isTimeType!=null)?json.isTimeType:null);
    /**
     * 归类设置
     * @type {String}
     */
    this.classifyConfig = build.buildString(json&&(json.classifyConfig!=null)?json.classifyConfig:null);
    /**
     * 是否原始答案
     * @type {Boolean}
     */
    this.isSourceAnswer = build.buildBoolean(json&&(json.isSourceAnswer!=null)?json.isSourceAnswer:null);
    /**
     * 是否标化答案
     * @type {Boolean}
     */
    this.isStandardAnswer = build.buildBoolean(json&&(json.isStandardAnswer!=null)?json.isStandardAnswer:null);
    /**
     * 是否库显数据
     * @type {Boolean}
     */
    this.isDisplayAnswer = build.buildBoolean(json&&(json.isDisplayAnswer!=null)?json.isDisplayAnswer:null);
    /**
     * 原始表头
     * @type {String}
     */
    this.sourceTitle = build.buildString(json&&(json.sourceTitle!=null)?json.sourceTitle:null);
    /**
     * 标化表头
     * @type {String}
     */
    this.standardTitle = build.buildString(json&&(json.standardTitle!=null)?json.standardTitle:null);
    /**
     * 库显表头
     * @type {String}
     */
    this.displayTitle = build.buildString(json&&(json.displayTitle!=null)?json.displayTitle:null);
}
/** HttpResult **/
function HttpResult_FollowupTaskStatisticsInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowupTaskStatisticsInfo}
     */
    this.retValue = build.buildFollowupTaskStatisticsInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 患者所有历史随访 **/
function PatientAllFollowupList(json=false){
    /**
     * 任务ID
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 随访状态
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 是否质控
     * @type {Boolean}
     */
    this.isQuality = build.buildBoolean(json&&(json.isQuality!=null)?json.isQuality:null);
}
/** 坐席错题信息 **/
function SeatMistakeInfo(json=false){
    /**
     * 页码
     * @type {Number}
     */
    this.pageNumber = build.buildNumber(json&&(json.pageNumber!=null)?json.pageNumber:null);
    /**
     * 页码备注
     * @type {String}
     */
    this.pageRemark = build.buildString(json&&(json.pageRemark!=null)?json.pageRemark:null);
    /**
     * 题目序号
     * @type {Number}
     */
    this.serialNumber = build.buildNumber(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * 问题题目
     * @type {String}
     */
    this.questionTitle = build.buildString(json&&(json.questionTitle!=null)?json.questionTitle:null);
    /**
     * 错题次数
     * @type {Number}
     */
    this.mistakeNumber = build.buildNumber(json&&(json.mistakeNumber!=null)?json.mistakeNumber:null);
    /**
     * 错题趋势
     * @type {Number}
     */
    this.mistakeTrend = build.buildNumber(json&&(json.mistakeTrend!=null)?json.mistakeTrend:null);
    /**
     * 批注
     * @type {Array.<MistakeAnnotationInfo>}
     */
    this.annotations = build.buildArray(json&&(json.annotations!=null)?json.annotations:null,build.buildMistakeAnnotationInfo);
}
/** 题目详情信息 **/
function QuestionDetailInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * t_questionnaire_new表id
     * @type {Number}
     */
    this.questionnaireNewId = build.buildNumber(json&&(json.questionnaireNewId!=null)?json.questionnaireNewId:null);
    /**
     * 题目序号
     * @type {Number}
     */
    this.serialNumber = build.buildNumber(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * ** 缓存本题设置的跳转逻辑 此题选择什么跳转哪一题
     * @type {String}
     */
    this.jumpNumber = build.buildString(json&&(json.jumpNumber!=null)?json.jumpNumber:null);
    /**
     * ** 缓存本题设置的显示逻辑 此题选择什么显示哪一题
     * @type {String}
     */
    this.displayNumber = build.buildString(json&&(json.displayNumber!=null)?json.displayNumber:null);
    /**
     * ** 跳转配置页面显示第几题第几项跳转此题
     * @type {String}
     */
    this.jumpConfig = build.buildString(json&&(json.jumpConfig!=null)?json.jumpConfig:null);
    /**
     * 显示配置显示第几题第几项选择跳转此题
     * @type {String}
     */
    this.displayConfig = build.buildString(json&&(json.displayConfig!=null)?json.displayConfig:null);
    /**
     * ** 选项布局 1：1列 2：2列 3：3列
     * @type {Number}
     */
    this.optionLayout = build.buildNumber(json&&(json.optionLayout!=null)?json.optionLayout:null);
    /**
     * ** (前端已经定义就不修改)疾病分组id
     * @type {Number}
     */
    this.warehousingGroup = build.buildNumber(json&&(json.warehousingGroup!=null)?json.warehousingGroup:null);
    /**
     * ** (前端已经定义就不修改)疾病字段id
     * @type {Number}
     */
    this.warehousingMatchingField = build.buildNumber(json&&(json.warehousingMatchingField!=null)?json.warehousingMatchingField:null);
    /**
     * ** (前端已定义布尔值)是否显示 1-不显示，2-显示
     * @type {Number}
     */
    this.seqDisabled = build.buildNumber(json&&(json.seqDisabled!=null)?json.seqDisabled:null);
    /**
     * ** (前端已定义布尔值)是否显示 1-不是首次，2-是首次
     * @type {Number}
     */
    this.isFirst = build.buildNumber(json&&(json.isFirst!=null)?json.isFirst:null);
    /**
     * ** (前端已定义布尔值)1: YYYY/MM/DD 2: YYYY-MM-DD 3:YYYY年MM月DD日
     * @type {Number}
     */
    this.dateType = build.buildNumber(json&&(json.dateType!=null)?json.dateType:null);
    /**
     * ** 多个时间连接字段
     * @type {String}
     */
    this.linkWord = build.buildString(json&&(json.linkWord!=null)?json.linkWord:null);
    /**
     * ** (前端已定义布尔值)是否是时间周期 1-不是，2-是
     * @type {Number}
     */
    this.dateCycle = build.buildNumber(json&&(json.dateCycle!=null)?json.dateCycle:null);
    /**
     * ** 填空题的配置
     * @type {String}
     */
    this.completeConfig = build.buildString(json&&(json.completeConfig!=null)?json.completeConfig:null);
    /**
     * 文本1 文本2 输入类型 填空字符长度
     * @type {String}
     */
    this.completeTextArr = build.buildString(json&&(json.completeTextArr!=null)?json.completeTextArr:null);
    /**
     * ** 段落题的配置
     * @type {String}
     */
    this.paragraphConfig = build.buildString(json&&(json.paragraphConfig!=null)?json.paragraphConfig:null);
    /**
     * ** (前端已定义布尔值)用于控制管理台的高亮显示 1-不，2-是
     * @type {Number}
     */
    this.manangerActive = build.buildNumber(json&&(json.manangerActive!=null)?json.manangerActive:null);
    /**
     * ** 问题类型1：单选 2：多选 3：下拉 4：填空 5：多项填空 6：段落说明
     * @type {Number}
     */
    this.type = build.buildNumber(json&&(json.type!=null)?json.type:null);
    /**
     * 问题标题
     * @type {String}
     */
    this.title = build.buildString(json&&(json.title!=null)?json.title:null);
    /**
     * ** (前端已定义布尔值)是否必填 1-不是，2-是
     * @type {Number}
     */
    this.isMust = build.buildNumber(json&&(json.isMust!=null)?json.isMust:null);
    /**
     * ** (前端已定义布尔值)是否显示 1-不是，2-是
     * @type {Number}
     */
    this.isShow = build.buildNumber(json&&(json.isShow!=null)?json.isShow:null);
    /**
     * ** 最大选项
     * @type {Number}
     */
    this.maxOption = build.buildNumber(json&&(json.maxOption!=null)?json.maxOption:null);
    /**
     * ** 最小选项
     * @type {Number}
     */
    this.minOption = build.buildNumber(json&&(json.minOption!=null)?json.minOption:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 操作人姓名
     * @type {String}
     */
    this.operatorName = build.buildString(json&&(json.operatorName!=null)?json.operatorName:null);
    /**
     * ** 是否开启 0-开启，1-未开启
     * @type {Number}
     */
    this.isOpen = build.buildNumber(json&&(json.isOpen!=null)?json.isOpen:null);
    /**
     * ** 是否删除 0-未删除，1-已删除
     * @type {Number}
     */
    this.isDelete = build.buildNumber(json&&(json.isDelete!=null)?json.isDelete:null);
    /**
     * 页码表id
     * @type {Number}
     */
    this.questionPageid = build.buildNumber(json&&(json.questionPageid!=null)?json.questionPageid:null);
    /**
     * 页码
     * @type {Number}
     */
    this.pageNumber = build.buildNumber(json&&(json.pageNumber!=null)?json.pageNumber:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 页码备注
     * @type {String}
     */
    this.pageRemark = build.buildString(json&&(json.pageRemark!=null)?json.pageRemark:null);
    /**
     * 选项信息
     * @type {Array.<TOptionsInfoResp>}
     */
    this.optionsInfoRespList = build.buildArray(json&&(json.optionsInfoRespList!=null)?json.optionsInfoRespList:null,build.buildTOptionsInfoResp);
    /**
     * 答案信息
     * @type {String}
     */
    this.answerInfo = build.buildString(json&&(json.answerInfo!=null)?json.answerInfo:null);
    /**
     * 患者答题信息表id
     * @type {Number}
     */
    this.patientAnswerInfoId = build.buildNumber(json&&(json.patientAnswerInfoId!=null)?json.patientAnswerInfoId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 排他配置
     * @type {String}
     */
    this.exclusiveConfig = build.buildString(json&&(json.exclusiveConfig!=null)?json.exclusiveConfig:null);
    /**
     * 量标题配置
     * @type {String}
     */
    this.scaleConfig = build.buildString(json&&(json.scaleConfig!=null)?json.scaleConfig:null);
    /**
     * 题干图片url
     * @type {String}
     */
    this.pictureUrl = build.buildString(json&&(json.pictureUrl!=null)?json.pictureUrl:null);
    /**
     * 说明
     * @type {String}
     */
    this.note = build.buildString(json&&(json.note!=null)?json.note:null);
    /**
     * 是否开启时间：0-否 ,1-是
     * @type {Boolean}
     */
    this.isTime = build.buildBoolean(json&&(json.isTime!=null)?json.isTime:null);
    /**
     * 时间逻辑，绑定该题的那些题目的id
     * @type {String}
     */
    this.bingTimeId = build.buildString(json&&(json.bingTimeId!=null)?json.bingTimeId:null);
    /**
     * 时间逻辑
     * @type {String}
     */
    this.timeConfigArr = build.buildString(json&&(json.timeConfigArr!=null)?json.timeConfigArr:null);
    /**
     * 提示标记颜色：1-红色，2-黄色，3-绿色
     * @type {Number}
     */
    this.tipColor = build.buildNumber(json&&(json.tipColor!=null)?json.tipColor:null);
    /**
     * 配置规则信息
     * @type {Array.<QuestionnaireQualityRule>}
     */
    this.questionnaireQualityRules = build.buildArray(json&&(json.questionnaireQualityRules!=null)?json.questionnaireQualityRules:null,build.buildQuestionnaireQualityRule);
    /**
     * 是否编辑规则
     * @type {Boolean}
     */
    this.haveRules = build.buildBoolean(json&&(json.haveRules!=null)?json.haveRules:null);
    /**
     * 是否质控
     * @type {Boolean}
     */
    this.haveQuality = build.buildBoolean(json&&(json.haveQuality!=null)?json.haveQuality:null);
    /**
     * 答案质控详情
     * @type {Array.<QualityControlProblemRecord>}
     */
    this.answerQualityControlInfo = build.buildArray(json&&(json.answerQualityControlInfo!=null)?json.answerQualityControlInfo:null,build.buildQualityControlProblemRecord);
    /**
     * 数值类型配置
     * @type {NumericTypeConfigInfo}
     */
    this.numericTypeConfig = build.buildNumericTypeConfigInfo(json&&(json.numericTypeConfig!=null)?json.numericTypeConfig:null);
}
/** 系统器官信息 **/
function SystemOrganName(json=false){
    /**
     * 器官或者系统名字
     * @type {String}
     */
    this.systemName = build.buildString(json&&(json.systemName!=null)?json.systemName:null);
    /**
     * 器官或者系统名字
     * @type {String}
     */
    this.organName = build.buildString(json&&(json.organName!=null)?json.organName:null);
    /**
     * 系统Id
     * @type {Number}
     */
    this.systemAssociationId = build.buildNumber(json&&(json.systemAssociationId!=null)?json.systemAssociationId:null);
    /**
     * 器官Id
     * @type {Number}
     */
    this.organAssociationId = build.buildNumber(json&&(json.organAssociationId!=null)?json.organAssociationId:null);
}
/** HttpResult **/
function HttpResult_BestRecordInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<BestRecordInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildBestRecordInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 问卷质控规则 **/
function QuestionnaireQualityRule(json=false){
    /**
     * 质控规则id
     * @type {Number}
     */
    this.ruleId = build.buildNumber(json&&(json.ruleId!=null)?json.ruleId:null);
    /**
     * 规则类型：1、话术提示，2、填写规范，3、评分说明
     * @type {Number}
     */
    this.ruleType = build.buildNumber(json&&(json.ruleType!=null)?json.ruleType:null);
    /**
     * 规则详细信息
     * @type {String}
     */
    this.rulDesc = build.buildString(json&&(json.rulDesc!=null)?json.rulDesc:null);
    /**
     * 问卷题目
     * @type {String}
     */
    this.questionTitle = build.buildString(json&&(json.questionTitle!=null)?json.questionTitle:null);
    /**
     * 关联问卷id
     * @type {Number}
     */
    this.questionnaireId = build.buildNumber(json&&(json.questionnaireId!=null)?json.questionnaireId:null);
    /**
     * 关联题目id
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 问卷名
     * @type {String}
     */
    this.questionnaireName = build.buildString(json&&(json.questionnaireName!=null)?json.questionnaireName:null);
    /**
     * 最后操作人id
     * @type {Number}
     */
    this.operateId = build.buildNumber(json&&(json.operateId!=null)?json.operateId:null);
    /**
     * 最后操作人姓名
     * @type {String}
     */
    this.operateName = build.buildString(json&&(json.operateName!=null)?json.operateName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 编辑时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** HttpResult **/
function HttpResult_QualityControlToDoInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<QualityControlToDoInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildQualityControlToDoInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TodayFollowUpCounts(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TodayFollowUpCount>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTodayFollowUpCount);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TimeSectionStatisticsInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {TimeSectionStatisticsInfo}
     */
    this.retValue = build.buildTimeSectionStatisticsInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 周之星 **/
function WeekStar(json=false){
    /**
     * 周开始时间
     * @type {String}
     */
    this.weekStartTime = build.buildString(json&&(json.weekStartTime!=null)?json.weekStartTime:null);
    /**
     * 周结束时间
     * @type {String}
     */
    this.weekEndTime = build.buildString(json&&(json.weekEndTime!=null)?json.weekEndTime:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 坐席姓名
     * @type {String}
     */
    this.seatName = build.buildString(json&&(json.seatName!=null)?json.seatName:null);
    /**
     * 奖励
     * @type {String}
     */
    this.reward = build.buildString(json&&(json.reward!=null)?json.reward:null);
    /**
     * 绩效
     * @type {String}
     */
    this.achievement = build.buildString(json&&(json.achievement!=null)?json.achievement:null);
    /**
     * 消息id
     * @type {Number}
     */
    this.messageId = build.buildNumber(json&&(json.messageId!=null)?json.messageId:null);
    /**
     * 是否强制推送
     * @type {Boolean}
     */
    this.isForceSend = build.buildBoolean(json&&(json.isForceSend!=null)?json.isForceSend:null);
    /**
     * 点赞数
     * @type {Number}
     */
    this.clickLikeCount = build.buildNumber(json&&(json.clickLikeCount!=null)?json.clickLikeCount:null);
    /**
     * 点赞坐席
     * @type {Array.<String>}
     */
    this.clickLikeSeatNames = build.buildArray(json&&(json.clickLikeSeatNames!=null)?json.clickLikeSeatNames:null,build.buildString);
}
/** HttpResult **/
function HttpResult_TaskTags(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TaskTag>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTaskTag);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 留存率 **/
function Retention(json=false){
    /**
     * 次日留存率
     * @type {Number}
     */
    this.nextDayRetention = build.buildNumber(json&&(json.nextDayRetention!=null)?json.nextDayRetention:null);
    /**
     * 三日留存率
     * @type {Number}
     */
    this.threeDaysRetention = build.buildNumber(json&&(json.threeDaysRetention!=null)?json.threeDaysRetention:null);
    /**
     * 七日留存率
     * @type {Number}
     */
    this.sevenDaysRetention = build.buildNumber(json&&(json.sevenDaysRetention!=null)?json.sevenDaysRetention:null);
    /**
     * 日期
     * @type {String}
     */
    this.date = build.buildString(json&&(json.date!=null)?json.date:null);
}
/** 患者标签 **/
function FollowupPatientTag(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 标签id
     * @type {Number}
     */
    this.tagId = build.buildNumber(json&&(json.tagId!=null)?json.tagId:null);
    /**
     * 标签名
     * @type {String}
     */
    this.tagName = build.buildString(json&&(json.tagName!=null)?json.tagName:null);
    /**
     * 分组：1基础标签，2任务标签，3特殊标签
     * @type {Number}
     */
    this.group = build.buildNumber(json&&(json.group!=null)?json.group:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 操作人姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 操作人账号
     * @type {String}
     */
    this.userAccount = build.buildString(json&&(json.userAccount!=null)?json.userAccount:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 编辑时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 疾病分类表 **/
function ManagerDiseaseClassification(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 疾病名称
     * @type {String}
     */
    this.diseaseName = build.buildString(json&&(json.diseaseName!=null)?json.diseaseName:null);
    /**
     * 分组数
     * @type {Number}
     */
    this.groupCount = build.buildNumber(json&&(json.groupCount!=null)?json.groupCount:null);
    /**
     * 字段数
     * @type {Number}
     */
    this.fieldCount = build.buildNumber(json&&(json.fieldCount!=null)?json.fieldCount:null);
    /**
     * 最后编辑账号
     * @type {String}
     */
    this.updateUserName = build.buildString(json&&(json.updateUserName!=null)?json.updateUserName:null);
    /**
     * 最后编辑账号id
     * @type {Number}
     */
    this.updateUserId = build.buildNumber(json&&(json.updateUserId!=null)?json.updateUserId:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 阿里响应 **/
function ALiYunResponseRecording(json=false){
    /**
     * 状态
     * @type {String}
     */
    this.code = build.buildString(json&&(json.code!=null)?json.code:null);
    /**
     * 状态
     * @type {Boolean}
     */
    this.success = build.buildBoolean(json&&(json.success!=null)?json.success:null);
    /**
     * requestId
     * @type {String}
     */
    this.requestId = build.buildString(json&&(json.requestId!=null)?json.requestId:null);
    /**
     * 状态码
     * @type {String}
     */
    this.httpStatusCode = build.buildString(json&&(json.httpStatusCode!=null)?json.httpStatusCode:null);
    /**
     * 话务ID
     * @type {Array.<ALiYunRecordings>}
     */
    this.recordings = build.buildArray(json&&(json.recordings!=null)?json.recordings:null,build.buildALiYunRecordings);
    /**
     * 角色列表
     * @type {Array.<ALiYunRoles>}
     */
    this.roles = build.buildArray(json&&(json.roles!=null)?json.roles:null,build.buildALiYunRoles);
    /**
     * 阿里录音下载
     * @type {Array.<ALiYunMediaDownloadParam>}
     */
    this.mediaDownloadParam = build.buildArray(json&&(json.mediaDownloadParam!=null)?json.mediaDownloadParam:null,build.buildALiYunMediaDownloadParam);
}
/** 图文咨询订单详情 **/
function ConsultOrderDetailInfo(json=false){
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者名字
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 患者所在的医院
     * @type {String}
     */
    this.patientHospital = build.buildString(json&&(json.patientHospital!=null)?json.patientHospital:null);
    /**
     * 患者头像
     * @type {String}
     */
    this.patientHeadImg = build.buildString(json&&(json.patientHeadImg!=null)?json.patientHeadImg:null);
    /**
     * 需要哪个方面的帮助
     * @type {String}
     */
    this.needHelp = build.buildString(json&&(json.needHelp!=null)?json.needHelp:null);
    /**
     * 病情照片
     * @type {Array.<String>}
     */
    this.pics = build.buildArray(json&&(json.pics!=null)?json.pics:null,build.buildString);
    /**
     * 医生ID
     * @type {Number}
     */
    this.doctorId = build.buildNumber(json&&(json.doctorId!=null)?json.doctorId:null);
    /**
     * 医生名字
     * @type {String}
     */
    this.doctorName = build.buildString(json&&(json.doctorName!=null)?json.doctorName:null);
    /**
     * 医生职位信息
     * @type {String}
     */
    this.position = build.buildString(json&&(json.position!=null)?json.position:null);
    /**
     * 医生所在医院
     * @type {String}
     */
    this.doctorHospital = build.buildString(json&&(json.doctorHospital!=null)?json.doctorHospital:null);
    /**
     * 科室
     * @type {String}
     */
    this.hospitalDepartment = build.buildString(json&&(json.hospitalDepartment!=null)?json.hospitalDepartment:null);
    /**
     * 医生头像
     * @type {String}
     */
    this.doctorHeadImg = build.buildString(json&&(json.doctorHeadImg!=null)?json.doctorHeadImg:null);
    /**
     * 最后一条的聊天内容
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 用户类型
     * @type {Number}
     */
    this.userType = build.buildNumber(json&&(json.userType!=null)?json.userType:null);
    /**
     * 最后内容的提交时间
     * @type {String}
     */
    this.lastTime = build.buildString(json&&(json.lastTime!=null)?json.lastTime:null);
}
/** HttpResult **/
function HttpResult_MessageManageInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {MessageManageInfo}
     */
    this.retValue = build.buildMessageManageInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_OperationPlatformTaskDatas(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<OperationPlatformTaskData>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildOperationPlatformTaskData);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_SeatMonthQuotaInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SeatMonthQuotaInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSeatMonthQuotaInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_GroupInfoLists(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<GroupInfoList>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildGroupInfoList);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访任务统计详情 **/
function FollowupTaskStatisticsInfo(json=false){
    /**
     * 短信随访未完成数
     * @type {Number}
     */
    this.smsFollowupNumber = build.buildNumber(json&&(json.smsFollowupNumber!=null)?json.smsFollowupNumber:null);
    /**
     * 随访数
     * @type {Number}
     */
    this.followupNumber = build.buildNumber(json&&(json.followupNumber!=null)?json.followupNumber:null);
    /**
     * 随访异常数
     * @type {Number}
     */
    this.followupAbnormalNumber = build.buildNumber(json&&(json.followupAbnormalNumber!=null)?json.followupAbnormalNumber:null);
    /**
     * 今日呼叫人数
     * @type {Number}
     */
    this.todayCallNumber = build.buildNumber(json&&(json.todayCallNumber!=null)?json.todayCallNumber:null);
    /**
     * 今日电话拨打次数
     * @type {Number}
     */
    this.todayTelephoneDialNumber = build.buildNumber(json&&(json.todayTelephoneDialNumber!=null)?json.todayTelephoneDialNumber:null);
    /**
     * 完成随访人数
     * @type {Number}
     */
    this.completeFollowupNumber = build.buildNumber(json&&(json.completeFollowupNumber!=null)?json.completeFollowupNumber:null);
    /**
     * 稍后拨打数
     * @type {Number}
     */
    this.callLaterNumber = build.buildNumber(json&&(json.callLaterNumber!=null)?json.callLaterNumber:null);
    /**
     * 今日提交数-问卷录入
     * @type {Number}
     */
    this.submitNumber = build.buildNumber(json&&(json.submitNumber!=null)?json.submitNumber:null);
    /**
     * 问卷录入未完成数
     * @type {Number}
     */
    this.questionnaireNumber = build.buildNumber(json&&(json.questionnaireNumber!=null)?json.questionnaireNumber:null);
    /**
     * 今日指标
     * @type {Number}
     */
    this.distributeQuotaNumber = build.buildNumber(json&&(json.distributeQuotaNumber!=null)?json.distributeQuotaNumber:null);
    /**
     * 已完成指标
     * @type {Number}
     */
    this.finishQuotaNumber = build.buildNumber(json&&(json.finishQuotaNumber!=null)?json.finishQuotaNumber:null);
    /**
     * 呼叫时长
     * @type {String}
     */
    this.callTime = build.buildString(json&&(json.callTime!=null)?json.callTime:null);
    /**
     * 需复核池数
     * @type {Number}
     */
    this.reviewPoolNumber = build.buildNumber(json&&(json.reviewPoolNumber!=null)?json.reviewPoolNumber:null);
}
/** 随访任务标签 **/
function CallCenterFollowUpTaskTagNew(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 标签名
     * @type {String}
     */
    this.tag = build.buildString(json&&(json.tag!=null)?json.tag:null);
    /**
     * 是否编辑 0 否 1是
     * @type {Boolean}
     */
    this.edit = build.buildBoolean(json&&(json.edit!=null)?json.edit:null);
}
/** 题目 **/
function Question(json=false){
    /**
     * 问题ID
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 题目序号
     * @type {Number}
     */
    this.qSeq = build.buildNumber(json&&(json.qSeq!=null)?json.qSeq:null);
    /**
     * 题目内容
     * @type {String}
     */
    this.questionContext = build.buildString(json&&(json.questionContext!=null)?json.questionContext:null);
    /**
     * 题目类型 1.单选  2.多选  3.文本填空 4.时间下拉框
     * @type {Number}
     */
    this.questionType = build.buildNumber(json&&(json.questionType!=null)?json.questionType:null);
    /**
     * 题目描述
     * @type {String}
     */
    this.questionDescription = build.buildString(json&&(json.questionDescription!=null)?json.questionDescription:null);
    /**
     * 题目标签
     * @type {String}
     */
    this.questionTag = build.buildString(json&&(json.questionTag!=null)?json.questionTag:null);
    /**
     * 是否显示：1.显示  2.不显示
     * @type {Boolean}
     */
    this.isShow = build.buildBoolean(json&&(json.isShow!=null)?json.isShow:null);
    /**
     * 最多选择项
     * @type {Number}
     */
    this.maxOption = build.buildNumber(json&&(json.maxOption!=null)?json.maxOption:null);
    /**
     * 最少选择项
     * @type {Number}
     */
    this.minOption = build.buildNumber(json&&(json.minOption!=null)?json.minOption:null);
    /**
     * 默认选项
     * @type {Number}
     */
    this.defaultOption = build.buildNumber(json&&(json.defaultOption!=null)?json.defaultOption:null);
    /**
     * 是否必做
     * @type {Boolean}
     */
    this.isMust = build.buildBoolean(json&&(json.isMust!=null)?json.isMust:null);
    /**
     * 题目选项集合
     * @type {Array.<QuestionOpt>}
     */
    this.questionOptions = build.buildArray(json&&(json.questionOptions!=null)?json.questionOptions:null,build.buildQuestionOpt);
    /**
     * 被绑定true    未绑定false
     * @type {Boolean}
     */
    this.isBind = build.buildBoolean(json&&(json.isBind!=null)?json.isBind:null);
    /**
     * 被绑定的选项ID
     * @type {Number}
     */
    this.boundOptionId = build.buildNumber(json&&(json.boundOptionId!=null)?json.boundOptionId:null);
}
/** 文件操作记录信息 **/
function FileOperationRecordInfo(json=false){
    /**
     * 任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 操作对象名称
     * @type {String}
     */
    this.operationObjectName = build.buildString(json&&(json.operationObjectName!=null)?json.operationObjectName:null);
    /**
     * 操作类型
     * @type {Number}
     */
    this.operationType = build.buildNumber(json&&(json.operationType!=null)?json.operationType:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operationPersonId = build.buildNumber(json&&(json.operationPersonId!=null)?json.operationPersonId:null);
    /**
     * 操作人姓名
     * @type {String}
     */
    this.operationPersonName = build.buildString(json&&(json.operationPersonName!=null)?json.operationPersonName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 操作备注
     * @type {String}
     */
    this.operationRemarks = build.buildString(json&&(json.operationRemarks!=null)?json.operationRemarks:null);
}
/** 角色权限信息 **/
function RoleModuleRelationInfo(json=false){
    /**
     * 是否可以编辑患者问卷
     * @type {Number}
     */
    this.isEdit = build.buildNumber(json&&(json.isEdit!=null)?json.isEdit:null);
    /**
     * 是否可以进行质控批改1：可以，2：不可以
     * @type {Number}
     */
    this.isQuality = build.buildNumber(json&&(json.isQuality!=null)?json.isQuality:null);
    /**
     * 角色信息
     * @type {RoleInfo}
     */
    this.roleInfo = build.buildRoleInfo(json&&(json.roleInfo!=null)?json.roleInfo:null);
    /**
     * 权限信息
     * @type {Array.<Number>}
     */
    this.moduleIds = build.buildArray(json&&(json.moduleIds!=null)?json.moduleIds:null,build.buildNumber);
    /**
     * 数据导出权限：1不可导出  2可导出
     * @type {Number}
     */
    this.exportPurview = build.buildNumber(json&&(json.exportPurview!=null)?json.exportPurview:null);
}
/** HttpResult **/
function HttpResult_ParameterLists(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<ParameterList>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildParameterList);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_OperationPlatformTaskData(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {OperationPlatformTaskData}
     */
    this.retValue = build.buildOperationPlatformTaskData(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访任务抽查患者 **/
function FollowUpTaskSpotCheckPatient(json=false){
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访任务详情ID
     * @type {Number}
     */
    this.followUpPatientInfoId = build.buildNumber(json&&(json.followUpPatientInfoId!=null)?json.followUpPatientInfoId:null);
    /**
     * 姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 录音id集合
     * @type {Array.<String>}
     */
    this.contactIds = build.buildArray(json&&(json.contactIds!=null)?json.contactIds:null,build.buildString);
    /**
     * 完成号码
     * @type {String}
     */
    this.completeNumber = build.buildString(json&&(json.completeNumber!=null)?json.completeNumber:null);
    /**
     * 号码关系备注
     * @type {String}
     */
    this.relationshipRemarks = build.buildString(json&&(json.relationshipRemarks!=null)?json.relationshipRemarks:null);
    /**
     * 是否重播：0未重播，1已重播
     * @type {Boolean}
     */
    this.isToReplay = build.buildBoolean(json&&(json.isToReplay!=null)?json.isToReplay:null);
    /**
     * 第一次抽查备注
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 管理台抽查备注
     * @type {String}
     */
    this.manageCheckRemarks = build.buildString(json&&(json.manageCheckRemarks!=null)?json.manageCheckRemarks:null);
    /**
     * 呼叫日期
     * @type {String}
     */
    this.callTime = build.buildString(json&&(json.callTime!=null)?json.callTime:null);
    /**
     * 关联抽查id
     * @type {Number}
     */
    this.spotCheckId = build.buildNumber(json&&(json.spotCheckId!=null)?json.spotCheckId:null);
    /**
     * 关联呼叫记录id
     * @type {String}
     */
    this.recordIds = build.buildString(json&&(json.recordIds!=null)?json.recordIds:null);
    /**
     * 抽查人类型：0-内部，1-外部，2-呼叫中心
     * @type {Number}
     */
    this.spotCheckUserType = build.buildNumber(json&&(json.spotCheckUserType!=null)?json.spotCheckUserType:null);
    /**
     * 抽查人ID
     * @type {Number}
     */
    this.spotCheckUserId = build.buildNumber(json&&(json.spotCheckUserId!=null)?json.spotCheckUserId:null);
    /**
     * 抽查人名称
     * @type {Number}
     */
    this.spotCheckUserName = build.buildNumber(json&&(json.spotCheckUserName!=null)?json.spotCheckUserName:null);
    /**
     * 第一次抽查状态
     * @type {String}
     */
    this.firstSpotCheckState = build.buildString(json&&(json.firstSpotCheckState!=null)?json.firstSpotCheckState:null);
    /**
     * 第二次抽查状态
     * @type {Number}
     */
    this.secondSpotCheckState = build.buildNumber(json&&(json.secondSpotCheckState!=null)?json.secondSpotCheckState:null);
    /**
     * 质检结果
     * @type {String}
     */
    this.qualityControlResult = build.buildString(json&&(json.qualityControlResult!=null)?json.qualityControlResult:null);
    /**
     * 最新第一次抽查时间
     * @type {String}
     */
    this.spotCheckTime = build.buildString(json&&(json.spotCheckTime!=null)?json.spotCheckTime:null);
    /**
     * 第二次抽查时间
     * @type {String}
     */
    this.manageSpotTime = build.buildString(json&&(json.manageSpotTime!=null)?json.manageSpotTime:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 处理结果：1重新拨打 2提醒坐席 4需修改问卷
     * @type {Number}
     */
    this.handleResult = build.buildNumber(json&&(json.handleResult!=null)?json.handleResult:null);
    /**
     * 随访状态
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 质控结果动态：1质控结果已提交（待审核），2审核不通过，3审核通过（已发送坐席），4坐席已读（待跟踪），5坐席已编辑（待跟踪），6质控完成
     * @type {Number}
     */
    this.qualityResultDynamic = build.buildNumber(json&&(json.qualityResultDynamic!=null)?json.qualityResultDynamic:null);
    /**
     * 质控分数
     * @type {Number}
     */
    this.qualityScore = build.buildNumber(json&&(json.qualityScore!=null)?json.qualityScore:null);
    /**
     * 错题数
     * @type {Number}
     */
    this.numberOfErrors = build.buildNumber(json&&(json.numberOfErrors!=null)?json.numberOfErrors:null);
    /**
     * 批注详情
     * @type {Array.<QualityControlProblemRecord>}
     */
    this.problemRecords = build.buildArray(json&&(json.problemRecords!=null)?json.problemRecords:null,build.buildQualityControlProblemRecord);
    /**
     * 是否其他坐席重拨
     * @type {Boolean}
     */
    this.isOtherSeatReply = build.buildBoolean(json&&(json.isOtherSeatReply!=null)?json.isOtherSeatReply:null);
    /**
     * 抽查坐席id
     * @type {Number}
     */
    this.spotCheckSeatId = build.buildNumber(json&&(json.spotCheckSeatId!=null)?json.spotCheckSeatId:null);
}
/** HttpResult **/
function HttpResult_MainOfControllerInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {MainOfControllerInfo}
     */
    this.retValue = build.buildMainOfControllerInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 问卷内容和问卷状态 **/
function TQuestionInfoRespAndStatus(json=false){
    /**
     * 问卷状态 1待发布 2已发布
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * 问卷内容
     * @type {Array.<TQuestionInfoResp>}
     */
    this.questionInfoResp = build.buildArray(json&&(json.questionInfoResp!=null)?json.questionInfoResp:null,build.buildTQuestionInfoResp);
}
/** 质控失败反馈 **/
function PassFailFeedBack(json=false){
    /**
     * 提醒id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 抽查记录id
     * @type {Number}
     */
    this.spotCheckId = build.buildNumber(json&&(json.spotCheckId!=null)?json.spotCheckId:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者信息id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 随访患者姓名
     * @type {String}
     */
    this.followupPatientName = build.buildString(json&&(json.followupPatientName!=null)?json.followupPatientName:null);
    /**
     * 随访任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访任务名称
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 质控失败原因
     * @type {String}
     */
    this.passFailReason = build.buildString(json&&(json.passFailReason!=null)?json.passFailReason:null);
    /**
     * 质检时间
     * @type {String}
     */
    this.spotCheckTime = build.buildString(json&&(json.spotCheckTime!=null)?json.spotCheckTime:null);
    /**
     * 反馈时间
     * @type {String}
     */
    this.feedBackTime = build.buildString(json&&(json.feedBackTime!=null)?json.feedBackTime:null);
    /**
     * 质控结果状态
     * @type {Number}
     */
    this.secondSpotCheckState = build.buildNumber(json&&(json.secondSpotCheckState!=null)?json.secondSpotCheckState:null);
    /**
     * 处理结果
     * @type {Number}
     */
    this.handleResult = build.buildNumber(json&&(json.handleResult!=null)?json.handleResult:null);
    /**
     * 第一次抽查状态
     * @type {String}
     */
    this.firstSpotCheckState = build.buildString(json&&(json.firstSpotCheckState!=null)?json.firstSpotCheckState:null);
    /**
     * 第一次抽查最新备注
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 是否已读
     * @type {Boolean}
     */
    this.isConfirm = build.buildBoolean(json&&(json.isConfirm!=null)?json.isConfirm:null);
    /**
     * 质控人提醒内容
     * @type {String}
     */
    this.qualityPersonRemindContent = build.buildString(json&&(json.qualityPersonRemindContent!=null)?json.qualityPersonRemindContent:null);
}
/** HttpResult **/
function HttpResult_CallTaskCenterInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<CallTaskCenterInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildCallTaskCenterInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowupSpotCheckRemarkss(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupSpotCheckRemarks>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupSpotCheckRemarks);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_ManagerDiseaseClassifications(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<ManagerDiseaseClassification>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildManagerDiseaseClassification);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** UnitSlots **/
function UnitSlots(json=false){
    /**
     * name
     * @type {String}
     */
    this.name = build.buildString(json&&(json.name!=null)?json.name:null);
    /**
     * original_word
     * @type {String}
     */
    this.original_word = build.buildString(json&&(json.original_word!=null)?json.original_word:null);
}
/** HttpResult **/
function HttpResult_string(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {String}
     */
    this.retValue = build.buildString(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 病区科室信息 **/
function PatientUserStatistics(json=false){
    /**
     * 用户ID
     * @type {Number}
     */
    this.uid = build.buildNumber(json&&(json.uid!=null)?json.uid:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 性别
     * @type {Number}
     */
    this.sex = build.buildNumber(json&&(json.sex!=null)?json.sex:null);
    /**
     * 年龄
     * @type {Number}
     */
    this.age = build.buildNumber(json&&(json.age!=null)?json.age:null);
    /**
     * 医院ID
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 医院姓名
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室ID
     * @type {Number}
     */
    this.departmentId = build.buildNumber(json&&(json.departmentId!=null)?json.departmentId:null);
    /**
     * 科室名称
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 病区代码
     * @type {String}
     */
    this.wardCode = build.buildString(json&&(json.wardCode!=null)?json.wardCode:null);
    /**
     * 病区名称
     * @type {String}
     */
    this.wardName = build.buildString(json&&(json.wardName!=null)?json.wardName:null);
}
/** 质控规则 **/
function QualityRule(json=false){
    /**
     * 质控规则id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 规则名称
     * @type {String}
     */
    this.ruleName = build.buildString(json&&(json.ruleName!=null)?json.ruleName:null);
    /**
     * 是否父级：0否，1是
     * @type {Boolean}
     */
    this.isFather = build.buildBoolean(json&&(json.isFather!=null)?json.isFather:null);
    /**
     * 关联任务id
     * @type {Number}
     */
    this.relationTaskId = build.buildNumber(json&&(json.relationTaskId!=null)?json.relationTaskId:null);
    /**
     * 关联任务名
     * @type {String}
     */
    this.relationTaskName = build.buildString(json&&(json.relationTaskName!=null)?json.relationTaskName:null);
    /**
     * 规则类型：1填写，2话术，3操作，4疾病
     * @type {Number}
     */
    this.ruleType = build.buildNumber(json&&(json.ruleType!=null)?json.ruleType:null);
    /**
     * 是否通用规则：0否，1是
     * @type {Boolean}
     */
    this.isNormal = build.buildBoolean(json&&(json.isNormal!=null)?json.isNormal:null);
    /**
     * 是否添加：0否，1是
     * @type {Boolean}
     */
    this.isAdd = build.buildBoolean(json&&(json.isAdd!=null)?json.isAdd:null);
    /**
     * 父节点id
     * @type {Number}
     */
    this.fatherId = build.buildNumber(json&&(json.fatherId!=null)?json.fatherId:null);
    /**
     * 最后操作人id
     * @type {Number}
     */
    this.lastUpdateUserId = build.buildNumber(json&&(json.lastUpdateUserId!=null)?json.lastUpdateUserId:null);
    /**
     * 最后操作人姓名
     * @type {String}
     */
    this.lastUpdateUserName = build.buildString(json&&(json.lastUpdateUserName!=null)?json.lastUpdateUserName:null);
    /**
     * 子规则数目
     * @type {Number}
     */
    this.sonRuleNum = build.buildNumber(json&&(json.sonRuleNum!=null)?json.sonRuleNum:null);
    /**
     * 子规则顺序
     * @type {Number}
     */
    this.sonRuleOrder = build.buildNumber(json&&(json.sonRuleOrder!=null)?json.sonRuleOrder:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 买家订单数量 **/
function BuyerOrderCount(json=false){
    /**
     * 买家Id
     * @type {Number}
     */
    this.buyerId = build.buildNumber(json&&(json.buyerId!=null)?json.buyerId:null);
    /**
     * 已有的订单数
     * @type {Number}
     */
    this.count = build.buildNumber(json&&(json.count!=null)?json.count:null);
}
/** 随访抽查记录 **/
function FollowupSpotCheckRemarks(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 抽查用户ID
     * @type {Number}
     */
    this.spotCheckUserId = build.buildNumber(json&&(json.spotCheckUserId!=null)?json.spotCheckUserId:null);
    /**
     * 抽查用户来源：0-内部，1-外部，2-呼叫中心
     * @type {Number}
     */
    this.spotCheckUserType = build.buildNumber(json&&(json.spotCheckUserType!=null)?json.spotCheckUserType:null);
    /**
     * 抽查用户名称
     * @type {String}
     */
    this.spotCheckUserName = build.buildString(json&&(json.spotCheckUserName!=null)?json.spotCheckUserName:null);
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访患者ID
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访任务患者详情ID
     * @type {Number}
     */
    this.followUpTaskPatientInfoId = build.buildNumber(json&&(json.followUpTaskPatientInfoId!=null)?json.followUpTaskPatientInfoId:null);
    /**
     * 抽查坐席ID
     * @type {Number}
     */
    this.spotCheckSeatsId = build.buildNumber(json&&(json.spotCheckSeatsId!=null)?json.spotCheckSeatsId:null);
    /**
     * 一级抽查状态
     * @type {String}
     */
    this.firstSpotCheckState = build.buildString(json&&(json.firstSpotCheckState!=null)?json.firstSpotCheckState:null);
    /**
     * 抽查备注
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 抽查时间
     * @type {String}
     */
    this.spotCheckTime = build.buildString(json&&(json.spotCheckTime!=null)?json.spotCheckTime:null);
    /**
     * 关联呼叫记录id集合
     * @type {String}
     */
    this.recordId = build.buildString(json&&(json.recordId!=null)?json.recordId:null);
    /**
     * 抽查号码
     * @type {String}
     */
    this.phone = build.buildString(json&&(json.phone!=null)?json.phone:null);
    /**
     * 管理台是否处理：0-未处理，1-已处理
     * @type {Boolean}
     */
    this.isHandle = build.buildBoolean(json&&(json.isHandle!=null)?json.isHandle:null);
    /**
     * 第二次抽查状态
     * @type {Number}
     */
    this.secondSpotCheckState = build.buildNumber(json&&(json.secondSpotCheckState!=null)?json.secondSpotCheckState:null);
    /**
     * 是否优质随访
     * @type {Boolean}
     */
    this.isGood = build.buildBoolean(json&&(json.isGood!=null)?json.isGood:null);
    /**
     * 处理结果：1需重拨 2需注意 4需修改问卷
     * @type {Number}
     */
    this.handleResult = build.buildNumber(json&&(json.handleResult!=null)?json.handleResult:null);
    /**
     * 质控结果动态：1质控结果已提交（待审核），2审核不通过，3审核通过（已发送坐席），4坐席已读（待跟踪），5坐席已编辑（待跟踪），6质控完成
     * @type {Number}
     */
    this.qualityResultDynamic = build.buildNumber(json&&(json.qualityResultDynamic!=null)?json.qualityResultDynamic:null);
    /**
     * 图片地址
     * @type {Array.<String>}
     */
    this.imageUrl = build.buildArray(json&&(json.imageUrl!=null)?json.imageUrl:null,build.buildString);
    /**
     * 质控分数
     * @type {Number}
     */
    this.qualityScore = build.buildNumber(json&&(json.qualityScore!=null)?json.qualityScore:null);
    /**
     * 错题数
     * @type {Number}
     */
    this.numberOfErrors = build.buildNumber(json&&(json.numberOfErrors!=null)?json.numberOfErrors:null);
    /**
     * 批注详情
     * @type {Array.<QualityControlProblemRecord>}
     */
    this.problemRecords = build.buildArray(json&&(json.problemRecords!=null)?json.problemRecords:null,build.buildQualityControlProblemRecord);
    /**
     * 重拨坐席id
     * @type {Number}
     */
    this.replaySeatId = build.buildNumber(json&&(json.replaySeatId!=null)?json.replaySeatId:null);
    /**
     * 重拨坐席姓名
     * @type {String}
     */
    this.replaySeatName = build.buildString(json&&(json.replaySeatName!=null)?json.replaySeatName:null);
    /**
     * 是否超时
     * @type {Boolean}
     */
    this.isTimeout = build.buildBoolean(json&&(json.isTimeout!=null)?json.isTimeout:null);
    /**
     * 是否不纳入
     * @type {Boolean}
     */
    this.isNotIncluded = build.buildBoolean(json&&(json.isNotIncluded!=null)?json.isNotIncluded:null);
    /**
     * 不纳入时间
     * @type {String}
     */
    this.notIncludedTime = build.buildString(json&&(json.notIncludedTime!=null)?json.notIncludedTime:null);
    /**
     * 不纳入类型
     * @type {Number}
     */
    this.notIncludedType = build.buildNumber(json&&(json.notIncludedType!=null)?json.notIncludedType:null);
    /**
     * 不纳入原因
     * @type {String}
     */
    this.notIncludedReason = build.buildString(json&&(json.notIncludedReason!=null)?json.notIncludedReason:null);
}
/** 护士信息 **/
function NurseInfo(json=false){
    /**
     * 护士id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 护士名字
     * @type {String}
     */
    this.nurseName = build.buildString(json&&(json.nurseName!=null)?json.nurseName:null);
    /**
     * 是否可以选择
     * @type {Boolean}
     */
    this.couldIsSelect = build.buildBoolean(json&&(json.couldIsSelect!=null)?json.couldIsSelect:null);
}
/** 未接来电记录 **/
function TelephoneFollowupIncomingCallPatient(json=false){
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 电话随访任务详情ID
     * @type {Number}
     */
    this.callTaskId = build.buildNumber(json&&(json.callTaskId!=null)?json.callTaskId:null);
    /**
     * 电话随访任务ID
     * @type {Number}
     */
    this.callTaskCenterId = build.buildNumber(json&&(json.callTaskCenterId!=null)?json.callTaskCenterId:null);
    /**
     * 呼叫类型：1电话随访，2电话通知，3电话回访
     * @type {Number}
     */
    this.callType = build.buildNumber(json&&(json.callType!=null)?json.callType:null);
    /**
     * 客服ID
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 电话随访任务名字
     * @type {String}
     */
    this.callTaskCenterName = build.buildString(json&&(json.callTaskCenterName!=null)?json.callTaskCenterName:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 患者关系
     * @type {String}
     */
    this.relationshipName = build.buildString(json&&(json.relationshipName!=null)?json.relationshipName:null);
    /**
     * 随访状态0初始化，1随访中，2成功，3失访，4死亡，5异常呼叫
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 上次呼叫时间
     * @type {String}
     */
    this.lastCallTime = build.buildString(json&&(json.lastCallTime!=null)?json.lastCallTime:null);
    /**
     * 联系方式ID
     * @type {Number}
     */
    this.phoneNumberId = build.buildNumber(json&&(json.phoneNumberId!=null)?json.phoneNumberId:null);
}
/** 呼叫患者就诊记录 **/
function CallPatientVisitingRecord(json=false){
    /**
     * 就诊时间
     * @type {String}
     */
    this.visitingDate = build.buildString(json&&(json.visitingDate!=null)?json.visitingDate:null);
    /**
     * 就诊类型 0门诊 1住院  2体检
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
    /**
     * 医院ID
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室ID
     * @type {Number}
     */
    this.departmentId = build.buildNumber(json&&(json.departmentId!=null)?json.departmentId:null);
    /**
     * 科室名称
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 诊断名
     * @type {String}
     */
    this.diagnosisName = build.buildString(json&&(json.diagnosisName!=null)?json.diagnosisName:null);
    /**
     * 主诊医生姓名
     * @type {String}
     */
    this.primaryPhysicianName = build.buildString(json&&(json.primaryPhysicianName!=null)?json.primaryPhysicianName:null);
}
/** 权限与角色信息 **/
function MenuAndRoleInfo(json=false){
    /**
     * 权限Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 父级ID
     * @type {Number}
     */
    this.fatherId = build.buildNumber(json&&(json.fatherId!=null)?json.fatherId:null);
    /**
     * url
     * @type {String}
     */
    this.moduleUrl = build.buildString(json&&(json.moduleUrl!=null)?json.moduleUrl:null);
    /**
     * 权限名称
     * @type {String}
     */
    this.moduleName = build.buildString(json&&(json.moduleName!=null)?json.moduleName:null);
    /**
     * 图标
     * @type {String}
     */
    this.iconPng = build.buildString(json&&(json.iconPng!=null)?json.iconPng:null);
    /**
     * 是否是父节点
     * @type {Number}
     */
    this.isFather = build.buildNumber(json&&(json.isFather!=null)?json.isFather:null);
    /**
     * 角色
     * @type {Array.<RoleInfo>}
     */
    this.roles = build.buildArray(json&&(json.roles!=null)?json.roles:null,build.buildRoleInfo);
}
/** 关系列表 **/
function Relationship(json=false){
    /**
     * 任务ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 关系名称
     * @type {String}
     */
    this.relationshipName = build.buildString(json&&(json.relationshipName!=null)?json.relationshipName:null);
}
/** 电话随访任务记录 **/
function CallTaskRecordDetail(json=false){
    /**
     * 电话随访任务记录Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 呼叫类型
     * @type {Number}
     */
    this.callType = build.buildNumber(json&&(json.callType!=null)?json.callType:null);
    /**
     * 用户Id
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 呼叫状态
     * @type {Number}
     */
    this.callStatus = build.buildNumber(json&&(json.callStatus!=null)?json.callStatus:null);
    /**
     * 用户名字
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 住院號
     * @type {String}
     */
    this.hospitalNumber = build.buildString(json&&(json.hospitalNumber!=null)?json.hospitalNumber:null);
    /**
     * 隨訪狀態
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 完成號碼
     * @type {String}
     */
    this.finishMobile = build.buildString(json&&(json.finishMobile!=null)?json.finishMobile:null);
    /**
     * 呼叫日期
     * @type {String}
     */
    this.callTime = build.buildString(json&&(json.callTime!=null)?json.callTime:null);
}
/** 手术记录信息 **/
function SurgeryRecordInfo(json=false){
    /**
     * 手术名字
     * @type {String}
     */
    this.surgeryName = build.buildString(json&&(json.surgeryName!=null)?json.surgeryName:null);
    /**
     * 手术时间
     * @type {String}
     */
    this.inputTime = build.buildString(json&&(json.inputTime!=null)?json.inputTime:null);
    /**
     * 申请时间
     * @type {String}
     */
    this.applyTime = build.buildString(json&&(json.applyTime!=null)?json.applyTime:null);
}
/** 任务中心简单信息 **/
function TaskCenterSimpleInfo(json=false){
    /**
     * 任务中心Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务名字
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
}
/** 阿里云请求参数 **/
function ALiYunRequest(json=false){
    /**
     * id
     * @type {String}
     */
    this.Action = build.buildString(json&&(json.Action!=null)?json.Action:null);
    /**
     * 呼叫中心实例ID
     * @type {String}
     */
    this.InstanceId = build.buildString(json&&(json.InstanceId!=null)?json.InstanceId:null);
    /**
     * 话务ID
     * @type {String}
     */
    this.ContactId = build.buildString(json&&(json.ContactId!=null)?json.ContactId:null);
    /**
     * 坐席ID
     * @type {String}
     */
    this.AgentId = build.buildString(json&&(json.AgentId!=null)?json.AgentId:null);
    /**
     * 坐席ID集合
     * @type {Array.<String>}
     */
    this.AgentIdList = build.buildArray(json&&(json.AgentIdList!=null)?json.AgentIdList:null,build.buildString);
    /**
     * 分段汇总类型：Daily（按天汇总）/ Hourly（按小时汇总）默认是Daily。
     * @type {String}
     */
    this.Interval = build.buildString(json&&(json.Interval!=null)?json.Interval:null);
    /**
     * 录音文件名
     * @type {String}
     */
    this.FileName = build.buildString(json&&(json.FileName!=null)?json.FileName:null);
    /**
     * 用户登陆名
     * @type {String}
     */
    this.LoginName = build.buildString(json&&(json.LoginName!=null)?json.LoginName:null);
    /**
     * 用户的全名
     * @type {String}
     */
    this.DisplayName = build.buildString(json&&(json.DisplayName!=null)?json.DisplayName:null);
    /**
     * 用户电子邮件地址，新建成功后会发送邮件，邮件中包含呼叫中心登录地址，以及用户名密码
     * @type {String}
     */
    this.Email = build.buildString(json&&(json.Email!=null)?json.Email:null);
    /**
     * 指定待创建用户的角色，需传入角色ID
     * @type {String}
     */
    this.RoleId = build.buildString(json&&(json.RoleId!=null)?json.RoleId:null);
    /**
     * 分页序号
     * @type {Number}
     */
    this.PageNumber = build.buildNumber(json&&(json.PageNumber!=null)?json.PageNumber:null);
    /**
     * 分页大小
     * @type {Number}
     */
    this.PageSize = build.buildNumber(json&&(json.PageSize!=null)?json.PageSize:null);
    /**
     * 获取的历史数据的起始时间，默认为当天的0时
     * @type {Number}
     */
    this.StartTime = build.buildNumber(json&&(json.StartTime!=null)?json.StartTime:null);
    /**
     * 获取的历史数据的终止时间，默认为当前时间
     * @type {Number}
     */
    this.EndTime = build.buildNumber(json&&(json.EndTime!=null)?json.EndTime:null);
    /**
     * 主叫号码
     * @type {String}
     */
    this.CallingNumber = build.buildString(json&&(json.CallingNumber!=null)?json.CallingNumber:null);
    /**
     * 被叫号码
     * @type {String}
     */
    this.CalledNumber = build.buildString(json&&(json.CalledNumber!=null)?json.CalledNumber:null);
    /**
     * 号码是否可用
     * @type {Boolean}
     */
    this.Active = build.buildBoolean(json&&(json.Active!=null)?json.Active:null);
}
/** 题号和选项 **/
function QuestionNumbersOptions(json=false){
    /**
     * 题号
     * @type {String}
     */
    this.number = build.buildString(json&&(json.number!=null)?json.number:null);
    /**
     * 选项
     * @type {String}
     */
    this.option = build.buildString(json&&(json.option!=null)?json.option:null);
}
/** 质控规则更新提醒详情 **/
function UpdateTipInfo(json=false){
    /**
     * 规则id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 问卷id
     * @type {Number}
     */
    this.questionnaireId = build.buildNumber(json&&(json.questionnaireId!=null)?json.questionnaireId:null);
    /**
     * 页码
     * @type {Number}
     */
    this.pageNumber = build.buildNumber(json&&(json.pageNumber!=null)?json.pageNumber:null);
    /**
     * 问题id
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 题目序号
     * @type {Number}
     */
    this.serialNumber = build.buildNumber(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * 是否已读
     * @type {Boolean}
     */
    this.isRead = build.buildBoolean(json&&(json.isRead!=null)?json.isRead:null);
}
/** 消息展板内容 **/
function MessageContent(json=false){
    /**
     * 疾病推荐文章标题
     * @type {Array.<ArticleIdAndTitle>}
     */
    this.diagnosisArticle = build.buildArray(json&&(json.diagnosisArticle!=null)?json.diagnosisArticle:null,build.buildArticleIdAndTitle);
    /**
     * 药物相关科普文章
     * @type {Array.<ArticleIdAndTitle>}
     */
    this.drugArticle = build.buildArray(json&&(json.drugArticle!=null)?json.drugArticle:null,build.buildArticleIdAndTitle);
    /**
     * 逾期提醒未服药物
     * @type {Array.<OverTimeDrug>}
     */
    this.overDrugs = build.buildArray(json&&(json.overDrugs!=null)?json.overDrugs:null,build.buildOverTimeDrug);
    /**
     * 逾期未添加检查结果
     * @type {Array.<OverTimeDrug>}
     */
    this.overInspect = build.buildArray(json&&(json.overInspect!=null)?json.overInspect:null,build.buildOverTimeDrug);
}
/** 检查检验报告明细 **/
function InspectionReportDetailed(json=false){
    /**
     * 检查报告ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 患者性别 1男 2女
     * @type {Number}
     */
    this.userSex = build.buildNumber(json&&(json.userSex!=null)?json.userSex:null);
    /**
     * 患者年龄
     * @type {Number}
     */
    this.age = build.buildNumber(json&&(json.age!=null)?json.age:null);
    /**
     * 就诊流水号
     * @type {String}
     */
    this.visitingNo = build.buildString(json&&(json.visitingNo!=null)?json.visitingNo:null);
    /**
     * 就诊科室名称
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 报告类型 1检验报告 ，2检查报告
     * @type {Number}
     */
    this.reportType = build.buildNumber(json&&(json.reportType!=null)?json.reportType:null);
    /**
     * 报告来源 1同步更新 2手动上传
     * @type {Number}
     */
    this.reportSource = build.buildNumber(json&&(json.reportSource!=null)?json.reportSource:null);
    /**
     * 检查类型
     * @type {String}
     */
    this.inspectType = build.buildString(json&&(json.inspectType!=null)?json.inspectType:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 病区名称（住院病人填写）
     * @type {String}
     */
    this.wardName = build.buildString(json&&(json.wardName!=null)?json.wardName:null);
    /**
     * 病床号（住院病人填写）
     * @type {String}
     */
    this.bed = build.buildString(json&&(json.bed!=null)?json.bed:null);
    /**
     * 检查人姓名
     * @type {String}
     */
    this.inspectorName = build.buildString(json&&(json.inspectorName!=null)?json.inspectorName:null);
    /**
     * 检验人姓名
     * @type {String}
     */
    this.examinerName = build.buildString(json&&(json.examinerName!=null)?json.examinerName:null);
    /**
     * 报告人姓名
     * @type {String}
     */
    this.reporterName = build.buildString(json&&(json.reporterName!=null)?json.reporterName:null);
    /**
     * 审核人姓名
     * @type {String}
     */
    this.verifierName = build.buildString(json&&(json.verifierName!=null)?json.verifierName:null);
    /**
     * 申请日期（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.applicantDate = build.buildString(json&&(json.applicantDate!=null)?json.applicantDate:null);
    /**
     * 采集日期（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.collectDate = build.buildString(json&&(json.collectDate!=null)?json.collectDate:null);
    /**
     * 检验日期（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.examineDate = build.buildString(json&&(json.examineDate!=null)?json.examineDate:null);
    /**
     * 报告日期（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.reportDate = build.buildString(json&&(json.reportDate!=null)?json.reportDate:null);
    /**
     * 报告单类别编码（1 = 一般临床检验, 2 =血液学检查, 3 = 临床化学检查, 4 = 临床免疫学检查, 5 = 临床微生物学检查, 6 = 临床寄生虫学检查, 7 = 分子生物学检查, 9999 = 其它）
     * @type {String}
     */
    this.reportTypeCode = build.buildString(json&&(json.reportTypeCode!=null)?json.reportTypeCode:null);
    /**
     * 报告单类别名称（填写中文。如“血常规”、“尿常规”等行业常识的名称）
     * @type {String}
     */
    this.reportTypeName = build.buildString(json&&(json.reportTypeName!=null)?json.reportTypeName:null);
    /**
     * 标本代码
     * @type {String}
     */
    this.specimenCode = build.buildString(json&&(json.specimenCode!=null)?json.specimenCode:null);
    /**
     * 标本名称
     * @type {String}
     */
    this.specimenName = build.buildString(json&&(json.specimenName!=null)?json.specimenName:null);
    /**
     * 检验指标
     * @type {Array.<LabIndex>}
     */
    this.labIndexs = build.buildArray(json&&(json.labIndexs!=null)?json.labIndexs:null,build.buildLabIndex);
    /**
     * 检查名称
     * @type {String}
     */
    this.checkName = build.buildString(json&&(json.checkName!=null)?json.checkName:null);
    /**
     * 检查部位
     * @type {String}
     */
    this.checkPoint = build.buildString(json&&(json.checkPoint!=null)?json.checkPoint:null);
    /**
     * 检查方法
     * @type {String}
     */
    this.checkMethod = build.buildString(json&&(json.checkMethod!=null)?json.checkMethod:null);
    /**
     * 检查所见
     * @type {String}
     */
    this.findings = build.buildString(json&&(json.findings!=null)?json.findings:null);
    /**
     * 检查结论
     * @type {String}
     */
    this.conclusions = build.buildString(json&&(json.conclusions!=null)?json.conclusions:null);
    /**
     * 检查图片
     * @type {String}
     */
    this.reportImgs = build.buildString(json&&(json.reportImgs!=null)?json.reportImgs:null);
    /**
     * 患者所有检查报告列表显示列表
     * @type {Array.<ReportListShow>}
     */
    this.reportListShow = build.buildArray(json&&(json.reportListShow!=null)?json.reportListShow:null,build.buildReportListShow);
}
/** 呼叫台跳转参数 **/
function CallCenterJumpParams(json=false){
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 随访任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者详情id
     * @type {Number}
     */
    this.followUpPatientInfoId = build.buildNumber(json&&(json.followUpPatientInfoId!=null)?json.followUpPatientInfoId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 问卷id
     * @type {Number}
     */
    this.questionnaireNewId = build.buildNumber(json&&(json.questionnaireNewId!=null)?json.questionnaireNewId:null);
}
/** 学习页面抽查信息 **/
function StudySpotCheckInfo(json=false){
    /**
     * 本次抽查id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 随访患者详情任务id
     * @type {Number}
     */
    this.taskPatientInfoId = build.buildNumber(json&&(json.taskPatientInfoId!=null)?json.taskPatientInfoId:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 坐席信息
     * @type {SeatUserInfos}
     */
    this.seatUserInfos = build.buildSeatUserInfos(json&&(json.seatUserInfos!=null)?json.seatUserInfos:null);
    /**
     * 一级抽查备注
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 随访状态
     * @type {Number}
     */
    this.followStatus = build.buildNumber(json&&(json.followStatus!=null)?json.followStatus:null);
    /**
     * 抽查时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 一级抽查状态
     * @type {String}
     */
    this.spotCheckState = build.buildString(json&&(json.spotCheckState!=null)?json.spotCheckState:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 是否优质
     * @type {Boolean}
     */
    this.isGood = build.buildBoolean(json&&(json.isGood!=null)?json.isGood:null);
}
/** HttpResult **/
function HttpResult_FollowUpTaskSpotCheckStatistics(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowUpTaskSpotCheckStatistics}
     */
    this.retValue = build.buildFollowUpTaskSpotCheckStatistics(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 任務名字信息 **/
function TaskNameInfo(json=false){
    /**
     * 任務Id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 任務名字
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
}
/** HttpResult **/
function HttpResult_String(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {String}
     */
    this.retValue = build.buildString(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowUpTaskSpotCheckPatients(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowUpTaskSpotCheckPatient>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowUpTaskSpotCheckPatient);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_PhoneRecordInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<PhoneRecordInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildPhoneRecordInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 呼叫平台-质控-主页面 **/
function MainOfControllerInfo(json=false){
    /**
     * 今日抽查/需抽查
     * @type {String}
     */
    this.todayCheckRatio = build.buildString(json&&(json.todayCheckRatio!=null)?json.todayCheckRatio:null);
    /**
     * 当月抽查/需抽查
     * @type {String}
     */
    this.thisMonthCheckRatio = build.buildString(json&&(json.thisMonthCheckRatio!=null)?json.thisMonthCheckRatio:null);
    /**
     * 合格
     * @type {Number}
     */
    this.qualified = build.buildNumber(json&&(json.qualified!=null)?json.qualified:null);
    /**
     * 不合格
     * @type {Number}
     */
    this.notQualified = build.buildNumber(json&&(json.notQualified!=null)?json.notQualified:null);
    /**
     * 坐席质控的任务列表
     * @type {Array.<SeatTaskInfo>}
     */
    this.seatTaskList = build.buildArray(json&&(json.seatTaskList!=null)?json.seatTaskList:null,build.buildSeatTaskInfo);
}
/** 患者参考信息字段组信息 **/
function PatientReferenceFieldGroupInfo(json=false){
    /**
     * 参考信息字段id
     * @type {Number}
     */
    this.referenceFieldId = build.buildNumber(json&&(json.referenceFieldId!=null)?json.referenceFieldId:null);
    /**
     * 参考字段名称
     * @type {String}
     */
    this.referenceFieldKey = build.buildString(json&&(json.referenceFieldKey!=null)?json.referenceFieldKey:null);
    /**
     * 参考字段名称
     * @type {Array.<ReferenceGroupFieldValueInfo>}
     */
    this.referenceValueList = build.buildArray(json&&(json.referenceValueList!=null)?json.referenceValueList:null,build.buildReferenceGroupFieldValueInfo);
}
/** 坐席日指标配置详情 **/
function SeatDayIndexDetail(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 指标日期
     * @type {String}
     */
    this.quotaDate = build.buildString(json&&(json.quotaDate!=null)?json.quotaDate:null);
    /**
     * 指标类型
     * @type {Number}
     */
    this.quotaType = build.buildNumber(json&&(json.quotaType!=null)?json.quotaType:null);
    /**
     * 指标类型字符串
     * @type {String}
     */
    this.quotaTypeStr = build.buildString(json&&(json.quotaTypeStr!=null)?json.quotaTypeStr:null);
    /**
     * 分配指标量
     * @type {Number}
     */
    this.distributeQuotaNumber = build.buildNumber(json&&(json.distributeQuotaNumber!=null)?json.distributeQuotaNumber:null);
    /**
     * 完成指标量
     * @type {Number}
     */
    this.finishQuotaNumber = build.buildNumber(json&&(json.finishQuotaNumber!=null)?json.finishQuotaNumber:null);
    /**
     * 特殊指标
     * @type {String}
     */
    this.specialQuota = build.buildString(json&&(json.specialQuota!=null)?json.specialQuota:null);
    /**
     * 数据颜色
     * @type {Number}
     */
    this.dataColor = build.buildNumber(json&&(json.dataColor!=null)?json.dataColor:null);
}
/** 患者手机号码 **/
function PatientPhoneNumber(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 手机号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 关系ID
     * @type {Number}
     */
    this.relationshipId = build.buildNumber(json&&(json.relationshipId!=null)?json.relationshipId:null);
    /**
     * 关系名称
     * @type {String}
     */
    this.relationshipName = build.buildString(json&&(json.relationshipName!=null)?json.relationshipName:null);
    /**
     * 最后呼叫状态
     * @type {Number}
     */
    this.lastCallState = build.buildNumber(json&&(json.lastCallState!=null)?json.lastCallState:null);
    /**
     * 新最后呼叫状态
     * @type {Number}
     */
    this.newLastCallState = build.buildNumber(json&&(json.newLastCallState!=null)?json.newLastCallState:null);
    /**
     * 今日是否已拨
     * @type {Boolean}
     */
    this.isTodayCall = build.buildBoolean(json&&(json.isTodayCall!=null)?json.isTodayCall:null);
    /**
     * 最后呼叫时间
     * @type {String}
     */
    this.lastCallTime = build.buildString(json&&(json.lastCallTime!=null)?json.lastCallTime:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 是否为最近拨打
     * @type {Boolean}
     */
    this.isLast = build.buildBoolean(json&&(json.isLast!=null)?json.isLast:null);
    /**
     * 是否能发送短信
     * @type {Boolean}
     */
    this.isSendSMS = build.buildBoolean(json&&(json.isSendSMS!=null)?json.isSendSMS:null);
    /**
     * 复制最后呼叫时间（年月日时分秒）
     * @type {String}
     */
    this.copyLastCallTime = build.buildString(json&&(json.copyLastCallTime!=null)?json.copyLastCallTime:null);
    /**
     * 手机号标签
     * @type {String}
     */
    this.phoneLabel = build.buildString(json&&(json.phoneLabel!=null)?json.phoneLabel:null);
    /**
     * 稍后拨打时间
     * @type {String}
     */
    this.laterCallTime = build.buildString(json&&(json.laterCallTime!=null)?json.laterCallTime:null);
    /**
     * 联系人姓名
     * @type {String}
     */
    this.contactName = build.buildString(json&&(json.contactName!=null)?json.contactName:null);
    /**
     * 联系类型
     * @type {Boolean}
     */
    this.phoneType = build.buildBoolean(json&&(json.phoneType!=null)?json.phoneType:null);
    /**
     * 联系等级id
     * @type {Number}
     */
    this.relationshipLevelId = build.buildNumber(json&&(json.relationshipLevelId!=null)?json.relationshipLevelId:null);
    /**
     * 联系等级
     * @type {Number}
     */
    this.relationshipLevel = build.buildNumber(json&&(json.relationshipLevel!=null)?json.relationshipLevel:null);
    /**
     * 配合分数
     * @type {Number}
     */
    this.cooperateScore = build.buildNumber(json&&(json.cooperateScore!=null)?json.cooperateScore:null);
    /**
     * 等级类别
     * @type {Boolean}
     */
    this.levelType = build.buildBoolean(json&&(json.levelType!=null)?json.levelType:null);
    /**
     * 是否加微信
     * @type {Boolean}
     */
    this.isAddWeChat = build.buildBoolean(json&&(json.isAddWeChat!=null)?json.isAddWeChat:null);
    /**
     * 联系状态
     * @type {Number}
     */
    this.contactStatus = build.buildNumber(json&&(json.contactStatus!=null)?json.contactStatus:null);
    /**
     * 联系情况
     * @type {Number}
     */
    this.contactInformation = build.buildNumber(json&&(json.contactInformation!=null)?json.contactInformation:null);
    /**
     * 归属地
     * @type {String}
     */
    this.belongAddress = build.buildString(json&&(json.belongAddress!=null)?json.belongAddress:null);
}
/** HttpResult **/
function HttpResult_int(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Number}
     */
    this.retValue = build.buildNumber(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 就诊信息 **/
function PatientVisitingInfo(json=false){
    /**
     * 就诊id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 就诊流水号
     * @type {String}
     */
    this.visitingNo = build.buildString(json&&(json.visitingNo!=null)?json.visitingNo:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 就诊类型（0门诊 1住院  2体检）
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
    /**
     * 数据来源（1同步更新 2手动上传）
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 医院id
     * @type {Number}
     */
    this.hospitalIOd = build.buildNumber(json&&(json.hospitalIOd!=null)?json.hospitalIOd:null);
    /**
     * 医院服务名称
     * @type {String}
     */
    this.hospitalService = build.buildString(json&&(json.hospitalService!=null)?json.hospitalService:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 诊断名
     * @type {String}
     */
    this.diagnosisName = build.buildString(json&&(json.diagnosisName!=null)?json.diagnosisName:null);
    /**
     * 科室id
     * @type {Number}
     */
    this.departmentId = build.buildNumber(json&&(json.departmentId!=null)?json.departmentId:null);
    /**
     * 科室名称
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 病区代码
     * @type {String}
     */
    this.wardCode = build.buildString(json&&(json.wardCode!=null)?json.wardCode:null);
    /**
     * 病区名称
     * @type {String}
     */
    this.wardName = build.buildString(json&&(json.wardName!=null)?json.wardName:null);
    /**
     * 病床号
     * @type {String}
     */
    this.bed = build.buildString(json&&(json.bed!=null)?json.bed:null);
    /**
     * 就诊时间
     * @type {String}
     */
    this.visitingDate = build.buildString(json&&(json.visitingDate!=null)?json.visitingDate:null);
    /**
     * 住院时间
     * @type {String}
     */
    this.admissionTime = build.buildString(json&&(json.admissionTime!=null)?json.admissionTime:null);
    /**
     * 出院时间
     * @type {String}
     */
    this.dischargeTime = build.buildString(json&&(json.dischargeTime!=null)?json.dischargeTime:null);
    /**
     * 入院诊断
     * @type {String}
     */
    this.admissionDiagnosis = build.buildString(json&&(json.admissionDiagnosis!=null)?json.admissionDiagnosis:null);
    /**
     * 出院诊断
     * @type {String}
     */
    this.dischargeDiagnosis = build.buildString(json&&(json.dischargeDiagnosis!=null)?json.dischargeDiagnosis:null);
    /**
     * 入院情况
     * @type {String}
     */
    this.admissionCondition = build.buildString(json&&(json.admissionCondition!=null)?json.admissionCondition:null);
    /**
     * 出院情况
     * @type {String}
     */
    this.dischargeCondition = build.buildString(json&&(json.dischargeCondition!=null)?json.dischargeCondition:null);
    /**
     * 治疗结果
     * @type {String}
     */
    this.cureResult = build.buildString(json&&(json.cureResult!=null)?json.cureResult:null);
    /**
     * 症状描述
     * @type {Number}
     */
    this.symptom = build.buildNumber(json&&(json.symptom!=null)?json.symptom:null);
    /**
     * 入院报告记录
     * @type {String}
     */
    this.admissionRecord = build.buildString(json&&(json.admissionRecord!=null)?json.admissionRecord:null);
    /**
     * 入院报告记录时间
     * @type {String}
     */
    this.admissionRecordTime = build.buildString(json&&(json.admissionRecordTime!=null)?json.admissionRecordTime:null);
    /**
     * 出院小结
     * @type {String}
     */
    this.dischargeRecord = build.buildString(json&&(json.dischargeRecord!=null)?json.dischargeRecord:null);
    /**
     * 出院小结图片
     * @type {String}
     */
    this.dischargeRecordImg = build.buildString(json&&(json.dischargeRecordImg!=null)?json.dischargeRecordImg:null);
    /**
     * 出院报告记录时间
     * @type {String}
     */
    this.discharge_recordTime = build.buildString(json&&(json.discharge_recordTime!=null)?json.discharge_recordTime:null);
    /**
     * 主诊医生工号
     * @type {String}
     */
    this.primary_physicianCode = build.buildString(json&&(json.primary_physicianCode!=null)?json.primary_physicianCode:null);
    /**
     * 主诊医生姓名
     * @type {String}
     */
    this.primary_physicianName = build.buildString(json&&(json.primary_physicianName!=null)?json.primary_physicianName:null);
    /**
     * 是否是专家门诊 （1 是 2否）
     * @type {Number}
     */
    this.isSpecialistClinic = build.buildNumber(json&&(json.isSpecialistClinic!=null)?json.isSpecialistClinic:null);
    /**
     * 手术时间
     * @type {String}
     */
    this.surgeryTime = build.buildString(json&&(json.surgeryTime!=null)?json.surgeryTime:null);
    /**
     * 手术记录
     * @type {String}
     */
    this.surgeryRecord = build.buildString(json&&(json.surgeryRecord!=null)?json.surgeryRecord:null);
    /**
     * 手术记录图
     * @type {String}
     */
    this.surgeryRecordImg = build.buildString(json&&(json.surgeryRecordImg!=null)?json.surgeryRecordImg:null);
    /**
     * 手术报告记录
     * @type {String}
     */
    this.operationRecord = build.buildString(json&&(json.operationRecord!=null)?json.operationRecord:null);
    /**
     * 手术报告记录时间
     * @type {String}
     */
    this.operationRecordTime = build.buildString(json&&(json.operationRecordTime!=null)?json.operationRecordTime:null);
    /**
     * 医嘱
     * @type {String}
     */
    this.doctorAdvice = build.buildString(json&&(json.doctorAdvice!=null)?json.doctorAdvice:null);
    /**
     * 医生建议
     * @type {String}
     */
    this.doctorProposal = build.buildString(json&&(json.doctorProposal!=null)?json.doctorProposal:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
}
/** 随访任务患者详情 **/
function FollowupTaskPatientInfo(json=false){
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访任务详情ID
     * @type {Number}
     */
    this.followUpPatientInfoId = build.buildNumber(json&&(json.followUpPatientInfoId!=null)?json.followUpPatientInfoId:null);
    /**
     * 是否注册APP
     * @type {Boolean}
     */
    this.isRegisterApp = build.buildBoolean(json&&(json.isRegisterApp!=null)?json.isRegisterApp:null);
    /**
     * 性别
     * @type {String}
     */
    this.userSex = build.buildString(json&&(json.userSex!=null)?json.userSex:null);
    /**
     * 年龄
     * @type {String}
     */
    this.userAge = build.buildString(json&&(json.userAge!=null)?json.userAge:null);
    /**
     * 姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 上次随访时间
     * @type {String}
     */
    this.lastFollowupTime = build.buildString(json&&(json.lastFollowupTime!=null)?json.lastFollowupTime:null);
    /**
     * 手术日期
     * @type {String}
     */
    this.operationDate = build.buildString(json&&(json.operationDate!=null)?json.operationDate:null);
    /**
     * 身份证件号码
     * @type {String}
     */
    this.card = build.buildString(json&&(json.card!=null)?json.card:null);
    /**
     * 疾病名称
     * @type {String}
     */
    this.diseaseName = build.buildString(json&&(json.diseaseName!=null)?json.diseaseName:null);
    /**
     * 诊断日期
     * @type {String}
     */
    this.diagnosisDate = build.buildString(json&&(json.diagnosisDate!=null)?json.diagnosisDate:null);
    /**
     * 治疗方式
     * @type {String}
     */
    this.treatment = build.buildString(json&&(json.treatment!=null)?json.treatment:null);
    /**
     * 主诊医生
     * @type {String}
     */
    this.primaryPhysicianName = build.buildString(json&&(json.primaryPhysicianName!=null)?json.primaryPhysicianName:null);
    /**
     * 出院日期
     * @type {String}
     */
    this.dischargeTime = build.buildString(json&&(json.dischargeTime!=null)?json.dischargeTime:null);
    /**
     * 生存状态：false生存，true死亡
     * @type {Boolean}
     */
    this.existenceState = build.buildBoolean(json&&(json.existenceState!=null)?json.existenceState:null);
    /**
     * 死亡时间
     * @type {String}
     */
    this.deathTime = build.buildString(json&&(json.deathTime!=null)?json.deathTime:null);
    /**
     * 死亡原因
     * @type {String}
     */
    this.deathReason = build.buildString(json&&(json.deathReason!=null)?json.deathReason:null);
    /**
     * 最后随访状态
     * @type {Number}
     */
    this.latelyFollowupState = build.buildNumber(json&&(json.latelyFollowupState!=null)?json.latelyFollowupState:null);
    /**
     * 是否使用新问卷：0-否，1-是
     * @type {Boolean}
     */
    this.isNewTask = build.buildBoolean(json&&(json.isNewTask!=null)?json.isNewTask:null);
    /**
     * 参考信息
     * @type {FollowupReferenceInfo}
     */
    this.referenceInfo = build.buildFollowupReferenceInfo(json&&(json.referenceInfo!=null)?json.referenceInfo:null);
    /**
     * 问卷录入提交记录ID
     * @type {Number}
     */
    this.submitRecordId = build.buildNumber(json&&(json.submitRecordId!=null)?json.submitRecordId:null);
    /**
     * 是否新参考信息：0-否，1-是
     * @type {Boolean}
     */
    this.isNewReference = build.buildBoolean(json&&(json.isNewReference!=null)?json.isNewReference:null);
    /**
     * 当前随访状态
     * @type {Number}
     */
    this.currentFollowupState = build.buildNumber(json&&(json.currentFollowupState!=null)?json.currentFollowupState:null);
    /**
     * 是否录音切割：0-否，1-是
     * @type {Boolean}
     */
    this.isRecordingSplit = build.buildBoolean(json&&(json.isRecordingSplit!=null)?json.isRecordingSplit:null);
    /**
     * 是否参考信息必读：0-否，1-是
     * @type {Boolean}
     */
    this.isReferenceRead = build.buildBoolean(json&&(json.isReferenceRead!=null)?json.isReferenceRead:null);
    /**
     * 是否开启需复核池：0-否，1-是
     * @type {Boolean}
     */
    this.isReviewPool = build.buildBoolean(json&&(json.isReviewPool!=null)?json.isReviewPool:null);
    /**
     * 复核状态
     * @type {Number}
     */
    this.reviewStatus = build.buildNumber(json&&(json.reviewStatus!=null)?json.reviewStatus:null);
    /**
     * 无能力状态
     * @type {Number}
     */
    this.incapableState = build.buildNumber(json&&(json.incapableState!=null)?json.incapableState:null);
    /**
     * 无能力原因
     * @type {String}
     */
    this.incapableReason = build.buildString(json&&(json.incapableReason!=null)?json.incapableReason:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 随访患者标签
     * @type {Array.<String>}
     */
    this.followupPatientTags = build.buildArray(json&&(json.followupPatientTags!=null)?json.followupPatientTags:null,build.buildString);
}
/** 患者随访问卷记录 **/
function PatientFollowUpQuestionnaireRecord(json=false){
    /**
     * 随访组随访记录ID
     * @type {Number}
     */
    this.followupGroupRecordId = build.buildNumber(json&&(json.followupGroupRecordId!=null)?json.followupGroupRecordId:null);
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 问卷模板名称
     * @type {String}
     */
    this.questionnaireTemplateName = build.buildString(json&&(json.questionnaireTemplateName!=null)?json.questionnaireTemplateName:null);
    /**
     * 问卷模板描述
     * @type {String}
     */
    this.questionnaireTemplateDescription = build.buildString(json&&(json.questionnaireTemplateDescription!=null)?json.questionnaireTemplateDescription:null);
    /**
     * 随访记录次序
     * @type {Number}
     */
    this.followupSequence = build.buildNumber(json&&(json.followupSequence!=null)?json.followupSequence:null);
    /**
     * 开始时间（收到时间）
     * @type {String}
     */
    this.followupStartdate = build.buildString(json&&(json.followupStartdate!=null)?json.followupStartdate:null);
    /**
     * 随访状态：1问卷待填写、2已填写完成、3电话随访进行中、4失访、5死亡
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
}
/** 呼叫状态响应结果 **/
function CallRecord(json=false){
    /**
     * 是否失访
     * @type {Boolean}
     */
    this.isLossFollowup = build.buildBoolean(json&&(json.isLossFollowup!=null)?json.isLossFollowup:null);
    /**
     * 随访人呼叫列表
     * @type {Array.<PatientPhoneNumber>}
     */
    this.patientPhoneNumbers = build.buildArray(json&&(json.patientPhoneNumbers!=null)?json.patientPhoneNumbers:null,build.buildPatientPhoneNumber);
}
/** 用户登录时间统计 **/
function UserLogin(json=false){
    /**
     * 时间
     * @type {String}
     */
    this.time = build.buildString(json&&(json.time!=null)?json.time:null);
    /**
     * 日期
     * @type {String}
     */
    this.date = build.buildString(json&&(json.date!=null)?json.date:null);
}
/** HttpResult **/
function HttpResult_UserTaskSpotCheckStatisticss(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<UserTaskSpotCheckStatistics>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildUserTaskSpotCheckStatistics);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 问卷颜色提示 **/
function ColorTips(json=false){
    /**
     * 红色提示
     * @type {String}
     */
    this.redTip = build.buildString(json&&(json.redTip!=null)?json.redTip:null);
    /**
     * 黄色提示
     * @type {String}
     */
    this.yellowTip = build.buildString(json&&(json.yellowTip!=null)?json.yellowTip:null);
    /**
     * 绿色提示
     * @type {String}
     */
    this.greenTip = build.buildString(json&&(json.greenTip!=null)?json.greenTip:null);
}
/** HttpResult **/
function HttpResult_longs(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<Number>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildNumber);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TPatientQuestionnaireAnswerResp(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {TPatientQuestionnaireAnswerResp}
     */
    this.retValue = build.buildTPatientQuestionnaireAnswerResp(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 下拉列表内容 **/
function GroupInfo(json=false){
    /**
     * ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 组id
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 组名
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 序号
     * @type {Number}
     */
    this.serialNumber = build.buildNumber(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * 标签id
     * @type {Number}
     */
    this.tagId = build.buildNumber(json&&(json.tagId!=null)?json.tagId:null);
    /**
     * 选项内容
     * @type {String}
     */
    this.optionContent = build.buildString(json&&(json.optionContent!=null)?json.optionContent:null);
    /**
     * 标准结果
     * @type {String}
     */
    this.optionResult = build.buildString(json&&(json.optionResult!=null)?json.optionResult:null);
    /**
     * 描述
     * @type {String}
     */
    this.optionRemark = build.buildString(json&&(json.optionRemark!=null)?json.optionRemark:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 是否删除：0否1是
     * @type {Boolean}
     */
    this.isDelete = build.buildBoolean(json&&(json.isDelete!=null)?json.isDelete:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 编辑时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 编辑随访组 **/
function EditFollowupGroup(json=false){
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访组头像
     * @type {String}
     */
    this.groupImage = build.buildString(json&&(json.groupImage!=null)?json.groupImage:null);
    /**
     * 随访组名称
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 随访组间隔时间集合
     * @type {Array.<FollowupGroupInterval>}
     */
    this.createFollowupGroupInterval = build.buildArray(json&&(json.createFollowupGroupInterval!=null)?json.createFollowupGroupInterval:null,build.buildFollowupGroupInterval);
    /**
     * 随访组对应患者集合
     * @type {Array.<Number>}
     */
    this.patientId = build.buildArray(json&&(json.patientId!=null)?json.patientId:null,build.buildNumber);
    /**
     * 随访组对应医生集合
     * @type {Array.<Number>}
     */
    this.doctorId = build.buildArray(json&&(json.doctorId!=null)?json.doctorId:null,build.buildNumber);
}
/** 坐席指标预告信息 **/
function SeatQuotaInfoResp(json=false){
    /**
     * 任务id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.name = build.buildString(json&&(json.name!=null)?json.name:null);
    /**
     * 总指标量
     * @type {Number}
     */
    this.totalQuotaNumber = build.buildNumber(json&&(json.totalQuotaNumber!=null)?json.totalQuotaNumber:null);
    /**
     * 总成功指标量
     * @type {Number}
     */
    this.totalSuccessQuotaNumber = build.buildNumber(json&&(json.totalSuccessQuotaNumber!=null)?json.totalSuccessQuotaNumber:null);
    /**
     * 总成功指标完成量
     * @type {Number}
     */
    this.totalSuccessQuotaFinishNumber = build.buildNumber(json&&(json.totalSuccessQuotaFinishNumber!=null)?json.totalSuccessQuotaFinishNumber:null);
    /**
     * 总呼叫指标量
     * @type {Number}
     */
    this.totalCallQuotaNumber = build.buildNumber(json&&(json.totalCallQuotaNumber!=null)?json.totalCallQuotaNumber:null);
    /**
     * 总呼叫指标完成量
     * @type {Number}
     */
    this.totalCallQuotaFinishNumber = build.buildNumber(json&&(json.totalCallQuotaFinishNumber!=null)?json.totalCallQuotaFinishNumber:null);
    /**
     * 呼叫量数据颜色1红，2绿
     * @type {Number}
     */
    this.callDataColor = build.buildNumber(json&&(json.callDataColor!=null)?json.callDataColor:null);
    /**
     * 成功量数据颜色，1红，2绿
     * @type {Number}
     */
    this.successDataColor = build.buildNumber(json&&(json.successDataColor!=null)?json.successDataColor:null);
    /**
     * 指标配置详情集合
     * @type {Array.<SeatDayIndexDetail>}
     */
    this.indexConfigDetailList = build.buildArray(json&&(json.indexConfigDetailList!=null)?json.indexConfigDetailList:null,build.buildSeatDayIndexDetail);
}
/** HttpResult **/
function HttpResult_SeatPatientFileRelationships(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SeatPatientFileRelationship>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSeatPatientFileRelationship);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 存储号码 **/
function RelationshipLevel(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 等级
     * @type {Number}
     */
    this.level = build.buildNumber(json&&(json.level!=null)?json.level:null);
    /**
     * 关系
     * @type {String}
     */
    this.relationship = build.buildString(json&&(json.relationship!=null)?json.relationship:null);
}
/** 随访组详情展示 **/
function FollowupGroup(json=false){
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访组头像
     * @type {String}
     */
    this.groupImage = build.buildString(json&&(json.groupImage!=null)?json.groupImage:null);
    /**
     * 随访组名称
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 创建人
     * @type {Number}
     */
    this.createUserId = build.buildNumber(json&&(json.createUserId!=null)?json.createUserId:null);
    /**
     * 随访组间隔时间集合
     * @type {Array.<FollowupGroupInterval>}
     */
    this.followupGroupIntervals = build.buildArray(json&&(json.followupGroupIntervals!=null)?json.followupGroupIntervals:null,build.buildFollowupGroupInterval);
    /**
     * 随访组对应患者集合
     * @type {Array.<FollowupGroupPatient>}
     */
    this.followupGroupPatients = build.buildArray(json&&(json.followupGroupPatients!=null)?json.followupGroupPatients:null,build.buildFollowupGroupPatient);
    /**
     * 随访组对应医生集合
     * @type {Array.<FollowupGroupDoctor>}
     */
    this.followupGroupDoctors = build.buildArray(json&&(json.followupGroupDoctors!=null)?json.followupGroupDoctors:null,build.buildFollowupGroupDoctor);
}
/** 随访问卷 **/
function QaTaskInfo(json=false){
    /**
     * 任务名称
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 考卷id
     * @type {Number}
     */
    this.paperId = build.buildNumber(json&&(json.paperId!=null)?json.paperId:null);
    /**
     * 问卷答案id
     * @type {Number}
     */
    this.paperResultId = build.buildNumber(json&&(json.paperResultId!=null)?json.paperResultId:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.gmtModify = build.buildString(json&&(json.gmtModify!=null)?json.gmtModify:null);
}
/** HttpResult **/
function HttpResult_bool(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Boolean}
     */
    this.retValue = build.buildBoolean(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_CallPatientInspectionReports(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<CallPatientInspectionReport>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildCallPatientInspectionReport);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 专病库同步推送参数 **/
function SdrAsyncPushParam(json=false){
    /**
     * 同步联系：1上传名单，2上传参考信息，3呼叫记录，4随访完成（成功、未成功、失访状态），5质控，6新增联系方式，7新结构推送
     * @type {Number}
     */
    this.asyncType = build.buildNumber(json&&(json.asyncType!=null)?json.asyncType:null);
    /**
     * 疾病Id
     * @type {Number}
     */
    this.diseaseId = build.buildNumber(json&&(json.diseaseId!=null)?json.diseaseId:null);
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followupTaskId = build.buildNumber(json&&(json.followupTaskId!=null)?json.followupTaskId:null);
    /**
     * 患者基本信息
     * @type {Array.<NewDeliverTableFixedFieldInfo>}
     */
    this.patientBasicInfoList = build.buildArray(json&&(json.patientBasicInfoList!=null)?json.patientBasicInfoList:null,build.buildNewDeliverTableFixedFieldInfo);
    /**
     * 答案列表
     * @type {Array.<QuestionnaireAnswerInfoNew>}
     */
    this.answerList = build.buildArray(json&&(json.answerList!=null)?json.answerList:null,build.buildQuestionnaireAnswerInfoNew);
    /**
     * 呼叫记录
     * @type {Array.<TNewFollowupCallRecordResp>}
     */
    this.callRecordRespList = build.buildArray(json&&(json.callRecordRespList!=null)?json.callRecordRespList:null,build.buildTNewFollowupCallRecordResp);
    /**
     * 添加联系方式
     * @type {Array.<TNewFollowupCallRecordResp>}
     */
    this.addContactInfoList = build.buildArray(json&&(json.addContactInfoList!=null)?json.addContactInfoList:null,build.buildTNewFollowupCallRecordResp);
    /**
     * 质控记录
     * @type {Array.<SdrSpotCheckRemarks>}
     */
    this.spotCheckRemarksList = build.buildArray(json&&(json.spotCheckRemarksList!=null)?json.spotCheckRemarksList:null,build.buildSdrSpotCheckRemarks);
    /**
     * 随访信息列表
     * @type {Array.<SdrAsyncPushFollowupParam>}
     */
    this.asyncPushFollowupList = build.buildArray(json&&(json.asyncPushFollowupList!=null)?json.asyncPushFollowupList:null,build.buildSdrAsyncPushFollowupParam);
}
/** HttpResult **/
function HttpResult_StudyInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<StudyInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildStudyInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访组间隔时间 **/
function FollowupGroupInterval(json=false){
    /**
     * 主键
     * @type {Number}
     */
    this.intervalId = build.buildNumber(json&&(json.intervalId!=null)?json.intervalId:null);
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访间隔时间次序
     * @type {Number}
     */
    this.intervalSequence = build.buildNumber(json&&(json.intervalSequence!=null)?json.intervalSequence:null);
    /**
     * 随访间隔时间（年）
     * @type {Number}
     */
    this.intervalYear = build.buildNumber(json&&(json.intervalYear!=null)?json.intervalYear:null);
    /**
     * 随访间隔时间（月）
     * @type {Number}
     */
    this.intervalMonth = build.buildNumber(json&&(json.intervalMonth!=null)?json.intervalMonth:null);
    /**
     * 随访间隔时间（周）
     * @type {Number}
     */
    this.intervalWeek = build.buildNumber(json&&(json.intervalWeek!=null)?json.intervalWeek:null);
}
/** 电话随访抽查结果 **/
function CallTaskSpotCheck(json=false){
    /**
     * 被查工号
     * @type {Number}
     */
    this.coverCheckUserId = build.buildNumber(json&&(json.coverCheckUserId!=null)?json.coverCheckUserId:null);
    /**
     * 姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 抽查状态 1：合格 2：不合格，不需重拨 3：不合格，需重播 4：不符合抽查条件
     * @type {Number}
     */
    this.spotCheckState = build.buildNumber(json&&(json.spotCheckState!=null)?json.spotCheckState:null);
    /**
     * 抽查描述
     * @type {String}
     */
    this.spotCheckDescribe = build.buildString(json&&(json.spotCheckDescribe!=null)?json.spotCheckDescribe:null);
    /**
     * 抽查日期
     * @type {String}
     */
    this.spotCheckDate = build.buildString(json&&(json.spotCheckDate!=null)?json.spotCheckDate:null);
    /**
     * 抽查人姓名
     * @type {String}
     */
    this.spotCheckName = build.buildString(json&&(json.spotCheckName!=null)?json.spotCheckName:null);
    /**
     * 抽查人id
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 是否重播
     * @type {Boolean}
     */
    this.isToReplay = build.buildBoolean(json&&(json.isToReplay!=null)?json.isToReplay:null);
    /**
     * 重播日期
     * @type {String}
     */
    this.toReplayDate = build.buildString(json&&(json.toReplayDate!=null)?json.toReplayDate:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室名称
     * @type {String}
     */
    this.deptName = build.buildString(json&&(json.deptName!=null)?json.deptName:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 任务详情ID
     * @type {Number}
     */
    this.callTaskId = build.buildNumber(json&&(json.callTaskId!=null)?json.callTaskId:null);
    /**
     * 任务ID
     * @type {Number}
     */
    this.callTaskCenterId = build.buildNumber(json&&(json.callTaskCenterId!=null)?json.callTaskCenterId:null);
    /**
     * 完成号码
     * @type {String}
     */
    this.completeNumber = build.buildString(json&&(json.completeNumber!=null)?json.completeNumber:null);
    /**
     * 阿里云录音ID
     * @type {String}
     */
    this.contactId = build.buildString(json&&(json.contactId!=null)?json.contactId:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
}
/** 工作台任务随访数据 **/
function OperationPlatformTaskFollowupData(json=false){
    /**
     * 任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访成功数
     * @type {Number}
     */
    this.successNumber = build.buildNumber(json&&(json.successNumber!=null)?json.successNumber:null);
    /**
     * 成功率
     * @type {String}
     */
    this.successRate = build.buildString(json&&(json.successRate!=null)?json.successRate:null);
    /**
     * 失访数
     * @type {Number}
     */
    this.loseNumber = build.buildNumber(json&&(json.loseNumber!=null)?json.loseNumber:null);
    /**
     * 失访率
     * @type {String}
     */
    this.loseRate = build.buildString(json&&(json.loseRate!=null)?json.loseRate:null);
    /**
     * 拒随数
     * @type {Number}
     */
    this.refuseNumber = build.buildNumber(json&&(json.refuseNumber!=null)?json.refuseNumber:null);
    /**
     * 拒随率
     * @type {String}
     */
    this.refuseRate = build.buildString(json&&(json.refuseRate!=null)?json.refuseRate:null);
    /**
     * 稍后拨打数
     * @type {Number}
     */
    this.laterNumber = build.buildNumber(json&&(json.laterNumber!=null)?json.laterNumber:null);
    /**
     * 异常数
     * @type {Number}
     */
    this.exceptionNumber = build.buildNumber(json&&(json.exceptionNumber!=null)?json.exceptionNumber:null);
    /**
     * 质控合格数
     * @type {Number}
     */
    this.qualifiedNumber = build.buildNumber(json&&(json.qualifiedNumber!=null)?json.qualifiedNumber:null);
    /**
     * 质控合格率
     * @type {String}
     */
    this.qualifiedRate = build.buildString(json&&(json.qualifiedRate!=null)?json.qualifiedRate:null);
    /**
     * 质控人数
     * @type {Number}
     */
    this.qualityPersonNumber = build.buildNumber(json&&(json.qualityPersonNumber!=null)?json.qualityPersonNumber:null);
    /**
     * 平均通话时长（完成有效）
     * @type {String}
     */
    this.avgCompleteValidTime = build.buildString(json&&(json.avgCompleteValidTime!=null)?json.avgCompleteValidTime:null);
    /**
     * 有效通话时长中位数
     * @type {String}
     */
    this.validTalkTimeMedian = build.buildString(json&&(json.validTalkTimeMedian!=null)?json.validTalkTimeMedian:null);
}
/** HttpResult **/
function HttpResult_PatientReferenceFieldGroupInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<PatientReferenceFieldGroupInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildPatientReferenceFieldGroupInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowupAwardInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupAwardInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupAwardInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowUpTaskPatientCallRecords(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowUpTaskPatientCallRecord>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowUpTaskPatientCallRecord);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 电话随访周期统计 **/
function CallPeriodicStatistics(json=false){
    /**
     * 日期
     * @type {String}
     */
    this.date = build.buildString(json&&(json.date!=null)?json.date:null);
    /**
     * 呼叫人数
     * @type {Number}
     */
    this.callPeopleNumber = build.buildNumber(json&&(json.callPeopleNumber!=null)?json.callPeopleNumber:null);
    /**
     * 拨打次数
     * @type {Number}
     */
    this.callSecondNumber = build.buildNumber(json&&(json.callSecondNumber!=null)?json.callSecondNumber:null);
    /**
     * 完成随访数
     * @type {Number}
     */
    this.completeFollowupNumber = build.buildNumber(json&&(json.completeFollowupNumber!=null)?json.completeFollowupNumber:null);
    /**
     * 异常数
     * @type {Number}
     */
    this.abnormalNumber = build.buildNumber(json&&(json.abnormalNumber!=null)?json.abnormalNumber:null);
    /**
     * 稍后拨打数
     * @type {Number}
     */
    this.callLaterNumber = build.buildNumber(json&&(json.callLaterNumber!=null)?json.callLaterNumber:null);
}
/** 新交付表问卷表头信息（选项） **/
function DeliveryHeadOptionList(json=false){
    /**
     * 问题id
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 选项id
     * @type {Number}
     */
    this.optionId = build.buildNumber(json&&(json.optionId!=null)?json.optionId:null);
    /**
     * 选项表头
     * @type {String}
     */
    this.optionExportName = build.buildString(json&&(json.optionExportName!=null)?json.optionExportName:null);
    /**
     * 答案
     * @type {String}
     */
    this.optionAnswerInfo = build.buildString(json&&(json.optionAnswerInfo!=null)?json.optionAnswerInfo:null);
}
/** HttpResult **/
function HttpResult_WeekStars(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<WeekStar>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildWeekStar);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 问卷质控规则(合并) **/
function QualityRuleResp(json=false){
    /**
     * 问卷题目
     * @type {String}
     */
    this.questionTitle = build.buildString(json&&(json.questionTitle!=null)?json.questionTitle:null);
    /**
     * 关联题目id
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 规则信息
     * @type {Array.<QuestionnaireQualityRuleResp>}
     */
    this.ruleInfo = build.buildArray(json&&(json.ruleInfo!=null)?json.ruleInfo:null,build.buildQuestionnaireQualityRuleResp);
}
/** 新交付表问卷答案信息 **/
function QuestionnaireAnswerInfoNew(json=false){
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 答案信息
     * @type {Array.<DeliveryHeadList>}
     */
    this.answers = build.buildArray(json&&(json.answers!=null)?json.answers:null,build.buildDeliveryHeadList);
}
/** 患者检查记录 **/
function CallPatientInspectionReport(json=false){
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 报告来源 1同步更新 2手动上传
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 就诊类别（ 0门诊 1住院  2体检）
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
    /**
     * 报告列表
     * @type {String}
     */
    this.reportList = build.buildString(json&&(json.reportList!=null)?json.reportList:null);
    /**
     * 科室
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 检查时间
     * @type {String}
     */
    this.examineDate = build.buildString(json&&(json.examineDate!=null)?json.examineDate:null);
}
/** 登录返回的认证 **/
function UserInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 手机号码
     * @type {String}
     */
    this.mobile = build.buildString(json&&(json.mobile!=null)?json.mobile:null);
    /**
     * 登录名称
     * @type {String}
     */
    this.loginName = build.buildString(json&&(json.loginName!=null)?json.loginName:null);
    /**
     * 头像
     * @type {String}
     */
    this.userIcon = build.buildString(json&&(json.userIcon!=null)?json.userIcon:null);
    /**
     * 性别
     * @type {Number}
     */
    this.userSex = build.buildNumber(json&&(json.userSex!=null)?json.userSex:null);
    /**
     * 用户类型
     * @type {Number}
     */
    this.userType = build.buildNumber(json&&(json.userType!=null)?json.userType:null);
    /**
     * 名称
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * im密码
     * @type {String}
     */
    this.imPassword = build.buildString(json&&(json.imPassword!=null)?json.imPassword:null);
    /**
     * 是否设置登录密码
     * @type {Boolean}
     */
    this.isSetLoginPassword = build.buildBoolean(json&&(json.isSetLoginPassword!=null)?json.isSetLoginPassword:null);
    /**
     * 设备名
     * @type {String}
     */
    this.osName = build.buildString(json&&(json.osName!=null)?json.osName:null);
    /**
     * 上次的登录时间
     * @type {String}
     */
    this.lastLoginTime = build.buildString(json&&(json.lastLoginTime!=null)?json.lastLoginTime:null);
    /**
     * 版本
     * @type {String}
     */
    this.version = build.buildString(json&&(json.version!=null)?json.version:null);
    /**
     * 权限
     * @type {Array.<String>}
     */
    this.userRole = build.buildArray(json&&(json.userRole!=null)?json.userRole:null,build.buildString);
    /**
     * 是否禁用
     * @type {Boolean}
     */
    this.isEnable = build.buildBoolean(json&&(json.isEnable!=null)?json.isEnable:null);
    /**
     * 注册时间
     * @type {String}
     */
    this.addTime = build.buildString(json&&(json.addTime!=null)?json.addTime:null);
    /**
     * 是否验证随访
     * @type {Boolean}
     */
    this.isCheckingFollowup = build.buildBoolean(json&&(json.isCheckingFollowup!=null)?json.isCheckingFollowup:null);
    /**
     * 验证随访状态：1默认状态不需要处理，2验证成功，3验证失败，4验证随访状态超过次数
     * @type {Number}
     */
    this.checkingFollowupType = build.buildNumber(json&&(json.checkingFollowupType!=null)?json.checkingFollowupType:null);
    /**
     * 渠道id
     * @type {Number}
     */
    this.channelId = build.buildNumber(json&&(json.channelId!=null)?json.channelId:null);
    /**
     * 是否是新用户
     * @type {Boolean}
     */
    this.isNewUser = build.buildBoolean(json&&(json.isNewUser!=null)?json.isNewUser:null);
}
/** 每题的答案 **/
function AdmissionAnswerInfo(json=false){
    /**
     * 题标
     * @type {String}
     */
    this.number = build.buildString(json&&(json.number!=null)?json.number:null);
    /**
     * 答案
     * @type {String}
     */
    this.answer = build.buildString(json&&(json.answer!=null)?json.answer:null);
    /**
     * 题目
     * @type {String}
     */
    this.topicContent = build.buildString(json&&(json.topicContent!=null)?json.topicContent:null);
}
/** 返回随访组内每位患者每次的APP随访记录详情 **/
function FollowupGroupPatientEachRecordAppDetail(json=false){
    /**
     * 随访记录ID
     * @type {Number}
     */
    this.followupGroupRecordId = build.buildNumber(json&&(json.followupGroupRecordId!=null)?json.followupGroupRecordId:null);
    /**
     * 随访组名称
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 随访记录次序
     * @type {Number}
     */
    this.followupSequence = build.buildNumber(json&&(json.followupSequence!=null)?json.followupSequence:null);
    /**
     * 随访状态 1问卷待填写、2已填写完成、3电话随访进行中、4失访、5死亡
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 随访方式：1.APP随访  2.电话随访
     * @type {Number}
     */
    this.followupMode = build.buildNumber(json&&(json.followupMode!=null)?json.followupMode:null);
    /**
     * 随访完成时间(本次没完成展示上次的)
     * @type {String}
     */
    this.followupOverdate = build.buildString(json&&(json.followupOverdate!=null)?json.followupOverdate:null);
    /**
     * 患者提交问卷的题目及答案
     * @type {Array.<ShowPatientQuestionAnswer>}
     */
    this.showPatientQuestionAnswer = build.buildArray(json&&(json.showPatientQuestionAnswer!=null)?json.showPatientQuestionAnswer:null,build.buildShowPatientQuestionAnswer);
}
/** 就诊流水号获取住院手术记录 **/
function MedicalSurgeryRecord(json=false){
    /**
     * 手术名称
     * @type {String}
     */
    this.surgeryName = build.buildString(json&&(json.surgeryName!=null)?json.surgeryName:null);
    /**
     * 手术开始时间（格式：yyyyMMdd HH:mm:ss）
     * @type {String}
     */
    this.surgeryTime = build.buildString(json&&(json.surgeryTime!=null)?json.surgeryTime:null);
}
/** HttpResult **/
function HttpResult_CallCenterUser(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {CallCenterUser}
     */
    this.retValue = build.buildCallCenterUser(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访短信模板列表 **/
function TTaskAndSmsRelationshipResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访任务表id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 短信code
     * @type {String}
     */
    this.smsCode = build.buildString(json&&(json.smsCode!=null)?json.smsCode:null);
    /**
     * 短信内容
     * @type {String}
     */
    this.smsContent = build.buildString(json&&(json.smsContent!=null)?json.smsContent:null);
    /**
     * 短信变量属性
     * @type {String}
     */
    this.smsVariable = build.buildString(json&&(json.smsVariable!=null)?json.smsVariable:null);
    /**
     * 短信标题
     * @type {String}
     */
    this.smsTitle = build.buildString(json&&(json.smsTitle!=null)?json.smsTitle:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 是否删除：false未删除 true已删除
     * @type {Boolean}
     */
    this.isDelete = build.buildBoolean(json&&(json.isDelete!=null)?json.isDelete:null);
}
/** 新交付表问卷表头信息 **/
function DeliveryHeadList(json=false){
    /**
     * 问题id
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 问题表头（疾病字段）
     * @type {String}
     */
    this.questionTitle = build.buildString(json&&(json.questionTitle!=null)?json.questionTitle:null);
    /**
     * 疾病id
     * @type {Number}
     */
    this.diseaseId = build.buildNumber(json&&(json.diseaseId!=null)?json.diseaseId:null);
    /**
     * 下标
     * @type {Number}
     */
    this.index = build.buildNumber(json&&(json.index!=null)?json.index:null);
    /**
     * 答案
     * @type {String}
     */
    this.answerInfo = build.buildString(json&&(json.answerInfo!=null)?json.answerInfo:null);
    /**
     * 选项
     * @type {Array.<DeliveryHeadOptionList>}
     */
    this.deliveryHeadOptionList = build.buildArray(json&&(json.deliveryHeadOptionList!=null)?json.deliveryHeadOptionList:null,build.buildDeliveryHeadOptionList);
}
/** HttpResult **/
function HttpResult_TQuestionPageResps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TQuestionPageResp>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTQuestionPageResp);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowupTags(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupTag>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupTag);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** sms短信批量响应参数 **/
function SendBatchResponse(json=false){
    /**
     * Message
     * @type {String}
     */
    this.Message = build.buildString(json&&(json.Message!=null)?json.Message:null);
    /**
     * RequestId
     * @type {String}
     */
    this.RequestId = build.buildString(json&&(json.RequestId!=null)?json.RequestId:null);
    /**
     * BizId
     * @type {String}
     */
    this.BizId = build.buildString(json&&(json.BizId!=null)?json.BizId:null);
    /**
     * Code
     * @type {String}
     */
    this.Code = build.buildString(json&&(json.Code!=null)?json.Code:null);
}
/** UnitSchema **/
function UnitSchema(json=false){
    /**
     * slots
     * @type {Array.<UnitSlots>}
     */
    this.slots = build.buildArray(json&&(json.slots!=null)?json.slots:null,build.buildUnitSlots);
    /**
     * intent
     * @type {String}
     */
    this.intent = build.buildString(json&&(json.intent!=null)?json.intent:null);
}
/** 随访组对应患者 **/
function FollowupGroupPatient(json=false){
    /**
     * 主键
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访组对应患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 患者头像
     * @type {String}
     */
    this.userIcon = build.buildString(json&&(json.userIcon!=null)?json.userIcon:null);
    /**
     * 加入时间
     * @type {String}
     */
    this.joinTime = build.buildString(json&&(json.joinTime!=null)?json.joinTime:null);
}
/** 患者提交问卷 **/
function PatientSubmitFollowUpQuestionnaire(json=false){
    /**
     * 题目ID
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 答案字符串
     * @type {String}
     */
    this.answerString = build.buildString(json&&(json.answerString!=null)?json.answerString:null);
    /**
     * 用户ID
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 评分
     * @type {String}
     */
    this.score = build.buildString(json&&(json.score!=null)?json.score:null);
    /**
     * 涉及图片url
     * @type {String}
     */
    this.imageUrl = build.buildString(json&&(json.imageUrl!=null)?json.imageUrl:null);
}
/** 选项 **/
function QuestionOption(json=false){
    /**
     * 选项
     * @type {String}
     */
    this.option = build.buildString(json&&(json.option!=null)?json.option:null);
    /**
     * 选项分数
     * @type {Number}
     */
    this.score = build.buildNumber(json&&(json.score!=null)?json.score:null);
    /**
     * 是否选择改选项
     * @type {Boolean}
     */
    this.isSelected = build.buildBoolean(json&&(json.isSelected!=null)?json.isSelected:null);
    /**
     * 是否填写
     * @type {Boolean}
     */
    this.isOther = build.buildBoolean(json&&(json.isOther!=null)?json.isOther:null);
    /**
     * 答案内容
     * @type {String}
     */
    this.answerContent = build.buildString(json&&(json.answerContent!=null)?json.answerContent:null);
    /**
     * 是否有UUId
     * @type {Boolean}
     */
    this.hasUUID = build.buildBoolean(json&&(json.hasUUID!=null)?json.hasUUID:null);
    /**
     * 内容类型
     * @type {String}
     */
    this.contentType = build.buildString(json&&(json.contentType!=null)?json.contentType:null);
    /**
     * 内容的值
     * @type {String}
     */
    this.contentValue = build.buildString(json&&(json.contentValue!=null)?json.contentValue:null);
    /**
     * ${parameter.des}
     * @type {String}
     */
    this.anotherQuestionUUID = build.buildString(json&&(json.anotherQuestionUUID!=null)?json.anotherQuestionUUID:null);
}
/** HttpResult **/
function HttpResult_PatientAllFollowupLists(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<PatientAllFollowupList>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildPatientAllFollowupList);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** API返回随访组内每位患者每次的随访记录 **/
function FollowupGroupPatientEachRecord(json=false){
    /**
     * 随访记录ID
     * @type {Number}
     */
    this.followupGroupRecordId = build.buildNumber(json&&(json.followupGroupRecordId!=null)?json.followupGroupRecordId:null);
    /**
     * 患者Id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访记录次序
     * @type {Number}
     */
    this.followupSequence = build.buildNumber(json&&(json.followupSequence!=null)?json.followupSequence:null);
    /**
     * 随访方式：1.APP随访  2.电话随访
     * @type {Number}
     */
    this.followupMode = build.buildNumber(json&&(json.followupMode!=null)?json.followupMode:null);
    /**
     * 随访状态 1问卷待填写、2已填写完成、3电话随访进行中、4失访、5死亡
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 随访完成时间(本次没完成展示上次的)
     * @type {String}
     */
    this.followupOverdate = build.buildString(json&&(json.followupOverdate!=null)?json.followupOverdate:null);
}
/** HttpResult **/
function HttpResult_TQuestionInfoResps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TQuestionInfoResp>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTQuestionInfoResp);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访短信发送记录 **/
function TFollowupSmsSendRecordResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 发送人Id
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 发送人来源：1呼叫台，2管理台，3监管台
     * @type {Number}
     */
    this.userSourceType = build.buildNumber(json&&(json.userSourceType!=null)?json.userSourceType:null);
    /**
     * 发送人名称
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者名称
     * @type {String}
     */
    this.followupPatientName = build.buildString(json&&(json.followupPatientName!=null)?json.followupPatientName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.aadmitNo = build.buildString(json&&(json.aadmitNo!=null)?json.aadmitNo:null);
    /**
     * 任务ID
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访状态
     * @type {String}
     */
    this.followUpTaskState = build.buildString(json&&(json.followUpTaskState!=null)?json.followUpTaskState:null);
    /**
     * 接收号码ID
     * @type {Number}
     */
    this.phoneNumberId = build.buildNumber(json&&(json.phoneNumberId!=null)?json.phoneNumberId:null);
    /**
     * 接收号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 短信模板code
     * @type {String}
     */
    this.templateCode = build.buildString(json&&(json.templateCode!=null)?json.templateCode:null);
    /**
     * 短信模板类型
     * @type {String}
     */
    this.templateTypes = build.buildString(json&&(json.templateTypes!=null)?json.templateTypes:null);
    /**
     * 短信标题
     * @type {String}
     */
    this.templateTitle = build.buildString(json&&(json.templateTitle!=null)?json.templateTitle:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.crateTime = build.buildString(json&&(json.crateTime!=null)?json.crateTime:null);
    /**
     * 发送状态：true-失败，false-成功
     * @type {String}
     */
    this.sendStatus = build.buildString(json&&(json.sendStatus!=null)?json.sendStatus:null);
    /**
     * 失败原因
     * @type {String}
     */
    this.failReason = build.buildString(json&&(json.failReason!=null)?json.failReason:null);
    /**
     * 短信内容
     * @type {String}
     */
    this.messageInfo = build.buildString(json&&(json.messageInfo!=null)?json.messageInfo:null);
    /**
     * 批次id
     * @type {Number}
     */
    this.batchId = build.buildNumber(json&&(json.batchId!=null)?json.batchId:null);
    /**
     * 批次名称
     * @type {String}
     */
    this.batchName = build.buildString(json&&(json.batchName!=null)?json.batchName:null);
    /**
     * 名单上传时间
     * @type {String}
     */
    this.uploadTime = build.buildString(json&&(json.uploadTime!=null)?json.uploadTime:null);
    /**
     * 发送次数
     * @type {Number}
     */
    this.sendNumber = build.buildNumber(json&&(json.sendNumber!=null)?json.sendNumber:null);
    /**
     * 发送人来源
     * @type {Number}
     */
    this.senderType = build.buildNumber(json&&(json.senderType!=null)?json.senderType:null);
}
/** 患者检验指标 **/
function LabIndex(json=false){
    /**
     * 检验指标名称
     * @type {String}
     */
    this.labIndexName = build.buildString(json&&(json.labIndexName!=null)?json.labIndexName:null);
    /**
     * 检验指标结果
     * @type {String}
     */
    this.labIndexResult = build.buildString(json&&(json.labIndexResult!=null)?json.labIndexResult:null);
    /**
     * 参考值范围
     * @type {String}
     */
    this.referenceRange = build.buildString(json&&(json.referenceRange!=null)?json.referenceRange:null);
    /**
     * 计量单位
     * @type {String}
     */
    this.unit = build.buildString(json&&(json.unit!=null)?json.unit:null);
    /**
     * 异常提示（NM、正常 H、偏高 L、偏低U、其他）
     * @type {String}
     */
    this.unusualPrompt = build.buildString(json&&(json.unusualPrompt!=null)?json.unusualPrompt:null);
}
/** 呼叫中心用户 **/
function CallCenterUser(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 用户名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 阿里云账户绑定标志
     * @type {Boolean}
     */
    this.isAliyunBound = build.buildBoolean(json&&(json.isAliyunBound!=null)?json.isAliyunBound:null);
    /**
     * 该用户创建时间
     * @type {String}
     */
    this.gmtCreate = build.buildString(json&&(json.gmtCreate!=null)?json.gmtCreate:null);
    /**
     * 该用户信息最后修改时间
     * @type {String}
     */
    this.gmtModified = build.buildString(json&&(json.gmtModified!=null)?json.gmtModified:null);
    /**
     * 是否允许接听
     * @type {Boolean}
     */
    this.isAllowAnswer = build.buildBoolean(json&&(json.isAllowAnswer!=null)?json.isAllowAnswer:null);
    /**
     * JSON WEB TOKEN
     * @type {String}
     */
    this.jwt = build.buildString(json&&(json.jwt!=null)?json.jwt:null);
    /**
     * 用户第一次登录时的JSESSIONID
     * @type {String}
     */
    this.jsessionid = build.buildString(json&&(json.jsessionid!=null)?json.jsessionid:null);
    /**
     * 绑定的设备id
     * @type {String}
     */
    this.serialNumber = build.buildString(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * 用户姓名
     * @type {String}
     */
    this.userRealName = build.buildString(json&&(json.userRealName!=null)?json.userRealName:null);
    /**
     * 用户类别：远程；全职
     * @type {String}
     */
    this.userSort = build.buildString(json&&(json.userSort!=null)?json.userSort:null);
    /**
     * 绑定的手机号
     * @type {String}
     */
    this.phone = build.buildString(json&&(json.phone!=null)?json.phone:null);
    /**
     * 是否允许自动绑定
     * @type {Boolean}
     */
    this.isAuto = build.buildBoolean(json&&(json.isAuto!=null)?json.isAuto:null);
    /**
     * 坐席类型：1阿里云坐席账号，2华为云坐席账号
     * @type {Number}
     */
    this.seatType = build.buildNumber(json&&(json.seatType!=null)?json.seatType:null);
}
/** 通话记录 **/
function TNewFollowupCallRecordResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 客服ID
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 客服姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 接听状态：1呼出，2呼入
     * @type {Number}
     */
    this.answerType = build.buildNumber(json&&(json.answerType!=null)?json.answerType:null);
    /**
     * 随访类型：1短信电话随访，2纯电话随访
     * @type {Number}
     */
    this.followupType = build.buildNumber(json&&(json.followupType!=null)?json.followupType:null);
    /**
     * 任务ID
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访患者详情ID
     * @type {Number}
     */
    this.followUpPatientInfoId = build.buildNumber(json&&(json.followUpPatientInfoId!=null)?json.followUpPatientInfoId:null);
    /**
     * 呼叫号码ID
     * @type {Number}
     */
    this.phoneNumberId = build.buildNumber(json&&(json.phoneNumberId!=null)?json.phoneNumberId:null);
    /**
     * 阿里云录音ID
     * @type {String}
     */
    this.contactId = build.buildString(json&&(json.contactId!=null)?json.contactId:null);
    /**
     * 阿里云录音时长
     * @type {String}
     */
    this.callTime = build.buildString(json&&(json.callTime!=null)?json.callTime:null);
    /**
     * 通话时间
     * @type {String}
     */
    this.talkTime = build.buildString(json&&(json.talkTime!=null)?json.talkTime:null);
    /**
     * 等待时间
     * @type {String}
     */
    this.waitingTime = build.buildString(json&&(json.waitingTime!=null)?json.waitingTime:null);
    /**
     * 呼叫状态: 1稍后拨打，2仅随访该患者，3短信随访成功，4电话随访成功，5初始化，6挂断（接通），7无人接听，8挂断（未接通），9停机，10关机，11拒随，12空号，13错号，14不知情
     * @type {Number}
     */
    this.callState = build.buildNumber(json&&(json.callState!=null)?json.callState:null);
    /**
     * 手机号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 号码关系备注
     * @type {String}
     */
    this.relationshipRemarks = build.buildString(json&&(json.relationshipRemarks!=null)?json.relationshipRemarks:null);
    /**
     * 联系人姓名
     * @type {String}
     */
    this.contactName = build.buildString(json&&(json.contactName!=null)?json.contactName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 主叫号码
     * @type {String}
     */
    this.callingPhoneNumber = build.buildString(json&&(json.callingPhoneNumber!=null)?json.callingPhoneNumber:null);
    /**
     * 是否是有效录音：0-否，1-是
     * @type {Boolean}
     */
    this.isEffective = build.buildBoolean(json&&(json.isEffective!=null)?json.isEffective:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 录音是否备份
     * @type {Boolean}
     */
    this.recordingBackupsState = build.buildBoolean(json&&(json.recordingBackupsState!=null)?json.recordingBackupsState:null);
}
/** 就诊计划 **/
function VisitingTaskInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 根id
     * @type {Number}
     */
    this.rootId = build.buildNumber(json&&(json.rootId!=null)?json.rootId:null);
    /**
     * 父id
     * @type {Number}
     */
    this.parentId = build.buildNumber(json&&(json.parentId!=null)?json.parentId:null);
    /**
     * 绑定计划的就诊id
     * @type {Number}
     */
    this.bindMedicalId = build.buildNumber(json&&(json.bindMedicalId!=null)?json.bindMedicalId:null);
    /**
     * 完成计划的就诊id
     * @type {Number}
     */
    this.completeMedicalId = build.buildNumber(json&&(json.completeMedicalId!=null)?json.completeMedicalId:null);
    /**
     * 随访医院ID
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 随访医院
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 随访科室ID
     * @type {Number}
     */
    this.deptId = build.buildNumber(json&&(json.deptId!=null)?json.deptId:null);
    /**
     * 随访科室
     * @type {String}
     */
    this.deptName = build.buildString(json&&(json.deptName!=null)?json.deptName:null);
    /**
     * 随访疾病
     * @type {String}
     */
    this.disease = build.buildString(json&&(json.disease!=null)?json.disease:null);
    /**
     * 随访医生ID
     * @type {Number}
     */
    this.doctorId = build.buildNumber(json&&(json.doctorId!=null)?json.doctorId:null);
    /**
     * 随访医生
     * @type {String}
     */
    this.doctorName = build.buildString(json&&(json.doctorName!=null)?json.doctorName:null);
    /**
     * 用户id
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 病人id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 方案ID
     * @type {Number}
     */
    this.solutionId = build.buildNumber(json&&(json.solutionId!=null)?json.solutionId:null);
    /**
     * 方案名称
     * @type {String}
     */
    this.solutionName = build.buildString(json&&(json.solutionName!=null)?json.solutionName:null);
    /**
     * 方案描述
     * @type {String}
     */
    this.solutionComment = build.buildString(json&&(json.solutionComment!=null)?json.solutionComment:null);
    /**
     * 计划开始时间
     * @type {String}
     */
    this.startTime = build.buildString(json&&(json.startTime!=null)?json.startTime:null);
    /**
     * 计划结束时间
     * @type {String}
     */
    this.endTime = build.buildString(json&&(json.endTime!=null)?json.endTime:null);
    /**
     * 计划随访时间
     * @type {String}
     */
    this.visitingTime = build.buildString(json&&(json.visitingTime!=null)?json.visitingTime:null);
    /**
     * 实际随访时间
     * @type {String}
     */
    this.realVisitingTime = build.buildString(json&&(json.realVisitingTime!=null)?json.realVisitingTime:null);
    /**
     * 循环第几次
     * @type {Number}
     */
    this.currentTimes = build.buildNumber(json&&(json.currentTimes!=null)?json.currentTimes:null);
    /**
     * 阶段
     * @type {Number}
     */
    this.stage = build.buildNumber(json&&(json.stage!=null)?json.stage:null);
    /**
     * 间隔时间
     * @type {Number}
     */
    this.frequency = build.buildNumber(json&&(json.frequency!=null)?json.frequency:null);
    /**
     * 间隔类型（1-天，2-周，3-月）
     * @type {Number}
     */
    this.frequencyType = build.buildNumber(json&&(json.frequencyType!=null)?json.frequencyType:null);
    /**
     * 开始时间
     * @type {Number}
     */
    this.beginTime = build.buildNumber(json&&(json.beginTime!=null)?json.beginTime:null);
    /**
     * 有效期
     * @type {Number}
     */
    this.invalidTime = build.buildNumber(json&&(json.invalidTime!=null)?json.invalidTime:null);
    /**
     * 类型（1-通用,2-自定义）
     * @type {Number}
     */
    this.originType = build.buildNumber(json&&(json.originType!=null)?json.originType:null);
    /**
     * 检查项
     * @type {String}
     */
    this.checkItem = build.buildString(json&&(json.checkItem!=null)?json.checkItem:null);
    /**
     * 治疗项
     * @type {String}
     */
    this.creatmentItem = build.buildString(json&&(json.creatmentItem!=null)?json.creatmentItem:null);
    /**
     * 状态
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * 外部单号
     * @type {String}
     */
    this.outId = build.buildString(json&&(json.outId!=null)?json.outId:null);
    /**
     * 随访建议
     * @type {String}
     */
    this.suggestion = build.buildString(json&&(json.suggestion!=null)?json.suggestion:null);
    /**
     * 问卷
     * @type {QaTaskInfo}
     */
    this.qaTaskInfo = build.buildQaTaskInfo(json&&(json.qaTaskInfo!=null)?json.qaTaskInfo:null);
    /**
     * 过期原因
     * @type {OverDueInfo}
     */
    this.overDueInfo = build.buildOverDueInfo(json&&(json.overDueInfo!=null)?json.overDueInfo:null);
    /**
     * 事件记录数量
     * @type {Number}
     */
    this.handleCount = build.buildNumber(json&&(json.handleCount!=null)?json.handleCount:null);
    /**
     * 就诊记录数量
     * @type {Number}
     */
    this.medicalCount = build.buildNumber(json&&(json.medicalCount!=null)?json.medicalCount:null);
}
/** 答案 **/
function Answer(json=false){
    /**
     * 答案ID
     * @type {Number}
     */
    this.answerId = build.buildNumber(json&&(json.answerId!=null)?json.answerId:null);
    /**
     * 问卷ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 题目ID
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 选项id集合，逗号隔开
     * @type {String}
     */
    this.option_ids = build.buildString(json&&(json.option_ids!=null)?json.option_ids:null);
    /**
     * 答案字符串
     * @type {String}
     */
    this.answerString = build.buildString(json&&(json.answerString!=null)?json.answerString:null);
    /**
     * huiyi_hospital.t_patient.id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * huiyi_user.t_user.id
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 评分
     * @type {String}
     */
    this.score = build.buildString(json&&(json.score!=null)?json.score:null);
    /**
     * 答案涉及图片地址
     * @type {String}
     */
    this.imageUrl = build.buildString(json&&(json.imageUrl!=null)?json.imageUrl:null);
}
/** HttpResult **/
function HttpResult_FollowupTaskCurrentInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowupTaskCurrentInfo}
     */
    this.retValue = build.buildFollowupTaskCurrentInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访组间隔时间 **/
function CreateFollowupGroupInterval(json=false){
    /**
     * 随访间隔时间次序
     * @type {Number}
     */
    this.intervalSequence = build.buildNumber(json&&(json.intervalSequence!=null)?json.intervalSequence:null);
    /**
     * 随访间隔时间（年）
     * @type {Number}
     */
    this.intervalYear = build.buildNumber(json&&(json.intervalYear!=null)?json.intervalYear:null);
    /**
     * 随访间隔时间（月）
     * @type {Number}
     */
    this.intervalMonth = build.buildNumber(json&&(json.intervalMonth!=null)?json.intervalMonth:null);
    /**
     * 随访间隔时间（周）
     * @type {Number}
     */
    this.intervalWeek = build.buildNumber(json&&(json.intervalWeek!=null)?json.intervalWeek:null);
}
/** HttpResult **/
function HttpResult_Relationships(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<Relationship>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildRelationship);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 录音Id **/
function CallRecordingInfo(json=false){
    /**
     * 呼叫时间
     * @type {String}
     */
    this.callTime = build.buildString(json&&(json.callTime!=null)?json.callTime:null);
    /**
     * 呼叫人
     * @type {String}
     */
    this.callName = build.buildString(json&&(json.callName!=null)?json.callName:null);
    /**
     * 阿里录音Id
     * @type {String}
     */
    this.contactId = build.buildString(json&&(json.contactId!=null)?json.contactId:null);
    /**
     * 电话类型
     * @type {Number}
     */
    this.callStatus = build.buildNumber(json&&(json.callStatus!=null)?json.callStatus:null);
}
/** UnitAction **/
function UnitAction(json=false){
    /**
     * action_id
     * @type {String}
     */
    this.action_id = build.buildString(json&&(json.action_id!=null)?json.action_id:null);
    /**
     * say
     * @type {String}
     */
    this.say = build.buildString(json&&(json.say!=null)?json.say:null);
    /**
     * type
     * @type {String}
     */
    this.type = build.buildString(json&&(json.type!=null)?json.type:null);
}
/** 坐席指标核算、预告结果集 **/
function SeatQuotaTableInfo(json=false){
    /**
     * 年-月-周
     * @type {String}
     */
    this.timeStr = build.buildString(json&&(json.timeStr!=null)?json.timeStr:null);
    /**
     * 开始时间
     * @type {String}
     */
    this.beginTime = build.buildString(json&&(json.beginTime!=null)?json.beginTime:null);
    /**
     * 结束时间
     * @type {String}
     */
    this.endTime = build.buildString(json&&(json.endTime!=null)?json.endTime:null);
    /**
     * 指标预告相关信息
     * @type {Array.<SeatQuotaInfoResp>}
     */
    this.tableInfo = build.buildArray(json&&(json.tableInfo!=null)?json.tableInfo:null,build.buildSeatQuotaInfoResp);
    /**
     * 本周日期范围，年月日
     * @type {Array.<String>}
     */
    this.timeList = build.buildArray(json&&(json.timeList!=null)?json.timeList:null,build.buildString);
}
/** 的话随访问卷详细 **/
function CallCenterQuestionnaireDetails(json=false){
    /**
     * hasGroup
     * @type {Boolean}
     */
    this.hasGroup = build.buildBoolean(json&&(json.hasGroup!=null)?json.hasGroup:null);
    /**
     * groupName
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * groupId
     * @type {String}
     */
    this.groupId = build.buildString(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * selectedQuestionIds
     * @type {String}
     */
    this.selectedQuestionIds = build.buildString(json&&(json.selectedQuestionIds!=null)?json.selectedQuestionIds:null);
    /**
     * answerQuestions
     * @type {Array.<CallCenterAnswerQuestions>}
     */
    this.answerQuestions = build.buildArray(json&&(json.answerQuestions!=null)?json.answerQuestions:null,build.buildCallCenterAnswerQuestions);
    /**
     * relationQuestion
     * @type {String}
     */
    this.relationQuestion = build.buildString(json&&(json.relationQuestion!=null)?json.relationQuestion:null);
}
/** 新消息信息 **/
function NewMessageMangerInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 消息类型
     * @type {Number}
     */
    this.type = build.buildNumber(json&&(json.type!=null)?json.type:null);
    /**
     * 标题
     * @type {String}
     */
    this.title = build.buildString(json&&(json.title!=null)?json.title:null);
    /**
     * 内容
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 终端（可多选，逗号隔开）：1-患者app，2-医生app，3-管理台，4-呼叫中心，5-外部质控
     * @type {String}
     */
    this.terminal = build.buildString(json&&(json.terminal!=null)?json.terminal:null);
    /**
     * 终端（可多选，逗号隔开）：1-患者app，2-医生app，3-管理台，4-呼叫中心，5-外部质控
     * @type {String}
     */
    this.terminalNumber = build.buildString(json&&(json.terminalNumber!=null)?json.terminalNumber:null);
    /**
     * 发送时间
     * @type {String}
     */
    this.sendTime = build.buildString(json&&(json.sendTime!=null)?json.sendTime:null);
    /**
     * 是否发送
     * @type {Boolean}
     */
    this.isSend = build.buildBoolean(json&&(json.isSend!=null)?json.isSend:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 内容类型
     * @type {String}
     */
    this.contentType = build.buildString(json&&(json.contentType!=null)?json.contentType:null);
    /**
     * 类型图片地址
     * @type {String}
     */
    this.typeImageAddress = build.buildString(json&&(json.typeImageAddress!=null)?json.typeImageAddress:null);
    /**
     * 是否强制推送
     * @type {Boolean}
     */
    this.isForceSend = build.buildBoolean(json&&(json.isForceSend!=null)?json.isForceSend:null);
    /**
     * 创建人id
     * @type {Number}
     */
    this.creatorId = build.buildNumber(json&&(json.creatorId!=null)?json.creatorId:null);
    /**
     * 创建人姓名
     * @type {String}
     */
    this.creatorName = build.buildString(json&&(json.creatorName!=null)?json.creatorName:null);
    /**
     * 是否已读
     * @type {Boolean}
     */
    this.isRead = build.buildBoolean(json&&(json.isRead!=null)?json.isRead:null);
    /**
     * 是否点赞
     * @type {Boolean}
     */
    this.isClickLike = build.buildBoolean(json&&(json.isClickLike!=null)?json.isClickLike:null);
    /**
     * 点赞数量
     * @type {Number}
     */
    this.clickLikeNumber = build.buildNumber(json&&(json.clickLikeNumber!=null)?json.clickLikeNumber:null);
    /**
     * 是否确认收到
     * @type {Boolean}
     */
    this.isConfirm = build.buildBoolean(json&&(json.isConfirm!=null)?json.isConfirm:null);
    /**
     * 消息分类：1-常规消息，2-指标核算，3-指标预告
     * @type {Number}
     */
    this.classification = build.buildNumber(json&&(json.classification!=null)?json.classification:null);
}
/** HttpResult **/
function HttpResult_InspectionReportDetailed(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {InspectionReportDetailed}
     */
    this.retValue = build.buildInspectionReportDetailed(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** API返回随访组内每位患者每次的随访记录及随访组名称 **/
function FollowupGroupPatientEachRecordAndGroupName(json=false){
    /**
     * 随访组名称
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * API返回随访组内每位患者每次的随访记录
     * @type {Array.<FollowupGroupPatientEachRecord>}
     */
    this.followupGroupPatientEachRecord = build.buildArray(json&&(json.followupGroupPatientEachRecord!=null)?json.followupGroupPatientEachRecord:null,build.buildFollowupGroupPatientEachRecord);
}
/** 最佳案例信息 **/
function BestCaseInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 任务名
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 11-电话和线上，12-电话，21-线上，22-无
     * @type {Number}
     */
    this.followUpWay = build.buildNumber(json&&(json.followUpWay!=null)?json.followUpWay:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者详情id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 坐席名
     * @type {String}
     */
    this.seatName = build.buildString(json&&(json.seatName!=null)?json.seatName:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 操作人姓名
     * @type {String}
     */
    this.operatorName = build.buildString(json&&(json.operatorName!=null)?json.operatorName:null);
    /**
     * 选送原因
     * @type {String}
     */
    this.pullReason = build.buildString(json&&(json.pullReason!=null)?json.pullReason:null);
    /**
     * 选送月份
     * @type {String}
     */
    this.pullMonth = build.buildString(json&&(json.pullMonth!=null)?json.pullMonth:null);
    /**
     * 是否选中
     * @type {Boolean}
     */
    this.isChecked = build.buildBoolean(json&&(json.isChecked!=null)?json.isChecked:null);
    /**
     * 是否已听录音
     * @type {Boolean}
     */
    this.isListen = build.buildBoolean(json&&(json.isListen!=null)?json.isListen:null);
    /**
     * 录音集合
     * @type {Array.<BestRecordInfo>}
     */
    this.bestRecordList = build.buildArray(json&&(json.bestRecordList!=null)?json.bestRecordList:null,build.buildBestRecordInfo);
    /**
     * 得票数
     * @type {Number}
     */
    this.numberOfVote = build.buildNumber(json&&(json.numberOfVote!=null)?json.numberOfVote:null);
    /**
     * 是否是最终最佳
     * @type {Boolean}
     */
    this.isBest = build.buildBoolean(json&&(json.isBest!=null)?json.isBest:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 坐席患者文件夹关系 **/
function SeatPatientFileRelationship(json=false){
    /**
     * ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followupTaskId = build.buildNumber(json&&(json.followupTaskId!=null)?json.followupTaskId:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者详情id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 来源
     * @type {Number}
     */
    this.source = build.buildNumber(json&&(json.source!=null)?json.source:null);
    /**
     * 来源
     * @type {String}
     */
    this.sourceStr = build.buildString(json&&(json.sourceStr!=null)?json.sourceStr:null);
    /**
     * 最后一次拨打时间
     * @type {String}
     */
    this.callDate = build.buildString(json&&(json.callDate!=null)?json.callDate:null);
    /**
     * 备注
     * @type {String}
     */
    this.remarks = build.buildString(json&&(json.remarks!=null)?json.remarks:null);
    /**
     * 已拨叫天数
     * @type {Number}
     */
    this.callDayNum = build.buildNumber(json&&(json.callDayNum!=null)?json.callDayNum:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 下标
     * @type {Number}
     */
    this.index = build.buildNumber(json&&(json.index!=null)?json.index:null);
}
/** 商品明细 **/
function GoodsDetail(json=false){
    /**
     * 商品id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 商品名称
     * @type {String}
     */
    this.goodsName = build.buildString(json&&(json.goodsName!=null)?json.goodsName:null);
    /**
     * 商品描述
     * @type {String}
     */
    this.goodsDes = build.buildString(json&&(json.goodsDes!=null)?json.goodsDes:null);
    /**
     * 商品数量
     * @type {Number}
     */
    this.goodsNumber = build.buildNumber(json&&(json.goodsNumber!=null)?json.goodsNumber:null);
    /**
     * 商品价格
     * @type {Number}
     */
    this.goodsBalance = build.buildNumber(json&&(json.goodsBalance!=null)?json.goodsBalance:null);
    /**
     * 商户ID
     * @type {Number}
     */
    this.merchantId = build.buildNumber(json&&(json.merchantId!=null)?json.merchantId:null);
    /**
     * 商品组
     * @type {Number}
     */
    this.goodsGroup = build.buildNumber(json&&(json.goodsGroup!=null)?json.goodsGroup:null);
    /**
     * 是否上架
     * @type {Boolean}
     */
    this.isOnShelf = build.buildBoolean(json&&(json.isOnShelf!=null)?json.isOnShelf:null);
    /**
     * 是否无限库存
     * @type {Boolean}
     */
    this.enableInfiniteStock = build.buildBoolean(json&&(json.enableInfiniteStock!=null)?json.enableInfiniteStock:null);
    /**
     * 库存
     * @type {Number}
     */
    this.stock = build.buildNumber(json&&(json.stock!=null)?json.stock:null);
    /**
     * 商品图文介绍
     * @type {String}
     */
    this.goodsBanners = build.buildString(json&&(json.goodsBanners!=null)?json.goodsBanners:null);
    /**
     * 主图
     * @type {String}
     */
    this.mainPicture = build.buildString(json&&(json.mainPicture!=null)?json.mainPicture:null);
    /**
     * 是否每日限制售卖数量
     * @type {Boolean}
     */
    this.enableDayLimitSale = build.buildBoolean(json&&(json.enableDayLimitSale!=null)?json.enableDayLimitSale:null);
    /**
     * 每日限制售卖数量
     * @type {Number}
     */
    this.dayLimitMaxSale = build.buildNumber(json&&(json.dayLimitMaxSale!=null)?json.dayLimitMaxSale:null);
    /**
     * 是否限制每天销售时间
     * @type {Boolean}
     */
    this.enableDayLimitTime = build.buildBoolean(json&&(json.enableDayLimitTime!=null)?json.enableDayLimitTime:null);
    /**
     * 开始的时间s
     * @type {Number}
     */
    this.dayLimitTimeStart = build.buildNumber(json&&(json.dayLimitTimeStart!=null)?json.dayLimitTimeStart:null);
    /**
     * 结束的时间s
     * @type {Number}
     */
    this.dayLimitTimeEnd = build.buildNumber(json&&(json.dayLimitTimeEnd!=null)?json.dayLimitTimeEnd:null);
    /**
     * 是否计入满减
     * @type {Boolean}
     */
    this.isMathCoupon = build.buildBoolean(json&&(json.isMathCoupon!=null)?json.isMathCoupon:null);
    /**
     * 商品规格
     * @type {String}
     */
    this.goodsSpecifications = build.buildString(json&&(json.goodsSpecifications!=null)?json.goodsSpecifications:null);
    /**
     * 商品规格id
     * @type {Number}
     */
    this.specificationId = build.buildNumber(json&&(json.specificationId!=null)?json.specificationId:null);
    /**
     * 商品积分量
     * @type {Number}
     */
    this.goodsPointsQuantity = build.buildNumber(json&&(json.goodsPointsQuantity!=null)?json.goodsPointsQuantity:null);
    /**
     * 商品积分抵扣率
     * @type {String}
     */
    this.goodsPointsDeductionRate = build.buildString(json&&(json.goodsPointsDeductionRate!=null)?json.goodsPointsDeductionRate:null);
    /**
     * 商品简介
     * @type {String}
     */
    this.goodsBriefIntroduction = build.buildString(json&&(json.goodsBriefIntroduction!=null)?json.goodsBriefIntroduction:null);
}
/** 聚合分答收益 **/
function AggReplyListMoney(json=false){
    /**
     * 分答id
     * @type {Number}
     */
    this.buyerRelationId = build.buildNumber(json&&(json.buyerRelationId!=null)?json.buyerRelationId:null);
    /**
     * 感谢医生的钱
     * @type {String}
     */
    this.platformMoney = build.buildString(json&&(json.platformMoney!=null)?json.platformMoney:null);
    /**
     * 订单次数
     * @type {Number}
     */
    this.orderNumber = build.buildNumber(json&&(json.orderNumber!=null)?json.orderNumber:null);
    /**
     * 成功付费
     * @type {Number}
     */
    this.payMoney = build.buildNumber(json&&(json.payMoney!=null)?json.payMoney:null);
}
/** 荟茁注册状态响应参数 **/
function HuiZhuoRegisterState(json=false){
    /**
     * false：未注册，true：已注册
     * @type {Boolean}
     */
    this.registerState = build.buildBoolean(json&&(json.registerState!=null)?json.registerState:null);
}
/** 坐席月指标信息 **/
function SeatMonthQuotaInfo(json=false){
    /**
     * 随访任务表id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访任务名
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 呼叫指标总数
     * @type {Number}
     */
    this.callQuotaTotal = build.buildNumber(json&&(json.callQuotaTotal!=null)?json.callQuotaTotal:null);
    /**
     * 呼叫指标完成
     * @type {Number}
     */
    this.callQuotaComplete = build.buildNumber(json&&(json.callQuotaComplete!=null)?json.callQuotaComplete:null);
    /**
     * 随访指标总数
     * @type {Number}
     */
    this.followupQuotaTotal = build.buildNumber(json&&(json.followupQuotaTotal!=null)?json.followupQuotaTotal:null);
    /**
     * 随访指标完成
     * @type {Number}
     */
    this.followupQuotaComplete = build.buildNumber(json&&(json.followupQuotaComplete!=null)?json.followupQuotaComplete:null);
}
/** HttpResult **/
function HttpResult_SmsTemplate(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {SmsTemplate}
     */
    this.retValue = build.buildSmsTemplate(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_ColorTips(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {ColorTips}
     */
    this.retValue = build.buildColorTips(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_MissedCallResults(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<MissedCallResult>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildMissedCallResult);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 病史问卷用户 **/
function HQUser(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 用户名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 医院ID
     * @type {String}
     */
    this.hospitalId = build.buildString(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 科室ID
     * @type {String}
     */
    this.departmentId = build.buildString(json&&(json.departmentId!=null)?json.departmentId:null);
}
/** 合格抽查记录Info **/
function QualifiedSpotCheckInfo(json=false){
    /**
     * 随访患者Id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者姓名
     * @type {String}
     */
    this.followupPatientName = build.buildString(json&&(json.followupPatientName!=null)?json.followupPatientName:null);
    /**
     * 随访患者住院号
     * @type {String}
     */
    this.followupAdmitNo = build.buildString(json&&(json.followupAdmitNo!=null)?json.followupAdmitNo:null);
    /**
     * 抽查结果
     * @type {String}
     */
    this.secondSpotCheckState = build.buildString(json&&(json.secondSpotCheckState!=null)?json.secondSpotCheckState:null);
    /**
     * 合格原因
     * @type {String}
     */
    this.firstSpotCheckState = build.buildString(json&&(json.firstSpotCheckState!=null)?json.firstSpotCheckState:null);
    /**
     * 详细描述
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 录音集合
     * @type {Array.<String>}
     */
    this.recordIds = build.buildArray(json&&(json.recordIds!=null)?json.recordIds:null,build.buildString);
}
/** 随访组基本信息 **/
function FollowupGroupBasicInfo(json=false){
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访组头像
     * @type {String}
     */
    this.groupImage = build.buildString(json&&(json.groupImage!=null)?json.groupImage:null);
    /**
     * 随访组名称
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 随访组状态： 1.正常  2.解散
     * @type {Number}
     */
    this.groupState = build.buildNumber(json&&(json.groupState!=null)?json.groupState:null);
}
/** HttpResult **/
function HttpResult_TodayFollowUpCount(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {TodayFollowUpCount}
     */
    this.retValue = build.buildTodayFollowUpCount(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访组对应医生 **/
function FollowupGroupDoctor(json=false){
    /**
     * 主键
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 随访组对应医生ID
     * @type {Number}
     */
    this.doctorId = build.buildNumber(json&&(json.doctorId!=null)?json.doctorId:null);
    /**
     * 医生姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 医生头像
     * @type {String}
     */
    this.userIcon = build.buildString(json&&(json.userIcon!=null)?json.userIcon:null);
    /**
     * 加入时间
     * @type {String}
     */
    this.joinTime = build.buildString(json&&(json.joinTime!=null)?json.joinTime:null);
}
/** 学习实体 **/
function StudyInfo(json=false){
    /**
     * 学习id
     * @type {Number}
     */
    this.studyId = build.buildNumber(json&&(json.studyId!=null)?json.studyId:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 标题
     * @type {String}
     */
    this.title = build.buildString(json&&(json.title!=null)?json.title:null);
    /**
     * 类型：1-话术和流程，2-问卷填写规范，3-常见问题，4-质控标准，5-补充材料
     * @type {Number}
     */
    this.type = build.buildNumber(json&&(json.type!=null)?json.type:null);
    /**
     * 标签
     * @type {String}
     */
    this.tags = build.buildString(json&&(json.tags!=null)?json.tags:null);
    /**
     * 内容
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 操作者id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 操作者姓名
     * @type {String}
     */
    this.operatorName = build.buildString(json&&(json.operatorName!=null)?json.operatorName:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 坐席排行榜 **/
function SeatRank(json=false){
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 坐席姓名
     * @type {String}
     */
    this.seatName = build.buildString(json&&(json.seatName!=null)?json.seatName:null);
    /**
     * 名次
     * @type {Number}
     */
    this.rankIndex = build.buildNumber(json&&(json.rankIndex!=null)?json.rankIndex:null);
    /**
     * 排名类型：1勤奋榜、2优质榜、3效率榜、4成功榜
     * @type {Number}
     */
    this.rankType = build.buildNumber(json&&(json.rankType!=null)?json.rankType:null);
    /**
     * 排名数据
     * @type {String}
     */
    this.rankData = build.buildString(json&&(json.rankData!=null)?json.rankData:null);
}
/** HttpResult **/
function HttpResult_LaterCallInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<LaterCallInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildLaterCallInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FeedbackInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FeedbackInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFeedbackInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访组随访记录表对象 **/
function FollowupGroupRecord(json=false){
    /**
     * 随访组记录id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访组ID
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 问卷模板id
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访方式:1.APP随访  2.电话随访
     * @type {Number}
     */
    this.followupMode = build.buildNumber(json&&(json.followupMode!=null)?json.followupMode:null);
    /**
     * 随访次序
     * @type {Number}
     */
    this.followupSequence = build.buildNumber(json&&(json.followupSequence!=null)?json.followupSequence:null);
    /**
     * 随访状态 1.问卷待填写 2.本次已填写完成 3.电话随访进行中 4.失访 5.死亡、
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 开始时间
     * @type {String}
     */
    this.followupStartdate = build.buildString(json&&(json.followupStartdate!=null)?json.followupStartdate:null);
    /**
     * 结束时间
     * @type {String}
     */
    this.followupOverdate = build.buildString(json&&(json.followupOverdate!=null)?json.followupOverdate:null);
    /**
     * 下次随访开始时间
     * @type {String}
     */
    this.nextFollowupStartdate = build.buildString(json&&(json.nextFollowupStartdate!=null)?json.nextFollowupStartdate:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 创建人
     * @type {Number}
     */
    this.createUserId = build.buildNumber(json&&(json.createUserId!=null)?json.createUserId:null);
    /**
     * 修改人
     * @type {Number}
     */
    this.updateUserId = build.buildNumber(json&&(json.updateUserId!=null)?json.updateUserId:null);
    /**
     * 电话随访任务id
     * @type {Number}
     */
    this.callTaskId = build.buildNumber(json&&(json.callTaskId!=null)?json.callTaskId:null);
    /**
     * 电话随访中心任务id
     * @type {Number}
     */
    this.callTaskCenterId = build.buildNumber(json&&(json.callTaskCenterId!=null)?json.callTaskCenterId:null);
}
/** 反馈信息info **/
function FeedbackInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 抽查id
     * @type {Number}
     */
    this.spotCheckId = build.buildNumber(json&&(json.spotCheckId!=null)?json.spotCheckId:null);
    /**
     * 任务ID
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者信息ID
     * @type {Number}
     */
    this.followUpTaskPatientInfoId = build.buildNumber(json&&(json.followUpTaskPatientInfoId!=null)?json.followUpTaskPatientInfoId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 反馈时间
     * @type {String}
     */
    this.feedBackTime = build.buildString(json&&(json.feedBackTime!=null)?json.feedBackTime:null);
    /**
     * 一级备注
     * @type {String}
     */
    this.firstSpotCheckRemarks = build.buildString(json&&(json.firstSpotCheckRemarks!=null)?json.firstSpotCheckRemarks:null);
    /**
     * 二级备注
     * @type {String}
     */
    this.secondSpotCheckRemarks = build.buildString(json&&(json.secondSpotCheckRemarks!=null)?json.secondSpotCheckRemarks:null);
    /**
     * 是否已经确认：false-否,true-是
     * @type {Boolean}
     */
    this.isConfirm = build.buildBoolean(json&&(json.isConfirm!=null)?json.isConfirm:null);
    /**
     * 结果
     * @type {String}
     */
    this.result = build.buildString(json&&(json.result!=null)?json.result:null);
    /**
     * 类别
     * @type {String}
     */
    this.category = build.buildString(json&&(json.category!=null)?json.category:null);
    /**
     * 是否紧急：false-否,true-是
     * @type {Boolean}
     */
    this.isUrgent = build.buildBoolean(json&&(json.isUrgent!=null)?json.isUrgent:null);
}
/** 分答列表 **/
function ReplyList(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 提问用户ID
     * @type {Number}
     */
    this.uid = build.buildNumber(json&&(json.uid!=null)?json.uid:null);
    /**
     * 追加ID
     * @type {Number}
     */
    this.chaseId = build.buildNumber(json&&(json.chaseId!=null)?json.chaseId:null);
    /**
     * 问题标题
     * @type {String}
     */
    this.problemTitle = build.buildString(json&&(json.problemTitle!=null)?json.problemTitle:null);
    /**
     * 问题内容
     * @type {String}
     */
    this.problemContent = build.buildString(json&&(json.problemContent!=null)?json.problemContent:null);
    /**
     * 用户名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 患者最近一次就诊所在医院名
     * @type {String}
     */
    this.userHospitalName = build.buildString(json&&(json.userHospitalName!=null)?json.userHospitalName:null);
    /**
     * 患者最近一次就诊所在科室名
     * @type {String}
     */
    this.userDepartmentName = build.buildString(json&&(json.userDepartmentName!=null)?json.userDepartmentName:null);
    /**
     * 患者最近一次就诊所在病区名
     * @type {String}
     */
    this.userWardName = build.buildString(json&&(json.userWardName!=null)?json.userWardName:null);
    /**
     * 医院名
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室名
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 医生姓名
     * @type {String}
     */
    this.doctorName = build.buildString(json&&(json.doctorName!=null)?json.doctorName:null);
    /**
     * 医生职称
     * @type {String}
     */
    this.doctorTitle = build.buildString(json&&(json.doctorTitle!=null)?json.doctorTitle:null);
    /**
     * 阅读量
     * @type {Number}
     */
    this.readingQuantity = build.buildNumber(json&&(json.readingQuantity!=null)?json.readingQuantity:null);
    /**
     * 感谢费
     * @type {Number}
     */
    this.money = build.buildNumber(json&&(json.money!=null)?json.money:null);
    /**
     * 疾病标签
     * @type {String}
     */
    this.diseaseLabel = build.buildString(json&&(json.diseaseLabel!=null)?json.diseaseLabel:null);
    /**
     * 答复时间
     * @type {String}
     */
    this.replyTime = build.buildString(json&&(json.replyTime!=null)?json.replyTime:null);
    /**
     * 答复状态 0：需要一元查看 1：已上传，2：已答复，3：已支付 ，4:未回答
     * @type {Number}
     */
    this.replyState = build.buildNumber(json&&(json.replyState!=null)?json.replyState:null);
    /**
     * 其他标签，多个标签已逗号隔开
     * @type {String}
     */
    this.otherLabel = build.buildString(json&&(json.otherLabel!=null)?json.otherLabel:null);
}
/** 逾期原因 **/
function OverDueInfo(json=false){
    /**
     * 随访任务id
     * @type {Number}
     */
    this.visitingTaskId = build.buildNumber(json&&(json.visitingTaskId!=null)?json.visitingTaskId:null);
    /**
     * 过期类型
     * @type {Number}
     */
    this.type = build.buildNumber(json&&(json.type!=null)?json.type:null);
    /**
     * 逾期原因
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.gmtCreate = build.buildString(json&&(json.gmtCreate!=null)?json.gmtCreate:null);
}
/** 检查检验报告 **/
function InspectionReport(json=false){
    /**
     * 患者Id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 报告ID
     * @type {Number}
     */
    this.reportId = build.buildNumber(json&&(json.reportId!=null)?json.reportId:null);
    /**
     * 就诊类别（ 0门诊 1住院  2体检）
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
    /**
     * 报告来源 1同步更新 2手动上传
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 报告名
     * @type {String}
     */
    this.reportName = build.buildString(json&&(json.reportName!=null)?json.reportName:null);
    /**
     * 就诊科室名称
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 检验日期（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.examineDate = build.buildString(json&&(json.examineDate!=null)?json.examineDate:null);
    /**
     * 报告日期（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.reportDate = build.buildString(json&&(json.reportDate!=null)?json.reportDate:null);
    /**
     * 报告图片地址（多张图片以逗号隔开）
     * @type {String}
     */
    this.reportImgs = build.buildString(json&&(json.reportImgs!=null)?json.reportImgs:null);
    /**
     * 报告类型
     * @type {Number}
     */
    this.reportType = build.buildNumber(json&&(json.reportType!=null)?json.reportType:null);
    /**
     * 就诊流水号
     * @type {String}
     */
    this.visitingNo = build.buildString(json&&(json.visitingNo!=null)?json.visitingNo:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
}
/** 工作台任务数据 **/
function OperationPlatformTaskData(json=false){
    /**
     * 任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 任务来源类型：1医院、2公司、3绘医、4其他
     * @type {Number}
     */
    this.taskSourceType = build.buildNumber(json&&(json.taskSourceType!=null)?json.taskSourceType:null);
    /**
     * 任务结束时间
     * @type {String}
     */
    this.taskEndTime = build.buildString(json&&(json.taskEndTime!=null)?json.taskEndTime:null);
    /**
     * 任务总人数
     * @type {Number}
     */
    this.taskTotalNumber = build.buildNumber(json&&(json.taskTotalNumber!=null)?json.taskTotalNumber:null);
    /**
     * 任务完成人数
     * @type {Number}
     */
    this.taskCompleteNumber = build.buildNumber(json&&(json.taskCompleteNumber!=null)?json.taskCompleteNumber:null);
    /**
     * 任务等待人数
     * @type {Number}
     */
    this.taskWaitNumber = build.buildNumber(json&&(json.taskWaitNumber!=null)?json.taskWaitNumber:null);
    /**
     * 任务完成率
     * @type {String}
     */
    this.taskCompleteRate = build.buildString(json&&(json.taskCompleteRate!=null)?json.taskCompleteRate:null);
    /**
     * ** 随访疾病id
     * @type {Number}
     */
    this.diseaseId = build.buildNumber(json&&(json.diseaseId!=null)?json.diseaseId:null);
    /**
     * 是否开启问卷录入
     * @type {Number}
     */
    this.isOpen = build.buildNumber(json&&(json.isOpen!=null)?json.isOpen:null);
    /**
     * 是否提醒总录音时长：0-否，1-是
     * @type {Boolean}
     */
    this.isTotalDuration = build.buildBoolean(json&&(json.isTotalDuration!=null)?json.isTotalDuration:null);
    /**
     * 是否提醒单个录音时长：0-否，1-是
     * @type {Boolean}
     */
    this.isSingleDuration = build.buildBoolean(json&&(json.isSingleDuration!=null)?json.isSingleDuration:null);
    /**
     * 是否提醒坐席学习
     * @type {Boolean}
     */
    this.isRemindStudy = build.buildBoolean(json&&(json.isRemindStudy!=null)?json.isRemindStudy:null);
    /**
     * 是否允许随访：0-不允许，1-允许
     * @type {Boolean}
     */
    this.isFollowup = build.buildBoolean(json&&(json.isFollowup!=null)?json.isFollowup:null);
    /**
     * 是否允许质控：0-不允许，1-允许
     * @type {Boolean}
     */
    this.isController = build.buildBoolean(json&&(json.isController!=null)?json.isController:null);
    /**
     * 是否允许学习：0-不允许，1-允许
     * @type {Boolean}
     */
    this.isStudy = build.buildBoolean(json&&(json.isStudy!=null)?json.isStudy:null);
    /**
     * 我的任务随访数据
     * @type {OperationPlatformTaskFollowupData}
     */
    this.myTaskFollowupData = build.buildOperationPlatformTaskFollowupData(json&&(json.myTaskFollowupData!=null)?json.myTaskFollowupData:null);
    /**
     * 平均任务随访数据
     * @type {OperationPlatformTaskFollowupData}
     */
    this.avgTaskFollowupData = build.buildOperationPlatformTaskFollowupData(json&&(json.avgTaskFollowupData!=null)?json.avgTaskFollowupData:null);
    /**
     * 全部任务随访数据
     * @type {OperationPlatformTaskFollowupData}
     */
    this.allTaskFollowupData = build.buildOperationPlatformTaskFollowupData(json&&(json.allTaskFollowupData!=null)?json.allTaskFollowupData:null);
}
/** 随访任务Resp **/
function TFollowUpTaskResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 坐席关联任务id
     * @type {Number}
     */
    this.peopleTaskId = build.buildNumber(json&&(json.peopleTaskId!=null)?json.peopleTaskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.title = build.buildString(json&&(json.title!=null)?json.title:null);
    /**
     * ** 任务来源类型1.医院2公司3绘医4其他
     * @type {Number}
     */
    this.taskSourceType = build.buildNumber(json&&(json.taskSourceType!=null)?json.taskSourceType:null);
    /**
     * ** 任务来源值
     * @type {String}
     */
    this.taskSourceValue = build.buildString(json&&(json.taskSourceValue!=null)?json.taskSourceValue:null);
    /**
     * ** 单位名
     * @type {String}
     */
    this.taskSourceValueName = build.buildString(json&&(json.taskSourceValueName!=null)?json.taskSourceValueName:null);
    /**
     * ** 联系人
     * @type {String}
     */
    this.linkman = build.buildString(json&&(json.linkman!=null)?json.linkman:null);
    /**
     * ** 联系方式
     * @type {Number}
     */
    this.contactInformation = build.buildNumber(json&&(json.contactInformation!=null)?json.contactInformation:null);
    /**
     * ** 责任人
     * @type {String}
     */
    this.personInCharge = build.buildString(json&&(json.personInCharge!=null)?json.personInCharge:null);
    /**
     * ** 随访疾病id
     * @type {Number}
     */
    this.diseaseId = build.buildNumber(json&&(json.diseaseId!=null)?json.diseaseId:null);
    /**
     * ** 随访疾病名称
     * @type {String}
     */
    this.diseaseName = build.buildString(json&&(json.diseaseName!=null)?json.diseaseName:null);
    /**
     * ** 复用交付表模板
     * @type {Number}
     */
    this.deliverTemplateId = build.buildNumber(json&&(json.deliverTemplateId!=null)?json.deliverTemplateId:null);
    /**
     * 交付表excel文件名称
     * @type {Number}
     */
    this.deliverTemplateList = build.buildNumber(json&&(json.deliverTemplateList!=null)?json.deliverTemplateList:null);
    /**
     * ** 任务标签1.急2v3重4密（原型图一致）
     * @type {Number}
     */
    this.taskTags = build.buildNumber(json&&(json.taskTags!=null)?json.taskTags:null);
    /**
     * ** 任务标签层级1，2，3（原型图一致）
     * @type {Number}
     */
    this.taskTagsHierarchy = build.buildNumber(json&&(json.taskTagsHierarchy!=null)?json.taskTagsHierarchy:null);
    /**
     * ** 11-电话和线上，12-电话，21-线上，22-无
     * @type {Number}
     */
    this.followUpWay = build.buildNumber(json&&(json.followUpWay!=null)?json.followUpWay:null);
    /**
     * ** 电话问卷id和线上问卷id，格式{1111,2222}
     * @type {String}
     */
    this.copyQuestionnaireId = build.buildString(json&&(json.copyQuestionnaireId!=null)?json.copyQuestionnaireId:null);
    /**
     * 随访名单excel文件名称
     * @type {String}
     */
    this.followUpList = build.buildString(json&&(json.followUpList!=null)?json.followUpList:null);
    /**
     * 交付模板状态 1没有excel 2解析中 3成功 4失败 5异常
     * @type {String}
     */
    this.deliverTemplateStatus = build.buildString(json&&(json.deliverTemplateStatus!=null)?json.deliverTemplateStatus:null);
    /**
     * 随访名单模板状态 1没有excel 2解析中 3表头成功 4表头失败 5内容解析成功 6内容解析有失败的 7异常
     * @type {String}
     */
    this.followUpListStatus = build.buildString(json&&(json.followUpListStatus!=null)?json.followUpListStatus:null);
    /**
     * ** 任务状态 1未开始 2进行中 3已暂停 4已完成 5异常
     * @type {String}
     */
    this.status = build.buildString(json&&(json.status!=null)?json.status:null);
    /**
     * 任务备注
     * @type {String}
     */
    this.mark = build.buildString(json&&(json.mark!=null)?json.mark:null);
    /**
     * ** 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 操作人名称
     * @type {String}
     */
    this.operatorName = build.buildString(json&&(json.operatorName!=null)?json.operatorName:null);
    /**
     * ** 是否删除 0-未删除，1-已删除
     * @type {Number}
     */
    this.isDelete = build.buildNumber(json&&(json.isDelete!=null)?json.isDelete:null);
    /**
     * 是否允许随访：0-不允许，1-允许
     * @type {Number}
     */
    this.isFollowup = build.buildNumber(json&&(json.isFollowup!=null)?json.isFollowup:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 任务开始时间
     * @type {String}
     */
    this.startTime = build.buildString(json&&(json.startTime!=null)?json.startTime:null);
    /**
     * 任务结束时间
     * @type {String}
     */
    this.endTime = build.buildString(json&&(json.endTime!=null)?json.endTime:null);
    /**
     * 已随访人数
     * @type {Number}
     */
    this.finishNum = build.buildNumber(json&&(json.finishNum!=null)?json.finishNum:null);
    /**
     * 待随访人数
     * @type {Number}
     */
    this.waitNum = build.buildNumber(json&&(json.waitNum!=null)?json.waitNum:null);
    /**
     * 本月完成
     * @type {Number}
     */
    this.thisMonthFinish = build.buildNumber(json&&(json.thisMonthFinish!=null)?json.thisMonthFinish:null);
    /**
     * 本月时长
     * @type {Number}
     */
    this.thisMonthCall = build.buildNumber(json&&(json.thisMonthCall!=null)?json.thisMonthCall:null);
    /**
     * 累计完成完成
     * @type {Number}
     */
    this.allFinish = build.buildNumber(json&&(json.allFinish!=null)?json.allFinish:null);
    /**
     * 累计时长
     * @type {Number}
     */
    this.allCall = build.buildNumber(json&&(json.allCall!=null)?json.allCall:null);
    /**
     * 失访人数
     * @type {Number}
     */
    this.lostNum = build.buildNumber(json&&(json.lostNum!=null)?json.lostNum:null);
    /**
     * 失访率
     * @type {String}
     */
    this.lostRate = build.buildString(json&&(json.lostRate!=null)?json.lostRate:null);
    /**
     * 合格率
     * @type {String}
     */
    this.passRate = build.buildString(json&&(json.passRate!=null)?json.passRate:null);
    /**
     * 抽查合格率（0-100）
     * @type {Number}
     */
    this.spotCheckRate = build.buildNumber(json&&(json.spotCheckRate!=null)?json.spotCheckRate:null);
    /**
     * 自定义开始时间
     * @type {String}
     */
    this.customStartTime = build.buildString(json&&(json.customStartTime!=null)?json.customStartTime:null);
    /**
     * 自定义结束时间
     * @type {String}
     */
    this.customEndTime = build.buildString(json&&(json.customEndTime!=null)?json.customEndTime:null);
    /**
     * 是否提醒总录音时长：0-否，1-是
     * @type {Boolean}
     */
    this.isTotalDuration = build.buildBoolean(json&&(json.isTotalDuration!=null)?json.isTotalDuration:null);
    /**
     * 是否提醒单个录音时长：0-否，1-是
     * @type {Boolean}
     */
    this.isSingleDuration = build.buildBoolean(json&&(json.isSingleDuration!=null)?json.isSingleDuration:null);
    /**
     * 是否提醒坐席学习
     * @type {Boolean}
     */
    this.isRemindStudy = build.buildBoolean(json&&(json.isRemindStudy!=null)?json.isRemindStudy:null);
    /**
     * 名单批次id
     * @type {Number}
     */
    this.batchId = build.buildNumber(json&&(json.batchId!=null)?json.batchId:null);
    /**
     * 名单批次
     * @type {String}
     */
    this.batchName = build.buildString(json&&(json.batchName!=null)?json.batchName:null);
    /**
     * 本次随访状态
     * @type {String}
     */
    this.followupState = build.buildString(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者详情id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 随访患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.adminNo = build.buildString(json&&(json.adminNo!=null)?json.adminNo:null);
    /**
     * 是否开启问卷录入
     * @type {Number}
     */
    this.isOpen = build.buildNumber(json&&(json.isOpen!=null)?json.isOpen:null);
    /**
     * 最后呼叫号码
     * @type {String}
     */
    this.lastCallPhone = build.buildString(json&&(json.lastCallPhone!=null)?json.lastCallPhone:null);
    /**
     * 今日指标
     * @type {Number}
     */
    this.distributeQuotaNumber = build.buildNumber(json&&(json.distributeQuotaNumber!=null)?json.distributeQuotaNumber:null);
    /**
     * 已完成指标
     * @type {Number}
     */
    this.finishQuotaNumber = build.buildNumber(json&&(json.finishQuotaNumber!=null)?json.finishQuotaNumber:null);
    /**
     * 指标类型
     * @type {String}
     */
    this.quotaType = build.buildString(json&&(json.quotaType!=null)?json.quotaType:null);
    /**
     * 任务别名
     * @type {String}
     */
    this.otherName = build.buildString(json&&(json.otherName!=null)?json.otherName:null);
}
/** 随访任务抽查统计 **/
function FollowUpTaskSpotCheckStatistics(json=false){
    /**
     * 全部统计数
     * @type {Number}
     */
    this.wholeStatistics = build.buildNumber(json&&(json.wholeStatistics!=null)?json.wholeStatistics:null);
    /**
     * 需要重播统计数
     * @type {Number}
     */
    this.wantedReplayStatistics = build.buildNumber(json&&(json.wantedReplayStatistics!=null)?json.wantedReplayStatistics:null);
    /**
     * 不需要重播统计数
     * @type {Number}
     */
    this.unwantedReplayStatistics = build.buildNumber(json&&(json.unwantedReplayStatistics!=null)?json.unwantedReplayStatistics:null);
    /**
     * 线上需要重播统计数
     * @type {Number}
     */
    this.onLineWantedReplayStatistics = build.buildNumber(json&&(json.onLineWantedReplayStatistics!=null)?json.onLineWantedReplayStatistics:null);
    /**
     * 需重拨数
     * @type {Number}
     */
    this.requireReplayNum = build.buildNumber(json&&(json.requireReplayNum!=null)?json.requireReplayNum:null);
    /**
     * 需注意数
     * @type {Number}
     */
    this.requireRemindNum = build.buildNumber(json&&(json.requireRemindNum!=null)?json.requireRemindNum:null);
    /**
     * 需修改数
     * @type {Number}
     */
    this.requireChangeNum = build.buildNumber(json&&(json.requireChangeNum!=null)?json.requireChangeNum:null);
    /**
     * 总数
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
    /**
     * 复杂重拨数
     * @type {Number}
     */
    this.complexReplyNum = build.buildNumber(json&&(json.complexReplyNum!=null)?json.complexReplyNum:null);
}
/** 患者答案功能Resp **/
function TPatientAnswerInfoResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 新问卷表主键id
     * @type {Number}
     */
    this.questionnaireNewId = build.buildNumber(json&&(json.questionnaireNewId!=null)?json.questionnaireNewId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * t_question_info表id
     * @type {Number}
     */
    this.questionInfo = build.buildNumber(json&&(json.questionInfo!=null)?json.questionInfo:null);
    /**
     * 患者答案信息json格式
     * @type {String}
     */
    this.answerInfo = build.buildString(json&&(json.answerInfo!=null)?json.answerInfo:null);
    /**
     * ** 来源类别 1-线上，2-电话
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 日期输入框信息 **/
function DateTimeTextInfo(json=false){
    /**
     * 日期时间信息
     * @type {DateTimeInfo}
     */
    this.date = build.buildDateTimeInfo(json&&(json.date!=null)?json.date:null);
    /**
     * 输入值
     * @type {String}
     */
    this.attachValue = build.buildString(json&&(json.attachValue!=null)?json.attachValue:null);
}
/** HttpResult **/
function HttpResult_CallPatientVisitingRecords(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<CallPatientVisitingRecord>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildCallPatientVisitingRecord);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TPatientAnswerInfoResp(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {TPatientAnswerInfoResp}
     */
    this.retValue = build.buildTPatientAnswerInfoResp(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 咨询发送信息 **/
function ConsultSendMessage(json=false){
    /**
     * 问题Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 信息类型
     * @type {String}
     */
    this.type = build.buildString(json&&(json.type!=null)?json.type:null);
    /**
     * userType
     * @type {Number}
     */
    this.userType = build.buildNumber(json&&(json.userType!=null)?json.userType:null);
    /**
     * 订单号
     * @type {String}
     */
    this.orderId = build.buildString(json&&(json.orderId!=null)?json.orderId:null);
    /**
     * 信息内容
     * @type {String}
     */
    this.consultContent = build.buildString(json&&(json.consultContent!=null)?json.consultContent:null);
    /**
     * 发送方Id
     * @type {String}
     */
    this.sender = build.buildString(json&&(json.sender!=null)?json.sender:null);
    /**
     * 收方Id
     * @type {String}
     */
    this.receiver = build.buildString(json&&(json.receiver!=null)?json.receiver:null);
    /**
     * 是否是建议
     * @type {Boolean}
     */
    this.isSuggest = build.buildBoolean(json&&(json.isSuggest!=null)?json.isSuggest:null);
    /**
     * 是否同意结束订单
     * @type {Boolean}
     */
    this.isAgree = build.buildBoolean(json&&(json.isAgree!=null)?json.isAgree:null);
    /**
     * 是否在线
     * @type {Number}
     */
    this.isOnline = build.buildNumber(json&&(json.isOnline!=null)?json.isOnline:null);
    /**
     * 是否结束
     * @type {Boolean}
     */
    this.isEnd = build.buildBoolean(json&&(json.isEnd!=null)?json.isEnd:null);
    /**
     * 心跳连接
     * @type {String}
     */
    this.heartBeat = build.buildString(json&&(json.heartBeat!=null)?json.heartBeat:null);
}
/** HttpResult **/
function HttpResult_SeatQuotaTableInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {SeatQuotaTableInfo}
     */
    this.retValue = build.buildSeatQuotaTableInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TQuestionInfoRespAndStatus(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {TQuestionInfoRespAndStatus}
     */
    this.retValue = build.buildTQuestionInfoRespAndStatus(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 日期时间信息 **/
function DateTimeInfo(json=false){
    /**
     * 年
     * @type {String}
     */
    this.yearSelect = build.buildString(json&&(json.yearSelect!=null)?json.yearSelect:null);
    /**
     * 月
     * @type {String}
     */
    this.monthSelect = build.buildString(json&&(json.monthSelect!=null)?json.monthSelect:null);
    /**
     * 日
     * @type {String}
     */
    this.daySelect = build.buildString(json&&(json.daySelect!=null)?json.daySelect:null);
}
/** 日期信息 **/
function DateInfo(json=false){
    /**
     * 问卷结果Id
     * @type {Number}
     */
    this.resultId = build.buildNumber(json&&(json.resultId!=null)?json.resultId:null);
    /**
     * 呼叫类型
     * @type {Number}
     */
    this.callType = build.buildNumber(json&&(json.callType!=null)?json.callType:null);
    /**
     * 问卷提交时间
     * @type {String}
     */
    this.dateTimeString = build.buildString(json&&(json.dateTimeString!=null)?json.dateTimeString:null);
}
/** 联系方式参数 **/
function ContactInformationParam(json=false){
    /**
     * 患者手机号
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 关系名称
     * @type {String}
     */
    this.relationshipName = build.buildString(json&&(json.relationshipName!=null)?json.relationshipName:null);
    /**
     * 联系人姓名
     * @type {String}
     */
    this.contactName = build.buildString(json&&(json.contactName!=null)?json.contactName:null);
    /**
     * 电话类型
     * @type {Boolean}
     */
    this.phoneType = build.buildBoolean(json&&(json.phoneType!=null)?json.phoneType:null);
    /**
     * 联系人等级id
     * @type {Number}
     */
    this.relationshipLevelId = build.buildNumber(json&&(json.relationshipLevelId!=null)?json.relationshipLevelId:null);
    /**
     * 联系人等级
     * @type {Number}
     */
    this.relationshipLevel = build.buildNumber(json&&(json.relationshipLevel!=null)?json.relationshipLevel:null);
    /**
     * 配合分数
     * @type {Number}
     */
    this.cooperateScore = build.buildNumber(json&&(json.cooperateScore!=null)?json.cooperateScore:null);
    /**
     * 归属地
     * @type {String}
     */
    this.belongAddress = build.buildString(json&&(json.belongAddress!=null)?json.belongAddress:null);
    /**
     * 呼叫状态
     * @type {Number}
     */
    this.callStatus = build.buildNumber(json&&(json.callStatus!=null)?json.callStatus:null);
}
/** 阿里录音下载 **/
function ALiYunMediaDownloadParam(json=false){
    /**
     * 患者名字
     * @type {String}
     */
    this.fileName = build.buildString(json&&(json.fileName!=null)?json.fileName:null);
    /**
     * 患者名字
     * @type {String}
     */
    this.signatureUrl = build.buildString(json&&(json.signatureUrl!=null)?json.signatureUrl:null);
}
/** 电话随访通用导入表头 **/
function CallCenterGeneralPurposeImportHeaders(json=false){
    /**
     * 导入排序ID
     * @type {Number}
     */
    this.sortId = build.buildNumber(json&&(json.sortId!=null)?json.sortId:null);
    /**
     * 用户姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 用户性别
     * @type {Number}
     */
    this.userSex = build.buildNumber(json&&(json.userSex!=null)?json.userSex:null);
    /**
     * 用户年龄
     * @type {Number}
     */
    this.age = build.buildNumber(json&&(json.age!=null)?json.age:null);
    /**
     * 诊断
     * @type {String}
     */
    this.medicalRecordName = build.buildString(json&&(json.medicalRecordName!=null)?json.medicalRecordName:null);
    /**
     * 诊断日期
     * @type {String}
     */
    this.diagnosisDate  = build.buildString(json&&(json.diagnosisDate !=null)?json.diagnosisDate :null);
    /**
     * 手术名称
     * @type {String}
     */
    this.allOperations = build.buildString(json&&(json.allOperations!=null)?json.allOperations:null);
    /**
     * 手术时间
     * @type {String}
     */
    this.surgeryDate = build.buildString(json&&(json.surgeryDate!=null)?json.surgeryDate:null);
    /**
     * 用户性别
     * @type {String}
     */
    this.card = build.buildString(json&&(json.card!=null)?json.card:null);
    /**
     * 电话随访导入的住院号
     * @type {String}
     */
    this.callAdmitNo = build.buildString(json&&(json.callAdmitNo!=null)?json.callAdmitNo:null);
    /**
     * 自定义1
     * @type {String}
     */
    this.customOne = build.buildString(json&&(json.customOne!=null)?json.customOne:null);
    /**
     * 自定义2
     * @type {String}
     */
    this.customTwo = build.buildString(json&&(json.customTwo!=null)?json.customTwo:null);
    /**
     * 自定义3
     * @type {String}
     */
    this.customThree = build.buildString(json&&(json.customThree!=null)?json.customThree:null);
    /**
     * 自定义4
     * @type {String}
     */
    this.customFour = build.buildString(json&&(json.customFour!=null)?json.customFour:null);
    /**
     * 自定义5
     * @type {String}
     */
    this.customFive = build.buildString(json&&(json.customFive!=null)?json.customFive:null);
    /**
     * 用户联系方式列表
     * @type {Array.<PhoneNumbersRelationship>}
     */
    this.phoneNumbersRelationships = build.buildArray(json&&(json.phoneNumbersRelationships!=null)?json.phoneNumbersRelationships:null,build.buildPhoneNumbersRelationship);
}
/** HttpResult **/
function HttpResult_QualityControlCallRecordInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<QualityControlCallRecordInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildQualityControlCallRecordInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FinishAndTodoInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FinishAndTodoInfo}
     */
    this.retValue = build.buildFinishAndTodoInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** API返回随访组内每位患者最大随访记录 **/
function FollowupGroupPatientRecord(json=false){
    /**
     * 患者Id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 患者头像
     * @type {String}
     */
    this.patientIcon = build.buildString(json&&(json.patientIcon!=null)?json.patientIcon:null);
    /**
     * 患者住院号
     * @type {String}
     */
    this.latelyAdmitNo = build.buildString(json&&(json.latelyAdmitNo!=null)?json.latelyAdmitNo:null);
    /**
     * 当前随访次数
     * @type {Number}
     */
    this.followupSequence = build.buildNumber(json&&(json.followupSequence!=null)?json.followupSequence:null);
    /**
     * 随访状态
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 最近一次随访完成时间(本次没完成展示上次的)
     * @type {String}
     */
    this.followupOverdate = build.buildString(json&&(json.followupOverdate!=null)?json.followupOverdate:null);
    /**
     * 问卷模板名称
     * @type {String}
     */
    this.questionnaireTemplateName = build.buildString(json&&(json.questionnaireTemplateName!=null)?json.questionnaireTemplateName:null);
}
/** HttpResult **/
function HttpResult_long(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Number}
     */
    this.retValue = build.buildNumber(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_UpdateTipInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<UpdateTipInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildUpdateTipInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 参数列表 **/
function ParameterList(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 姓名
     * @type {String}
     */
    this.name = build.buildString(json&&(json.name!=null)?json.name:null);
}
/** 时间段统计信息 **/
function TimeSectionStatisticsInfo(json=false){
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 时间段
     * @type {String}
     */
    this.timeSection = build.buildString(json&&(json.timeSection!=null)?json.timeSection:null);
    /**
     * 任务数
     * @type {Number}
     */
    this.taskNumber = build.buildNumber(json&&(json.taskNumber!=null)?json.taskNumber:null);
    /**
     * 呼叫人数
     * @type {Number}
     */
    this.callNumber = build.buildNumber(json&&(json.callNumber!=null)?json.callNumber:null);
    /**
     * 接通数
     * @type {Number}
     */
    this.contactSuccessNumber = build.buildNumber(json&&(json.contactSuccessNumber!=null)?json.contactSuccessNumber:null);
    /**
     * 随访完成数
     * @type {Number}
     */
    this.completeNumber = build.buildNumber(json&&(json.completeNumber!=null)?json.completeNumber:null);
    /**
     * 随访完成数
     * @type {String}
     */
    this.completeRate = build.buildString(json&&(json.completeRate!=null)?json.completeRate:null);
    /**
     * 随访成功数
     * @type {Number}
     */
    this.successNumber = build.buildNumber(json&&(json.successNumber!=null)?json.successNumber:null);
    /**
     * 成功率
     * @type {String}
     */
    this.successRate = build.buildString(json&&(json.successRate!=null)?json.successRate:null);
    /**
     * 失访数
     * @type {Number}
     */
    this.loseNumber = build.buildNumber(json&&(json.loseNumber!=null)?json.loseNumber:null);
    /**
     * 失访率
     * @type {String}
     */
    this.loseRate = build.buildString(json&&(json.loseRate!=null)?json.loseRate:null);
    /**
     * 拒随数
     * @type {Number}
     */
    this.refuseNumber = build.buildNumber(json&&(json.refuseNumber!=null)?json.refuseNumber:null);
    /**
     * 拒随率
     * @type {String}
     */
    this.refuseRate = build.buildString(json&&(json.refuseRate!=null)?json.refuseRate:null);
    /**
     * 质控合格数
     * @type {Number}
     */
    this.qualifiedNumber = build.buildNumber(json&&(json.qualifiedNumber!=null)?json.qualifiedNumber:null);
    /**
     * 质控合格率
     * @type {String}
     */
    this.qualifiedRate = build.buildString(json&&(json.qualifiedRate!=null)?json.qualifiedRate:null);
    /**
     * 质控人数
     * @type {Number}
     */
    this.qualityPersonNumber = build.buildNumber(json&&(json.qualityPersonNumber!=null)?json.qualityPersonNumber:null);
    /**
     * 指标量
     * @type {Number}
     */
    this.quotaNumber = build.buildNumber(json&&(json.quotaNumber!=null)?json.quotaNumber:null);
    /**
     * 指标完成数
     * @type {Number}
     */
    this.quotaFinishNumber = build.buildNumber(json&&(json.quotaFinishNumber!=null)?json.quotaFinishNumber:null);
    /**
     * 指标完成率
     * @type {String}
     */
    this.quotaFinishRate = build.buildString(json&&(json.quotaFinishRate!=null)?json.quotaFinishRate:null);
}
/** 呼叫患者信息 **/
function CallPatient(json=false){
    /**
     * 任务ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务中心ID
     * @type {Number}
     */
    this.taskCenterId = build.buildNumber(json&&(json.taskCenterId!=null)?json.taskCenterId:null);
    /**
     * 性别
     * @type {Number}
     */
    this.userSex = build.buildNumber(json&&(json.userSex!=null)?json.userSex:null);
    /**
     * 年龄
     * @type {Number}
     */
    this.userAge = build.buildNumber(json&&(json.userAge!=null)?json.userAge:null);
    /**
     * 姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 是否注册
     * @type {Boolean}
     */
    this.isRegister = build.buildBoolean(json&&(json.isRegister!=null)?json.isRegister:null);
    /**
     * 住院号
     * @type {String}
     */
    this.callAdmitNo = build.buildString(json&&(json.callAdmitNo!=null)?json.callAdmitNo:null);
    /**
     * 手术时间
     * @type {String}
     */
    this.surgeryDate = build.buildString(json&&(json.surgeryDate!=null)?json.surgeryDate:null);
    /**
     * 确诊日期
     * @type {String}
     */
    this.diagnosisDate = build.buildString(json&&(json.diagnosisDate!=null)?json.diagnosisDate:null);
    /**
     * 所有手术名称
     * @type {String}
     */
    this.allOperations = build.buildString(json&&(json.allOperations!=null)?json.allOperations:null);
    /**
     * 病案诊断名称
     * @type {String}
     */
    this.medicalRecordName = build.buildString(json&&(json.medicalRecordName!=null)?json.medicalRecordName:null);
    /**
     * 其他诊断
     * @type {String}
     */
    this.otherdDiagnosis = build.buildString(json&&(json.otherdDiagnosis!=null)?json.otherdDiagnosis:null);
    /**
     * 就诊记录列表
     * @type {Array.<CallPatientVisitingRecord>}
     */
    this.callPatientVisitingRecords = build.buildArray(json&&(json.callPatientVisitingRecords!=null)?json.callPatientVisitingRecords:null,build.buildCallPatientVisitingRecord);
    /**
     * 随访人呼叫列表
     * @type {Array.<PatientPhoneNumber>}
     */
    this.patientPhoneNumbers = build.buildArray(json&&(json.patientPhoneNumbers!=null)?json.patientPhoneNumbers:null,build.buildPatientPhoneNumber);
    /**
     * 问卷信息
     * @type {NewQuestionnaireInfo}
     */
    this.newQuestionnaireInfo = build.buildNewQuestionnaireInfo(json&&(json.newQuestionnaireInfo!=null)?json.newQuestionnaireInfo:null);
    /**
     * APP随访转电话随访新问卷信息
     * @type {String}
     */
    this.showPatientQuestionAnswerList = build.buildString(json&&(json.showPatientQuestionAnswerList!=null)?json.showPatientQuestionAnswerList:null);
    /**
     * APP随访转电话随访新问卷结果
     * @type {Array.<ShowPatientQuestionAnswer>}
     */
    this.showPatientQuestionAnswersResult = build.buildArray(json&&(json.showPatientQuestionAnswersResult!=null)?json.showPatientQuestionAnswersResult:null,build.buildShowPatientQuestionAnswer);
    /**
     * 自定义1
     * @type {String}
     */
    this.customOne = build.buildString(json&&(json.customOne!=null)?json.customOne:null);
    /**
     * 自定义2
     * @type {String}
     */
    this.customTwo = build.buildString(json&&(json.customTwo!=null)?json.customTwo:null);
    /**
     * 自定义3
     * @type {String}
     */
    this.customThree = build.buildString(json&&(json.customThree!=null)?json.customThree:null);
    /**
     * 自定义4
     * @type {String}
     */
    this.customFour = build.buildString(json&&(json.customFour!=null)?json.customFour:null);
    /**
     * 自定义5
     * @type {String}
     */
    this.customFive = build.buildString(json&&(json.customFive!=null)?json.customFive:null);
    /**
     * 是否已填写问卷
     * @type {Boolean}
     */
    this.isFillQuestionnaires = build.buildBoolean(json&&(json.isFillQuestionnaires!=null)?json.isFillQuestionnaires:null);
}
/** 手机号标签 **/
function PhoneLabel(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 号码id
     * @type {Number}
     */
    this.phoneId = build.buildNumber(json&&(json.phoneId!=null)?json.phoneId:null);
    /**
     * 标签
     * @type {String}
     */
    this.label = build.buildString(json&&(json.label!=null)?json.label:null);
    /**
     * 是否选中
     * @type {Boolean}
     */
    this.isChoose = build.buildBoolean(json&&(json.isChoose!=null)?json.isChoose:null);
}
/** Map **/
function StringMap(json=false){
    /**
     * key
     * @type {String}
     */
    this.key = build.buildString(json&&(json.key!=null)?json.key:null);
    /**
     * value
     * @type {String}
     */
    this.value = build.buildString(json&&(json.value!=null)?json.value:null);
}
/** 推送提醒 **/
function PushRemind(json=false){
    /**
     * 推送ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 提醒模板ID
     * @type {Number}
     */
    this.remindTemplateId = build.buildNumber(json&&(json.remindTemplateId!=null)?json.remindTemplateId:null);
    /**
     * 提醒模板周期ID
     * @type {Number}
     */
    this.remindTemplateCycleId = build.buildNumber(json&&(json.remindTemplateCycleId!=null)?json.remindTemplateCycleId:null);
    /**
     * 类型 1：药物 2：检查
     * @type {Number}
     */
    this.prescriptionType = build.buildNumber(json&&(json.prescriptionType!=null)?json.prescriptionType:null);
    /**
     * 药物名
     * @type {String}
     */
    this.drugName = build.buildString(json&&(json.drugName!=null)?json.drugName:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 剂量
     * @type {String}
     */
    this.eachTimeDose = build.buildString(json&&(json.eachTimeDose!=null)?json.eachTimeDose:null);
}
/** HttpResult **/
function HttpResult_VisitingTaskInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<VisitingTaskInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildVisitingTaskInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 调查患者信息 **/
function FollowupQuestionnaireData(json=false){
    /**
     * 字段Key
     * @type {String}
     */
    this.fieldKey = build.buildString(json&&(json.fieldKey!=null)?json.fieldKey:null);
    /**
     * 字段值
     * @type {String}
     */
    this.fieldValue = build.buildString(json&&(json.fieldValue!=null)?json.fieldValue:null);
    /**
     * 字段Key-拼接值
     * @type {String}
     */
    this.fieldMontageKey = build.buildString(json&&(json.fieldMontageKey!=null)?json.fieldMontageKey:null);
    /**
     * 补充框内容
     * @type {Array.<FollowupQuestionnaireData>}
     */
    this.subFieldValueDataModelList = build.buildArray(json&&(json.subFieldValueDataModelList!=null)?json.subFieldValueDataModelList:null,build.buildFollowupQuestionnaireData);
}
/** HttpResult **/
function HttpResult_SurgeryRecords(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SurgeryRecord>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSurgeryRecord);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_PatientMedicalRecords(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<PatientMedicalRecord>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildPatientMedicalRecord);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 患者所有检查报告列表显示 **/
function ReportListShow(json=false){
    /**
     * 报告ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 检验日期
     * @type {String}
     */
    this.examineDate = build.buildString(json&&(json.examineDate!=null)?json.examineDate:null);
    /**
     * 检查类型
     * @type {String}
     */
    this.inspectType = build.buildString(json&&(json.inspectType!=null)?json.inspectType:null);
    /**
     * 检查名称
     * @type {String}
     */
    this.checkName = build.buildString(json&&(json.checkName!=null)?json.checkName:null);
    /**
     * 检查结论
     * @type {String}
     */
    this.conclusions = build.buildString(json&&(json.conclusions!=null)?json.conclusions:null);
    /**
     * 标本类型
     * @type {String}
     */
    this.specimenName = build.buildString(json&&(json.specimenName!=null)?json.specimenName:null);
    /**
     * 报告单类别名称
     * @type {String}
     */
    this.reportTypeName = build.buildString(json&&(json.reportTypeName!=null)?json.reportTypeName:null);
    /**
     * 检验指标
     * @type {Array.<LabIndex>}
     */
    this.labIndexs = build.buildArray(json&&(json.labIndexs!=null)?json.labIndexs:null,build.buildLabIndex);
    /**
     * 报告图片地址（多张图片以逗号隔开）
     * @type {String}
     */
    this.reportImgs = build.buildString(json&&(json.reportImgs!=null)?json.reportImgs:null);
}
/** 消息info **/
function MessageManageInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 消息类型：1-平台公告，2-短信消息
     * @type {Number}
     */
    this.type = build.buildNumber(json&&(json.type!=null)?json.type:null);
    /**
     * 标题
     * @type {String}
     */
    this.title = build.buildString(json&&(json.title!=null)?json.title:null);
    /**
     * 内容
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 终端（可多选，逗号隔开）：1-患者app，2-医生app，3-管理台，4-呼叫中心，5-外部质控
     * @type {String}
     */
    this.terminal = build.buildString(json&&(json.terminal!=null)?json.terminal:null);
    /**
     * 是否定时时间
     * @type {String}
     */
    this.sendTime = build.buildString(json&&(json.sendTime!=null)?json.sendTime:null);
    /**
     * 是否发送
     * @type {Boolean}
     */
    this.isSend = build.buildBoolean(json&&(json.isSend!=null)?json.isSend:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** 交付表固定字段信息 **/
function NewDeliverTableFixedFieldInfo(json=false){
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者信息id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 姓名
     * @type {String}
     */
    this.name = build.buildString(json&&(json.name!=null)?json.name:null);
    /**
     * 性别
     * @type {String}
     */
    this.sex = build.buildString(json&&(json.sex!=null)?json.sex:null);
    /**
     * 年龄
     * @type {String}
     */
    this.age = build.buildString(json&&(json.age!=null)?json.age:null);
    /**
     * 身份证号
     * @type {String}
     */
    this.idCard = build.buildString(json&&(json.idCard!=null)?json.idCard:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 生存状态
     * @type {Number}
     */
    this.existenceState = build.buildNumber(json&&(json.existenceState!=null)?json.existenceState:null);
    /**
     * 新生存状态：0生存，1死亡，2未知
     * @type {Number}
     */
    this.newExistenceState = build.buildNumber(json&&(json.newExistenceState!=null)?json.newExistenceState:null);
    /**
     * 随访状态
     * @type {String}
     */
    this.followupState = build.buildString(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 随访完成时间
     * @type {String}
     */
    this.followupCompleteTime = build.buildString(json&&(json.followupCompleteTime!=null)?json.followupCompleteTime:null);
    /**
     * 呼叫坐席id
     * @type {Number}
     */
    this.callSeatId = build.buildNumber(json&&(json.callSeatId!=null)?json.callSeatId:null);
    /**
     * 呼叫坐席
     * @type {String}
     */
    this.callSeat = build.buildString(json&&(json.callSeat!=null)?json.callSeat:null);
    /**
     * 质检状态
     * @type {Number}
     */
    this.qualityState = build.buildNumber(json&&(json.qualityState!=null)?json.qualityState:null);
    /**
     * 质检人id
     * @type {Number}
     */
    this.qualityPersonId = build.buildNumber(json&&(json.qualityPersonId!=null)?json.qualityPersonId:null);
    /**
     * 质检人
     * @type {String}
     */
    this.qualityPerson = build.buildString(json&&(json.qualityPerson!=null)?json.qualityPerson:null);
    /**
     * 质检结果
     * @type {String}
     */
    this.qualityResult = build.buildString(json&&(json.qualityResult!=null)?json.qualityResult:null);
    /**
     * 质检二级抽查状态
     * @type {String}
     */
    this.qualitySecondSpotCheckState = build.buildString(json&&(json.qualitySecondSpotCheckState!=null)?json.qualitySecondSpotCheckState:null);
    /**
     * 质检处理结果
     * @type {String}
     */
    this.qualityHandleResult = build.buildString(json&&(json.qualityHandleResult!=null)?json.qualityHandleResult:null);
    /**
     * 质检一级抽查状态
     * @type {String}
     */
    this.qualityFirstSpotCheckState = build.buildString(json&&(json.qualityFirstSpotCheckState!=null)?json.qualityFirstSpotCheckState:null);
    /**
     * 质检详情
     * @type {String}
     */
    this.qualityRemarks = build.buildString(json&&(json.qualityRemarks!=null)?json.qualityRemarks:null);
    /**
     * 质检时间
     * @type {String}
     */
    this.qualityTime = build.buildString(json&&(json.qualityTime!=null)?json.qualityTime:null);
    /**
     * 问卷完成率
     * @type {String}
     */
    this.writeRatio = build.buildString(json&&(json.writeRatio!=null)?json.writeRatio:null);
    /**
     * 疾病名称
     * @type {String}
     */
    this.diseaseName = build.buildString(json&&(json.diseaseName!=null)?json.diseaseName:null);
    /**
     * 诊断日期
     * @type {String}
     */
    this.diagnosisDate = build.buildString(json&&(json.diagnosisDate!=null)?json.diagnosisDate:null);
    /**
     * 治疗方式
     * @type {String}
     */
    this.treatmentMode = build.buildString(json&&(json.treatmentMode!=null)?json.treatmentMode:null);
    /**
     * 主诊医生
     * @type {String}
     */
    this.doctorName = build.buildString(json&&(json.doctorName!=null)?json.doctorName:null);
    /**
     * 治疗日期
     * @type {String}
     */
    this.treatmentDate = build.buildString(json&&(json.treatmentDate!=null)?json.treatmentDate:null);
    /**
     * 出院日期
     * @type {String}
     */
    this.dischargeTime = build.buildString(json&&(json.dischargeTime!=null)?json.dischargeTime:null);
    /**
     * 出院带药
     * @type {String}
     */
    this.dischargeMedication = build.buildString(json&&(json.dischargeMedication!=null)?json.dischargeMedication:null);
    /**
     * 联系方式头
     * @type {Array.<StringMap>}
     */
    this.contactInformationHead = build.buildArray(json&&(json.contactInformationHead!=null)?json.contactInformationHead:null,build.buildStringMap);
    /**
     * 联系方式
     * @type {Array.<ContactInformationContent>}
     */
    this.contactInformation = build.buildArray(json&&(json.contactInformation!=null)?json.contactInformation:null,build.buildContactInformationContent);
    /**
     * 最后呼叫状态
     * @type {String}
     */
    this.lastCallState = build.buildString(json&&(json.lastCallState!=null)?json.lastCallState:null);
    /**
     * 最后呼叫号码
     * @type {String}
     */
    this.lastCallPhone = build.buildString(json&&(json.lastCallPhone!=null)?json.lastCallPhone:null);
    /**
     * 备注信息
     * @type {String}
     */
    this.remarks = build.buildString(json&&(json.remarks!=null)?json.remarks:null);
}
/** 就诊流水号获取住院手术记录 **/
function SurgeryRecord(json=false){
    /**
     * 手术名称
     * @type {String}
     */
    this.surgeryName = build.buildString(json&&(json.surgeryName!=null)?json.surgeryName:null);
    /**
     * 申请时间（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.inputTime = build.buildString(json&&(json.inputTime!=null)?json.inputTime:null);
    /**
     * 计划手术时间（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.applyTime = build.buildString(json&&(json.applyTime!=null)?json.applyTime:null);
    /**
     * 手术开始时间（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.surgeryTime = build.buildString(json&&(json.surgeryTime!=null)?json.surgeryTime:null);
    /**
     * 手术结束时间（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.surgeryEndTime = build.buildString(json&&(json.surgeryEndTime!=null)?json.surgeryEndTime:null);
}
/** ${model.des} **/
function QualityControlCallRecordInfo(json=false){
    /**
     * ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 被叫号码
     * @type {String}
     */
    this.calledPhoneNumber = build.buildString(json&&(json.calledPhoneNumber!=null)?json.calledPhoneNumber:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者ID
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访基本信息表ID
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.followupPatientName = build.buildString(json&&(json.followupPatientName!=null)?json.followupPatientName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.followupAdminNo = build.buildString(json&&(json.followupAdminNo!=null)?json.followupAdminNo:null);
    /**
     * 号码关系
     * @type {String}
     */
    this.relationshipRemarks = build.buildString(json&&(json.relationshipRemarks!=null)?json.relationshipRemarks:null);
    /**
     * 联系人姓名
     * @type {String}
     */
    this.contactName = build.buildString(json&&(json.contactName!=null)?json.contactName:null);
    /**
     * 呼叫状态id
     * @type {Number}
     */
    this.callStateId = build.buildNumber(json&&(json.callStateId!=null)?json.callStateId:null);
    /**
     * 呼叫时间
     * @type {String}
     */
    this.followUpDate = build.buildString(json&&(json.followUpDate!=null)?json.followUpDate:null);
    /**
     * 呼叫坐席
     * @type {String}
     */
    this.callSeat = build.buildString(json&&(json.callSeat!=null)?json.callSeat:null);
    /**
     * 呼叫坐席id
     * @type {Number}
     */
    this.callSeatId = build.buildNumber(json&&(json.callSeatId!=null)?json.callSeatId:null);
    /**
     * 主叫号码
     * @type {String}
     */
    this.callingPhoneNumber = build.buildString(json&&(json.callingPhoneNumber!=null)?json.callingPhoneNumber:null);
    /**
     * 阿里云录音时长
     * @type {String}
     */
    this.talkTime = build.buildString(json&&(json.talkTime!=null)?json.talkTime:null);
    /**
     * 坐席通话时长
     * @type {String}
     */
    this.talkingTime = build.buildString(json&&(json.talkingTime!=null)?json.talkingTime:null);
    /**
     * 等待时长
     * @type {String}
     */
    this.waitingTime = build.buildString(json&&(json.waitingTime!=null)?json.waitingTime:null);
    /**
     * 通话id
     * @type {String}
     */
    this.contactId = build.buildString(json&&(json.contactId!=null)?json.contactId:null);
    /**
     * 有无录音
     * @type {Boolean}
     */
    this.isRecording = build.buildBoolean(json&&(json.isRecording!=null)?json.isRecording:null);
    /**
     * 录音地址
     * @type {String}
     */
    this.recording = build.buildString(json&&(json.recording!=null)?json.recording:null);
    /**
     * 批次id
     * @type {Number}
     */
    this.batchId = build.buildNumber(json&&(json.batchId!=null)?json.batchId:null);
    /**
     * 批次名称
     * @type {String}
     */
    this.batchName = build.buildString(json&&(json.batchName!=null)?json.batchName:null);
    /**
     * 名单上传时间
     * @type {String}
     */
    this.uploadTime = build.buildString(json&&(json.uploadTime!=null)?json.uploadTime:null);
    /**
     * 位置
     * @type {Number}
     */
    this.index = build.buildNumber(json&&(json.index!=null)?json.index:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 呼叫坐席真实姓名
     * @type {String}
     */
    this.callSeatRealName = build.buildString(json&&(json.callSeatRealName!=null)?json.callSeatRealName:null);
    /**
     * 总条数
     * @type {Number}
     */
    this.totalNumber = build.buildNumber(json&&(json.totalNumber!=null)?json.totalNumber:null);
    /**
     * 当前条数
     * @type {Number}
     */
    this.currentNumber = build.buildNumber(json&&(json.currentNumber!=null)?json.currentNumber:null);
    /**
     * 分割点
     * @type {String}
     */
    this.splitPoint = build.buildString(json&&(json.splitPoint!=null)?json.splitPoint:null);
    /**
     * 是否录音确认
     * @type {Boolean}
     */
    this.isRecordingConfirm = build.buildBoolean(json&&(json.isRecordingConfirm!=null)?json.isRecordingConfirm:null);
    /**
     * 挂断方：agent坐席、customer客户
     * @type {String}
     */
    this.releaseInitiator = build.buildString(json&&(json.releaseInitiator!=null)?json.releaseInitiator:null);
    /**
     * 是否加微信
     * @type {Boolean}
     */
    this.isAddWeChat = build.buildBoolean(json&&(json.isAddWeChat!=null)?json.isAddWeChat:null);
    /**
     * 联系状态
     * @type {Number}
     */
    this.contactStatus = build.buildNumber(json&&(json.contactStatus!=null)?json.contactStatus:null);
    /**
     * 联系情况
     * @type {Number}
     */
    this.contactInformation = build.buildNumber(json&&(json.contactInformation!=null)?json.contactInformation:null);
}
/** 医生大厅首页信息 **/
function HomePageDoctorInfo(json=false){
    /**
     * 医生大厅信息医生类型
     * @type {Number}
     */
    this.doctorKind = build.buildNumber(json&&(json.doctorKind!=null)?json.doctorKind:null);
    /**
     * 不同的医生列表
     * @type {Array.<ConsultDoctorUser>}
     */
    this.consultDoctor = build.buildArray(json&&(json.consultDoctor!=null)?json.consultDoctor:null,build.buildConsultDoctorUser);
}
/** 问卷模板 **/
function QuestionnaireTemplateInfo(json=false){
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 问卷模板名称
     * @type {String}
     */
    this.questionnaireTemplateName = build.buildString(json&&(json.questionnaireTemplateName!=null)?json.questionnaireTemplateName:null);
    /**
     * 问卷模板描述
     * @type {String}
     */
    this.questionnaireTemplateDescription = build.buildString(json&&(json.questionnaireTemplateDescription!=null)?json.questionnaireTemplateDescription:null);
}
/** HttpResult **/
function HttpResult_TFollowupSmsSendRecordResps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TFollowupSmsSendRecordResp>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTFollowupSmsSendRecordResp);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 参考信息组字段值信息 **/
function ReferenceGroupFieldValueInfo(json=false){
    /**
     * 参考信息组id
     * @type {Number}
     */
    this.referenceGroupId = build.buildNumber(json&&(json.referenceGroupId!=null)?json.referenceGroupId:null);
    /**
     * 参考信息id
     * @type {Number}
     */
    this.referenceInfoId = build.buildNumber(json&&(json.referenceInfoId!=null)?json.referenceInfoId:null);
    /**
     * 参考字段值
     * @type {String}
     */
    this.referenceFieldValue = build.buildString(json&&(json.referenceFieldValue!=null)?json.referenceFieldValue:null);
}
/** 页码和页码含有的题目功能Resp **/
function TQuestionPageResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 页码
     * @type {Number}
     */
    this.pageNumber = build.buildNumber(json&&(json.pageNumber!=null)?json.pageNumber:null);
    /**
     * 页码备注
     * @type {String}
     */
    this.pageRemark = build.buildString(json&&(json.pageRemark!=null)?json.pageRemark:null);
    /**
     * ** 题目表主键
     * @type {Number}
     */
    this.questionInfoId = build.buildNumber(json&&(json.questionInfoId!=null)?json.questionInfoId:null);
    /**
     * 新问卷表主键id
     * @type {Number}
     */
    this.questionnaireNewId = build.buildNumber(json&&(json.questionnaireNewId!=null)?json.questionnaireNewId:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * ** 是否开启 0-开启，1-未开启
     * @type {Number}
     */
    this.isOpen = build.buildNumber(json&&(json.isOpen!=null)?json.isOpen:null);
    /**
     * ** 是否删除 0-未删除，1-已删除
     * @type {Number}
     */
    this.isDelete = build.buildNumber(json&&(json.isDelete!=null)?json.isDelete:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * ** 第几页
     * @type {Number}
     */
    this.pageIndex = build.buildNumber(json&&(json.pageIndex!=null)?json.pageIndex:null);
    /**
     * ** 页宽
     * @type {Number}
     */
    this.pageSize = build.buildNumber(json&&(json.pageSize!=null)?json.pageSize:null);
}
/** HttpResult **/
function HttpResult_RelationshipLevels(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<RelationshipLevel>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildRelationshipLevel);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_HuiZhuoRegisterState(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {HuiZhuoRegisterState}
     */
    this.retValue = build.buildHuiZhuoRegisterState(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 下拉列表内容 **/
function GroupInfoList(json=false){
    /**
     * 标签id
     * @type {Number}
     */
    this.tagId = build.buildNumber(json&&(json.tagId!=null)?json.tagId:null);
    /**
     * 配置：0允许检索，1允许补充，2多层级
     * @type {Array.<Number>}
     */
    this.configuration = build.buildArray(json&&(json.configuration!=null)?json.configuration:null,build.buildNumber);
    /**
     * 组id
     * @type {Number}
     */
    this.groupId = build.buildNumber(json&&(json.groupId!=null)?json.groupId:null);
    /**
     * 组名
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 组内容
     * @type {Array.<GroupInfo>}
     */
    this.groupInfoList = build.buildArray(json&&(json.groupInfoList!=null)?json.groupInfoList:null,build.buildGroupInfo);
    /**
     * 下拉内容
     * @type {Array.<String>}
     */
    this.labelInfos = build.buildArray(json&&(json.labelInfos!=null)?json.labelInfos:null,build.buildString);
}
/** HttpResult **/
function HttpResult_Integer(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Number}
     */
    this.retValue = build.buildNumber(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_PhoneLabels(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<PhoneLabel>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildPhoneLabel);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_SeatMistakeInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SeatMistakeInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSeatMistakeInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 随访异常无能力信息 **/
function FollowUpTaskSwitchMark(json=false){
    /**
     * 是否开启录音剪切
     * @type {Boolean}
     */
    this.isRecordingSplit = build.buildBoolean(json&&(json.isRecordingSplit!=null)?json.isRecordingSplit:null);
    /**
     * 是否参考信息必读
     * @type {Boolean}
     */
    this.isReferenceRead = build.buildBoolean(json&&(json.isReferenceRead!=null)?json.isReferenceRead:null);
    /**
     * 是否开启需复核池
     * @type {Boolean}
     */
    this.isReviewPool = build.buildBoolean(json&&(json.isReviewPool!=null)?json.isReviewPool:null);
}
/** HttpResult **/
function HttpResult_QualityRuleResp(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {QualityRuleResp}
     */
    this.retValue = build.buildQualityRuleResp(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 专病库同步推送随访参数 **/
function SdrAsyncPushFollowupParam(json=false){
    /**
     * 患者基本信息
     * @type {NewDeliverTableFixedFieldInfo}
     */
    this.patientBasicInfo = build.buildNewDeliverTableFixedFieldInfo(json&&(json.patientBasicInfo!=null)?json.patientBasicInfo:null);
    /**
     * 患者随访任务问卷信息
     * @type {Array.<FollowupQuestionnaireData>}
     */
    this.questionnaireDataList = build.buildArray(json&&(json.questionnaireDataList!=null)?json.questionnaireDataList:null,build.buildFollowupQuestionnaireData);
}
/** 圆饼图统计 **/
function PieStatisticsByTaskName(json=false){
    /**
     * 表格
     * @type {PieStatisticsTableByWorkNum}
     */
    this.pieStatisticsTableByWorkNum = build.buildPieStatisticsTableByWorkNum(json&&(json.pieStatisticsTableByWorkNum!=null)?json.pieStatisticsTableByWorkNum:null);
    /**
     * 剩余随访数
     * @type {Number}
     */
    this.remainFollowupNumber = build.buildNumber(json&&(json.remainFollowupNumber!=null)?json.remainFollowupNumber:null);
    /**
     * 完成随访数
     * @type {Number}
     */
    this.finishFollowupNum = build.buildNumber(json&&(json.finishFollowupNum!=null)?json.finishFollowupNum:null);
}
/** 电话随访问卷题目 **/
function CallCenterAnswerQuestions(json=false){
    /**
     * required
     * @type {Boolean}
     */
    this.required = build.buildBoolean(json&&(json.required!=null)?json.required:null);
    /**
     * questionId
     * @type {String}
     */
    this.questionId = build.buildString(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * questionType
     * @type {String}
     */
    this.questionType = build.buildString(json&&(json.questionType!=null)?json.questionType:null);
    /**
     * questionContent
     * @type {String}
     */
    this.questionContent = build.buildString(json&&(json.questionContent!=null)?json.questionContent:null);
    /**
     * questionNumber
     * @type {Number}
     */
    this.questionNumber = build.buildNumber(json&&(json.questionNumber!=null)?json.questionNumber:null);
    /**
     * hasOtherOption
     * @type {Boolean}
     */
    this.hasOtherOption = build.buildBoolean(json&&(json.hasOtherOption!=null)?json.hasOtherOption:null);
    /**
     * otherOptionContent
     * @type {String}
     */
    this.otherOptionContent = build.buildString(json&&(json.otherOptionContent!=null)?json.otherOptionContent:null);
    /**
     * hasChild
     * @type {Boolean}
     */
    this.hasChild = build.buildBoolean(json&&(json.hasChild!=null)?json.hasChild:null);
    /**
     * question
     * @type {Array.<CallCenterAnswerQuestions>}
     */
    this.question = build.buildArray(json&&(json.question!=null)?json.question:null,build.buildCallCenterAnswerQuestions);
    /**
     * goodQuestionOption
     * @type {Array.<CallCenterQuestionOption>}
     */
    this.goodQuestionOption = build.buildArray(json&&(json.goodQuestionOption!=null)?json.goodQuestionOption:null,build.buildCallCenterQuestionOption);
    /**
     * badQuestionOption
     * @type {Array.<CallCenterQuestionOption>}
     */
    this.badQuestionOption = build.buildArray(json&&(json.badQuestionOption!=null)?json.badQuestionOption:null,build.buildCallCenterQuestionOption);
    /**
     * mmid
     * @type {String}
     */
    this.mmid = build.buildString(json&&(json.mmid!=null)?json.mmid:null);
    /**
     * uuid
     * @type {String}
     */
    this.uuid = build.buildString(json&&(json.uuid!=null)?json.uuid:null);
    /**
     * isNotShow
     * @type {Boolean}
     */
    this.isNotShow = build.buildBoolean(json&&(json.isNotShow!=null)?json.isNotShow:null);
}
/** 稍后拨打提醒信息 **/
function LaterCallInfo(json=false){
    /**
     * 任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 任务名
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 疾病id
     * @type {Number}
     */
    this.diseaseId = build.buildNumber(json&&(json.diseaseId!=null)?json.diseaseId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者详情id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 稍后拨打时间
     * @type {String}
     */
    this.laterCallTime = build.buildString(json&&(json.laterCallTime!=null)?json.laterCallTime:null);
}
/** 问卷模板基本信息 **/
function SimpleQuestionnaireTemplate(json=false){
    /**
     * 问卷模板ID
     * @type {Number}
     */
    this.questionnaireTemplateId = build.buildNumber(json&&(json.questionnaireTemplateId!=null)?json.questionnaireTemplateId:null);
    /**
     * 问卷模板名称
     * @type {String}
     */
    this.questionnaireTemplateName = build.buildString(json&&(json.questionnaireTemplateName!=null)?json.questionnaireTemplateName:null);
    /**
     * 问卷模板描述
     * @type {String}
     */
    this.questionnaireTemplateDescription = build.buildString(json&&(json.questionnaireTemplateDescription!=null)?json.questionnaireTemplateDescription:null);
}
/** 问题 **/
function AnswerQuestion(json=false){
    /**
     * 问题Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 问题类型
     * @type {String}
     */
    this.questionType = build.buildString(json&&(json.questionType!=null)?json.questionType:null);
    /**
     * 问题内容
     * @type {String}
     */
    this.questionContent = build.buildString(json&&(json.questionContent!=null)?json.questionContent:null);
    /**
     * 题目
     * @type {String}
     */
    this.questionNumber = build.buildString(json&&(json.questionNumber!=null)?json.questionNumber:null);
    /**
     * 正常选项
     * @type {Array.<QuestionOption>}
     */
    this.goodQuestionOption = build.buildArray(json&&(json.goodQuestionOption!=null)?json.goodQuestionOption:null,build.buildQuestionOption);
    /**
     * 异常选项
     * @type {Array.<QuestionOption>}
     */
    this.badQuestionOption = build.buildArray(json&&(json.badQuestionOption!=null)?json.badQuestionOption:null,build.buildQuestionOption);
    /**
     * 有其他选项
     * @type {Boolean}
     */
    this.hasOtherOption = build.buildBoolean(json&&(json.hasOtherOption!=null)?json.hasOtherOption:null);
    /**
     * 选填
     * @type {String}
     */
    this.otherOptionContent = build.buildString(json&&(json.otherOptionContent!=null)?json.otherOptionContent:null);
    /**
     * 是否子题
     * @type {Boolean}
     */
    this.hasChild = build.buildBoolean(json&&(json.hasChild!=null)?json.hasChild:null);
    /**
     * 子题
     * @type {Array.<AnswerQuestion>}
     */
    this.question = build.buildArray(json&&(json.question!=null)?json.question:null,build.buildAnswerQuestion);
}
/** 短信模板 **/
function BatchAddPatientAnswerInfo(json=false){
    /**
     * 随访患者表id（后台预览为-1）
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 新问卷表id主键
     * @type {Number}
     */
    this.questionnaireNewId = build.buildNumber(json&&(json.questionnaireNewId!=null)?json.questionnaireNewId:null);
    /**
     * 题目表id主键
     * @type {Number}
     */
    this.questionInfo = build.buildNumber(json&&(json.questionInfo!=null)?json.questionInfo:null);
    /**
     * 患者答案信息json格式
     * @type {String}
     */
    this.answerInfo = build.buildString(json&&(json.answerInfo!=null)?json.answerInfo:null);
    /**
     * ** 来源类别 1-线上，2-电话
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * （只有电话才填）电话随访录入人员id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
}
/** 患者的诊断信息 **/
function PatientDiagnosisInfo(json=false){
    /**
     * 医院
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 诊断日期
     * @type {String}
     */
    this.visitingDate = build.buildString(json&&(json.visitingDate!=null)?json.visitingDate:null);
    /**
     * 就诊类型
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
}
/** 展示患者提交问卷的题目、答案、问卷模板名称、问卷模板描述 **/
function ShowPatientSubmitQuestionAnswer(json=false){
    /**
     * 问卷基本信息
     * @type {SimpleQuestionnaireTemplate}
     */
    this.simpleQuestionnaireTemplate = build.buildSimpleQuestionnaireTemplate(json&&(json.simpleQuestionnaireTemplate!=null)?json.simpleQuestionnaireTemplate:null);
    /**
     * 患者提交问卷的题目及答案
     * @type {Array.<ShowPatientQuestionAnswer>}
     */
    this.showPatientQuestionAnswer = build.buildArray(json&&(json.showPatientQuestionAnswer!=null)?json.showPatientQuestionAnswer:null,build.buildShowPatientQuestionAnswer);
}
/** 月份投票信息表 **/
function FollowupVoteMonthInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 选送月份
     * @type {String}
     */
    this.pullMonth = build.buildString(json&&(json.pullMonth!=null)?json.pullMonth:null);
    /**
     * 投票截止时间
     * @type {String}
     */
    this.endTime = build.buildString(json&&(json.endTime!=null)?json.endTime:null);
    /**
     * 是否已经生成评估结果
     * @type {Boolean}
     */
    this.isEnd = build.buildBoolean(json&&(json.isEnd!=null)?json.isEnd:null);
    /**
     * 奖金
     * @type {String}
     */
    this.cash = build.buildString(json&&(json.cash!=null)?json.cash:null);
    /**
     * 绩效分
     * @type {String}
     */
    this.performanceScore = build.buildString(json&&(json.performanceScore!=null)?json.performanceScore:null);
    /**
     * 是否推送
     * @type {Boolean}
     */
    this.isPush = build.buildBoolean(json&&(json.isPush!=null)?json.isPush:null);
    /**
     * 消息id
     * @type {Number}
     */
    this.messageId = build.buildNumber(json&&(json.messageId!=null)?json.messageId:null);
    /**
     * 最终获奖名单
     * @type {Array.<FollowupAwardInfo>}
     */
    this.awardInfoList = build.buildArray(json&&(json.awardInfoList!=null)?json.awardInfoList:null,build.buildFollowupAwardInfo);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** HttpResult **/
function HttpResult_qualifiedSpotCheckInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<QualifiedSpotCheckInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildQualifiedSpotCheckInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_CallTaskStatistics(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {CallTaskStatistics}
     */
    this.retValue = build.buildCallTaskStatistics(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** API返回随访组内每位患者最大随访记录及随访组信息 **/
function FollowupGroupPatientRecordInfo(json=false){
    /**
     * API返回随访组内每位患者随访记录
     * @type {FollowupGroupBasicInfo}
     */
    this.followupGroupBasicInfo = build.buildFollowupGroupBasicInfo(json&&(json.followupGroupBasicInfo!=null)?json.followupGroupBasicInfo:null);
    /**
     * API返回随访组内每位患者最大随访记录
     * @type {Array.<FollowupGroupPatientRecord>}
     */
    this.followupGroupPatientRecord = build.buildArray(json&&(json.followupGroupPatientRecord!=null)?json.followupGroupPatientRecord:null,build.buildFollowupGroupPatientRecord);
}
/** 新问卷 **/
function JumpSetUp(json=false){
    /**
     * 选项序号
     * @type {Number}
     */
    this.optionNumber = build.buildNumber(json&&(json.optionNumber!=null)?json.optionNumber:null);
    /**
     * 跳题目序号
     * @type {Number}
     */
    this.jumpQuestionNumber = build.buildNumber(json&&(json.jumpQuestionNumber!=null)?json.jumpQuestionNumber:null);
    /**
     * 是否正常结束
     * @type {Boolean}
     */
    this.isNormalEnd = build.buildBoolean(json&&(json.isNormalEnd!=null)?json.isNormalEnd:null);
}
/** 外部质控-抽查信息 **/
function FollowupSpotCheckRecordResp(json=false){
    /**
     * ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访患者ID
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访任务患者详情ID
     * @type {Number}
     */
    this.followUpTaskPatientInfoId = build.buildNumber(json&&(json.followUpTaskPatientInfoId!=null)?json.followUpTaskPatientInfoId:null);
    /**
     * 二级质检抽查状态：0电话抽查-不合格，1电话抽查-合格 ，2电话抽查-不合格，不需重拨（提醒坐席），3电话抽查-不合格，需重拨 （重新拨打），4电话抽查-不合格，其他（平台相关），5线上抽查-合格，6线上抽查-不合格，不需重拨，7线上抽查-不合格，需重拨
     * @type {Number}
     */
    this.secondSpotCheckState = build.buildNumber(json&&(json.secondSpotCheckState!=null)?json.secondSpotCheckState:null);
    /**
     * 抽查备注
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 管理台抽查备注
     * @type {String}
     */
    this.manageCheckRemarks = build.buildString(json&&(json.manageCheckRemarks!=null)?json.manageCheckRemarks:null);
    /**
     * 结果
     * @type {String}
     */
    this.sbResult = build.buildString(json&&(json.sbResult!=null)?json.sbResult:null);
    /**
     * 抽查时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 处理结果：1重新拨打 2提醒坐席 4需修改问卷
     * @type {Number}
     */
    this.handleResult = build.buildNumber(json&&(json.handleResult!=null)?json.handleResult:null);
    /**
     * 第一次抽查状态
     * @type {String}
     */
    this.firstSpotCheckState = build.buildString(json&&(json.firstSpotCheckState!=null)?json.firstSpotCheckState:null);
    /**
     * 管理台处理时间
     * @type {String}
     */
    this.replyTime = build.buildString(json&&(json.replyTime!=null)?json.replyTime:null);
    /**
     * 图片地址
     * @type {Array.<String>}
     */
    this.imageUrl = build.buildArray(json&&(json.imageUrl!=null)?json.imageUrl:null,build.buildString);
    /**
     * 质控分数
     * @type {Number}
     */
    this.qualityScore = build.buildNumber(json&&(json.qualityScore!=null)?json.qualityScore:null);
    /**
     * 管理台抽查备注
     * @type {Array.<StringMap>}
     */
    this.manageHistoryCheckRemark = build.buildArray(json&&(json.manageHistoryCheckRemark!=null)?json.manageHistoryCheckRemark:null,build.buildStringMap);
}
/** 患者检查报告 **/
function PatientInspectionReport(json=false){
    /**
     * 报告日期
     * @type {String}
     */
    this.reportTime = build.buildString(json&&(json.reportTime!=null)?json.reportTime:null);
    /**
     * 报告图片地址
     * @type {String}
     */
    this.reportImgs = build.buildString(json&&(json.reportImgs!=null)?json.reportImgs:null);
}
/** HttpResult **/
function HttpResult_SeatFiles(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SeatFile>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSeatFile);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_NewMessageMangerInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<NewMessageMangerInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildNewMessageMangerInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_PassFailFeedBacks(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<PassFailFeedBack>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildPassFailFeedBack);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 医院信息 **/
function HospitalInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
}
/** 质控批注 **/
function QualityControlProblemRecord(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访患者详情id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 答案id
     * @type {Number}
     */
    this.answerInfoId = build.buildNumber(json&&(json.answerInfoId!=null)?json.answerInfoId:null);
    /**
     * 题号
     * @type {Number}
     */
    this.serialNumber = build.buildNumber(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * 问卷id
     * @type {Number}
     */
    this.questionnaireId = build.buildNumber(json&&(json.questionnaireId!=null)?json.questionnaireId:null);
    /**
     * 质控员id
     * @type {Number}
     */
    this.qualityControlUserId = build.buildNumber(json&&(json.qualityControlUserId!=null)?json.qualityControlUserId:null);
    /**
     * 是否正确
     * @type {Boolean}
     */
    this.isRight = build.buildBoolean(json&&(json.isRight!=null)?json.isRight:null);
    /**
     * 备注
     * @type {String}
     */
    this.remark = build.buildString(json&&(json.remark!=null)?json.remark:null);
}
/** 患者的简略信息 **/
function ManagerPatientSimpleInfo(json=false){
    /**
     * 患者Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者名字
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 是否默认随访人
     * @type {Boolean}
     */
    this.isFollowup = build.buildBoolean(json&&(json.isFollowup!=null)?json.isFollowup:null);
}
/** HttpResult **/
function HttpResult_SeatUserInfoss(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SeatUserInfos>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSeatUserInfos);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_CallPatient(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {CallPatient}
     */
    this.retValue = build.buildCallPatient(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 圆饼图表格统计 **/
function PieStatisticsTableByWorkNum(json=false){
    /**
     * 客服人员名单
     * @type {Array.<Number>}
     */
    this.userIds = build.buildArray(json&&(json.userIds!=null)?json.userIds:null,build.buildNumber);
    /**
     * 日期
     * @type {String}
     */
    this.callTime = build.buildString(json&&(json.callTime!=null)?json.callTime:null);
    /**
     * 任务名
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 呼叫名单的人数
     * @type {Number}
     */
    this.needCallNumber = build.buildNumber(json&&(json.needCallNumber!=null)?json.needCallNumber:null);
    /**
     * 总呼叫次数
     * @type {Number}
     */
    this.totalCallNumber = build.buildNumber(json&&(json.totalCallNumber!=null)?json.totalCallNumber:null);
    /**
     * 成功率
     * @type {String}
     */
    this.successRate = build.buildString(json&&(json.successRate!=null)?json.successRate:null);
}
/** 病区信息 **/
function WardInfo(json=false){
    /**
     * 病区Code
     * @type {String}
     */
    this.wardCode = build.buildString(json&&(json.wardCode!=null)?json.wardCode:null);
    /**
     * 病区名字
     * @type {String}
     */
    this.wardName = build.buildString(json&&(json.wardName!=null)?json.wardName:null);
    /**
     * 病区下的护士信息
     * @type {Array.<NurseInfo>}
     */
    this.nurseInfos = build.buildArray(json&&(json.nurseInfos!=null)?json.nurseInfos:null,build.buildNurseInfo);
}
/** HttpResult **/
function HttpResult_FollowupSpotCheckRecordResps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupSpotCheckRecordResp>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupSpotCheckRecordResp);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_MedicalRecordDetailed(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {MedicalRecordDetailed}
     */
    this.retValue = build.buildMedicalRecordDetailed(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 新题目结果 **/
function NewQuestionResult(json=false){
    /**
     * 结果标题
     * @type {String}
     */
    this.resultTitle = build.buildString(json&&(json.resultTitle!=null)?json.resultTitle:null);
    /**
     * 结果备注
     * @type {String}
     */
    this.resultRemarks = build.buildString(json&&(json.resultRemarks!=null)?json.resultRemarks:null);
    /**
     * 关联标题
     * @type {String}
     */
    this.relationTitle = build.buildString(json&&(json.relationTitle!=null)?json.relationTitle:null);
    /**
     * 关联选项
     * @type {Array.<NewQuestionResult>}
     */
    this.relationOption = build.buildArray(json&&(json.relationOption!=null)?json.relationOption:null,build.buildNewQuestionResult);
}
/** 最终获奖名单 **/
function FollowupAwardInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 选送月份
     * @type {String}
     */
    this.pullMonth = build.buildString(json&&(json.pullMonth!=null)?json.pullMonth:null);
    /**
     * 案例id
     * @type {Number}
     */
    this.caseId = build.buildNumber(json&&(json.caseId!=null)?json.caseId:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 坐席名
     * @type {String}
     */
    this.seatName = build.buildString(json&&(json.seatName!=null)?json.seatName:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.taskId = build.buildNumber(json&&(json.taskId!=null)?json.taskId:null);
    /**
     * 任务名
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 奖金
     * @type {String}
     */
    this.cash = build.buildString(json&&(json.cash!=null)?json.cash:null);
    /**
     * 绩效分
     * @type {String}
     */
    this.performanceScore = build.buildString(json&&(json.performanceScore!=null)?json.performanceScore:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
}
/** 题目功能Resp **/
function TQuestionInfoResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * t_questionnaire_new表id
     * @type {Number}
     */
    this.questionnaireNewId = build.buildNumber(json&&(json.questionnaireNewId!=null)?json.questionnaireNewId:null);
    /**
     * 题目序号
     * @type {Number}
     */
    this.serialNumber = build.buildNumber(json&&(json.serialNumber!=null)?json.serialNumber:null);
    /**
     * ** 缓存本题设置的跳转逻辑 此题选择什么跳转哪一题
     * @type {String}
     */
    this.jumpNumber = build.buildString(json&&(json.jumpNumber!=null)?json.jumpNumber:null);
    /**
     * ** 缓存本题设置的显示逻辑 此题选择什么显示哪一题
     * @type {String}
     */
    this.displayNumber = build.buildString(json&&(json.displayNumber!=null)?json.displayNumber:null);
    /**
     * ** 跳转配置页面显示第几题第几项跳转此题
     * @type {String}
     */
    this.jumpConfig = build.buildString(json&&(json.jumpConfig!=null)?json.jumpConfig:null);
    /**
     * 显示配置显示第几题第几项选择跳转此题
     * @type {String}
     */
    this.displayConfig = build.buildString(json&&(json.displayConfig!=null)?json.displayConfig:null);
    /**
     * ** 选项布局 1：1列 2：2列 3：3列
     * @type {Number}
     */
    this.optionLayout = build.buildNumber(json&&(json.optionLayout!=null)?json.optionLayout:null);
    /**
     * ** (前端已经定义就不修改)疾病分组id
     * @type {Number}
     */
    this.warehousingGroup = build.buildNumber(json&&(json.warehousingGroup!=null)?json.warehousingGroup:null);
    /**
     * ** (前端已经定义就不修改)疾病字段id
     * @type {Number}
     */
    this.warehousingMatchingField = build.buildNumber(json&&(json.warehousingMatchingField!=null)?json.warehousingMatchingField:null);
    /**
     * ** (前端已定义布尔值)是否显示 1-不显示，2-显示
     * @type {Number}
     */
    this.seqDisabled = build.buildNumber(json&&(json.seqDisabled!=null)?json.seqDisabled:null);
    /**
     * ** (前端已定义布尔值)是否显示 1-不是首次，2-是首次
     * @type {Number}
     */
    this.isFirst = build.buildNumber(json&&(json.isFirst!=null)?json.isFirst:null);
    /**
     * ** (前端已定义布尔值)1: YYYY/MM/DD 2: YYYY-MM-DD 3:YYYY年MM月DD日
     * @type {Number}
     */
    this.dateType = build.buildNumber(json&&(json.dateType!=null)?json.dateType:null);
    /**
     * ** 多个时间连接字段
     * @type {String}
     */
    this.linkWord = build.buildString(json&&(json.linkWord!=null)?json.linkWord:null);
    /**
     * ** (前端已定义布尔值)是否是时间周期 1-不是，2-是
     * @type {Number}
     */
    this.dateCycle = build.buildNumber(json&&(json.dateCycle!=null)?json.dateCycle:null);
    /**
     * ** 填空题的配置
     * @type {String}
     */
    this.completeConfig = build.buildString(json&&(json.completeConfig!=null)?json.completeConfig:null);
    /**
     * 文本1 文本2 输入类型 填空字符长度
     * @type {String}
     */
    this.completeTextArr = build.buildString(json&&(json.completeTextArr!=null)?json.completeTextArr:null);
    /**
     * ** 段落题的配置
     * @type {String}
     */
    this.paragraphConfig = build.buildString(json&&(json.paragraphConfig!=null)?json.paragraphConfig:null);
    /**
     * ** (前端已定义布尔值)用于控制管理台的高亮显示 1-不，2-是
     * @type {Number}
     */
    this.manangerActive = build.buildNumber(json&&(json.manangerActive!=null)?json.manangerActive:null);
    /**
     * ** 问题类型1：单选 2：多选 3：下拉 4：填空 5：多项填空 6：段落说明
     * @type {Number}
     */
    this.type = build.buildNumber(json&&(json.type!=null)?json.type:null);
    /**
     * 问题标题
     * @type {String}
     */
    this.title = build.buildString(json&&(json.title!=null)?json.title:null);
    /**
     * ** (前端已定义布尔值)是否必填 1-不是，2-是
     * @type {Number}
     */
    this.isMust = build.buildNumber(json&&(json.isMust!=null)?json.isMust:null);
    /**
     * ** (前端已定义布尔值)是否显示 1-不是，2-是
     * @type {Number}
     */
    this.isShow = build.buildNumber(json&&(json.isShow!=null)?json.isShow:null);
    /**
     * ** 最大选项
     * @type {Number}
     */
    this.maxOption = build.buildNumber(json&&(json.maxOption!=null)?json.maxOption:null);
    /**
     * ** 最小选项
     * @type {Number}
     */
    this.minOption = build.buildNumber(json&&(json.minOption!=null)?json.minOption:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * 操作人姓名
     * @type {String}
     */
    this.operatorName = build.buildString(json&&(json.operatorName!=null)?json.operatorName:null);
    /**
     * ** 是否开启 0-开启，1-未开启
     * @type {Number}
     */
    this.isOpen = build.buildNumber(json&&(json.isOpen!=null)?json.isOpen:null);
    /**
     * ** 是否删除 0-未删除，1-已删除
     * @type {Number}
     */
    this.isDelete = build.buildNumber(json&&(json.isDelete!=null)?json.isDelete:null);
    /**
     * 页码表id
     * @type {Number}
     */
    this.questionPageid = build.buildNumber(json&&(json.questionPageid!=null)?json.questionPageid:null);
    /**
     * 页码
     * @type {Number}
     */
    this.pageNumber = build.buildNumber(json&&(json.pageNumber!=null)?json.pageNumber:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 页码备注
     * @type {String}
     */
    this.pageRemark = build.buildString(json&&(json.pageRemark!=null)?json.pageRemark:null);
    /**
     * 选项信息
     * @type {Array.<TOptionsInfoResp>}
     */
    this.optionsInfoRespList = build.buildArray(json&&(json.optionsInfoRespList!=null)?json.optionsInfoRespList:null,build.buildTOptionsInfoResp);
    /**
     * 答案信息
     * @type {String}
     */
    this.answerInfo = build.buildString(json&&(json.answerInfo!=null)?json.answerInfo:null);
    /**
     * 患者答题信息表id
     * @type {Number}
     */
    this.patientAnswerInfoId = build.buildNumber(json&&(json.patientAnswerInfoId!=null)?json.patientAnswerInfoId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 排他配置
     * @type {String}
     */
    this.exclusiveConfig = build.buildString(json&&(json.exclusiveConfig!=null)?json.exclusiveConfig:null);
    /**
     * 量标题配置
     * @type {String}
     */
    this.scaleConfig = build.buildString(json&&(json.scaleConfig!=null)?json.scaleConfig:null);
    /**
     * 题干图片url
     * @type {String}
     */
    this.pictureUrl = build.buildString(json&&(json.pictureUrl!=null)?json.pictureUrl:null);
    /**
     * 说明
     * @type {String}
     */
    this.note = build.buildString(json&&(json.note!=null)?json.note:null);
    /**
     * 是否开启时间：0-否 ,1-是
     * @type {Boolean}
     */
    this.isTime = build.buildBoolean(json&&(json.isTime!=null)?json.isTime:null);
    /**
     * 时间逻辑，绑定该题的那些题目的id
     * @type {String}
     */
    this.bingTimeId = build.buildString(json&&(json.bingTimeId!=null)?json.bingTimeId:null);
    /**
     * 时间逻辑
     * @type {String}
     */
    this.timeConfigArr = build.buildString(json&&(json.timeConfigArr!=null)?json.timeConfigArr:null);
    /**
     * 提示标记颜色：1-红色，2-黄色，3-绿色
     * @type {Number}
     */
    this.tipColor = build.buildNumber(json&&(json.tipColor!=null)?json.tipColor:null);
    /**
     * 显示逻辑
     * @type {String}
     */
    this.displayInfo = build.buildString(json&&(json.displayInfo!=null)?json.displayInfo:null);
    /**
     * 跳转逻辑
     * @type {String}
     */
    this.jumpInfo = build.buildString(json&&(json.jumpInfo!=null)?json.jumpInfo:null);
    /**
     * 导出内容：1选项，2补充框，3选项+补充框，4填写的答案，5原始日期，6格式化日期，7原始日期+格式化日期
     * @type {String}
     */
    this.exportContent = build.buildString(json&&(json.exportContent!=null)?json.exportContent:null);
    /**
     * 导出的表头
     * @type {String}
     */
    this.exportHead = build.buildString(json&&(json.exportHead!=null)?json.exportHead:null);
    /**
     * 是否导出
     * @type {Boolean}
     */
    this.isExport = build.buildBoolean(json&&(json.isExport!=null)?json.isExport:null);
    /**
     * 数值类型配置
     * @type {NumericTypeConfigInfo}
     */
    this.numericTypeConfig = build.buildNumericTypeConfigInfo(json&&(json.numericTypeConfig!=null)?json.numericTypeConfig:null);
}
/** 逾期提醒未服药物 **/
function OverTimeDrug(json=false){
    /**
     * 提醒时间
     * @type {String}
     */
    this.remindTime = build.buildString(json&&(json.remindTime!=null)?json.remindTime:null);
    /**
     * 药物（检查）
     * @type {Array.<String>}
     */
    this.drugs = build.buildArray(json&&(json.drugs!=null)?json.drugs:null,build.buildString);
}
/** HttpResult **/
function HttpResult_TFollowUpPeopleTaskResps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TFollowUpPeopleTaskResp>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTFollowUpPeopleTaskResp);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 文件信息 **/
function FileInfo(json=false){
    /**
     * 文件id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 文件名
     * @type {String}
     */
    this.fileName = build.buildString(json&&(json.fileName!=null)?json.fileName:null);
    /**
     * 文件夹id
     * @type {Number}
     */
    this.fileFolderId = build.buildNumber(json&&(json.fileFolderId!=null)?json.fileFolderId:null);
    /**
     * 文件夹名
     * @type {String}
     */
    this.folderName = build.buildString(json&&(json.folderName!=null)?json.folderName:null);
    /**
     * 创建人id
     * @type {Number}
     */
    this.createPersonId = build.buildNumber(json&&(json.createPersonId!=null)?json.createPersonId:null);
    /**
     * 创建人姓名
     * @type {String}
     */
    this.createPersonName = build.buildString(json&&(json.createPersonName!=null)?json.createPersonName:null);
    /**
     * 更新人id
     * @type {Number}
     */
    this.updatePersonId = build.buildNumber(json&&(json.updatePersonId!=null)?json.updatePersonId:null);
    /**
     * 更新人姓名
     * @type {String}
     */
    this.updatePersonName = build.buildString(json&&(json.updatePersonName!=null)?json.updatePersonName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 文件后缀
     * @type {String}
     */
    this.fileSuffix = build.buildString(json&&(json.fileSuffix!=null)?json.fileSuffix:null);
    /**
     * 文件标签
     * @type {Array.<String>}
     */
    this.fileTags = build.buildArray(json&&(json.fileTags!=null)?json.fileTags:null,build.buildString);
    /**
     * 历史信息
     * @type {Array.<FileOperationRecordInfo>}
     */
    this.historyInfo = build.buildArray(json&&(json.historyInfo!=null)?json.historyInfo:null,build.buildFileOperationRecordInfo);
}
/** 角色信息 **/
function RoleInfo(json=false){
    /**
     * 角色id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 角色名称
     * @type {String}
     */
    this.roleName = build.buildString(json&&(json.roleName!=null)?json.roleName:null);
    /**
     * 角色说明
     * @type {String}
     */
    this.roleExplain = build.buildString(json&&(json.roleExplain!=null)?json.roleExplain:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
}
/** HttpResult **/
function HttpResult_QualityTimeStages(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<QualityTimeStage>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildQualityTimeStage);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 患者就诊信息 **/
function PatientMedicalRecord(json=false){
    /**
     * 就诊ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 就诊流水号
     * @type {String}
     */
    this.visitingNo = build.buildString(json&&(json.visitingNo!=null)?json.visitingNo:null);
    /**
     * 就诊类型 0门诊 1住院 2体检
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
    /**
     * 数据来源 1同步更新 2手动上传
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 就诊日期（格式：yyyy-MM-dd）
     * @type {String}
     */
    this.visitingDate = build.buildString(json&&(json.visitingDate!=null)?json.visitingDate:null);
    /**
     * 出院时间（格式：yyyy-MM-dd）
     * @type {String}
     */
    this.dischargeTime = build.buildString(json&&(json.dischargeTime!=null)?json.dischargeTime:null);
    /**
     * 就诊科室名称
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 主诊医生姓名
     * @type {String}
     */
    this.primaryPhysicianName = build.buildString(json&&(json.primaryPhysicianName!=null)?json.primaryPhysicianName:null);
    /**
     * 诊断名
     * @type {String}
     */
    this.diagnosisName = build.buildString(json&&(json.diagnosisName!=null)?json.diagnosisName:null);
    /**
     * 症状描述
     * @type {String}
     */
    this.symptom = build.buildString(json&&(json.symptom!=null)?json.symptom:null);
    /**
     * 是否是专家门诊 1是 2否
     * @type {Number}
     */
    this.isSpecialistClinic = build.buildNumber(json&&(json.isSpecialistClinic!=null)?json.isSpecialistClinic:null);
    /**
     * 是否包含报告
     * @type {Boolean}
     */
    this.isContain = build.buildBoolean(json&&(json.isContain!=null)?json.isContain:null);
}
/** 平均分 **/
function ScoreAverageStatistics(json=false){
    /**
     * 题号
     * @type {String}
     */
    this.number = build.buildString(json&&(json.number!=null)?json.number:null);
    /**
     * 平均分
     * @type {Number}
     */
    this.averageScore = build.buildNumber(json&&(json.averageScore!=null)?json.averageScore:null);
}
/** 患者Excel基本信息 **/
function CallPatientInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者名字
     * @type {String}
     */
    this.name = build.buildString(json&&(json.name!=null)?json.name:null);
    /**
     * 性别
     * @type {String}
     */
    this.gender = build.buildString(json&&(json.gender!=null)?json.gender:null);
    /**
     * 身份证号码
     * @type {String}
     */
    this.card = build.buildString(json&&(json.card!=null)?json.card:null);
    /**
     * 电话号码
     * @type {String}
     */
    this.mobile = build.buildString(json&&(json.mobile!=null)?json.mobile:null);
    /**
     * 住院号
     * @type {String}
     */
    this.hospitalNumber = build.buildString(json&&(json.hospitalNumber!=null)?json.hospitalNumber:null);
}
/** 坐席文件夹 **/
function SeatFile(json=false){
    /**
     * ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 坐席id
     * @type {Number}
     */
    this.seatId = build.buildNumber(json&&(json.seatId!=null)?json.seatId:null);
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followupTaskId = build.buildNumber(json&&(json.followupTaskId!=null)?json.followupTaskId:null);
    /**
     * 文件夹名
     * @type {String}
     */
    this.fileName = build.buildString(json&&(json.fileName!=null)?json.fileName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 修改时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 患者数
     * @type {Number}
     */
    this.patientNum = build.buildNumber(json&&(json.patientNum!=null)?json.patientNum:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 是否存在
     * @type {Boolean}
     */
    this.isExit = build.buildBoolean(json&&(json.isExit!=null)?json.isExit:null);
    /**
     * 来源
     * @type {Number}
     */
    this.source = build.buildNumber(json&&(json.source!=null)?json.source:null);
}
/** 用户任务抽查统计 **/
function UserTaskSpotCheckStatistics(json=false){
    /**
     * 抽查状态类型 1：合格 2：不合格，不需重拨 3：不合格，需重播 4：不符合抽查条件
     * @type {Number}
     */
    this.spotCheckStateType = build.buildNumber(json&&(json.spotCheckStateType!=null)?json.spotCheckStateType:null);
    /**
     * 抽查数量
     * @type {Number}
     */
    this.spotCheckStateNumber = build.buildNumber(json&&(json.spotCheckStateNumber!=null)?json.spotCheckStateNumber:null);
}
/** HttpResult **/
function HttpResult_strings(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<String>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildString);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowupInfoKVs(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupInfoKV>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupInfoKV);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 电话随访任务中心信息 **/
function CallTaskCenterInfo(json=false){
    /**
     * 电话随访任务Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务名字
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 医院Id
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 科室Id
     * @type {Number}
     */
    this.deptId = build.buildNumber(json&&(json.deptId!=null)?json.deptId:null);
    /**
     * 任务状态 1已创建 2进行中 3已结束
     * @type {Number}
     */
    this.taskState = build.buildNumber(json&&(json.taskState!=null)?json.taskState:null);
    /**
     * 医院名字
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室名字
     * @type {String}
     */
    this.deptName = build.buildString(json&&(json.deptName!=null)?json.deptName:null);
    /**
     * 呼叫类型
     * @type {Number}
     */
    this.callType = build.buildNumber(json&&(json.callType!=null)?json.callType:null);
    /**
     * 患者名单
     * @type {String}
     */
    this.patientList = build.buildString(json&&(json.patientList!=null)?json.patientList:null);
    /**
     * 任务完成
     * @type {String}
     */
    this.taskSchedule = build.buildString(json&&(json.taskSchedule!=null)?json.taskSchedule:null);
    /**
     * 任务类型
     * @type {Number}
     */
    this.taskType = build.buildNumber(json&&(json.taskType!=null)?json.taskType:null);
    /**
     * 問卷Id
     * @type {Number}
     */
    this.questionnaireId = build.buildNumber(json&&(json.questionnaireId!=null)?json.questionnaireId:null);
    /**
     * 任务开始时间
     * @type {String}
     */
    this.startTime = build.buildString(json&&(json.startTime!=null)?json.startTime:null);
    /**
     * 任务结束时间
     * @type {String}
     */
    this.endTime = build.buildString(json&&(json.endTime!=null)?json.endTime:null);
    /**
     * 任务实际结束时间
     * @type {String}
     */
    this.actualEndTime = build.buildString(json&&(json.actualEndTime!=null)?json.actualEndTime:null);
    /**
     * 父级ID
     * @type {Number}
     */
    this.fatherId = build.buildNumber(json&&(json.fatherId!=null)?json.fatherId:null);
    /**
     * 优先级：1低，2中，3高
     * @type {Number}
     */
    this.priorityType = build.buildNumber(json&&(json.priorityType!=null)?json.priorityType:null);
}
/** 内容分类 **/
function NewQuestionnaireContentInfo(json=false){
    /**
     * 是否分组
     * @type {Boolean}
     */
    this.hasGroup = build.buildBoolean(json&&(json.hasGroup!=null)?json.hasGroup:null);
    /**
     * 分组名称
     * @type {String}
     */
    this.groupName = build.buildString(json&&(json.groupName!=null)?json.groupName:null);
    /**
     * 分组中被选中的问题Ids
     * @type {Array.<Number>}
     */
    this.selectedQuestionIds = build.buildArray(json&&(json.selectedQuestionIds!=null)?json.selectedQuestionIds:null,build.buildNumber);
    /**
     * 问题
     * @type {Array.<AnswerQuestion>}
     */
    this.answerQuestions = build.buildArray(json&&(json.answerQuestions!=null)?json.answerQuestions:null,build.buildAnswerQuestion);
    /**
     * 对应的问题
     * @type {String}
     */
    this.relationQuestion = build.buildString(json&&(json.relationQuestion!=null)?json.relationQuestion:null);
}
/** 问卷质控规则 **/
function QuestionnaireQualityRuleResp(json=false){
    /**
     * 规则id
     * @type {Number}
     */
    this.ruleId = build.buildNumber(json&&(json.ruleId!=null)?json.ruleId:null);
    /**
     * 规则类型：1、话术提示，2、填写规范，3、评分说明
     * @type {Number}
     */
    this.ruleType = build.buildNumber(json&&(json.ruleType!=null)?json.ruleType:null);
    /**
     * 规则详细信息
     * @type {String}
     */
    this.ruleDesc = build.buildString(json&&(json.ruleDesc!=null)?json.ruleDesc:null);
    /**
     * 是否已读
     * @type {Boolean}
     */
    this.isRead = build.buildBoolean(json&&(json.isRead!=null)?json.isRead:null);
}
/** 上传报告草稿箱 **/
function DraftsReport(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 患者id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 检验日期（格式：yyyy-MM-dd HH:mm:ss）
     * @type {String}
     */
    this.examineDate = build.buildString(json&&(json.examineDate!=null)?json.examineDate:null);
    /**
     * 报告类型 1检验报告 ，2检查报告
     * @type {Number}
     */
    this.reportType = build.buildNumber(json&&(json.reportType!=null)?json.reportType:null);
    /**
     * 报告名称
     * @type {String}
     */
    this.reportName = build.buildString(json&&(json.reportName!=null)?json.reportName:null);
    /**
     * 报告图片多张以逗号隔开
     * @type {String}
     */
    this.reportImgs = build.buildString(json&&(json.reportImgs!=null)?json.reportImgs:null);
}
/** 选项功能Resp **/
function TOptionsInfoResp(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * t_question_info表主键
     * @type {Number}
     */
    this.questionInfoId = build.buildNumber(json&&(json.questionInfoId!=null)?json.questionInfoId:null);
    /**
     * 题目序号
     * @type {Number}
     */
    this.optionsSerialNumber = build.buildNumber(json&&(json.optionsSerialNumber!=null)?json.optionsSerialNumber:null);
    /**
     * ** (前端已定义布尔值)是否能选 1-不，2-可以
     * @type {Boolean}
     */
    this.disabled = build.buildBoolean(json&&(json.disabled!=null)?json.disabled:null);
    /**
     * ** (前端已定义布尔值)是否允许填空 1-不，2-可以
     * @type {Boolean}
     */
    this.allowFill = build.buildBoolean(json&&(json.allowFill!=null)?json.allowFill:null);
    /**
     * ** (前端已定义布尔值)是否选中 1-不，2-可以
     * @type {Boolean}
     */
    this.selected = build.buildBoolean(json&&(json.selected!=null)?json.selected:null);
    /**
     * ** 选项所关联的显示id的列表
     * @type {String}
     */
    this.optionDisplayQuestionId = build.buildString(json&&(json.optionDisplayQuestionId!=null)?json.optionDisplayQuestionId:null);
    /**
     * 选项所跳转的问题id
     * @type {Number}
     */
    this.optionJumpQuestionId = build.buildNumber(json&&(json.optionJumpQuestionId!=null)?json.optionJumpQuestionId:null);
    /**
     * ** 选项的内容文本
     * @type {String}
     */
    this.optionTitle = build.buildString(json&&(json.optionTitle!=null)?json.optionTitle:null);
    /**
     * ** 1：单选 2：多选 3：下拉 4：填空 5：多项填空 6：段落说明
     * @type {Number}
     */
    this.optionType = build.buildNumber(json&&(json.optionType!=null)?json.optionType:null);
    /**
     * ** (前端已定义布尔值)是否允许上传题目 1-不，2-可
     * @type {Boolean}
     */
    this.allowUpload = build.buildBoolean(json&&(json.allowUpload!=null)?json.allowUpload:null);
    /**
     * ** 选项允许填空的时候所填入的文字
     * @type {String}
     */
    this.fillContent = build.buildString(json&&(json.fillContent!=null)?json.fillContent:null);
    /**
     *  是否排他
     * @type {Boolean}
     */
    this.isExclusive = build.buildBoolean(json&&(json.isExclusive!=null)?json.isExclusive:null);
    /**
     * ** 上传图片的地址
     * @type {String}
     */
    this.uploadImage = build.buildString(json&&(json.uploadImage!=null)?json.uploadImage:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.operatorId = build.buildNumber(json&&(json.operatorId!=null)?json.operatorId:null);
    /**
     * ** 是否开启 0-开启，1-未开启
     * @type {Number}
     */
    this.isOpen = build.buildNumber(json&&(json.isOpen!=null)?json.isOpen:null);
    /**
     * ** 是否删除 0-未删除，1-已删除
     * @type {Number}
     */
    this.isDelete = build.buildNumber(json&&(json.isDelete!=null)?json.isDelete:null);
    /**
     * 更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 排他问题Id集合
     * @type {Array.<Number>}
     */
    this.exclusiveIds = build.buildArray(json&&(json.exclusiveIds!=null)?json.exclusiveIds:null,build.buildNumber);
    /**
     * 是否显示时间
     * @type {Boolean}
     */
    this.showTime = build.buildBoolean(json&&(json.showTime!=null)?json.showTime:null);
    /**
     * 是否有选项显示内容
     * @type {Boolean}
     */
    this.isHaveOptionDisplayContent = build.buildBoolean(json&&(json.isHaveOptionDisplayContent!=null)?json.isHaveOptionDisplayContent:null);
    /**
     * 选项显示内容
     * @type {String}
     */
    this.optionDisplayContent = build.buildString(json&&(json.optionDisplayContent!=null)?json.optionDisplayContent:null);
    /**
     * 选项填写的答案
     * @type {String}
     */
    this.answerExport = build.buildString(json&&(json.answerExport!=null)?json.answerExport:null);
    /**
     * 是否有选项扩展内容
     * @type {Boolean}
     */
    this.isExtension = build.buildBoolean(json&&(json.isExtension!=null)?json.isExtension:null);
    /**
     * 选项扩展内容
     * @type {String}
     */
    this.optionExtension = build.buildString(json&&(json.optionExtension!=null)?json.optionExtension:null);
    /**
     * 是香导出(新增该列) 0-香，1-是
     * @type {Boolean}
     */
    this.isExport = build.buildBoolean(json&&(json.isExport!=null)?json.isExport:null);
    /**
     * 导出内容: 1选项，2补充框，3选项+补充框
     * @type {Number}
     */
    this.exportContent = build.buildNumber(json&&(json.exportContent!=null)?json.exportContent:null);
    /**
     * 导出的表头
     * @type {String}
     */
    this.exportHead = build.buildString(json&&(json.exportHead!=null)?json.exportHead:null);
    /**
     * 选项补充框格式预览
     * @type {String}
     */
    this.exportPreview = build.buildString(json&&(json.exportPreview!=null)?json.exportPreview:null);
    /**
     * 是否绑定条件
     * @type {Boolean}
     */
    this.isBindCondition = build.buildBoolean(json&&(json.isBindCondition!=null)?json.isBindCondition:null);
}
/** HttpResult **/
function HttpResult_StudySpotCheckInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<StudySpotCheckInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildStudySpotCheckInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 问卷统计分数 **/
function QuestionnaireScoreStatisticInfo(json=false){
    /**
     * 护士Id
     * @type {Number}
     */
    this.nurseId = build.buildNumber(json&&(json.nurseId!=null)?json.nurseId:null);
    /**
     * 患者Id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者名字
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 患者名字
     * @type {String}
     */
    this.nurseName = build.buildString(json&&(json.nurseName!=null)?json.nurseName:null);
    /**
     * 病区
     * @type {String}
     */
    this.wardName = build.buildString(json&&(json.wardName!=null)?json.wardName:null);
    /**
     * 问卷标题
     * @type {String}
     */
    this.questionnaireTitle = build.buildString(json&&(json.questionnaireTitle!=null)?json.questionnaireTitle:null);
    /**
     * 填写问卷时间
     * @type {String}
     */
    this.commitTime = build.buildString(json&&(json.commitTime!=null)?json.commitTime:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室名称
     * @type {String}
     */
    this.deptName = build.buildString(json&&(json.deptName!=null)?json.deptName:null);
    /**
     * 异常选项
     * @type {Boolean}
     */
    this.isFillException = build.buildBoolean(json&&(json.isFillException!=null)?json.isFillException:null);
    /**
     * 患者每题得分的情况
     * @type {Array.<TopicScoreInfo>}
     */
    this.topicScoreInfos = build.buildArray(json&&(json.topicScoreInfos!=null)?json.topicScoreInfos:null,build.buildTopicScoreInfo);
    /**
     * 總分
     * @type {Number}
     */
    this.allScores = build.buildNumber(json&&(json.allScores!=null)?json.allScores:null);
}
/** HttpResult **/
function HttpResult_FollowupVoteMonthInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowupVoteMonthInfo}
     */
    this.retValue = build.buildFollowupVoteMonthInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowupDeliveryQuestions(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupDeliveryQuestion>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupDeliveryQuestion);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 返回随访组内每位患者每次的随访记录详情 **/
function FollowupGroupPatientEachRecordDetail(json=false){
    /**
     * 返回随访组内每位患者每次的APP随访记录详情
     * @type {FollowupGroupPatientEachRecordAppDetail}
     */
    this.followupGroupPatientEachRecordAppDetail = build.buildFollowupGroupPatientEachRecordAppDetail(json&&(json.followupGroupPatientEachRecordAppDetail!=null)?json.followupGroupPatientEachRecordAppDetail:null);
    /**
     * 問卷和患者的信息(电话随访记录详情)
     * @type {QuestionAndPatientDiagnosisInfo}
     */
    this.questionAndPatientDiagnosisInfo = build.buildQuestionAndPatientDiagnosisInfo(json&&(json.questionAndPatientDiagnosisInfo!=null)?json.questionAndPatientDiagnosisInfo:null);
}
/** HttpResult **/
function HttpResult_BestCaseInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<BestCaseInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildBestCaseInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_QualityRules(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<QualityRule>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildQualityRule);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 患者最近一次的就診信息 **/
function ManagerPatientVisitingInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 主治医生名字
     * @type {String}
     */
    this.primaryPhysicianName = build.buildString(json&&(json.primaryPhysicianName!=null)?json.primaryPhysicianName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
}
/** 模块信息 **/
function ModuleInfo(json=false){
    /**
     * 模板Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 模板名字
     * @type {String}
     */
    this.moduleName = build.buildString(json&&(json.moduleName!=null)?json.moduleName:null);
    /**
     * 模板URL
     * @type {String}
     */
    this.moduleUrl = build.buildString(json&&(json.moduleUrl!=null)?json.moduleUrl:null);
    /**
     * 模板图标
     * @type {String}
     */
    this.iconPng = build.buildString(json&&(json.iconPng!=null)?json.iconPng:null);
    /**
     * 父Id
     * @type {Number}
     */
    this.fatherId = build.buildNumber(json&&(json.fatherId!=null)?json.fatherId:null);
    /**
     * 是否是父节点
     * @type {Number}
     */
    this.isFather = build.buildNumber(json&&(json.isFather!=null)?json.isFather:null);
    /**
     * 子模块
     * @type {Array.<ModuleInfo>}
     */
    this.modules = build.buildArray(json&&(json.modules!=null)?json.modules:null,build.buildModuleInfo);
}
/** 患者随访情况 **/
function FollowUpPatientCondition(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 随访任务表id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 随访患者表id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访状态: 9电话随访完成，10失访，11拒绝随访
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 生存状态：0生存，1死亡
     * @type {Boolean}
     */
    this.existenceState = build.buildBoolean(json&&(json.existenceState!=null)?json.existenceState:null);
    /**
     * 随访类型： 11-电话和线上，12-电话，21-线上，22-无
     * @type {Number}
     */
    this.followupType = build.buildNumber(json&&(json.followupType!=null)?json.followupType:null);
    /**
     * 死亡时间
     * @type {String}
     */
    this.deathTime = build.buildString(json&&(json.deathTime!=null)?json.deathTime:null);
    /**
     * 死亡原因
     * @type {String}
     */
    this.deathReason = build.buildString(json&&(json.deathReason!=null)?json.deathReason:null);
}
/** 坐席排名排行榜 **/
function SeatIndexRank(json=false){
    /**
     * 当前坐席排名
     * @type {Number}
     */
    this.currentSeatIndex = build.buildNumber(json&&(json.currentSeatIndex!=null)?json.currentSeatIndex:null);
    /**
     * 排名类型：1勤奋榜、2优质榜、3效率榜、4成功榜
     * @type {Number}
     */
    this.rankType = build.buildNumber(json&&(json.rankType!=null)?json.rankType:null);
    /**
     * 坐席排行榜
     * @type {Array.<SeatRank>}
     */
    this.seatRankList = build.buildArray(json&&(json.seatRankList!=null)?json.seatRankList:null,build.buildSeatRank);
}
/** 問卷和患者的信息 **/
function QuestionAndPatientDiagnosisInfo(json=false){
    /**
     * 任务详细ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 任务中心ID
     * @type {Number}
     */
    this.taskCenterId = build.buildNumber(json&&(json.taskCenterId!=null)?json.taskCenterId:null);
    /**
     * 任务状态 1已创建 2进行中 3已结束
     * @type {Number}
     */
    this.taskState = build.buildNumber(json&&(json.taskState!=null)?json.taskState:null);
    /**
     * 客服ID
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 问卷结果Id
     * @type {Number}
     */
    this.resultId = build.buildNumber(json&&(json.resultId!=null)?json.resultId:null);
    /**
     * 问卷内容
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 患者Id
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 问卷Id
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 编辑人
     * @type {String}
     */
    this.editor = build.buildString(json&&(json.editor!=null)?json.editor:null);
    /**
     * 问卷类型
     * @type {Number}
     */
    this.questionnaireKind = build.buildNumber(json&&(json.questionnaireKind!=null)?json.questionnaireKind:null);
    /**
     * 患者名字
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 患者信息
     * @type {CallPatientDetails}
     */
    this.callPatientDetails = build.buildCallPatientDetails(json&&(json.callPatientDetails!=null)?json.callPatientDetails:null);
    /**
     * 呼叫信息
     * @type {Array.<CallRecordingInfo>}
     */
    this.callRecordingInfos = build.buildArray(json&&(json.callRecordingInfos!=null)?json.callRecordingInfos:null,build.buildCallRecordingInfo);
    /**
     * 录音
     * @type {String}
     */
    this.recording = build.buildString(json&&(json.recording!=null)?json.recording:null);
    /**
     * 提交时间
     * @type {String}
     */
    this.commitTime = build.buildString(json&&(json.commitTime!=null)?json.commitTime:null);
    /**
     * APP随访转电话随访新问卷结果
     * @type {Array.<ShowPatientQuestionAnswer>}
     */
    this.showPatientQuestionAnswersResult = build.buildArray(json&&(json.showPatientQuestionAnswersResult!=null)?json.showPatientQuestionAnswersResult:null,build.buildShowPatientQuestionAnswer);
}
/** HttpResult **/
function HttpResult_CallPeriodicStatisticss(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<CallPeriodicStatistics>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildCallPeriodicStatistics);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 咨询服务信息 **/
function ConsultChatUserInfo(json=false){
    /**
     * 订单Id
     * @type {String}
     */
    this.orderId = build.buildString(json&&(json.orderId!=null)?json.orderId:null);
    /**
     * 发送方Id
     * @type {String}
     */
    this.sender = build.buildString(json&&(json.sender!=null)?json.sender:null);
    /**
     * 收方Id
     * @type {String}
     */
    this.receiver = build.buildString(json&&(json.receiver!=null)?json.receiver:null);
}
/** HttpResult **/
function HttpResult_StudyInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {StudyInfo}
     */
    this.retValue = build.buildStudyInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 患者提交问卷的题目及答案 **/
function ShowPatientQuestionAnswer(json=false){
    /**
     * 题目ID
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 题目序号
     * @type {Number}
     */
    this.qSeq = build.buildNumber(json&&(json.qSeq!=null)?json.qSeq:null);
    /**
     * 题目内容
     * @type {String}
     */
    this.questionContext = build.buildString(json&&(json.questionContext!=null)?json.questionContext:null);
    /**
     * 题目类型 1.单选  2.多选  3.文本填空 4.时间下拉框
     * @type {Number}
     */
    this.questionType = build.buildNumber(json&&(json.questionType!=null)?json.questionType:null);
    /**
     * 题目描述
     * @type {String}
     */
    this.questionDescription = build.buildString(json&&(json.questionDescription!=null)?json.questionDescription:null);
    /**
     * 题目标签
     * @type {String}
     */
    this.questionTag = build.buildString(json&&(json.questionTag!=null)?json.questionTag:null);
    /**
     * 是否显示：1.显示  2.不显示
     * @type {Boolean}
     */
    this.isShow = build.buildBoolean(json&&(json.isShow!=null)?json.isShow:null);
    /**
     * 是否必做
     * @type {Boolean}
     */
    this.isMust = build.buildBoolean(json&&(json.isMust!=null)?json.isMust:null);
    /**
     * 被绑定true    未绑定false
     * @type {Boolean}
     */
    this.isBind = build.buildBoolean(json&&(json.isBind!=null)?json.isBind:null);
    /**
     * 被绑定的选项ID
     * @type {Number}
     */
    this.boundOptionId = build.buildNumber(json&&(json.boundOptionId!=null)?json.boundOptionId:null);
    /**
     * 患者的答案字符串
     * @type {String}
     */
    this.answerString = build.buildString(json&&(json.answerString!=null)?json.answerString:null);
}
/** 最后的药物统计结果 **/
function FinalMedicineStatisticsResults(json=false){
    /**
     * 统计结果
     * @type {Array.<QuestionnaireMedicineStatisticInfo>}
     */
    this.questionnaireMedicineStatisticInfo = build.buildArray(json&&(json.questionnaireMedicineStatisticInfo!=null)?json.questionnaireMedicineStatisticInfo:null,build.buildQuestionnaireMedicineStatisticInfo);
    /**
     * 横标题
     * @type {Array.<String>}
     */
    this.horizontalTitle = build.buildArray(json&&(json.horizontalTitle!=null)?json.horizontalTitle:null,build.buildString);
}
/** HttpResult **/
function HttpResult_FeedbackPatientInformations(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FeedbackPatientInformation>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFeedbackPatientInformation);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowUpPatientCondition(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowUpPatientCondition}
     */
    this.retValue = build.buildFollowUpPatientCondition(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TelephoneFollowupIncomingCallPatients(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TelephoneFollowupIncomingCallPatient>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTelephoneFollowupIncomingCallPatient);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 切换栏 **/
function SwitchBar(json=false){
    /**
     * 就诊ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 就诊流水号
     * @type {Number}
     */
    this.sourceType = build.buildNumber(json&&(json.sourceType!=null)?json.sourceType:null);
    /**
     * 就诊流水号
     * @type {String}
     */
    this.visitingNo = build.buildString(json&&(json.visitingNo!=null)?json.visitingNo:null);
    /**
     * 就诊类型 0门诊 1住院 2体检
     * @type {Number}
     */
    this.visitingType = build.buildNumber(json&&(json.visitingType!=null)?json.visitingType:null);
    /**
     * 就诊时间
     * @type {String}
     */
    this.visitingDate = build.buildString(json&&(json.visitingDate!=null)?json.visitingDate:null);
}
/** 患者提交的问题答案 **/
function QuestionAndAnswer(json=false){
    /**
     * 题目ID
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 答案字符串
     * @type {String}
     */
    this.answerString = build.buildString(json&&(json.answerString!=null)?json.answerString:null);
}
/** 抽查记录 **/
function SdrSpotCheckRemarks(json=false){
    /**
     * 随访库中质控记录id
     * @type {Number}
     */
    this.oldSpotCheckId = build.buildNumber(json&&(json.oldSpotCheckId!=null)?json.oldSpotCheckId:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 随访患者ID
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 抽查用户ID
     * @type {Number}
     */
    this.spotCheckUserId = build.buildNumber(json&&(json.spotCheckUserId!=null)?json.spotCheckUserId:null);
    /**
     * 抽查用户姓名
     * @type {String}
     */
    this.spotCheckUserName = build.buildString(json&&(json.spotCheckUserName!=null)?json.spotCheckUserName:null);
    /**
     * 抽查人来源：0-内部，1-外部，2-呼叫中心
     * @type {Number}
     */
    this.spotCheckUserType = build.buildNumber(json&&(json.spotCheckUserType!=null)?json.spotCheckUserType:null);
    /**
     * 一级质检状态
     * @type {String}
     */
    this.firstSpotCheckState = build.buildString(json&&(json.firstSpotCheckState!=null)?json.firstSpotCheckState:null);
    /**
     * 第二次抽查状态：0不合格，1合格
     * @type {Number}
     */
    this.secondSpotCheckState = build.buildNumber(json&&(json.secondSpotCheckState!=null)?json.secondSpotCheckState:null);
    /**
     * 抽查备注
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 被抽查坐席id
     * @type {Number}
     */
    this.spotCheckSeatsId = build.buildNumber(json&&(json.spotCheckSeatsId!=null)?json.spotCheckSeatsId:null);
    /**
     * 是否处理
     * @type {Boolean}
     */
    this.isHandle = build.buildBoolean(json&&(json.isHandle!=null)?json.isHandle:null);
    /**
     * 是否是优质随访
     * @type {Boolean}
     */
    this.isGood = build.buildBoolean(json&&(json.isGood!=null)?json.isGood:null);
    /**
     * 处理结果
     * @type {Number}
     */
    this.handleResult = build.buildNumber(json&&(json.handleResult!=null)?json.handleResult:null);
    /**
     * 质控动态
     * @type {Number}
     */
    this.qualityResultDynamic = build.buildNumber(json&&(json.qualityResultDynamic!=null)?json.qualityResultDynamic:null);
    /**
     * 图片地址
     * @type {String}
     */
    this.imageUrl = build.buildString(json&&(json.imageUrl!=null)?json.imageUrl:null);
    /**
     * 坐席是否处理
     * @type {Boolean}
     */
    this.isSeatDeal = build.buildBoolean(json&&(json.isSeatDeal!=null)?json.isSeatDeal:null);
    /**
     * 通话记录id
     * @type {String}
     */
    this.recordId = build.buildString(json&&(json.recordId!=null)?json.recordId:null);
    /**
     * 追踪次数
     * @type {Number}
     */
    this.trackNumber = build.buildNumber(json&&(json.trackNumber!=null)?json.trackNumber:null);
    /**
     * 质控来源
     * @type {Number}
     */
    this.qualityScore = build.buildNumber(json&&(json.qualityScore!=null)?json.qualityScore:null);
}
/** 每题的得分 **/
function TopicScoreInfo(json=false){
    /**
     * 题目标号
     * @type {String}
     */
    this.number = build.buildString(json&&(json.number!=null)?json.number:null);
    /**
     * 题目
     * @type {String}
     */
    this.topicContent = build.buildString(json&&(json.topicContent!=null)?json.topicContent:null);
    /**
     * 选项内容
     * @type {String}
     */
    this.optionContent = build.buildString(json&&(json.optionContent!=null)?json.optionContent:null);
    /**
     * 分数
     * @type {Number}
     */
    this.scores = build.buildNumber(json&&(json.scores!=null)?json.scores:null);
    /**
     * 是否为父题
     * @type {Boolean}
     */
    this.isFather = build.buildBoolean(json&&(json.isFather!=null)?json.isFather:null);
}
/** HttpResult **/
function HttpResult_FollowupTaskPatientInfo(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowupTaskPatientInfo}
     */
    this.retValue = build.buildFollowupTaskPatientInfo(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 通话录音详细 **/
function ALiYunRecordings(json=false){
    /**
     * 话务ID
     * @type {String}
     */
    this.ContactId = build.buildString(json&&(json.ContactId!=null)?json.ContactId:null);
    /**
     * 话务类型，参考枚举类型内呼, 外呼, 内部通话
     * @type {String}
     */
    this.ContactType = build.buildString(json&&(json.ContactType!=null)?json.ContactType:null);
    /**
     * 坐席ID,坐席ID等同于该座席的RAM子账户ID
     * @type {String}
     */
    this.AgentId = build.buildString(json&&(json.AgentId!=null)?json.AgentId:null);
    /**
     * 坐席名字
     * @type {String}
     */
    this.AgentName = build.buildString(json&&(json.AgentName!=null)?json.AgentName:null);
    /**
     * 主叫号码
     * @type {String}
     */
    this.CallingNumber = build.buildString(json&&(json.CallingNumber!=null)?json.CallingNumber:null);
    /**
     * 被叫号码
     * @type {String}
     */
    this.CalledNumber = build.buildString(json&&(json.CalledNumber!=null)?json.CalledNumber:null);
    /**
     * 通话开始时间
     * @type {String}
     */
    this.StartTime = build.buildString(json&&(json.StartTime!=null)?json.StartTime:null);
    /**
     * 通话时长
     * @type {String}
     */
    this.Duration = build.buildString(json&&(json.Duration!=null)?json.Duration:null);
    /**
     * 录音文件名字
     * @type {String}
     */
    this.FileName = build.buildString(json&&(json.FileName!=null)?json.FileName:null);
    /**
     * 录音文件描述
     * @type {String}
     */
    this.FileDescription = build.buildString(json&&(json.FileDescription!=null)?json.FileDescription:null);
    /**
     * 座席所在音轨标示
     * @type {String}
     */
    this.Channel = build.buildString(json&&(json.Channel!=null)?json.Channel:null);
    /**
     * 呼叫中心实例ID
     * @type {String}
     */
    this.InstanceId = build.buildString(json&&(json.InstanceId!=null)?json.InstanceId:null);
    /**
     * 智能质检文本ID
     * @type {String}
     */
    this.QualityCheckTid = build.buildString(json&&(json.QualityCheckTid!=null)?json.QualityCheckTid:null);
    /**
     * 智能质检任务ID
     * @type {String}
     */
    this.QualityCheckTaskId = build.buildString(json&&(json.QualityCheckTaskId!=null)?json.QualityCheckTaskId:null);
}
/** 随访信息 **/
function FollowupInfo(json=false){
    /**
     * 一级表头
     * @type {String}
     */
    this.header = build.buildString(json&&(json.header!=null)?json.header:null);
    /**
     * 交付表KV
     * @type {Array.<FollowupInfoKV>}
     */
    this.followupInfoKV = build.buildArray(json&&(json.followupInfoKV!=null)?json.followupInfoKV:null,build.buildFollowupInfoKV);
}
/** UnitResult **/
function UnitResult(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * schema
     * @type {UnitSchema}
     */
    this.schema = build.buildUnitSchema(json&&(json.schema!=null)?json.schema:null);
    /**
     * action_list
     * @type {Array.<UnitAction>}
     */
    this.action_list = build.buildArray(json&&(json.action_list!=null)?json.action_list:null,build.buildUnitAction);
}
/** 饼状图统计 **/
function QuestionnairePieStatistics(json=false){
    /**
     * 统计名称
     * @type {String}
     */
    this.statisticsName = build.buildString(json&&(json.statisticsName!=null)?json.statisticsName:null);
    /**
     * 每道题的平均分
     * @type {Array.<ScoreAverageStatistics>}
     */
    this.scoreAverageStatistics = build.buildArray(json&&(json.scoreAverageStatistics!=null)?json.scoreAverageStatistics:null,build.buildScoreAverageStatistics);
}
/** HttpResult **/
function HttpResult_TodayFollowUpInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TodayFollowUpInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTodayFollowUpInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TFollowUpTaskResps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TFollowUpTaskResp>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTFollowUpTaskResp);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 待完成质控信息 **/
function QualityControlToDoInfo(json=false){
    /**
     * 抽查id
     * @type {Number}
     */
    this.spotCheckId = build.buildNumber(json&&(json.spotCheckId!=null)?json.spotCheckId:null);
    /**
     * 任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访患者姓名
     * @type {String}
     */
    this.followupPatientName = build.buildString(json&&(json.followupPatientName!=null)?json.followupPatientName:null);
    /**
     * 随访患者信息id
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 疾病id
     * @type {Number}
     */
    this.diseaseId = build.buildNumber(json&&(json.diseaseId!=null)?json.diseaseId:null);
    /**
     * 质控时间
     * @type {String}
     */
    this.spotCheckTime = build.buildString(json&&(json.spotCheckTime!=null)?json.spotCheckTime:null);
    /**
     * 质控人id
     * @type {Number}
     */
    this.spotCheckUserId = build.buildNumber(json&&(json.spotCheckUserId!=null)?json.spotCheckUserId:null);
    /**
     * 质控人姓名
     * @type {String}
     */
    this.spotCheckUserName = build.buildString(json&&(json.spotCheckUserName!=null)?json.spotCheckUserName:null);
    /**
     * 是否提醒总录音时长：0-否，1-是
     * @type {Boolean}
     */
    this.isTotalDuration = build.buildBoolean(json&&(json.isTotalDuration!=null)?json.isTotalDuration:null);
    /**
     * 是否提醒单个录音时长：0-否，1-是
     * @type {Boolean}
     */
    this.isSingleDuration = build.buildBoolean(json&&(json.isSingleDuration!=null)?json.isSingleDuration:null);
    /**
     * 是否提醒坐席学习
     * @type {Boolean}
     */
    this.isRemindStudy = build.buildBoolean(json&&(json.isRemindStudy!=null)?json.isRemindStudy:null);
}
/** 反馈信息info **/
function ConfirmInformation(json=false){
    /**
     * 是否全读状态-0：未全读，1-已全读
     * @type {Number}
     */
    this.isAllRead = build.buildNumber(json&&(json.isAllRead!=null)?json.isAllRead:null);
    /**
     * 未读条数
     * @type {Number}
     */
    this.unreadCount = build.buildNumber(json&&(json.unreadCount!=null)?json.unreadCount:null);
}
/** HttpResult **/
function HttpResult_CallTaskSpotChecks(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<CallTaskSpotCheck>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildCallTaskSpotCheck);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 题目答案 **/
function CallCenterQuestionOption(json=false){
    /**
     * option
     * @type {String}
     */
    this.option = build.buildString(json&&(json.option!=null)?json.option:null);
    /**
     * score
     * @type {String}
     */
    this.score = build.buildString(json&&(json.score!=null)?json.score:null);
    /**
     * hasUUID
     * @type {Boolean}
     */
    this.hasUUID = build.buildBoolean(json&&(json.hasUUID!=null)?json.hasUUID:null);
    /**
     * anotherQuestionUUID
     * @type {String}
     */
    this.anotherQuestionUUID = build.buildString(json&&(json.anotherQuestionUUID!=null)?json.anotherQuestionUUID:null);
    /**
     * answerContent
     * @type {String}
     */
    this.answerContent = build.buildString(json&&(json.answerContent!=null)?json.answerContent:null);
    /**
     * isSelected
     * @type {Boolean}
     */
    this.isSelected = build.buildBoolean(json&&(json.isSelected!=null)?json.isSelected:null);
    /**
     * isOther
     * @type {Boolean}
     */
    this.isOther = build.buildBoolean(json&&(json.isOther!=null)?json.isOther:null);
    /**
     * contentType
     * @type {String}
     */
    this.contentType = build.buildString(json&&(json.contentType!=null)?json.contentType:null);
    /**
     * contentValue
     * @type {String}
     */
    this.contentValue = build.buildString(json&&(json.contentValue!=null)?json.contentValue:null);
}
/** HttpResult **/
function HttpResult_CallRecord(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {CallRecord}
     */
    this.retValue = build.buildCallRecord(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 分答列表 **/
function ReplyHistoryList(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 答复状态 0：需要一元查看 1：已上传，2：已答复，3：已支付 ，4:未回答
     * @type {Number}
     */
    this.replyState = build.buildNumber(json&&(json.replyState!=null)?json.replyState:null);
    /**
     * 问题标题
     * @type {String}
     */
    this.problemTitle = build.buildString(json&&(json.problemTitle!=null)?json.problemTitle:null);
    /**
     * 用户名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 患者最近一次就诊所在医院名
     * @type {String}
     */
    this.userHospitalName = build.buildString(json&&(json.userHospitalName!=null)?json.userHospitalName:null);
    /**
     * 患者最近一次就诊所在科室名
     * @type {String}
     */
    this.userDepartmentName = build.buildString(json&&(json.userDepartmentName!=null)?json.userDepartmentName:null);
    /**
     * 患者最近一次就诊所在病区名
     * @type {String}
     */
    this.userWardName = build.buildString(json&&(json.userWardName!=null)?json.userWardName:null);
    /**
     * 医院名
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室名
     * @type {String}
     */
    this.departmentName = build.buildString(json&&(json.departmentName!=null)?json.departmentName:null);
    /**
     * 医生姓名
     * @type {String}
     */
    this.doctorName = build.buildString(json&&(json.doctorName!=null)?json.doctorName:null);
    /**
     * 医生职称
     * @type {String}
     */
    this.doctorTitle = build.buildString(json&&(json.doctorTitle!=null)?json.doctorTitle:null);
    /**
     * 阅读量
     * @type {Number}
     */
    this.readingQuantity = build.buildNumber(json&&(json.readingQuantity!=null)?json.readingQuantity:null);
}
/** 完成和待办信息 **/
function FinishAndTodoInfo(json=false){
    /**
     * 历史完成人数
     * @type {Number}
     */
    this.historyFinishTotalCount = build.buildNumber(json&&(json.historyFinishTotalCount!=null)?json.historyFinishTotalCount:null);
    /**
     * 历史呼叫总时长
     * @type {String}
     */
    this.historyCallTimeTotalCount = build.buildString(json&&(json.historyCallTimeTotalCount!=null)?json.historyCallTimeTotalCount:null);
    /**
     * 待重拨总数
     * @type {Number}
     */
    this.todoRedialTotalCount = build.buildNumber(json&&(json.todoRedialTotalCount!=null)?json.todoRedialTotalCount:null);
    /**
     * 今日待重拨总数
     * @type {Number}
     */
    this.todayRedialTotalCount = build.buildNumber(json&&(json.todayRedialTotalCount!=null)?json.todayRedialTotalCount:null);
    /**
     * 待修改总数
     * @type {Number}
     */
    this.todoChangeTotalCount = build.buildNumber(json&&(json.todoChangeTotalCount!=null)?json.todoChangeTotalCount:null);
    /**
     * 今日待修改总数
     * @type {Number}
     */
    this.todayChangeTotalCount = build.buildNumber(json&&(json.todayChangeTotalCount!=null)?json.todayChangeTotalCount:null);
    /**
     * 待完成指标
     * @type {Number}
     */
    this.todoCompleteQuotaTotalCount = build.buildNumber(json&&(json.todoCompleteQuotaTotalCount!=null)?json.todoCompleteQuotaTotalCount:null);
    /**
     * 待投票
     * @type {Number}
     */
    this.todoVoteCount = build.buildNumber(json&&(json.todoVoteCount!=null)?json.todoVoteCount:null);
}
/** 电话随访问卷 **/
function CallFollowupQuestionnaire(json=false){
    /**
     * 问卷Id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 问卷标题
     * @type {String}
     */
    this.questionnaireTitle = build.buildString(json&&(json.questionnaireTitle!=null)?json.questionnaireTitle:null);
}
/** 阿里云呼叫中心2.0版本，contact实体 **/
function ContactInfos(json=false){
    /**
     * 呼叫类型
     * @type {String}
     */
    this.callType = build.buildString(json&&(json.callType!=null)?json.callType:null);
    /**
     * 被叫
     * @type {String}
     */
    this.callee = build.buildString(json&&(json.callee!=null)?json.callee:null);
    /**
     * 主叫
     * @type {String}
     */
    this.caller = build.buildString(json&&(json.caller!=null)?json.caller:null);
    /**
     * contactId
     * @type {String}
     */
    this.jobId = build.buildString(json&&(json.jobId!=null)?json.jobId:null);
}
/** HttpResult **/
function HttpResult_CallCenterFollowUpTaskTagNews(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<CallCenterFollowUpTaskTagNew>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildCallCenterFollowUpTaskTagNew);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_FollowUpQualityControlResultInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowUpQualityControlResultInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowUpQualityControlResultInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_SmsTemplates(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<SmsTemplate>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildSmsTemplate);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 科室信息 **/
function DepartmentInfo(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 医院ID
     * @type {Number}
     */
    this.hospitalId = build.buildNumber(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 名称
     * @type {String}
     */
    this.hdName = build.buildString(json&&(json.hdName!=null)?json.hdName:null);
}
/** 处理选项时返回的参数 **/
function ReturnDealWithOption(json=false){
    /**
     * 选项集合
     * @type {Array.<QuestionOption>}
     */
    this.questionOptions = build.buildArray(json&&(json.questionOptions!=null)?json.questionOptions:null,build.buildQuestionOption);
    /**
     * 关联字符串
     * @type {String}
     */
    this.questionnaireContentString = build.buildString(json&&(json.questionnaireContentString!=null)?json.questionnaireContentString:null);
}
/** 统计结果详情 **/
function QuestionnaireMedicineStatisticDetailInfo(json=false){
    /**
     * 提交时间
     * @type {String}
     */
    this.commitTime = build.buildString(json&&(json.commitTime!=null)?json.commitTime:null);
    /**
     * 填写人
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 问卷名称
     * @type {String}
     */
    this.questionnaireTitle = build.buildString(json&&(json.questionnaireTitle!=null)?json.questionnaireTitle:null);
    /**
     * 题号和选项
     * @type {Array.<QuestionNumbersOptions>}
     */
    this.questionNumbersOptions = build.buildArray(json&&(json.questionNumbersOptions!=null)?json.questionNumbersOptions:null,build.buildQuestionNumbersOptions);
}
/** HttpResult **/
function HttpResult_FileInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FileInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFileInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 任務統計 **/
function TaskStatisticsOfTaskId(json=false){
    /**
     * 任务中心Id
     * @type {Number}
     */
    this.taskCenterId = build.buildNumber(json&&(json.taskCenterId!=null)?json.taskCenterId:null);
    /**
     * userIds
     * @type {Array.<Number>}
     */
    this.userIds = build.buildArray(json&&(json.userIds!=null)?json.userIds:null,build.buildNumber);
    /**
     * userId的string
     * @type {String}
     */
    this.userIdSting = build.buildString(json&&(json.userIdSting!=null)?json.userIdSting:null);
    /**
     * 任务名字
     * @type {String}
     */
    this.taskName = build.buildString(json&&(json.taskName!=null)?json.taskName:null);
    /**
     * 每日呼叫人数
     * @type {Number}
     */
    this.dayPeoples = build.buildNumber(json&&(json.dayPeoples!=null)?json.dayPeoples:null);
    /**
     * 成功率
     * @type {String}
     */
    this.successfulRate = build.buildString(json&&(json.successfulRate!=null)?json.successfulRate:null);
    /**
     * 稍后拨打
     * @type {Number}
     */
    this.callLater = build.buildNumber(json&&(json.callLater!=null)?json.callLater:null);
    /**
     * 成功数
     * @type {Number}
     */
    this.successNumber = build.buildNumber(json&&(json.successNumber!=null)?json.successNumber:null);
    /**
     * 停机数
     * @type {Number}
     */
    this.downtimeNumber = build.buildNumber(json&&(json.downtimeNumber!=null)?json.downtimeNumber:null);
    /**
     * 无人接听
     * @type {Number}
     */
    this.noBodyNumber = build.buildNumber(json&&(json.noBodyNumber!=null)?json.noBodyNumber:null);
    /**
     * 挂断
     * @type {Number}
     */
    this.hangUpNumber = build.buildNumber(json&&(json.hangUpNumber!=null)?json.hangUpNumber:null);
    /**
     * 拒聊
     * @type {Number}
     */
    this.refuseNumber = build.buildNumber(json&&(json.refuseNumber!=null)?json.refuseNumber:null);
    /**
     * 错号
     * @type {Number}
     */
    this.wrongNumber = build.buildNumber(json&&(json.wrongNumber!=null)?json.wrongNumber:null);
    /**
     * 空号
     * @type {Number}
     */
    this.emptyNumber = build.buildNumber(json&&(json.emptyNumber!=null)?json.emptyNumber:null);
    /**
     * 关机
     * @type {Number}
     */
    this.shutDownNumber = build.buildNumber(json&&(json.shutDownNumber!=null)?json.shutDownNumber:null);
    /**
     * 拒接
     * @type {Number}
     */
    this.refuseAcceptNumber = build.buildNumber(json&&(json.refuseAcceptNumber!=null)?json.refuseAcceptNumber:null);
}
/** 随访任务当前详情 **/
function FollowupTaskCurrentInfo(json=false){
    /**
     * 当前随访状态状态
     * @type {Number}
     */
    this.currentFollowState = build.buildNumber(json&&(json.currentFollowState!=null)?json.currentFollowState:null);
    /**
     * 问卷ID
     * @type {Number}
     */
    this.questionnaireId = build.buildNumber(json&&(json.questionnaireId!=null)?json.questionnaireId:null);
    /**
     * 问卷标题
     * @type {String}
     */
    this.title = build.buildString(json&&(json.title!=null)?json.title:null);
    /**
     * 随访坐席ID
     * @type {Number}
     */
    this.followupSeatsId = build.buildNumber(json&&(json.followupSeatsId!=null)?json.followupSeatsId:null);
    /**
     * 问卷类型 1-线上问卷，2-电话问卷
     * @type {Number}
     */
    this.questionnaireType = build.buildNumber(json&&(json.questionnaireType!=null)?json.questionnaireType:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 手术日期
     * @type {String}
     */
    this.operationDate = build.buildString(json&&(json.operationDate!=null)?json.operationDate:null);
    /**
     * 是否新问卷：0-否，1-是
     * @type {Boolean}
     */
    this.isNewTask = build.buildBoolean(json&&(json.isNewTask!=null)?json.isNewTask:null);
    /**
     * 是否参与状态流转：0-否，1-是
     * @type {Boolean}
     */
    this.isMain = build.buildBoolean(json&&(json.isMain!=null)?json.isMain:null);
}
/** 药物统计结果 **/
function QuestionnaireMedicineStatisticInfo(json=false){
    /**
     * 问卷标题
     * @type {String}
     */
    this.questionnaireTitle = build.buildString(json&&(json.questionnaireTitle!=null)?json.questionnaireTitle:null);
    /**
     * 填写问卷时间
     * @type {String}
     */
    this.commitTime = build.buildString(json&&(json.commitTime!=null)?json.commitTime:null);
    /**
     * 填写份数
     * @type {Number}
     */
    this.copyNumber = build.buildNumber(json&&(json.copyNumber!=null)?json.copyNumber:null);
    /**
     * 填写人数
     * @type {Number}
     */
    this.peopleNumber = build.buildNumber(json&&(json.peopleNumber!=null)?json.peopleNumber:null);
    /**
     * 选项和数目聚合
     * @type {Array.<QuestionNumbersOptionsList>}
     */
    this.statisticOptionAggregation  = build.buildArray(json&&(json.statisticOptionAggregation !=null)?json.statisticOptionAggregation :null,build.buildQuestionNumbersOptionsList);
}
/** HttpResult **/
function HttpResult_TTaskAndSmsRelationshipResps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TTaskAndSmsRelationshipResp>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTTaskAndSmsRelationshipResp);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** HttpResult **/
function HttpResult_TimeSectionStatisticsInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<TimeSectionStatisticsInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildTimeSectionStatisticsInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 最后的药物统计结果详情 **/
function FinalMedicineStatisticsResultDetails(json=false){
    /**
     * 统计结果详情
     * @type {Array.<QuestionnaireMedicineStatisticDetailInfo>}
     */
    this.questionnaireMedicineStatisticDetailInfo = build.buildArray(json&&(json.questionnaireMedicineStatisticDetailInfo!=null)?json.questionnaireMedicineStatisticDetailInfo:null,build.buildQuestionnaireMedicineStatisticDetailInfo);
    /**
     * 横标题
     * @type {Array.<String>}
     */
    this.horizontalTitle = build.buildArray(json&&(json.horizontalTitle!=null)?json.horizontalTitle:null,build.buildString);
}
/** 短信模板 **/
function SmsTemplate(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 短信标题
     * @type {String}
     */
    this.smsTitle = build.buildString(json&&(json.smsTitle!=null)?json.smsTitle:null);
    /**
     * 关联疾病ID
     * @type {Number}
     */
    this.relationDiseaseId = build.buildNumber(json&&(json.relationDiseaseId!=null)?json.relationDiseaseId:null);
    /**
     * 关联疾病名称
     * @type {String}
     */
    this.relationDiseaseName = build.buildString(json&&(json.relationDiseaseName!=null)?json.relationDiseaseName:null);
    /**
     * 短信用途类型：1-线上问卷，2-电话问卷
     * @type {String}
     */
    this.smsPurposeType = build.buildString(json&&(json.smsPurposeType!=null)?json.smsPurposeType:null);
    /**
     * 短信模板内容
     * @type {String}
     */
    this.smsContent = build.buildString(json&&(json.smsContent!=null)?json.smsContent:null);
    /**
     * 短信模板CODE
     * @type {String}
     */
    this.smsCode = build.buildString(json&&(json.smsCode!=null)?json.smsCode:null);
    /**
     * 创建用户ID
     * @type {Number}
     */
    this.createManagerUserId = build.buildNumber(json&&(json.createManagerUserId!=null)?json.createManagerUserId:null);
    /**
     * 创建用户名称
     * @type {String}
     */
    this.createManagerUserName = build.buildString(json&&(json.createManagerUserName!=null)?json.createManagerUserName:null);
    /**
     * 最后更新时间
     * @type {String}
     */
    this.updateTime = build.buildString(json&&(json.updateTime!=null)?json.updateTime:null);
    /**
     * 短信类型：随访题型，体检通知，推广短信，就诊指引
     * @type {String}
     */
    this.smsTypes = build.buildString(json&&(json.smsTypes!=null)?json.smsTypes:null);
    /**
     * 短信平台：1阿里云短信平台，2联麓信息短信平台
     * @type {Number}
     */
    this.smsChannel = build.buildNumber(json&&(json.smsChannel!=null)?json.smsChannel:null);
    /**
     * 短信标签
     * @type {String}
     */
    this.smsTags = build.buildString(json&&(json.smsTags!=null)?json.smsTags:null);
    /**
     * 使用次数
     * @type {Number}
     */
    this.usageCount = build.buildNumber(json&&(json.usageCount!=null)?json.usageCount:null);
    /**
     * 是否已经选中，false未选中 true已选中
     * @type {Boolean}
     */
    this.isSelect = build.buildBoolean(json&&(json.isSelect!=null)?json.isSelect:null);
    /**
     * 父id
     * @type {Number}
     */
    this.fatherId = build.buildNumber(json&&(json.fatherId!=null)?json.fatherId:null);
    /**
     * 运营商类型：1中国联通，2中国电信，3中国移动
     * @type {Number}
     */
    this.operatorType = build.buildNumber(json&&(json.operatorType!=null)?json.operatorType:null);
}
/** 随访质控-患者列表 **/
function FollowUpQualityControlResultInfo(json=false){
    /**
     * 任务id
     * @type {Number}
     */
    this.followUpTaskId = build.buildNumber(json&&(json.followUpTaskId!=null)?json.followUpTaskId:null);
    /**
     * 任务名称
     * @type {String}
     */
    this.followUpTaskName = build.buildString(json&&(json.followUpTaskName!=null)?json.followUpTaskName:null);
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 随访患者ID
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访基本信息表ID
     * @type {Number}
     */
    this.followupPatientInfoId = build.buildNumber(json&&(json.followupPatientInfoId!=null)?json.followupPatientInfoId:null);
    /**
     * 患者姓名
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.hospitalId = build.buildString(json&&(json.hospitalId!=null)?json.hospitalId:null);
    /**
     * 随访状态
     * @type {String}
     */
    this.followUpState = build.buildString(json&&(json.followUpState!=null)?json.followUpState:null);
    /**
     * 随访状态id
     * @type {Number}
     */
    this.followUpStateId = build.buildNumber(json&&(json.followUpStateId!=null)?json.followUpStateId:null);
    /**
     * 呼叫时间
     * @type {String}
     */
    this.followUpDate = build.buildString(json&&(json.followUpDate!=null)?json.followUpDate:null);
    /**
     * 被叫号码
     * @type {String}
     */
    this.calledNumber = build.buildString(json&&(json.calledNumber!=null)?json.calledNumber:null);
    /**
     * 被叫号码标签
     * @type {String}
     */
    this.calledNumberLabel = build.buildString(json&&(json.calledNumberLabel!=null)?json.calledNumberLabel:null);
    /**
     * 号码关系
     * @type {String}
     */
    this.numberRelationship = build.buildString(json&&(json.numberRelationship!=null)?json.numberRelationship:null);
    /**
     * 最后呼叫状态
     * @type {String}
     */
    this.lastCallState = build.buildString(json&&(json.lastCallState!=null)?json.lastCallState:null);
    /**
     * 最后呼叫状态id
     * @type {Number}
     */
    this.lastCallStateId = build.buildNumber(json&&(json.lastCallStateId!=null)?json.lastCallStateId:null);
    /**
     * 呼叫坐席
     * @type {String}
     */
    this.callSeat = build.buildString(json&&(json.callSeat!=null)?json.callSeat:null);
    /**
     * 呼叫坐席id
     * @type {Number}
     */
    this.callSeatId = build.buildNumber(json&&(json.callSeatId!=null)?json.callSeatId:null);
    /**
     * 质检结果ID
     * @type {Number}
     */
    this.qualityControlResultId = build.buildNumber(json&&(json.qualityControlResultId!=null)?json.qualityControlResultId:null);
    /**
     * 质检结果
     * @type {Number}
     */
    this.qualityControlResult = build.buildNumber(json&&(json.qualityControlResult!=null)?json.qualityControlResult:null);
    /**
     * 质检人ID
     * @type {Number}
     */
    this.qualityControlPersonId = build.buildNumber(json&&(json.qualityControlPersonId!=null)?json.qualityControlPersonId:null);
    /**
     * 质检人来源：0-内部，1-外部，2-呼叫中心
     * @type {Number}
     */
    this.qualityControlPersonType = build.buildNumber(json&&(json.qualityControlPersonType!=null)?json.qualityControlPersonType:null);
    /**
     * 质检人名称
     * @type {String}
     */
    this.qualityControlPersonName = build.buildString(json&&(json.qualityControlPersonName!=null)?json.qualityControlPersonName:null);
    /**
     * 是否重播完成：0重播未完成，1重播已完成
     * @type {Boolean}
     */
    this.isToReplay = build.buildBoolean(json&&(json.isToReplay!=null)?json.isToReplay:null);
    /**
     * 是否短信校验：0未校验，1已校验
     * @type {Boolean}
     */
    this.isSmsCheck = build.buildBoolean(json&&(json.isSmsCheck!=null)?json.isSmsCheck:null);
    /**
     * 随访完成时间
     * @type {String}
     */
    this.followupCompleteTime = build.buildString(json&&(json.followupCompleteTime!=null)?json.followupCompleteTime:null);
    /**
     * 质检状态(是否抽查：0待抽查，1已抽查)
     * @type {Number}
     */
    this.isSpotCheck = build.buildNumber(json&&(json.isSpotCheck!=null)?json.isSpotCheck:null);
    /**
     * 质检内容
     * @type {String}
     */
    this.spotCheck = build.buildString(json&&(json.spotCheck!=null)?json.spotCheck:null);
    /**
     * 是否前置优先级：0-未前置，1-已经前置
     * @type {Boolean}
     */
    this.level = build.buildBoolean(json&&(json.level!=null)?json.level:null);
    /**
     * 第一次抽查状态
     * @type {String}
     */
    this.firstSpotCheckState = build.buildString(json&&(json.firstSpotCheckState!=null)?json.firstSpotCheckState:null);
    /**
     * 第二次抽查状态
     * @type {Number}
     */
    this.secondSpotCheckState = build.buildNumber(json&&(json.secondSpotCheckState!=null)?json.secondSpotCheckState:null);
    /**
     * 第一次抽查最新时间
     * @type {String}
     */
    this.spotCheckTime = build.buildString(json&&(json.spotCheckTime!=null)?json.spotCheckTime:null);
    /**
     * 第一次抽查最新备注
     * @type {String}
     */
    this.spotCheckRemarks = build.buildString(json&&(json.spotCheckRemarks!=null)?json.spotCheckRemarks:null);
    /**
     * 第二次抽查备注(审核备注)
     * @type {String}
     */
    this.manageCheckRemarks = build.buildString(json&&(json.manageCheckRemarks!=null)?json.manageCheckRemarks:null);
    /**
     * 第二次抽查最新时间(审核时间)
     * @type {String}
     */
    this.manageSpotTime = build.buildString(json&&(json.manageSpotTime!=null)?json.manageSpotTime:null);
    /**
     * 问卷填写率
     * @type {String}
     */
    this.writeRatio = build.buildString(json&&(json.writeRatio!=null)?json.writeRatio:null);
    /**
     * 生存状态
     * @type {Number}
     */
    this.existenceState = build.buildNumber(json&&(json.existenceState!=null)?json.existenceState:null);
    /**
     * 详情描述
     * @type {String}
     */
    this.detailDescription = build.buildString(json&&(json.detailDescription!=null)?json.detailDescription:null);
    /**
     * 质控结果动态
     * @type {Number}
     */
    this.qualityResultDynamic = build.buildNumber(json&&(json.qualityResultDynamic!=null)?json.qualityResultDynamic:null);
    /**
     * 坐席处理时间
     * @type {String}
     */
    this.seatDealTime = build.buildString(json&&(json.seatDealTime!=null)?json.seatDealTime:null);
    /**
     * 处理结果：1重新拨打 2提醒坐席 4需修改问卷
     * @type {Number}
     */
    this.handleResult = build.buildNumber(json&&(json.handleResult!=null)?json.handleResult:null);
    /**
     * 抽查id
     * @type {Number}
     */
    this.spotCheckId = build.buildNumber(json&&(json.spotCheckId!=null)?json.spotCheckId:null);
    /**
     * 批次id
     * @type {Number}
     */
    this.batchId = build.buildNumber(json&&(json.batchId!=null)?json.batchId:null);
    /**
     * 批次名称
     * @type {String}
     */
    this.batchName = build.buildString(json&&(json.batchName!=null)?json.batchName:null);
    /**
     * 上传时间
     * @type {String}
     */
    this.uploadTime = build.buildString(json&&(json.uploadTime!=null)?json.uploadTime:null);
    /**
     * 是否发送短信
     * @type {Boolean}
     */
    this.isSendSms = build.buildBoolean(json&&(json.isSendSms!=null)?json.isSendSms:null);
    /**
     * 位置
     * @type {Number}
     */
    this.index = build.buildNumber(json&&(json.index!=null)?json.index:null);
    /**
     * 是否复核
     * @type {Number}
     */
    this.isReview = build.buildNumber(json&&(json.isReview!=null)?json.isReview:null);
    /**
     * 质控分数
     * @type {Number}
     */
    this.qualityScore = build.buildNumber(json&&(json.qualityScore!=null)?json.qualityScore:null);
}
/** 反馈患者信息列表 **/
function FeedbackPatientInformation(json=false){
    /**
     * 患者ID
     * @type {Number}
     */
    this.patientId = build.buildNumber(json&&(json.patientId!=null)?json.patientId:null);
    /**
     * 患者信息
     * @type {String}
     */
    this.patientName = build.buildString(json&&(json.patientName!=null)?json.patientName:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
}
/** 问卷结果 **/
function QuestionResultDetail(json=false){
    /**
     * 问卷Id
     * @type {Number}
     */
    this.questionId = build.buildNumber(json&&(json.questionId!=null)?json.questionId:null);
    /**
     * 问卷内容
     * @type {String}
     */
    this.content = build.buildString(json&&(json.content!=null)?json.content:null);
    /**
     * 关联Id
     * @type {Number}
     */
    this.associationId = build.buildNumber(json&&(json.associationId!=null)?json.associationId:null);
    /**
     * 编辑人
     * @type {String}
     */
    this.editor = build.buildString(json&&(json.editor!=null)?json.editor:null);
    /**
     * 是否填写了异常选项
     * @type {Boolean}
     */
    this.isFillException = build.buildBoolean(json&&(json.isFillException!=null)?json.isFillException:null);
}
/** HttpResult **/
function HttpResult_StringMaps(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<StringMap>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildStringMap);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 医生账号信息 **/
function ConsultDoctorUser(json=false){
    /**
     * id
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 用户姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 头像
     * @type {String}
     */
    this.userIcon = build.buildString(json&&(json.userIcon!=null)?json.userIcon:null);
    /**
     * 性别
     * @type {Number}
     */
    this.userSex = build.buildNumber(json&&(json.userSex!=null)?json.userSex:null);
    /**
     * 职称
     * @type {String}
     */
    this.userTitle = build.buildString(json&&(json.userTitle!=null)?json.userTitle:null);
    /**
     * 医院名称
     * @type {String}
     */
    this.hospitalName = build.buildString(json&&(json.hospitalName!=null)?json.hospitalName:null);
    /**
     * 科室
     * @type {String}
     */
    this.hospitalDepartment = build.buildString(json&&(json.hospitalDepartment!=null)?json.hospitalDepartment:null);
    /**
     * 专长
     * @type {String}
     */
    this.expertise = build.buildString(json&&(json.expertise!=null)?json.expertise:null);
    /**
     * 荣誉
     * @type {String}
     */
    this.honor = build.buildString(json&&(json.honor!=null)?json.honor:null);
    /**
     * 获赞总数
     * @type {Number}
     */
    this.fabulousCount = build.buildNumber(json&&(json.fabulousCount!=null)?json.fabulousCount:null);
    /**
     * 是否点赞 true是 false否
     * @type {Boolean}
     */
    this.isFabulous = build.buildBoolean(json&&(json.isFabulous!=null)?json.isFabulous:null);
    /**
     * 学术任职
     * @type {String}
     */
    this.academicActivities = build.buildString(json&&(json.academicActivities!=null)?json.academicActivities:null);
    /**
     * 门诊时间
     * @type {String}
     */
    this.outpatientTimeList = build.buildString(json&&(json.outpatientTimeList!=null)?json.outpatientTimeList:null);
    /**
     * 患者人数
     * @type {Number}
     */
    this.patientCount = build.buildNumber(json&&(json.patientCount!=null)?json.patientCount:null);
    /**
     * 是否开通咨询服务-- 1:不开通, 2:开通, 3: 超过限量
     * @type {Number}
     */
    this.consultation = build.buildNumber(json&&(json.consultation!=null)?json.consultation:null);
    /**
     * 服务费
     * @type {Number}
     */
    this.consultPrice = build.buildNumber(json&&(json.consultPrice!=null)?json.consultPrice:null);
    /**
     * 服务患者人数
     * @type {Number}
     */
    this.serviceCount = build.buildNumber(json&&(json.serviceCount!=null)?json.serviceCount:null);
    /**
     * 是否开启随访 0：否 1：是
     * @type {Boolean}
     */
    this.isFollowup = build.buildBoolean(json&&(json.isFollowup!=null)?json.isFollowup:null);
    /**
     * 随访状态  1：已申请 2：已接受 3：已拒绝
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 联系id
     * @type {Number}
     */
    this.contactsId = build.buildNumber(json&&(json.contactsId!=null)?json.contactsId:null);
}
/** HttpResult **/
function HttpResult_PatientPhoneNumbers(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<PatientPhoneNumber>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildPatientPhoneNumber);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 未接来电记录列表 **/
function MissedCallResult(json=false){
    /**
     * 来电ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 来电号码
     * @type {String}
     */
    this.incomingTelegramNumber = build.buildString(json&&(json.incomingTelegramNumber!=null)?json.incomingTelegramNumber:null);
    /**
     * 来电时间
     * @type {String}
     */
    this.incomingTelegramTime = build.buildString(json&&(json.incomingTelegramTime!=null)?json.incomingTelegramTime:null);
}
/** 质控时间阶段 **/
function QualityTimeStage(json=false){
    /**
     * 抽查记录id
     * @type {Number}
     */
    this.spotCheckId = build.buildNumber(json&&(json.spotCheckId!=null)?json.spotCheckId:null);
    /**
     * 操作人id
     * @type {Number}
     */
    this.userId = build.buildNumber(json&&(json.userId!=null)?json.userId:null);
    /**
     * 操作人姓名
     * @type {String}
     */
    this.userName = build.buildString(json&&(json.userName!=null)?json.userName:null);
    /**
     * 创建时间
     * @type {String}
     */
    this.createTime = build.buildString(json&&(json.createTime!=null)?json.createTime:null);
    /**
     * 失败原因
     * @type {String}
     */
    this.failReason = build.buildString(json&&(json.failReason!=null)?json.failReason:null);
    /**
     * 类型
     * @type {Number}
     */
    this.type = build.buildNumber(json&&(json.type!=null)?json.type:null);
}
/** HttpResult **/
function HttpResult_FollowupInfos(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupInfo>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupInfo);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 患者参考信息info **/
function FollowupReferenceInfo(json=false){
    /**
     * 随访任务ID
     * @type {Number}
     */
    this.followupTaskId = build.buildNumber(json&&(json.followupTaskId!=null)?json.followupTaskId:null);
    /**
     * 随访患者ID
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 参考信息key_value
     * @type {String}
     */
    this.keyValue = build.buildString(json&&(json.keyValue!=null)?json.keyValue:null);
}
/** 今日随访信息 **/
function TodayFollowUpInfo(json=false){
    /**
     * 患者姓名
     * @type {String}
     */
    this.name = build.buildString(json&&(json.name!=null)?json.name:null);
    /**
     * 患者性别(1男、2女)
     * @type {Number}
     */
    this.sex = build.buildNumber(json&&(json.sex!=null)?json.sex:null);
    /**
     * 患者年龄
     * @type {String}
     */
    this.age = build.buildString(json&&(json.age!=null)?json.age:null);
    /**
     * 住院号
     * @type {String}
     */
    this.admitNo = build.buildString(json&&(json.admitNo!=null)?json.admitNo:null);
    /**
     * 随访患者id
     * @type {Number}
     */
    this.followupPatientId = build.buildNumber(json&&(json.followupPatientId!=null)?json.followupPatientId:null);
    /**
     * 随访任务详情id
     * @type {Number}
     */
    this.followUpPatientInfoId = build.buildNumber(json&&(json.followUpPatientInfoId!=null)?json.followUpPatientInfoId:null);
    /**
     * 主诊医生
     * @type {String}
     */
    this.doctorName = build.buildString(json&&(json.doctorName!=null)?json.doctorName:null);
    /**
     * 治疗方式
     * @type {String}
     */
    this.treatmentMode = build.buildString(json&&(json.treatmentMode!=null)?json.treatmentMode:null);
    /**
     * 随访状态
     * @type {Number}
     */
    this.followupState = build.buildNumber(json&&(json.followupState!=null)?json.followupState:null);
    /**
     * 呼叫号码
     * @type {String}
     */
    this.phoneNumber = build.buildString(json&&(json.phoneNumber!=null)?json.phoneNumber:null);
    /**
     * 随访完成时间
     * @type {String}
     */
    this.followUpCompleteTime = build.buildString(json&&(json.followUpCompleteTime!=null)?json.followUpCompleteTime:null);
    /**
     * 呼叫状态
     * @type {Number}
     */
    this.callState = build.buildNumber(json&&(json.callState!=null)?json.callState:null);
    /**
     * 是否质检
     * @type {Number}
     */
    this.isSpotCheck = build.buildNumber(json&&(json.isSpotCheck!=null)?json.isSpotCheck:null);
    /**
     * 质检内容
     * @type {String}
     */
    this.spotCheck = build.buildString(json&&(json.spotCheck!=null)?json.spotCheck:null);
    /**
     * 是否录音分割
     * @type {Boolean}
     */
    this.isSplitRecording = build.buildBoolean(json&&(json.isSplitRecording!=null)?json.isSplitRecording:null);
}
/** 电话随访患者详细信息 **/
function CallPatientDetails(json=false){
    /**
     * 患者诊断信息
     * @type {Array.<PatientDiagnosisInfo>}
     */
    this.patientDiagnosisInfos = build.buildArray(json&&(json.patientDiagnosisInfos!=null)?json.patientDiagnosisInfos:null,build.buildPatientDiagnosisInfo);
    /**
     * 患者检查报告信息
     * @type {Array.<PatientInspectionReport>}
     */
    this.patientInspectionReport = build.buildArray(json&&(json.patientInspectionReport!=null)?json.patientInspectionReport:null,build.buildPatientInspectionReport);
}
/** HttpResult **/
function HttpResult_FollowupPatientTags(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {Array.<FollowupPatientTag>}
     */
    this.retValue = build.buildArray(json&&(json.retValue!=null)?json.retValue:null,build.buildFollowupPatientTag);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}
/** 相关文章信息 **/
function ArticleIdAndTitle(json=false){
    /**
     * 文章ID
     * @type {Number}
     */
    this.id = build.buildNumber(json&&(json.id!=null)?json.id:null);
    /**
     * 文章标题
     * @type {String}
     */
    this.articleTitle = build.buildString(json&&(json.articleTitle!=null)?json.articleTitle:null);
    /**
     * 文章内容
     * @type {String}
     */
    this.articleContent = build.buildString(json&&(json.articleContent!=null)?json.articleContent:null);
}
/** HttpResult **/
function HttpResult_FollowUpTaskSwitchMark(json=false){
    /**
     * status
     * @type {Number}
     */
    this.status = build.buildNumber(json&&(json.status!=null)?json.status:null);
    /**
     * desc
     * @type {String}
     */
    this.desc = build.buildString(json&&(json.desc!=null)?json.desc:null);
    /**
     * 页码
     * @type {Number}
     */
    this.page = build.buildNumber(json&&(json.page!=null)?json.page:null);
    /**
     * 总页码
     * @type {Number}
     */
    this.totalPage = build.buildNumber(json&&(json.totalPage!=null)?json.totalPage:null);
    /**
     * retValue
     * @type {FollowUpTaskSwitchMark}
     */
    this.retValue = build.buildFollowUpTaskSwitchMark(json&&(json.retValue!=null)?json.retValue:null);
    /**
     * 总数量
     * @type {Number}
     */
    this.totalCount = build.buildNumber(json&&(json.totalCount!=null)?json.totalCount:null);
}

function sendAjax(ajax) {
    if(ajax.type==="POST"){
        if(ajax.typeEx==="FORM"){
            return axios({
                url:ajax.url,
                method:ajax.type,
                data:qs.stringify(ajax.data()),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8;",
                    "jwt": storage.getStorage("jwt")
                }
            })
        }else{
            return axios({
                url:ajax.url,
                method:ajax.type,
                data:JSON.stringify(ajax.data()),
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "jwt": storage.getStorage("jwt")
                }
            })
        }
    }else{
        return axios({
            url:ajax.url,
            method:ajax.type,
            params:ajax.data(),
            headers: {
                "Content-Type": "application/json; charset=utf-8;",
                "jwt": storage.getStorage("jwt")
            }
        })
    }
}

/**
 * 查询患者标签
 * @constructor
 */
function RestNewFollowupCallCenterServiceQueryTagByPatient() {
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/newFollowupCallCenterService/queryTagByPatient";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupPatientTags}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupPatientTags(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupPatientTags(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询任务标签
 * @constructor
 */
function RestNewFollowupCallCenterServiceQueryTaskTag() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    this.url = "/newFollowupCallCenterService/queryTaskTag";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TaskTags}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TaskTags(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TaskTags(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 呼叫台添加患者标签
 * @constructor
 */
function RestNewFollowupCallCenterServiceAddPatientTag() {
    /**
     * parameter 标签id集合
     * @type {Array.<Number>}
     * @required true
     */
    this.p_tagIds = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访患者姓名
     * @type {String}
     * @required true
     */
    this.p_followupPatientName = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 住院号
     * @type {String}
     * @required true
     */
    this.p_admitNo = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/newFollowupCallCenterService/addPatientTag";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            tagIds:this.p_tagIds,
            followupPatientId:this.p_followupPatientId,
            followupPatientName:this.p_followupPatientName,
            patientId:this.p_patientId,
            taskId:this.p_taskId,
            admitNo:this.p_admitNo,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 呼叫台删除患者标签
 * @constructor
 */
function RestNewFollowupCallCenterServiceDeletePatientTag() {
    /**
     * parameter 标签id集合
     * @type {Array.<Number>}
     * @required true
     */
    this.p_tagIds = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访患者姓名
     * @type {String}
     * @required true
     */
    this.p_followupPatientName = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 住院号
     * @type {String}
     * @required true
     */
    this.p_admitNo = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/newFollowupCallCenterService/deletePatientTag";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            tagIds:this.p_tagIds,
            followupPatientId:this.p_followupPatientId,
            followupPatientName:this.p_followupPatientName,
            patientId:this.p_patientId,
            taskId:this.p_taskId,
            admitNo:this.p_admitNo,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取当前任务添加的学习文件
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFileListByTaskId() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 文件夹id
     * @type {Number}
     * @required false
     */
    this.p_folderId = null;
    /**
     * parameter 0：根据文件夹id查询，1：查询该任务下全部文件，2：查询该任务下已分配学习的文件。
     * @type {Number}
     * @required true
     */
    this.p_flag = null;
    this.url = "/newFollowupCallCenterService/getFileListByTaskId";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            folderId:this.p_folderId,
            flag:this.p_flag,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FileInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FileInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FileInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取文件夹名称
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFolderNameList() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 0：根据文件夹id查询，1：查询该任务下全部文件夹，2：查询该任务下已分配学习的文件夹。
     * @type {Number}
     * @required true
     */
    this.p_flag = null;
    this.url = "/newFollowupCallCenterService/getFolderNameList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            flag:this.p_flag,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FileInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FileInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FileInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取预览文件的url
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetPreviewFileUrl() {
    /**
     * parameter 文件id
     * @type {Number}
     * @required true
     */
    this.p_fileId = null;
    this.url = "/newFollowupCallCenterService/getPreviewFileUrl";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            fileId:this.p_fileId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 问卷录入页面的患者详情
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetPatientInfoQuestionnaire() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/newFollowupCallCenterService/getPatientInfoQuestionnaire";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 提交问卷录入记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceAddSubmitRecord() {
    /**
     * parameter 问卷录入提交记录ID
     * @type {Number}
     * @required true
     */
    this.p_submitRecordId = null;
    /**
     * parameter 随访患者详情id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientInfoId = null;
    this.url = "/newFollowupCallCenterService/addSubmitRecord";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            submitRecordId:this.p_submitRecordId,
            followupPatientInfoId:this.p_followupPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 稍后拨打提示
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetCallReminderLater() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    this.url = "/newFollowupCallCenterService/getCallReminderLater";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_LaterCallInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_LaterCallInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_LaterCallInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加或选择手机标签
 * @constructor
 */
function RestNewFollowupCallCenterServiceAddOrSelectPhoneLabel() {
    /**
     * parameter 标签ID
     * @type {Number}
     * @required false
     */
    this.p_id = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 号码id
     * @type {Number}
     * @required true
     */
    this.p_phoneId = null;
    /**
     * parameter 标签
     * @type {String}
     * @required false
     */
    this.p_label = null;
    /**
     * parameter 是否选中 false：未选中   true：选中
     * @type {Boolean}
     * @required true
     */
    this.p_isChoose = null;
    this.url = "/newFollowupCallCenterService/addOrSelectPhoneLabel";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            patientId:this.p_patientId,
            taskId:this.p_taskId,
            phoneId:this.p_phoneId,
            label:this.p_label,
            isChoose:this.p_isChoose,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取手机号标签列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetPhoneLabelList() {
    /**
     * parameter 手机号ID
     * @type {Number}
     * @required true
     */
    this.p_phoneId = null;
    this.url = "/newFollowupCallCenterService/getPhoneLabelList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            phoneId:this.p_phoneId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PhoneLabels}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PhoneLabels(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PhoneLabels(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取今日随访完成的患者详情
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo() {
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访状态
     * @type {Number}
     * @required true
     */
    this.p_followupState = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTodayCompletePatientInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            followupTaskId:this.p_followupTaskId,
            followupState:this.p_followupState,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取今日随访完成
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTodayComplete() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 患者姓名
     * @type {String}
     * @required false
     */
    this.p_patientName = null;
    /**
     * parameter 住院号
     * @type {String}
     * @required false
     */
    this.p_hospitalId = null;
    /**
     * parameter 随访状态
     * @type {Number}
     * @required false
     */
    this.p_followupState = null;
    /**
     * parameter 呼叫状态
     * @type {Number}
     * @required false
     */
    this.p_callState = null;
    /**
     * parameter 时间区间(几天内的)
     * @type {Number}
     * @required false
     */
    this.p_timeInterval = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTodayComplete";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            seatId:this.p_seatId,
            patientName:this.p_patientName,
            hospitalId:this.p_hospitalId,
            followupState:this.p_followupState,
            callState:this.p_callState,
            timeInterval:this.p_timeInterval,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TodayFollowUpInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TodayFollowUpInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TodayFollowUpInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取今日完成随访的数量
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTodayCompleteCount() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 时间区间(几天内的)
     * @type {Number}
     * @required false
     */
    this.p_timeInterval = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTodayCompleteCount";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            seatId:this.p_seatId,
            timeInterval:this.p_timeInterval,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TodayFollowUpCount}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TodayFollowUpCount(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TodayFollowUpCount(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据随访id和患者id查询随访情况
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpPatientCondition() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    this.url = "/newFollowupCallCenterService/getFollowUpPatientCondition";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            followupTaskId:this.p_followupTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpPatientCondition}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpPatientCondition(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpPatientCondition(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加通话的等待时间
 * @constructor
 */
function RestNewFollowupCallCenterServiceAddRecordWaitingTime() {
    /**
     * parameter 通话记录id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 录音id
     * @type {String}
     * @required true
     */
    this.p_contactId = null;
    /**
     * parameter 通话时间
     * @type {String}
     * @required false
     */
    this.p_talkTime = null;
    /**
     * parameter 等待时间
     * @type {String}
     * @required false
     */
    this.p_waitingTime = null;
    this.url = "/newFollowupCallCenterService/addRecordWaitingTime";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            contactId:this.p_contactId,
            talkTime:this.p_talkTime,
            waitingTime:this.p_waitingTime,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取任务下的学习模块
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetStudyListByTask() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 该任务已添加的学习
     * @type {Boolean}
     * @required true
     */
    this.p_isAdd = null;
    this.url = "/newFollowupCallCenterService/getStudyListByTask";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            isAdd:this.p_isAdd,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_StudyInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_StudyInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_StudyInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取一条学习
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetStudyById() {
    /**
     * parameter studyId
     * @type {Number}
     * @required true
     */
    this.p_studyId = null;
    this.url = "/newFollowupCallCenterService/getStudyById";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            studyId:this.p_studyId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_StudyInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_StudyInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_StudyInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 该坐席今日已随访
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetTodayFollowupCount() {
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/newFollowupCallCenterService/getTodayFollowupCount";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_long}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_long(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_long(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更改坐席随访权限
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateSeatFollowUpPermission() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/newFollowupCallCenterService/updateSeatFollowUpPermission";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询随访任务池列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskList() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required false
     */
    this.p_taskId = null;
    /**
     * parameter 任务名称
     * @type {String}
     * @required false
     */
    this.p_title = null;
    /**
     * parameter ** 任务来源类型1.医院2公司3绘医4其他
     * @type {Number}
     * @required false
     */
    this.p_taskSourceType = null;
    /**
     * parameter ** 随访疾病id
     * @type {Number}
     * @required false
     */
    this.p_diseaseId = null;
    /**
     * parameter ** 状态 1未开始 2进行中，3已暂停
     * @type {String}
     * @required true
     */
    this.p_status = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getQueryQFollowUpTaskList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            taskId:this.p_taskId,
            title:this.p_title,
            taskSourceType:this.p_taskSourceType,
            diseaseId:this.p_diseaseId,
            status:this.p_status,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TFollowUpTaskResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TFollowUpTaskResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TFollowUpTaskResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询坐席是否允许随访
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetSeatsIsAllowFollowup() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    this.url = "/newFollowupCallCenterService/getSeatsIsAllowFollowup";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            taskId:this.p_taskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_bool}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_bool(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_bool(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据坐席号查询随访任务池列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskListByUserId() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    this.url = "/newFollowupCallCenterService/getQueryQFollowUpTaskListByUserId";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TFollowUpTaskResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TFollowUpTaskResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TFollowUpTaskResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据任务状态查询随访任务池列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskListByStatus() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务名称
     * @type {String}
     * @required false
     */
    this.p_title = null;
    /**
     * parameter ** 任务来源类型1.医院2公司3绘医4其他
     * @type {Number}
     * @required false
     */
    this.p_taskSourceType = null;
    /**
     * parameter ** 随访疾病id
     * @type {Number}
     * @required false
     */
    this.p_diseaseId = null;
    /**
     * parameter ** 状态 1数据处理中 2未开始 3进行中 4已暂停 5已完成 6异常
     * @type {String}
     * @required true
     */
    this.p_status = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getQueryQFollowUpTaskListByStatus";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            title:this.p_title,
            taskSourceType:this.p_taskSourceType,
            diseaseId:this.p_diseaseId,
            status:this.p_status,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TFollowUpTaskResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TFollowUpTaskResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TFollowUpTaskResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取疾病分类 有字段的
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetDiseaseClassificationList() {
    this.url = "/newFollowupCallCenterService/getDiseaseClassificationList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
        }
    }
    /**
     * parameter result
     * @type {HttpResult_ManagerDiseaseClassifications}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_ManagerDiseaseClassifications(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_ManagerDiseaseClassifications(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取统计任务详情
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 是否从首页进入任务：默认为false，只有在首页点开始时为true
     * @type {Boolean}
     * @required true
     */
    this.p_isFrontPage = null;
    this.url = "/newFollowupCallCenterService/getSeatsFollowupTaskStatisticsInfo";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            isFrontPage:this.p_isFrontPage,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskStatisticsInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskStatisticsInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskStatisticsInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取短信发送记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetSmsSendRecord() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required false
     */
    this.p_followUpPatientId = null;
    this.url = "/newFollowupCallCenterService/getSmsSendRecord";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupTaskId:this.p_followupTaskId,
            followUpPatientId:this.p_followUpPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TFollowupSmsSendRecordResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TFollowupSmsSendRecordResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TFollowupSmsSendRecordResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required false
     */
    this.p_followupPatientId = null;
    this.url = "/newFollowupCallCenterService/getFollowupTaskPatientInfo";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取未完成随访任务患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetIncompleteFollowupTaskPatientInfo() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    this.url = "/newFollowupCallCenterService/getIncompleteFollowupTaskPatientInfo";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取该任务下该坐席所有复核池患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetReviewFollowupTaskPatientInfoList() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required true
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getReviewFollowupTaskPatientInfoList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientExceptionInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取异常随访任务患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfo() {
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    this.url = "/newFollowupCallCenterService/getAbnormalFollowupTaskPatientInfo";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            patientId:this.p_patientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取该任务下该坐席所有异常随访任务患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required true
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getAbnormalFollowupTaskPatientInfoList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientExceptionInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取稍后拨打随访任务患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfo() {
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    this.url = "/newFollowupCallCenterService/getCallLaterFollowupTaskPatientInfo";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            patientId:this.p_patientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取该任务下该坐席所有稍后拨打随访任务患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required true
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getCallLaterFollowupTaskPatientInfoList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientExceptionInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取该任务下该坐席所有稍后拨打、异常随访任务患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetAllFollowupTaskPatientInfoList() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 住院号
     * @type {String}
     * @required false
     */
    this.p_admitNo = null;
    /**
     * parameter 患者姓名
     * @type {String}
     * @required false
     */
    this.p_patientName = null;
    /**
     * parameter 随访状态 8:稍后，13异常
     * @type {Number}
     * @required false
     */
    this.p_followupStatus = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required true
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getAllFollowupTaskPatientInfoList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            admitNo:this.p_admitNo,
            patientName:this.p_patientName,
            followupStatus:this.p_followupStatus,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientExceptionInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientExceptionInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访患者备注
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowupPatientRemarks() {
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/newFollowupCallCenterService/getFollowupPatientRemarks";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更新随访患者备注
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks() {
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访患者备注信息
     * @type {String}
     * @required true
     */
    this.p_followupRemarks = null;
    this.url = "/newFollowupCallCenterService/updateFollowupPatientRemarks";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            followupRemarks:this.p_followupRemarks,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访患者联系方式
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    this.url = "/newFollowupCallCenterService/getFollowupPatientContactInformationList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            followupTaskId:this.p_followupTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PatientPhoneNumbers}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PatientPhoneNumbers(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PatientPhoneNumbers(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取获取荟茁注册状态
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetHuiZhuoRegisterState() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    this.url = "/newFollowupCallCenterService/getHuiZhuoRegisterState";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            followupTaskId:this.p_followupTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_HuiZhuoRegisterState}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_HuiZhuoRegisterState(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_HuiZhuoRegisterState(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据联系方式获取通话记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetPhoneRecordInfoListByPhoneNumber() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 手机号
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 随访任务id
     * @type {Number}
     * @required false
     */
    this.p_followUpTaskId = null;
    this.url = "/newFollowupCallCenterService/getPhoneRecordInfoListByPhoneNumber";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            phoneNumber:this.p_phoneNumber,
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PhoneRecordInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PhoneRecordInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PhoneRecordInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加随访患者联系方式
 * @constructor
 */
function RestNewFollowupCallCenterServiceAddFollowupPatientContactInformation() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 患者手机号
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 关系名称
     * @type {String}
     * @required false
     */
    this.p_relationshipName = null;
    /**
     * parameter 联系人姓名
     * @type {String}
     * @required false
     */
    this.p_contactName = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required false
     */
    this.p_followupTaskId = null;
    /**
     * parameter 电话类型
     * @type {Boolean}
     * @required false
     */
    this.p_phoneType = null;
    /**
     * parameter 联系人等级id
     * @type {Number}
     * @required false
     */
    this.p_relationshipLevelId = null;
    /**
     * parameter 联系人等级
     * @type {Number}
     * @required false
     */
    this.p_relationshipLevel = null;
    /**
     * parameter 配合分数
     * @type {Number}
     * @required false
     */
    this.p_cooperateScore = null;
    this.url = "/newFollowupCallCenterService/addFollowupPatientContactInformation";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            patientId:this.p_patientId,
            phoneNumber:this.p_phoneNumber,
            relationshipName:this.p_relationshipName,
            contactName:this.p_contactName,
            followupTaskId:this.p_followupTaskId,
            phoneType:this.p_phoneType,
            relationshipLevelId:this.p_relationshipLevelId,
            relationshipLevel:this.p_relationshipLevel,
            cooperateScore:this.p_cooperateScore,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_int}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_int(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_int(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 批量添加随访患者联系方式
 * @constructor
 */
function RestNewFollowupCallCenterServiceBatchAddFollowupPatientContactInformation() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required false
     */
    this.p_followupTaskId = null;
    /**
     * parameter 联系方式集合
     * @type {Array.<ContactInformationParam>}
     * @required true
     */
    this.p_contactInformationList = null;
    this.url = "/newFollowupCallCenterService/batchAddFollowupPatientContactInformation";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            patientId:this.p_patientId,
            followupTaskId:this.p_followupTaskId,
            contactInformationList:this.p_contactInformationList,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 编辑随访患者联系方式
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 联系方式ID
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 患者手机号
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 关系名称
     * @type {String}
     * @required true
     */
    this.p_relationshipName = null;
    /**
     * parameter 最后呼叫状态
     * @type {Number}
     * @required true
     */
    this.p_lastCallState = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 呼叫日期
     * @type {String}
     * @required true
     */
    this.p_callDate = null;
    /**
     * parameter 1表示只修改联系人关系，2表示修改呼叫状态，3表示都修改了，4修改了联系人姓名
     * @type {Number}
     * @required true
     */
    this.p_updateType = null;
    /**
     * parameter 联系人姓名
     * @type {String}
     * @required false
     */
    this.p_contactName = null;
    /**
     * parameter 电话类型
     * @type {Boolean}
     * @required false
     */
    this.p_phoneType = null;
    /**
     * parameter 联系人等级id
     * @type {Number}
     * @required false
     */
    this.p_relationshipLevelId = null;
    /**
     * parameter 联系人等级
     * @type {Number}
     * @required false
     */
    this.p_relationshipLevel = null;
    /**
     * parameter 配合分数
     * @type {Number}
     * @required false
     */
    this.p_cooperateScore = null;
    /**
     * parameter 是否识别归属地
     * @type {Boolean}
     * @required false
     */
    this.p_isIdentifyBelongAddress = null;
    /**
     * parameter 联系状态
     * @type {Number}
     * @required false
     */
    this.p_contactStatus = null;
    /**
     * parameter 联系情况
     * @type {Number}
     * @required false
     */
    this.p_contactInformation = null;
    this.url = "/newFollowupCallCenterService/updateFollowupPatientContactInformation";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            id:this.p_id,
            patientId:this.p_patientId,
            phoneNumber:this.p_phoneNumber,
            relationshipName:this.p_relationshipName,
            lastCallState:this.p_lastCallState,
            taskId:this.p_taskId,
            callDate:this.p_callDate,
            updateType:this.p_updateType,
            contactName:this.p_contactName,
            phoneType:this.p_phoneType,
            relationshipLevelId:this.p_relationshipLevelId,
            relationshipLevel:this.p_relationshipLevel,
            cooperateScore:this.p_cooperateScore,
            isIdentifyBelongAddress:this.p_isIdentifyBelongAddress,
            contactStatus:this.p_contactStatus,
            contactInformation:this.p_contactInformation,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 发送随访短信
 * @constructor
 */
function RestNewFollowupCallCenterServiceSendingFollowupSms() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 短信模板
     * @type {String}
     * @required true
     */
    this.p_smsCode = null;
    /**
     * parameter 患者手机号列表
     * @type {Array.<PatientPhoneNumber>}
     * @required true
     */
    this.p_phoneNumberList = null;
    this.url = "/newFollowupCallCenterService/sendingFollowupSms";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupPatientId:this.p_followupPatientId,
            followUpTaskId:this.p_followUpTaskId,
            smsCode:this.p_smsCode,
            phoneNumberList:this.p_phoneNumberList,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 发送随访短信2
 * @constructor
 */
function RestNewFollowupCallCenterServiceSendingFollowupSmsTask() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 短信模板code
     * @type {String}
     * @required true
     */
    this.p_smsCode = null;
    /**
     * parameter 患者手机号列表
     * @type {Array.<PatientPhoneNumber>}
     * @required true
     */
    this.p_phoneNumberList = null;
    this.url = "/newFollowupCallCenterService/sendingFollowupSmsTask";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupPatientId:this.p_followupPatientId,
            followUpTaskId:this.p_followUpTaskId,
            smsCode:this.p_smsCode,
            phoneNumberList:this.p_phoneNumberList,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据短信code查询短信模板
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetSmsTemplateByCode() {
    /**
     * parameter 短信code
     * @type {String}
     * @required true
     */
    this.p_smsCode = null;
    this.url = "/newFollowupCallCenterService/getSmsTemplateByCode";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            smsCode:this.p_smsCode,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SmsTemplate}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SmsTemplate(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SmsTemplate(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取子短信模板列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetSonSmsTemplateList() {
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_fatherId = null;
    this.url = "/newFollowupCallCenterService/getSonSmsTemplateList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            fatherId:this.p_fatherId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SmsTemplates}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SmsTemplates(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SmsTemplates(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 第一次保存呼叫记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceFirstUpdatePhoneNumberCallState() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 联系方式ID
     * @type {Number}
     * @required true
     */
    this.p_phoneNumberId = null;
    /**
     * parameter 2.0版本阿里云通话实体
     * @type {ContactInfos}
     * @required false
     */
    this.p_contactId = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 主叫号码
     * @type {String}
     * @required true
     */
    this.p_callingPhoneNumber = null;
    /**
     * parameter 坐席呼出平台：1阿里云，2华为云
     * @type {Number}
     * @required false
     */
    this.p_callPlatform = null;
    this.url = "/newFollowupCallCenterService/firstUpdatePhoneNumberCallState";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            patientId:this.p_patientId,
            followupPatientId:this.p_followupPatientId,
            followupTaskId:this.p_followupTaskId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            phoneNumberId:this.p_phoneNumberId,
            contactId:this.p_contactId,
            phoneNumber:this.p_phoneNumber,
            callingPhoneNumber:this.p_callingPhoneNumber,
            callPlatform:this.p_callPlatform,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_long}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_long(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_long(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 第二次保存呼叫记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdatePhoneNumberCallState() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 呼叫记录id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 联系方式ID
     * @type {Number}
     * @required true
     */
    this.p_phoneNumberId = null;
    /**
     * parameter 2.0版本阿里云通话实体
     * @type {ContactInfos}
     * @required false
     */
    this.p_contactId = null;
    /**
     * parameter 最后呼叫状态
     * @type {Number}
     * @required true
     */
    this.p_callState = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 主叫号码
     * @type {String}
     * @required false
     */
    this.p_callingPhoneNumber = null;
    /**
     * parameter 号码关系备注
     * @type {String}
     * @required false
     */
    this.p_relationshipRemarks = null;
    /**
     * parameter 有效通话时长
     * @type {String}
     * @required false
     */
    this.p_callTime = null;
    /**
     * parameter 稍后拨打时间
     * @type {String}
     * @required false
     */
    this.p_laterCallTime = null;
    /**
     * parameter 联系人姓名
     * @type {String}
     * @required false
     */
    this.p_contactName = null;
    /**
     * parameter 联系人来源
     * @type {Number}
     * @required true
     */
    this.p_followupSource = null;
    /**
     * parameter 坐席呼出平台：1阿里云，2华为云
     * @type {Number}
     * @required false
     */
    this.p_callPlatform = null;
    /**
     * parameter 联系状态
     * @type {Number}
     * @required false
     */
    this.p_contactStatus = null;
    /**
     * parameter 联系情况
     * @type {Number}
     * @required false
     */
    this.p_contactInformation = null;
    this.url = "/newFollowupCallCenterService/updatePhoneNumberCallState";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            id:this.p_id,
            userId:this.p_userId,
            patientId:this.p_patientId,
            followupPatientId:this.p_followupPatientId,
            followupTaskId:this.p_followupTaskId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            phoneNumberId:this.p_phoneNumberId,
            contactId:this.p_contactId,
            callState:this.p_callState,
            phoneNumber:this.p_phoneNumber,
            callingPhoneNumber:this.p_callingPhoneNumber,
            relationshipRemarks:this.p_relationshipRemarks,
            callTime:this.p_callTime,
            laterCallTime:this.p_laterCallTime,
            contactName:this.p_contactName,
            followupSource:this.p_followupSource,
            callPlatform:this.p_callPlatform,
            contactStatus:this.p_contactStatus,
            contactInformation:this.p_contactInformation,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更新随访任务异常呼叫或稍后拨打
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 手机号id
     * @type {Number}
     * @required false
     */
    this.p_phoneNumberId = null;
    /**
     * parameter 稍后拨打时间
     * @type {String}
     * @required false
     */
    this.p_laterCallTime = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    this.url = "/newFollowupCallCenterService/updateAbnormalCallOrCallLater";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            phoneNumberId:this.p_phoneNumberId,
            laterCallTime:this.p_laterCallTime,
            patientId:this.p_patientId,
            followupPatientId:this.p_followupPatientId,
            followupTaskId:this.p_followupTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更新随访患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateFollowupPatient() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 随访状态
     * @type {Number}
     * @required true
     */
    this.p_followupState = null;
    /**
     * parameter 随访配合度
     * @type {Number}
     * @required true
     */
    this.p_followupCooperate = null;
    /**
     * parameter 是否死亡：false生存 true死亡
     * @type {Boolean}
     * @required false
     */
    this.p_isDeath = null;
    /**
     * parameter 新生存状态：0生存，1死亡，2未知
     * @type {Number}
     * @required false
     */
    this.p_newExistenceState = null;
    /**
     * parameter 死亡时间
     * @type {String}
     * @required false
     */
    this.p_deathTime = null;
    /**
     * parameter 死亡原因
     * @type {String}
     * @required false
     */
    this.p_deathReason = null;
    /**
     * parameter 随访来源:1第一次随访完成，2质控，3异常，4稍后拨打
     * @type {Number}
     * @required true
     */
    this.p_followupSource = null;
    /**
     * parameter 随访方式：1无特殊要求，2仅电话随访
     * @type {Number}
     * @required false
     */
    this.p_followupMode = null;
    /**
     * parameter 随访方式标记（呼叫中心的标记）：0-电话，1-线上，2-电话+线上
     * @type {Number}
     * @required true
     */
    this.p_followupTypeSign = null;
    /**
     * parameter 抽查记录id
     * @type {Number}
     * @required false
     */
    this.p_spotCheckId = null;
    /**
     * parameter 拒绝随访二级状态：0无状态默认，1沟通不畅，2拒绝随访
     * @type {Number}
     * @required false
     */
    this.p_refuseSecondStatus = null;
    this.url = "/newFollowupCallCenterService/updateFollowupPatient";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            followupState:this.p_followupState,
            followupCooperate:this.p_followupCooperate,
            isDeath:this.p_isDeath,
            newExistenceState:this.p_newExistenceState,
            deathTime:this.p_deathTime,
            deathReason:this.p_deathReason,
            followupSource:this.p_followupSource,
            followupMode:this.p_followupMode,
            followupTypeSign:this.p_followupTypeSign,
            spotCheckId:this.p_spotCheckId,
            refuseSecondStatus:this.p_refuseSecondStatus,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取最后随访问卷历史
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetLastFollowupQuestionnaireHistory() {
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/newFollowupCallCenterService/getLastFollowupQuestionnaireHistory";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_StringMaps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_StringMaps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_StringMaps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取疾病短信模板列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetDiseaseSmsTemplateList() {
    /**
     * parameter 疾病ID
     * @type {Number}
     * @required true
     */
    this.p_diseaseId = null;
    this.url = "/newFollowupCallCenterService/getDiseaseSmsTemplateList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            diseaseId:this.p_diseaseId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SmsTemplates}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SmsTemplates(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SmsTemplates(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访短信模板列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetSmsTemplateTaskList() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/newFollowupCallCenterService/getSmsTemplateTaskList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TTaskAndSmsRelationshipResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TTaskAndSmsRelationshipResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TTaskAndSmsRelationshipResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取住院号获取历史随访数据
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetAdmitNoAndHistoryFollowupData() {
    /**
     * parameter 住院号
     * @type {String}
     * @required true
     */
    this.p_admitNo = null;
    this.url = "/newFollowupCallCenterService/getAdmitNoAndHistoryFollowupData";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            admitNo:this.p_admitNo,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务抽查统计
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckStatistics() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTaskSpotCheckStatistics";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpTaskSpotCheckStatistics}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpTaskSpotCheckStatistics(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpTaskSpotCheckStatistics(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务抽查列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckList() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 二次抽查状态：2:-注意事项，3-需重拨，7-需转电
     * @type {Number}
     * @required false
     */
    this.p_secondSpotCheckState = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    /**
     * parameter 处理结果：1重新拨打 2提醒坐席 4需修改问卷
     * @type {Number}
     * @required false
     */
    this.p_handleResult = null;
    /**
     * parameter 住院号
     * @type {String}
     * @required false
     */
    this.p_admitNo = null;
    /**
     * parameter 患者姓名
     * @type {String}
     * @required false
     */
    this.p_patientName = null;
    /**
     * parameter 是否处理，true:已处理，false:未处理
     * @type {Boolean}
     * @required false
     */
    this.p_isHandle = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTaskSpotCheckList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            secondSpotCheckState:this.p_secondSpotCheckState,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
            handleResult:this.p_handleResult,
            admitNo:this.p_admitNo,
            patientName:this.p_patientName,
            isHandle:this.p_isHandle,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpTaskSpotCheckPatients}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpTaskSpotCheckPatients(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpTaskSpotCheckPatients(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务重播患者详情
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowupTaskReplayPatientInfo() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    this.url = "/newFollowupCallCenterService/getFollowupTaskReplayPatientInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 得到录音列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetALiRecording() {
    /**
     * parameter 获取录音Id列表（逗号隔开）
     * @type {String}
     * @required true
     */
    this.p_contactId = null;
    this.url = "/newFollowupCallCenterService/getALiRecording";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            contactId:this.p_contactId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_strings}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_strings(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_strings(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取合格的抽查记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetQualifiedSpotCheckList() {
    /**
     * parameter 用户id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务Id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 每页条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getQualifiedSpotCheckList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            taskId:this.p_taskId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_qualifiedSpotCheckInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_qualifiedSpotCheckInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_qualifiedSpotCheckInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取学习页面随访任务所有抽查记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTaskAllSpotCheck() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required false
     */
    this.p_seatId = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required false
     */
    this.p_patientId = null;
    /**
     * parameter 优质随访筛选(0显示全部随访，1只看优质随访)
     * @type {Number}
     * @required false
     */
    this.p_qualityScreen = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 每页条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTaskAllSpotCheck";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            taskId:this.p_taskId,
            seatId:this.p_seatId,
            patientId:this.p_patientId,
            qualityScreen:this.p_qualityScreen,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_StudySpotCheckInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_StudySpotCheckInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_StudySpotCheckInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据任务id获取该任务下的坐席
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetSeatsByTaskId() {
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/newFollowupCallCenterService/getSeatsByTaskId";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SeatUserInfoss}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SeatUserInfoss(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SeatUserInfoss(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据质检id当前质检的结果动态
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateQualityResultDynamicById() {
    /**
     * parameter 质检id
     * @type {Array.<Number>}
     * @required true
     */
    this.p_spotCheckId = null;
    /**
     * parameter 操作人id(质控员id，坐席id)
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 操作人来源：0管理台，1监管台，2呼叫台
     * @type {Number}
     * @required true
     */
    this.p_userType = null;
    /**
     * parameter 质检结果动态
     * @type {Number}
     * @required true
     */
    this.p_qualityResultDynamic = null;
    /**
     * parameter 随访任务详情ID
     * @type {Array.<Number>}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    this.url = "/newFollowupCallCenterService/updateQualityResultDynamicById";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            spotCheckId:this.p_spotCheckId,
            userId:this.p_userId,
            userType:this.p_userType,
            qualityResultDynamic:this.p_qualityResultDynamic,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据参数修改随访患者信息
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateFollowUpPatientInfoByParams() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required false
     */
    this.p_patientId = null;
    /**
     * parameter 是否复核
     * @type {Number}
     * @required true
     */
    this.p_isReview = null;
    /**
     * parameter 操作人id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 操作人姓名
     * @type {String}
     * @required true
     */
    this.p_userName = null;
    this.url = "/newFollowupCallCenterService/updateFollowUpPatientInfoByParams";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followupPatientId:this.p_followupPatientId,
            patientId:this.p_patientId,
            isReview:this.p_isReview,
            userId:this.p_userId,
            userName:this.p_userName,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取全部任务抽查待完成列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetAllTaskSpotCheckToDoList() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    /**
     * parameter 处理结果：1重新拨打 2提醒坐席 4需修改问卷
     * @type {Number}
     * @required false
     */
    this.p_handleResult = null;
    this.url = "/newFollowupCallCenterService/getAllTaskSpotCheckToDoList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
            handleResult:this.p_handleResult,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_QualityControlToDoInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_QualityControlToDoInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_QualityControlToDoInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取等级关系
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetLevelRelationship() {
    /**
     * parameter 关系等级
     * @type {Number}
     * @required false
     */
    this.p_level = null;
    this.url = "/newFollowupCallCenterService/getLevelRelationship";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            level:this.p_level,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_StringMaps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_StringMaps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_StringMaps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取全部等级关系
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetAllRelationshipLevel() {
    this.url = "/newFollowupCallCenterService/getAllRelationshipLevel";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
        }
    }
    /**
     * parameter result
     * @type {HttpResult_RelationshipLevels}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_RelationshipLevels(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_RelationshipLevels(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 修改录音分割点
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateRecordingSplitPoint() {
    /**
     * parameter 录音id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 录音分割点
     * @type {String}
     * @required true
     */
    this.p_recordingSplitPoint = null;
    /**
     * parameter 是否延时
     * @type {Boolean}
     * @required false
     */
    this.p_isDelay = null;
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者信息id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientInfoId = null;
    this.url = "/newFollowupCallCenterService/updateRecordingSplitPoint";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            recordingSplitPoint:this.p_recordingSplitPoint,
            isDelay:this.p_isDelay,
            nowUserId:this.p_nowUserId,
            phoneNumber:this.p_phoneNumber,
            followUpTaskId:this.p_followUpTaskId,
            followupPatientInfoId:this.p_followupPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 取消录音分割点
 * @constructor
 */
function RestNewFollowupCallCenterServiceCancellationRecordingSplitPoint() {
    /**
     * parameter 录音id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者信息id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientInfoId = null;
    this.url = "/newFollowupCallCenterService/cancellationRecordingSplitPoint";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            nowUserId:this.p_nowUserId,
            phoneNumber:this.p_phoneNumber,
            followUpTaskId:this.p_followUpTaskId,
            followupPatientInfoId:this.p_followupPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 修改随访患者无能力状态
 * @constructor
 */
function RestNewFollowupCallCenterServiceUpdateSuspectedIncapableState() {
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 无能力原因
     * @type {String}
     * @required true
     */
    this.p_incapableReason = null;
    /**
     * parameter 随访任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 用户id
     * @type {Number}
     * @required true
     */
    this.p_confirmId = null;
    /**
     * parameter 用户姓名
     * @type {String}
     * @required true
     */
    this.p_confirmName = null;
    this.url = "/newFollowupCallCenterService/updateSuspectedIncapableState";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            incapableReason:this.p_incapableReason,
            followUpTaskId:this.p_followUpTaskId,
            confirmId:this.p_confirmId,
            confirmName:this.p_confirmName,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务开关标记
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTaskSwitchMark() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTaskSwitchMark";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpTaskSwitchMark}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpTaskSwitchMark(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpTaskSwitchMark(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务复杂重拨列表
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetFollowUpTaskComplexReplayList() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/newFollowupCallCenterService/getFollowUpTaskComplexReplayList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            followUpTaskId:this.p_followUpTaskId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpTaskSpotCheckPatients}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpTaskSpotCheckPatients(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpTaskSpotCheckPatients(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取新手保护结束时间
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetNoviceProtectionEndTime() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务Id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/newFollowupCallCenterService/getNoviceProtectionEndTime";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 校验电话号码
 * @constructor
 */
function RestNewFollowupCallCenterServiceCheckPhoneNumber() {
    /**
     * parameter 电话号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    this.url = "/newFollowupCallCenterService/checkPhoneNumber";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            phoneNumber:this.p_phoneNumber,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取号码运营商
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetPhoneNumberOperator() {
    /**
     * parameter 电话号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    this.url = "/newFollowupCallCenterService/getPhoneNumberOperator";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            phoneNumber:this.p_phoneNumber,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取呼叫记录挂断方
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetCallRecordReleaseInitiator() {
    /**
     * parameter contactId
     * @type {String}
     * @required true
     */
    this.p_contactId = null;
    this.url = "/newFollowupCallCenterService/getCallRecordReleaseInitiator";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            contactId:this.p_contactId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取号码情况
 * @constructor
 */
function RestNewFollowupCallCenterServiceGetPhoneNumberStatus() {
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    this.url = "/newFollowupCallCenterService/getPhoneNumberStatus";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            phoneNumber:this.p_phoneNumber,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加号码状态异常呼叫记录
 * @constructor
 */
function RestNewFollowupCallCenterServiceAddPhoneNumberStateAbnormalCallRecord() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者详情id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 手机号码id
     * @type {Number}
     * @required true
     */
    this.p_phoneNumberId = null;
    /**
     * parameter contactId
     * @type {String}
     * @required false
     */
    this.p_contactId = null;
    /**
     * parameter 呼叫状态
     * @type {Number}
     * @required true
     */
    this.p_callState = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 主叫号码
     * @type {String}
     * @required false
     */
    this.p_callingPhoneNumber = null;
    /**
     * parameter 联系状态
     * @type {Number}
     * @required false
     */
    this.p_contactStatus = null;
    /**
     * parameter 联系情况
     * @type {Number}
     * @required false
     */
    this.p_contactInformation = null;
    this.url = "/newFollowupCallCenterService/addPhoneNumberStateAbnormalCallRecord";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            patientId:this.p_patientId,
            followupPatientId:this.p_followupPatientId,
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            phoneNumberId:this.p_phoneNumberId,
            contactId:this.p_contactId,
            callState:this.p_callState,
            phoneNumber:this.p_phoneNumber,
            callingPhoneNumber:this.p_callingPhoneNumber,
            contactStatus:this.p_contactStatus,
            contactInformation:this.p_contactInformation,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 最佳随访案例列表
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerQueryBestFollowupCaseList() {
    /**
     * parameter 推送月份
     * @type {String}
     * @required true
     */
    this.p_pullMonth = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/bestFollowupCaseCallcenterController/queryBestFollowupCaseList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            pullMonth:this.p_pullMonth,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_BestCaseInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_BestCaseInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_BestCaseInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据推送月份获取截止时间
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerQueryEndTimeInfoByPullMonth() {
    /**
     * parameter 推送月份
     * @type {String}
     * @required true
     */
    this.p_pullMonth = null;
    this.url = "/bestFollowupCaseCallcenterController/queryEndTimeInfoByPullMonth";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            pullMonth:this.p_pullMonth,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupVoteMonthInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupVoteMonthInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupVoteMonthInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据案例id获取录音
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerQueryBestRecordByCaseId() {
    /**
     * parameter 案例id
     * @type {Number}
     * @required true
     */
    this.p_caseId = null;
    this.url = "/bestFollowupCaseCallcenterController/queryBestRecordByCaseId";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            caseId:this.p_caseId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_BestRecordInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_BestRecordInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_BestRecordInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更改录音状态
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerUpdateStatus() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 案例id
     * @type {Number}
     * @required true
     */
    this.p_caseId = null;
    this.url = "/bestFollowupCaseCallcenterController/updateStatus";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            caseId:this.p_caseId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 投票机制
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerVote() {
    /**
     * parameter 案例id集合
     * @type {Array.<Number>}
     * @required true
     */
    this.p_caseIds = null;
    /**
     * parameter 投票人id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    this.url = "/bestFollowupCaseCallcenterController/vote";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            caseIds:this.p_caseIds,
            userId:this.p_userId,
            taskId:this.p_taskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 历史榜单
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerHistoricalList() {
    /**
     * parameter 推送月份
     * @type {String}
     * @required true
     */
    this.p_pullMonth = null;
    this.url = "/bestFollowupCaseCallcenterController/historicalList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            pullMonth:this.p_pullMonth,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupAwardInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupAwardInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupAwardInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 最佳随访案例消息
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerRecentNews() {
    this.url = "/bestFollowupCaseCallcenterController/recentNews";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取要投票的月份
 * @constructor
 */
function RestBestFollowupCaseCallcenterControllerQueryPullMonth() {
    this.url = "/bestFollowupCaseCallcenterController/queryPullMonth";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
        }
    }
    /**
     * parameter result
     * @type {HttpResult_strings}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_strings(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_strings(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 展示最新消息
 * @constructor
 */
function RestPCMessageCallcenterControllerGetNewestMessage() {
    this.url = "/pCMessageCallcenterController/getNewestMessage";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
        }
    }
    /**
     * parameter result
     * @type {HttpResult_MessageManageInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_MessageManageInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_MessageManageInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加或修改异常随访文件夹
 * @constructor
 */
function RestAbnormalFollowupFileControllerEditExceptionFile() {
    /**
     * parameter id
     * @type {Number}
     * @required flase
     */
    this.p_id = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 文件夹名
     * @type {String}
     * @required true
     */
    this.p_fileName = null;
    this.url = "/abnormalFollowupFileController/editExceptionFile";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            seatId:this.p_seatId,
            taskId:this.p_taskId,
            fileName:this.p_fileName,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 删除异常随访文件夹
 * @constructor
 */
function RestAbnormalFollowupFileControllerDeleteExceptionFile() {
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    this.url = "/abnormalFollowupFileController/deleteExceptionFile";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询异常随访文件夹
 * @constructor
 */
function RestAbnormalFollowupFileControllerGetExceptionFile() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required false
     */
    this.p_followupPatientId = null;
    this.url = "/abnormalFollowupFileController/getExceptionFile";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            taskId:this.p_taskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SeatFiles}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SeatFiles(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SeatFiles(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据文件夹id获取患者信息
 * @constructor
 */
function RestAbnormalFollowupFileControllerGetExceptionPatient() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 文件夹id
     * @type {Number}
     * @required true
     */
    this.p_fileId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/abnormalFollowupFileController/getExceptionPatient";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            taskId:this.p_taskId,
            fileId:this.p_fileId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SeatPatientFileRelationships}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SeatPatientFileRelationships(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SeatPatientFileRelationships(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 将患者添加到文件夹
 * @constructor
 */
function RestAbnormalFollowupFileControllerAddPatientToFile() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 文件夹id
     * @type {Number}
     * @required false
     */
    this.p_fileId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访患者详情id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientInfoId = null;
    /**
     * parameter 来源
     * @type {Number}
     * @required true
     */
    this.p_source = null;
    this.url = "/abnormalFollowupFileController/addPatientToFile";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            taskId:this.p_taskId,
            fileId:this.p_fileId,
            followupPatientId:this.p_followupPatientId,
            followupPatientInfoId:this.p_followupPatientInfoId,
            source:this.p_source,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取下一个异常患者id
 * @constructor
 */
function RestAbnormalFollowupFileControllerGetNextExceptionFollowupPatientId() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 文件夹id
     * @type {Number}
     * @required true
     */
    this.p_fileId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/abnormalFollowupFileController/getNextExceptionFollowupPatientId";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            followUpTaskId:this.p_followUpTaskId,
            fileId:this.p_fileId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_long}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_long(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_long(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取坐席的外呼号码
 * @constructor
 */
function RestCallCenterServiceGetPhoneNumber() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterService/getPhoneNumber";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 电话任务统计数
 * @constructor
 */
function RestCallCenterServiceGetCallTaskStatistics() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    this.url = "/callCenterService/getCallTaskStatistics";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            taskCenterId:this.p_taskCenterId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallTaskStatistics}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallTaskStatistics(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallTaskStatistics(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加患者手机号码
 * @constructor
 */
function RestCallCenterServiceAddPatientPhoneNumber() {
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_callTaskId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 关系ID
     * @type {Number}
     * @required true
     */
    this.p_relationshipId = null;
    this.url = "/callCenterService/addPatientPhoneNumber";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            callTaskId:this.p_callTaskId,
            patientId:this.p_patientId,
            phoneNumber:this.p_phoneNumber,
            relationshipId:this.p_relationshipId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PatientPhoneNumbers}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PatientPhoneNumbers(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PatientPhoneNumbers(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更新患者手机号码或状态
 * @constructor
 */
function RestCallCenterServiceUpdatePatientPhoneNumber() {
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_callTaskId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required false
     */
    this.p_phoneNumber = null;
    /**
     * parameter 关系ID
     * @type {Number}
     * @required false
     */
    this.p_relationshipId = null;
    /**
     * parameter 状态
     * @type {Number}
     * @required false
     */
    this.p_lastCallState = null;
    this.url = "/callCenterService/updatePatientPhoneNumber";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            callTaskId:this.p_callTaskId,
            patientId:this.p_patientId,
            phoneNumber:this.p_phoneNumber,
            relationshipId:this.p_relationshipId,
            lastCallState:this.p_lastCallState,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PatientPhoneNumbers}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PatientPhoneNumbers(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PatientPhoneNumbers(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 电话随访为患者添加备注
 * @constructor
 */
function RestCallCenterServiceAddPatientLabel() {
    /**
     * parameter 患者id
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 备注
     * @type {String}
     * @required true
     */
    this.p_labelName = null;
    this.url = "/callCenterService/addPatientLabel";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            labelName:this.p_labelName,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_int}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_int(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_int(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 电话随访获取患者备注
 * @constructor
 */
function RestCallCenterServiceGetPatientLabel() {
    /**
     * parameter 患者id
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    this.url = "/callCenterService/getPatientLabel";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取呼叫患者信息
 * @constructor
 */
function RestCallCenterServiceGetCallPatient() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    /**
     * parameter 呼叫类型：1电话随访 2电话通知 3电话回访 4APP转电话随访
     * @type {Number}
     * @required true
     */
    this.p_callType = null;
    this.url = "/callCenterService/getCallPatient";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            taskCenterId:this.p_taskCenterId,
            callType:this.p_callType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallPatient}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallPatient(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallPatient(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加本次呼叫状态(是否已失访)
 * @constructor
 */
function RestCallCenterServiceAddCallRecord() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 阿里云录音ID
     * @type {String}
     * @required false
     */
    this.p_contactId = null;
    /**
     * parameter 呼叫类型：1电话随访 2电话通知 3电话回访
     * @type {Number}
     * @required true
     */
    this.p_callType = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_callTaskId = null;
    /**
     * parameter 呼叫号码ID
     * @type {Number}
     * @required true
     */
    this.p_phoneNumberId = null;
    /**
     * parameter 呼叫状态： 1稍后拨打，2空号，3停机，4关机，5拒接，6无人接听，7挂断，8拒聊，9错号，10成功
     * @type {Number}
     * @required true
     */
    this.p_callState = null;
    /**
     * parameter 稍后呼叫时间
     * @type {String}
     * @required false
     */
    this.p_updateTime = null;
    /**
     * parameter 客服名字
     * @type {String}
     * @required true
     */
    this.p_userName = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 接听状态：1呼出，2呼入
     * @type {Number}
     * @required false
     */
    this.p_answerType = null;
    this.url = "/callCenterService/addCallRecord";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            patientId:this.p_patientId,
            contactId:this.p_contactId,
            callType:this.p_callType,
            callTaskId:this.p_callTaskId,
            phoneNumberId:this.p_phoneNumberId,
            callState:this.p_callState,
            updateTime:this.p_updateTime,
            userName:this.p_userName,
            phoneNumber:this.p_phoneNumber,
            answerType:this.p_answerType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallRecord}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallRecord(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallRecord(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 批量发送短信
 * @constructor
 */
function RestCallCenterServiceSendingBatchSms() {
    /**
     * parameter 客服ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_callTaskId = null;
    /**
     * parameter 呼叫号码
     * @type {Array.<String>}
     * @required true
     */
    this.p_phoneNumbers = null;
    this.url = "/callCenterService/sendingBatchSms";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            callTaskId:this.p_callTaskId,
            phoneNumbers:this.p_phoneNumbers,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_int}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_int(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_int(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取异常随访人
 * @constructor
 */
function RestCallCenterServiceGetAbnormalCallPatient() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    /**
     * parameter 呼叫类型：1电话随访 2电话通知 3电话回访 4APP转电话随访
     * @type {Number}
     * @required true
     */
    this.p_callType = null;
    this.url = "/callCenterService/getAbnormalCallPatient";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            taskCenterId:this.p_taskCenterId,
            callType:this.p_callType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallPatient}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallPatient(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallPatient(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 随访成功
 * @constructor
 */
function RestCallCenterServiceFollowupSuccess() {
    /**
     * parameter ID
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 阿里云录音ID
     * @type {String}
     * @required false
     */
    this.p_contactId = null;
    /**
     * parameter 呼叫类型：1电话随访 2电话通知 3电话回访 4APP转电话随访
     * @type {Number}
     * @required true
     */
    this.p_callType = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_callTaskId = null;
    /**
     * parameter 呼叫号码ID
     * @type {Number}
     * @required true
     */
    this.p_phoneNumberId = null;
    /**
     * parameter 患者姓名
     * @type {String}
     * @required true
     */
    this.p_patientName = null;
    /**
     * parameter 客服名字
     * @type {String}
     * @required true
     */
    this.p_userName = null;
    /**
     * parameter 本次随访时间
     * @type {String}
     * @required true
     */
    this.p_followupTime = null;
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_phoneNumber = null;
    /**
     * parameter 问卷类型
     * @type {Number}
     * @required false
     */
    this.p_questionnaireKind = null;
    /**
     * parameter 是否重播 0：否 1：是
     * @type {Boolean}
     * @required true
     */
    this.p_isToReplay = null;
    /**
     * parameter 问卷结果ID
     * @type {Number}
     * @required false
     */
    this.p_questionnaireResultId = null;
    /**
     * parameter 是否已填写问卷
     * @type {Boolean}
     * @required true
     */
    this.p_isFillQuestionnaires = null;
    /**
     * parameter 问卷结果
     * @type {String}
     * @required false
     */
    this.p_optionContent = null;
    /**
     * parameter 问卷结果信息
     * @type {Array.<QuestionResultDetail>}
     * @required false
     */
    this.p_questionResultDetails = null;
    /**
     * parameter APP转电话随访问题结果
     * @type {Array.<PatientSubmitFollowUpQuestionnaire>}
     * @required false
     */
    this.p_patientSubmitFollowUpQuestionnaire = null;
    /**
     * parameter 接听状态：1呼出，2呼入
     * @type {Number}
     * @required false
     */
    this.p_answerType = null;
    this.url = "/callCenterService/followupSuccess";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            userId:this.p_userId,
            patientId:this.p_patientId,
            contactId:this.p_contactId,
            callType:this.p_callType,
            callTaskId:this.p_callTaskId,
            phoneNumberId:this.p_phoneNumberId,
            patientName:this.p_patientName,
            userName:this.p_userName,
            followupTime:this.p_followupTime,
            phoneNumber:this.p_phoneNumber,
            questionnaireKind:this.p_questionnaireKind,
            isToReplay:this.p_isToReplay,
            questionnaireResultId:this.p_questionnaireResultId,
            isFillQuestionnaires:this.p_isFillQuestionnaires,
            optionContent:this.p_optionContent,
            questionResultDetails:this.p_questionResultDetails,
            patientSubmitFollowUpQuestionnaire:this.p_patientSubmitFollowUpQuestionnaire,
            answerType:this.p_answerType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_int}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_int(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_int(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取所有关系列表
 * @constructor
 */
function RestCallCenterServiceGetAllRelationship() {
    this.url = "/callCenterService/getAllRelationship";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
        }
    }
    /**
     * parameter result
     * @type {HttpResult_Relationships}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_Relationships(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_Relationships(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务主节点
 * @constructor
 */
function RestCallCenterServiceGetVisitingRootTasks() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required false
     */
    this.p_patientId = null;
    this.url = "/callCenterService/getVisitingRootTasks";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_VisitingTaskInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_VisitingTaskInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_VisitingTaskInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务
 * @constructor
 */
function RestCallCenterServiceGetVisitingTasks() {
    /**
     * parameter RootID
     * @type {Number}
     * @required false
     */
    this.p_rootId = null;
    /**
     * parameter 患者id
     * @type {Number}
     * @required false
     */
    this.p_patientId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 每页条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/callCenterService/getVisitingTasks";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            rootId:this.p_rootId,
            patientId:this.p_patientId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_VisitingTaskInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_VisitingTaskInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_VisitingTaskInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 分页获取患者就诊记录列表
 * @constructor
 */
function RestCallCenterServiceGetCallPatientVisitingRecords() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 加载条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/callCenterService/getCallPatientVisitingRecords";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallPatientVisitingRecords}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallPatientVisitingRecords(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallPatientVisitingRecords(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取周期统计数
 * @constructor
 */
function RestCallCenterServiceGetCallPeriodicStatistics() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    /**
     * parameter 起始时间
     * @type {String}
     * @required true
     */
    this.p_startTime = null;
    /**
     * parameter 结束时间
     * @type {String}
     * @required true
     */
    this.p_endTime = null;
    this.url = "/callCenterService/getCallPeriodicStatistics";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            taskCenterId:this.p_taskCenterId,
            startTime:this.p_startTime,
            endTime:this.p_endTime,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallPeriodicStatisticss}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallPeriodicStatisticss(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallPeriodicStatisticss(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 按照任务状态获取任务列表
 * @constructor
 */
function RestCallCenterServiceGetTaskCenterList() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 医院Id
     * @type {Number}
     * @required false
     */
    this.p_hospitalId = null;
    /**
     * parameter 科室Id
     * @type {Number}
     * @required false
     */
    this.p_deptId = null;
    /**
     * parameter 任务状态 2进行中 3已结束
     * @type {Number}
     * @required true
     */
    this.p_taskState = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    this.url = "/callCenterService/getTaskCenterList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            hospitalId:this.p_hospitalId,
            deptId:this.p_deptId,
            taskState:this.p_taskState,
            pageIndex:this.p_pageIndex,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallTaskCenterInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallTaskCenterInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallTaskCenterInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 分页获取患者检查记录列表
 * @constructor
 */
function RestCallCenterServiceGetCallPatientInspectionReportList() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 加载条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/callCenterService/getCallPatientInspectionReportList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallPatientInspectionReports}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallPatientInspectionReports(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallPatientInspectionReports(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取任务医院列表
 * @constructor
 */
function RestCallCenterServiceGetCallTaskHospitalNameList() {
    /**
     * parameter 任务状态 1已创建 2进行中 3已结束
     * @type {Number}
     * @required false
     */
    this.p_taskState = null;
    this.url = "/callCenterService/getCallTaskHospitalNameList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            taskState:this.p_taskState,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_ParameterLists}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_ParameterLists(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_ParameterLists(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取任务科室列表
 * @constructor
 */
function RestCallCenterServiceGetCallTaskDeptNameList() {
    /**
     * parameter 医院ID
     * @type {Number}
     * @required true
     */
    this.p_hospitalId = null;
    this.url = "/callCenterService/getCallTaskDeptNameList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            hospitalId:this.p_hospitalId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_ParameterLists}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_ParameterLists(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_ParameterLists(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取重播患者信息
 * @constructor
 */
function RestCallCenterServiceGetReplayCallPatient() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_callTaskId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    /**
     * parameter 呼叫类型：1电话随访 2电话通知 3电话回访 4APP转电话随访
     * @type {Number}
     * @required true
     */
    this.p_callType = null;
    this.url = "/callCenterService/getReplayCallPatient";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            callTaskId:this.p_callTaskId,
            taskCenterId:this.p_taskCenterId,
            callType:this.p_callType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallPatient}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallPatient(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallPatient(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者更多信息
 * @constructor
 */
function RestCallCenterServiceGetPatientMoreInformation() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    this.url = "/callCenterService/getPatientMoreInformation";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            taskId:this.p_taskId,
            taskCenterId:this.p_taskCenterId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_StringMaps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_StringMaps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_StringMaps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取用户任务抽查统计数
 * @constructor
 */
function RestCallCenterServiceGetUserTaskSpotCheckStatistics() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_uid = null;
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    this.url = "/callCenterService/getUserTaskSpotCheckStatistics";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            uid:this.p_uid,
            taskCenterId:this.p_taskCenterId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_UserTaskSpotCheckStatisticss}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_UserTaskSpotCheckStatisticss(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_UserTaskSpotCheckStatisticss(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取抽查记录
 * @constructor
 */
function RestCallCenterServiceGetUserTaskSpotCheckList() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_uid = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskCenterId = null;
    /**
     * parameter 每页条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    /**
     * parameter 当前页
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 抽查状态 1：合格 2：不合格，不需重拨 3：不合格，需重播 4：不符合抽查条件
     * @type {Number}
     * @required false
     */
    this.p_spotCheckState = null;
    this.url = "/callCenterService/getUserTaskSpotCheckList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            uid:this.p_uid,
            taskCenterId:this.p_taskCenterId,
            pageSize:this.p_pageSize,
            pageIndex:this.p_pageIndex,
            spotCheckState:this.p_spotCheckState,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallTaskSpotChecks}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallTaskSpotChecks(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallTaskSpotChecks(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取录音列表
 * @constructor
 */
function RestCallCenterServiceGetCallSoundRecording() {
    /**
     * parameter 阿里云录音ID
     * @type {String}
     * @required true
     */
    this.p_contactId = null;
    this.url = "/callCenterService/getCallSoundRecording";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            contactId:this.p_contactId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_strings}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_strings(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_strings(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取任务标签
 * @constructor
 */
function RestCallCenterPersonTagsControllerGetTags() {
    /**
     * parameter 任务ID
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    this.url = "/callCenterPersonTagsController/getTags";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallCenterFollowUpTaskTagNews}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallCenterFollowUpTaskTagNews(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallCenterFollowUpTaskTagNews(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者任务标签
 * @constructor
 */
function RestCallCenterPersonTagsControllerGetPatientTags() {
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    this.url = "/callCenterPersonTagsController/getPatientTags";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientId:this.p_followUpPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 修改患者任务标签
 * @constructor
 */
function RestCallCenterPersonTagsControllerEditPatientTags() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    /**
     * parameter jsonString
     * @type {String}
     * @required true
     */
    this.p_tags = null;
    this.url = "/callCenterPersonTagsController/editPatientTags";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientId:this.p_followUpPatientId,
            tags:this.p_tags,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加意见反馈
 * @constructor
 */
function RestFeedbackOutControllerAddFeedBack() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 意见分类：软件出错；使用意见
     * @type {String}
     * @required true
     */
    this.p_classification = null;
    /**
     * parameter 标题
     * @type {String}
     * @required true
     */
    this.p_title = null;
    /**
     * parameter 反馈内容
     * @type {String}
     * @required true
     */
    this.p_content = null;
    /**
     * parameter 反馈内容图片
     * @type {String}
     * @required false
     */
    this.p_contentImgs = null;
    /**
     * parameter 是否紧急:flase否，true是
     * @type {Boolean}
     * @required false
     */
    this.p_isExigency = null;
    this.url = "/feedbackOutController/addFeedBack";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            classification:this.p_classification,
            title:this.p_title,
            content:this.p_content,
            contentImgs:this.p_contentImgs,
            isExigency:this.p_isExigency,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 分页获取患者就诊信息
 * @constructor
 */
function RestFeedbackOutControllerGetPatientMedicalRecordList() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 当前页
     * @type {Number}
     * @required true
     */
    this.p_page = null;
    this.url = "/feedbackOutController/getPatientMedicalRecordList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            page:this.p_page,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PatientMedicalRecords}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PatientMedicalRecords(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PatientMedicalRecords(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据VisitingNo获取就诊详细信息
 * @constructor
 */
function RestFeedbackOutControllerGetVisitingNoMedicalRecordDetail() {
    /**
     * parameter 就诊流水号
     * @type {String}
     * @required true
     */
    this.p_visitingNo = null;
    this.url = "/feedbackOutController/getVisitingNoMedicalRecordDetail";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            visitingNo:this.p_visitingNo,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_MedicalRecordDetailed}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_MedicalRecordDetailed(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_MedicalRecordDetailed(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取就诊报告明细
 * @constructor
 */
function RestFeedbackOutControllerGetInspectionReportDetailed() {
    /**
     * parameter 报告Id
     * @type {Number}
     * @required true
     */
    this.p_reportId = null;
    this.url = "/feedbackOutController/getInspectionReportDetailed";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            reportId:this.p_reportId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_InspectionReportDetailed}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_InspectionReportDetailed(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_InspectionReportDetailed(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取是否全读状态-0：未全读，1-已全读
 * @constructor
 */
function RestFeedbackOutControllerGetIsAllRead() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/feedbackOutController/getIsAllRead";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_ConfirmInformation}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_ConfirmInformation(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_ConfirmInformation(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取反馈列表
 * @constructor
 */
function RestFeedbackOutControllerGetFeedbackList() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 是否已读
     * @type {Boolean}
     * @required false
     */
    this.p_isRead = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 每页条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/feedbackOutController/getFeedbackList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            isRead:this.p_isRead,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FeedbackInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FeedbackInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FeedbackInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 确认反馈消息
 * @constructor
 */
function RestFeedbackOutControllerConfirmFeedbackById() {
    /**
     * parameter 反馈消息ID
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 抽查id
     * @type {Number}
     * @required false
     */
    this.p_spotCheckId = null;
    /**
     * parameter 操作人id
     * @type {Number}
     * @required false
     */
    this.p_userId = null;
    this.url = "/feedbackOutController/confirmFeedbackById";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            spotCheckId:this.p_spotCheckId,
            userId:this.p_userId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 呼叫平台-质控主页面
 * @constructor
 */
function RestFeedbackOutControllerMainOfController() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter ip
     * @type {String}
     * @required true
     */
    this.p_ip = null;
    /**
     * parameter fig
     * @type {String}
     * @required true
     */
    this.p_fig = null;
    this.url = "/feedbackOutController/mainOfController";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            ip:this.p_ip,
            fig:this.p_fig,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_MainOfControllerInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_MainOfControllerInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_MainOfControllerInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务患者信息
 * @constructor
 */
function RestFeedbackOutControllerGetFollowupTaskPatientInfo() {
    /**
     * parameter 坐席ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required false
     */
    this.p_followupPatientId = null;
    this.url = "/feedbackOutController/getFollowupTaskPatientInfo";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 质控开始时间
 * @constructor
 */
function RestFeedbackOutControllerAddFollowupQualityTime() {
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 抽查人id
     * @type {Number}
     * @required true
     */
    this.p_spotCheckUserId = null;
    this.url = "/feedbackOutController/addFollowupQualityTime";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            followUpTaskId:this.p_followUpTaskId,
            spotCheckUserId:this.p_spotCheckUserId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_long}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_long(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_long(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 质控结束时间
 * @constructor
 */
function RestFeedbackOutControllerUpdateFollowupQualityTime() {
    /**
     * parameter 质控记录的id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    this.url = "/feedbackOutController/updateFollowupQualityTime";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 得到录音列表
 * @constructor
 */
function RestFeedbackOutControllerGetALiRecording() {
    /**
     * parameter 获取录音Id列表（逗号隔开）
     * @type {String}
     * @required true
     */
    this.p_contactId = null;
    this.url = "/feedbackOutController/getALiRecording";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            contactId:this.p_contactId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_strings}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_strings(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_strings(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者随访任务当前状态
 * @constructor
 */
function RestFeedbackOutControllerGetFollowupTaskCurrentState() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访任务患者详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskPatientInfoId = null;
    /**
     * parameter 随访任务患者ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    this.url = "/feedbackOutController/getFollowupTaskCurrentState";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followUpTaskPatientInfoId:this.p_followUpTaskPatientInfoId,
            followUpPatientId:this.p_followUpPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskCurrentInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskCurrentInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskCurrentInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 只查询题目和答案
 * @constructor
 */
function RestFeedbackOutControllerQueryOnlyQuestionAndAnswer() {
    /**
     * parameter t_questionnaire_new表id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/feedbackOutController/queryOnlyQuestionAndAnswer";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireNewId:this.p_questionnaireNewId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TQuestionInfoResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TQuestionInfoResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TQuestionInfoResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务患者呼叫记录列表
 * @constructor
 */
function RestFeedbackOutControllerGetFollowUpTaskPatientCallRecordList() {
    /**
     * parameter 随访任务患者详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    this.url = "/feedbackOutController/getFollowUpTaskPatientCallRecordList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpPatientInfoId:this.p_followUpPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpTaskPatientCallRecords}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpTaskPatientCallRecords(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpTaskPatientCallRecords(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加随访抽查记录
 * @constructor
 */
function RestFeedbackOutControllerAddFollowupSpotCheckRemarks() {
    /**
     * parameter 抽查用户ID
     * @type {Number}
     * @required true
     */
    this.p_spotCheckUserId = null;
    /**
     * parameter 抽查人来源：0-内部，1-外部，2-呼叫中心
     * @type {Number}
     * @required true
     */
    this.p_spotCheckUserType = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务患者详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskPatientInfoId = null;
    /**
     * parameter 抽查坐席ID
     * @type {Number}
     * @required true
     */
    this.p_spotCheckSeatsId = null;
    /**
     * parameter 抽查状态ID集合，（逗号隔开，首尾也要逗号隔开）
     * @type {String}
     * @required true
     */
    this.p_firstSpotCheckState = null;
    /**
     * parameter 第二次抽查状态
     * @type {Number}
     * @required true
     */
    this.p_secondSpotCheckState = null;
    /**
     * parameter 抽查备注
     * @type {String}
     * @required false
     */
    this.p_spotCheckRemarks = null;
    /**
     * parameter 指定坐席ID
     * @type {Number}
     * @required false
     */
    this.p_appointSeatsId = null;
    /**
     * parameter 关联呼叫记录ID集合，（逗号隔开，首尾不要加逗号）
     * @type {String}
     * @required false
     */
    this.p_recordId = null;
    /**
     * parameter 抽查人姓名
     * @type {String}
     * @required true
     */
    this.p_spotCheckUserName = null;
    /**
     * parameter 随访患者姓名
     * @type {String}
     * @required true
     */
    this.p_followupPatientName = null;
    /**
     * parameter 住院号
     * @type {String}
     * @required true
     */
    this.p_admitNo = null;
    /**
     * parameter 抽查号码
     * @type {String}
     * @required false
     */
    this.p_phone = null;
    /**
     * parameter 是否优质随访
     * @type {Boolean}
     * @required false
     */
    this.p_isGood = null;
    /**
     * parameter 结果标记
     * @type {Number}
     * @required true
     */
    this.p_handleResult = null;
    /**
     * parameter 质检图片集合
     * @type {Array.<String>}
     * @required false
     */
    this.p_imageUrl = null;
    /**
     * parameter 质控分数
     * @type {Number}
     * @required false
     */
    this.p_qualityScore = null;
    this.url = "/feedbackOutController/addFollowupSpotCheckRemarks";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            spotCheckUserId:this.p_spotCheckUserId,
            spotCheckUserType:this.p_spotCheckUserType,
            followUpTaskId:this.p_followUpTaskId,
            followupPatientId:this.p_followupPatientId,
            followUpTaskPatientInfoId:this.p_followUpTaskPatientInfoId,
            spotCheckSeatsId:this.p_spotCheckSeatsId,
            firstSpotCheckState:this.p_firstSpotCheckState,
            secondSpotCheckState:this.p_secondSpotCheckState,
            spotCheckRemarks:this.p_spotCheckRemarks,
            appointSeatsId:this.p_appointSeatsId,
            recordId:this.p_recordId,
            spotCheckUserName:this.p_spotCheckUserName,
            followupPatientName:this.p_followupPatientName,
            admitNo:this.p_admitNo,
            phone:this.p_phone,
            isGood:this.p_isGood,
            handleResult:this.p_handleResult,
            imageUrl:this.p_imageUrl,
            qualityScore:this.p_qualityScore,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更新抽查记录
 * @constructor
 */
function RestFeedbackOutControllerUpdateFollowupSpotCheck() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 随访患者信息id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientInfoId = null;
    /**
     * parameter 一级抽查状态，逗号隔开，首尾也要加逗号
     * @type {String}
     * @required true
     */
    this.p_firstSpotCheckState = null;
    /**
     * parameter 备注
     * @type {String}
     * @required false
     */
    this.p_spotCheckRemarks = null;
    /**
     * parameter 第二次抽查状态
     * @type {Number}
     * @required true
     */
    this.p_secondSpotCheckState = null;
    /**
     * parameter 是否优质随访
     * @type {Boolean}
     * @required false
     */
    this.p_isGood = null;
    /**
     * parameter 结果标记
     * @type {Number}
     * @required true
     */
    this.p_handleResult = null;
    /**
     * parameter 质检图片集合
     * @type {Array.<String>}
     * @required false
     */
    this.p_imageUrl = null;
    /**
     * parameter 质控分数
     * @type {Number}
     * @required false
     */
    this.p_qualityScore = null;
    this.url = "/feedbackOutController/updateFollowupSpotCheck";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            id:this.p_id,
            followupPatientInfoId:this.p_followupPatientInfoId,
            firstSpotCheckState:this.p_firstSpotCheckState,
            spotCheckRemarks:this.p_spotCheckRemarks,
            secondSpotCheckState:this.p_secondSpotCheckState,
            isGood:this.p_isGood,
            handleResult:this.p_handleResult,
            imageUrl:this.p_imageUrl,
            qualityScore:this.p_qualityScore,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访抽查记录
 * @constructor
 */
function RestFeedbackOutControllerGetFollowupSpotCheckRemarksList() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访任务患者详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskPatientInfoId = null;
    this.url = "/feedbackOutController/getFollowupSpotCheckRemarksList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followUpTaskPatientInfoId:this.p_followUpTaskPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupSpotCheckRemarkss}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupSpotCheckRemarkss(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupSpotCheckRemarkss(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取质控时间阶段
 * @constructor
 */
function RestFeedbackOutControllerGetQualityTimeStage() {
    /**
     * parameter 抽查记录id
     * @type {Array.<Number>}
     * @required false
     */
    this.p_spotCheckId = null;
    /**
     * parameter 操作人id
     * @type {Array.<Number>}
     * @required false
     */
    this.p_userId = null;
    /**
     * parameter 类型
     * @type {Array.<Number>}
     * @required false
     */
    this.p_type = null;
    this.url = "/feedbackOutController/getQualityTimeStage";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            spotCheckId:this.p_spotCheckId,
            userId:this.p_userId,
            type:this.p_type,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_QualityTimeStages}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_QualityTimeStages(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_QualityTimeStages(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取可抽查的用户列表
 * @constructor
 */
function RestFeedbackOutControllerGetAbleSpotCheckUserList() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 当前坐席id
     * @type {Number}
     * @required true
     */
    this.p_nowSeatId = null;
    /**
     * parameter 患者姓名/住院号
     * @type {String}
     * @required false
     */
    this.p_nameOrHospitalization = null;
    /**
     * parameter 呼叫坐席ID集合
     * @type {Array.<Number>}
     * @required false
     */
    this.p_callSeatId = null;
    /**
     * parameter 随访状态ID集合
     * @type {Array.<Number>}
     * @required false
     */
    this.p_followUpStateId = null;
    /**
     * parameter 质检状态(是否抽查：0待抽查，1已抽查)
     * @type {Boolean}
     * @required false
     */
    this.p_isSpotCheck = null;
    /**
     * parameter 完成日期
     * @type {String}
     * @required false
     */
    this.p_finishData = null;
    /**
     * parameter 质控结果动态
     * @type {Number}
     * @required false
     */
    this.p_qualityResultDynamic = null;
    /**
     * parameter 是否展示我的质控
     * @type {Boolean}
     * @required false
     */
    this.p_isShowOwnQuality = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/feedbackOutController/getAbleSpotCheckUserList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            nowSeatId:this.p_nowSeatId,
            nameOrHospitalization:this.p_nameOrHospitalization,
            callSeatId:this.p_callSeatId,
            followUpStateId:this.p_followUpStateId,
            isSpotCheck:this.p_isSpotCheck,
            finishData:this.p_finishData,
            qualityResultDynamic:this.p_qualityResultDynamic,
            isShowOwnQuality:this.p_isShowOwnQuality,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpQualityControlResultInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpQualityControlResultInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpQualityControlResultInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取今日质控人数
 * @constructor
 */
function RestFeedbackOutControllerGetTodayQualityCount() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 当前坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/feedbackOutController/getTodayQualityCount";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_Integer}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_Integer(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_Integer(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询任务坐席列表
 * @constructor
 */
function RestFeedbackOutControllerQueryFollowUpPeopleTaskList() {
    /**
     * parameter 当前坐席id
     * @type {Number}
     * @required true
     */
    this.p_nowSeatId = null;
    /**
     * parameter 坐席表id
     * @type {Number}
     * @required false
     */
    this.p_callCenterUserId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required false
     */
    this.p_followUpTaskId = null;
    /**
     * parameter ** 是否开启 0-开启，1-关闭
     * @type {Number}
     * @required false
     */
    this.p_isOpen = null;
    this.url = "/feedbackOutController/queryFollowUpPeopleTaskList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowSeatId:this.p_nowSeatId,
            callCenterUserId:this.p_callCenterUserId,
            followUpTaskId:this.p_followUpTaskId,
            isOpen:this.p_isOpen,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TFollowUpPeopleTaskResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TFollowUpPeopleTaskResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TFollowUpPeopleTaskResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取重播不合格任务启用坐席列表
 * @constructor
 */
function RestFeedbackOutControllerGetReplayUnqualifiedTaskEnableSeatsList() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访任务患者详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskPatientInfoId = null;
    /**
     * parameter 当前随访状态状态
     * @type {Number}
     * @required true
     */
    this.p_currentFollowState = null;
    this.url = "/feedbackOutController/getReplayUnqualifiedTaskEnableSeatsList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followUpTaskPatientInfoId:this.p_followUpTaskPatientInfoId,
            currentFollowState:this.p_currentFollowState,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TFollowUpPeopleTaskResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TFollowUpPeopleTaskResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TFollowUpPeopleTaskResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取质控规则
 * @constructor
 */
function RestFeedbackOutControllerGetQualityRule() {
    /**
     * parameter 规则名称
     * @type {String}
     * @required false
     */
    this.p_ruleName = null;
    /**
     * parameter 关联任务id
     * @type {Number}
     * @required false
     */
    this.p_relationTaskId = null;
    /**
     * parameter 判断是否添加的当前任务id
     * @type {Number}
     * @required false
     */
    this.p_judgeIsAddTaskId = null;
    /**
     * parameter 判断是否所有关联的任务
     * @type {Number}
     * @required false
     */
    this.p_judgeIsAllRelationTask = null;
    /**
     * parameter 是否父级：0否，1是
     * @type {Boolean}
     * @required false
     */
    this.p_isFather = null;
    /**
     * parameter 父节点id
     * @type {Number}
     * @required false
     */
    this.p_fatherId = null;
    /**
     * parameter 是否通用规则：0否，1是
     * @type {Boolean}
     * @required false
     */
    this.p_isNormal = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/feedbackOutController/getQualityRule";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            ruleName:this.p_ruleName,
            relationTaskId:this.p_relationTaskId,
            judgeIsAddTaskId:this.p_judgeIsAddTaskId,
            judgeIsAllRelationTask:this.p_judgeIsAllRelationTask,
            isFather:this.p_isFather,
            fatherId:this.p_fatherId,
            isNormal:this.p_isNormal,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_QualityRules}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_QualityRules(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_QualityRules(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取呼叫记录
 * @constructor
 */
function RestFeedbackOutControllerGetRecordList() {
    /**
     * parameter followUpPatientInfoId
     * @type {Number}
     * @required ${methodParameterDom.required}
     */
    this.p_followUpPatientInfoId = null;
    this.url = "/feedbackOutController/getRecordList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpPatientInfoId:this.p_followUpPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowUpTaskPatientCallRecords}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowUpTaskPatientCallRecords(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowUpTaskPatientCallRecords(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 是否提醒去听录音
 * @constructor
 */
function RestFeedbackOutControllerIsRemind() {
    /**
     * parameter 随访患者详情id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 总时长提醒
     * @type {Boolean}
     * @required true
     */
    this.p_isTotalDuration = null;
    /**
     * parameter 单时长提醒
     * @type {Boolean}
     * @required true
     */
    this.p_isSingleDuration = null;
    this.url = "/feedbackOutController/isRemind";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            followUpTaskId:this.p_followUpTaskId,
            isTotalDuration:this.p_isTotalDuration,
            isSingleDuration:this.p_isSingleDuration,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_bool}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_bool(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_bool(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更新呼叫记录
 * @constructor
 */
function RestFeedbackOutControllerUpdateRecordList() {
    /**
     * parameter ids
     * @type {Array.<Number>}
     * @required ${methodParameterDom.required}
     */
    this.p_ids = null;
    this.url = "/feedbackOutController/updateRecordList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            ids:this.p_ids,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 判断质控员是否在关联任务下
 * @constructor
 */
function RestFeedbackOutControllerIsInRelationTask() {
    /**
     * parameter 提醒id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    this.url = "/feedbackOutController/isInRelationTask";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_bool}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_bool(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_bool(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据id集合删除质控提醒
 * @constructor
 */
function RestFeedbackOutControllerDeleteRemindByIds() {
    /**
     * parameter 提醒id
     * @type {Array.<Number>}
     * @required true
     */
    this.p_id = null;
    this.url = "/feedbackOutController/deleteRemindByIds";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取审核不通过反馈列表
 * @constructor
 */
function RestFeedbackOutControllerGetPassFailFeedBackList() {
    /**
     * parameter 质检员id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 是否已读：0否，1是
     * @type {Boolean}
     * @required false
     */
    this.p_isConfirm = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/feedbackOutController/getPassFailFeedBackList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            isConfirm:this.p_isConfirm,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PassFailFeedBacks}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PassFailFeedBacks(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PassFailFeedBacks(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访患者复核
 * @constructor
 */
function RestFeedbackOutControllerGetFollowupPatientReview() {
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/feedbackOutController/getFollowupPatientReview";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_Integer}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_Integer(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_Integer(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 分页获取患者就诊信息
 * @constructor
 */
function RestFeedbackOutControllerGetPatientMedicalRecordNewList() {
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    /**
     * parameter 当前页
     * @type {Number}
     * @required true
     */
    this.p_page = null;
    /**
     * parameter 科室名称
     * @type {String}
     * @required false
     */
    this.p_departmentName = null;
    /**
     * parameter 就诊类型 0门诊 1住院 2体检
     * @type {Number}
     * @required false
     */
    this.p_visitingType = null;
    /**
     * parameter 就诊日期开始
     * @type {String}
     * @required false
     */
    this.p_visitingDateStart = null;
    /**
     * parameter 就诊日期结束
     * @type {String}
     * @required false
     */
    this.p_visitingDateEnd = null;
    /**
     * parameter 有无体检报告
     * @type {Boolean}
     * @required false
     */
    this.p_isRecording = null;
    this.url = "/feedbackOutController/getPatientMedicalRecordNewList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            patientId:this.p_patientId,
            page:this.p_page,
            departmentName:this.p_departmentName,
            visitingType:this.p_visitingType,
            visitingDateStart:this.p_visitingDateStart,
            visitingDateEnd:this.p_visitingDateEnd,
            isRecording:this.p_isRecording,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PatientMedicalRecords}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PatientMedicalRecords(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PatientMedicalRecords(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者入院报告
 * @constructor
 */
function RestFeedbackOutControllerGetPatientAdmissionRecord() {
    /**
     * parameter 就诊流水号
     * @type {String}
     * @required true
     */
    this.p_visitingNo = null;
    this.url = "/feedbackOutController/getPatientAdmissionRecord";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            visitingNo:this.p_visitingNo,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者出院报告
 * @constructor
 */
function RestFeedbackOutControllerGetPatientDischargeRecord() {
    /**
     * parameter 就诊流水号
     * @type {String}
     * @required true
     */
    this.p_visitingNo = null;
    this.url = "/feedbackOutController/getPatientDischargeRecord";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            visitingNo:this.p_visitingNo,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者手术记录
 * @constructor
 */
function RestFeedbackOutControllerGetPatientSurgeryRecord() {
    /**
     * parameter 就诊流水号
     * @type {String}
     * @required true
     */
    this.p_visitingNo = null;
    this.url = "/feedbackOutController/getPatientSurgeryRecord";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            visitingNo:this.p_visitingNo,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SurgeryRecords}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SurgeryRecords(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SurgeryRecords(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取问卷质控规则更新提示
 * @constructor
 */
function RestNewFollowupQuestionListServiceGetUpdateTips() {
    /**
     * parameter 问卷Id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireId = null;
    /**
     * parameter 坐席Id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/newFollowupQuestionListService/getUpdateTips";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireId:this.p_questionnaireId,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_UpdateTipInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_UpdateTipInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_UpdateTipInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 更新是否已读
 * @constructor
 */
function RestNewFollowupQuestionListServiceUpdateIsRead() {
    /**
     * parameter 规则id
     * @type {Number}
     * @required true
     */
    this.p_ruleId = null;
    /**
     * parameter 坐席Id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/newFollowupQuestionListService/updateIsRead";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            ruleId:this.p_ruleId,
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据问题获取规则
 * @constructor
 */
function RestNewFollowupQuestionListServiceQueryRuleByCondition() {
    /**
     * parameter 坐席Id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 题目id
     * @type {Number}
     * @required true
     */
    this.p_questionId = null;
    this.url = "/newFollowupQuestionListService/queryRuleByCondition";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            questionId:this.p_questionId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_QualityRuleResp}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_QualityRuleResp(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_QualityRuleResp(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询问卷标记
 * @constructor
 */
function RestNewFollowupQuestionListServiceGetTips() {
    /**
     * parameter 问卷Id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    this.url = "/newFollowupQuestionListService/getTips";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_ColorTips}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_ColorTips(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_ColorTips(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访任务问卷ID
 * @constructor
 */
function RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    this.url = "/newFollowupQuestionListService/getFollowupTaskQuestionnaireNewId";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupTaskId:this.p_followupTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_long}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_long(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_long(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询页码和题目标题属性列表
 * @constructor
 */
function RestNewFollowupQuestionListServiceQueryPageAndQuestionList() {
    /**
     * parameter t_questionnaire_new表id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    this.url = "/newFollowupQuestionListService/queryPageAndQuestionList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireNewId:this.p_questionnaireNewId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TQuestionInfoResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TQuestionInfoResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TQuestionInfoResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询下一页上一页页码和题目信息列表
 * @constructor
 */
function RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePage() {
    /**
     * parameter t_questionnaire_new表id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 页码
     * @type {Number}
     * @required true
     */
    this.p_pageNumber = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required false
     */
    this.p_followupPatientId = null;
    this.url = "/newFollowupQuestionListService/queryPageAndQuestionListForOnePage";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireNewId:this.p_questionnaireNewId,
            pageNumber:this.p_pageNumber,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TQuestionInfoResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TQuestionInfoResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TQuestionInfoResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询下一页上一页页码和题目信息列表
 * @constructor
 */
function RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePageNew() {
    /**
     * parameter 是否从问卷列表进入
     * @type {Boolean}
     * @required true
     */
    this.p_isQuestionnaireList = null;
    /**
     * parameter t_questionnaire_new表id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 页码
     * @type {Number}
     * @required true
     */
    this.p_pageNumber = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required false
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访患者表详情id
     * @type {Number}
     * @required false
     */
    this.p_followupPatientInfoId = null;
    this.url = "/newFollowupQuestionListService/queryPageAndQuestionListForOnePageNew";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            isQuestionnaireList:this.p_isQuestionnaireList,
            questionnaireNewId:this.p_questionnaireNewId,
            pageNumber:this.p_pageNumber,
            followupPatientId:this.p_followupPatientId,
            followupPatientInfoId:this.p_followupPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_QuestionDetailInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_QuestionDetailInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_QuestionDetailInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 新增患者答题信息
 * @constructor
 */
function RestNewFollowupQuestionListServiceAddPatientAnswerInfo() {
    /**
     * parameter 随访患者表id（后台预览为-1）
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 新问卷表id主键
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 题目表id主键
     * @type {Number}
     * @required true
     */
    this.p_questionInfo = null;
    /**
     * parameter 患者答案信息json格式
     * @type {String}
     * @required true
     */
    this.p_answerInfo = null;
    /**
     * parameter ** 来源类别 1-线上，2-电话
     * @type {Number}
     * @required true
     */
    this.p_sourceType = null;
    /**
     * parameter （只有电话才填）电话随访录入人员id
     * @type {Number}
     * @required false
     */
    this.p_operatorId = null;
    /**
     * parameter 是否修改记录
     * @type {Boolean}
     * @required false
     */
    this.p_isRecord = null;
    /**
     * parameter 问题类型
     * @type {Number}
     * @required false
     */
    this.p_questionType = null;
    this.url = "/newFollowupQuestionListService/addPatientAnswerInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            questionnaireNewId:this.p_questionnaireNewId,
            questionInfo:this.p_questionInfo,
            answerInfo:this.p_answerInfo,
            sourceType:this.p_sourceType,
            operatorId:this.p_operatorId,
            isRecord:this.p_isRecord,
            questionType:this.p_questionType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TPatientAnswerInfoResp}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TPatientAnswerInfoResp(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TPatientAnswerInfoResp(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 保存患者答题信息（正常和异常）
 * @constructor
 */
function RestNewFollowupQuestionListServiceUpdatePatientAnswerInfoById() {
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 随访患者表id（后台预览为-1）
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 新问卷表id主键
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 题目表id主键
     * @type {Number}
     * @required true
     */
    this.p_questionInfo = null;
    /**
     * parameter 患者答案信息json格式
     * @type {String}
     * @required true
     */
    this.p_answerInfo = null;
    /**
     * parameter ** 来源类别 1-线上，2-电话
     * @type {Number}
     * @required false
     */
    this.p_sourceType = null;
    /**
     * parameter （只有电话才填）电话随访录入人员id
     * @type {Number}
     * @required false
     */
    this.p_operatorId = null;
    /**
     * parameter 是否修改记录
     * @type {Boolean}
     * @required false
     */
    this.p_isRecord = null;
    /**
     * parameter 问题类型
     * @type {Number}
     * @required false
     */
    this.p_questionType = null;
    this.url = "/newFollowupQuestionListService/updatePatientAnswerInfoById";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            followupPatientId:this.p_followupPatientId,
            questionnaireNewId:this.p_questionnaireNewId,
            questionInfo:this.p_questionInfo,
            answerInfo:this.p_answerInfo,
            sourceType:this.p_sourceType,
            operatorId:this.p_operatorId,
            isRecord:this.p_isRecord,
            questionType:this.p_questionType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询页码信息
 * @constructor
 */
function RestNewFollowupQuestionListServiceQueryQuestionPageList() {
    /**
     * parameter 页码信息
     * @type {TQuestionPageResp}
     * @required true
     */
    this.p_questionPageResp = null;
    this.url = "/newFollowupQuestionListService/queryQuestionPageList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionPageResp:this.p_questionPageResp,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TQuestionPageResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TQuestionPageResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TQuestionPageResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 新增患者问卷答题表
 * @constructor
 */
function RestNewFollowupQuestionListServiceAddPatientQuestionnaireAnswer() {
    /**
     * parameter 随访患者表id（后台预览为-1）
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 新问卷表id主键
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 进行到哪一页
     * @type {String}
     * @required false
     */
    this.p_pageNumber = null;
    this.url = "/newFollowupQuestionListService/addPatientQuestionnaireAnswer";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            questionnaireNewId:this.p_questionnaireNewId,
            pageNumber:this.p_pageNumber,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TPatientQuestionnaireAnswerResp}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TPatientQuestionnaireAnswerResp(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TPatientQuestionnaireAnswerResp(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 修改患者问卷答题表
 * @constructor
 */
function RestNewFollowupQuestionListServiceUpdatePatientQuestionnaireAnswer() {
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 随访患者表id（后台预览为-1）
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 新问卷表id主键
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 进行到哪一页
     * @type {String}
     * @required false
     */
    this.p_pageNumber = null;
    /**
     * parameter 是否完成 0-完成，1-未完成
     * @type {Number}
     * @required false
     */
    this.p_finish = null;
    this.url = "/newFollowupQuestionListService/updatePatientQuestionnaireAnswer";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            followupPatientId:this.p_followupPatientId,
            questionnaireNewId:this.p_questionnaireNewId,
            pageNumber:this.p_pageNumber,
            finish:this.p_finish,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询患者问卷答题表
 * @constructor
 */
function RestNewFollowupQuestionListServiceQueryPatientQuestionnaireAnswer() {
    /**
     * parameter 随访患者表id（后台预览为-1）
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 新问卷表id主键
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    this.url = "/newFollowupQuestionListService/queryPatientQuestionnaireAnswer";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            questionnaireNewId:this.p_questionnaireNewId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TPatientQuestionnaireAnswerResp}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TPatientQuestionnaireAnswerResp(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TPatientQuestionnaireAnswerResp(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 填充电话问卷答案
 * @constructor
 */
function RestNewFollowupQuestionListServiceFillTelQuestionnaireNewAnswer() {
    /**
     * parameter t_questionnaire_new表id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter ** 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/newFollowupQuestionListService/fillTelQuestionnaireNewAnswer";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireNewId:this.p_questionnaireNewId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取问卷分页列表
 * @constructor
 */
function RestNewFollowupQuestionListServiceGetQuestionnairePageList() {
    /**
     * parameter t_questionnaire_new表id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    this.url = "/newFollowupQuestionListService/getQuestionnairePageList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireNewId:this.p_questionnaireNewId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TQuestionInfoResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TQuestionInfoResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TQuestionInfoResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据ID删除答案选项信息
 * @constructor
 */
function RestNewFollowupQuestionListServiceDelAnswerOptionById() {
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireNewId = null;
    /**
     * parameter 答案ID
     * @type {Number}
     * @required true
     */
    this.p_patientAnswerInfoId = null;
    this.url = "/newFollowupQuestionListService/delAnswerOptionById";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireNewId:this.p_questionnaireNewId,
            patientAnswerInfoId:this.p_patientAnswerInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 批量添加患者答题信息
 * @constructor
 */
function RestNewFollowupQuestionListServiceBatchAddPatientAnswerInfo() {
    /**
     * parameter 批量答案信息列表
     * @type {Array.<BatchAddPatientAnswerInfo>}
     * @required true
     */
    this.p_batchAnswerInfoList = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 是否是修改问卷
     * @type {Boolean}
     * @required true
     */
    this.p_isRecord = null;
    this.url = "/newFollowupQuestionListService/batchAddPatientAnswerInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            batchAnswerInfoList:this.p_batchAnswerInfoList,
            taskId:this.p_taskId,
            isRecord:this.p_isRecord,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 预览问卷
 * @constructor
 */
function RestNewFollowupQuestionListServicePreviewQuestionnaire() {
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 当前页码
     * @type {Number}
     * @required true
     */
    this.p_pageNumber = null;
    /**
     * parameter 随访类型
     * @type {Number}
     * @required true
     */
    this.p_followUpType = null;
    this.url = "/newFollowupQuestionListService/previewQuestionnaire";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            pageNumber:this.p_pageNumber,
            followUpType:this.p_followUpType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TQuestionInfoRespAndStatus}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TQuestionInfoRespAndStatus(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TQuestionInfoRespAndStatus(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 预览任务
 * @constructor
 */
function RestNewFollowupQuestionListServicePreviewTask() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    this.url = "/newFollowupQuestionListService/previewTask";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            taskId:this.p_taskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据任务id集合和坐席id查询有学习资料更新的任务id
 * @constructor
 */
function RestNewFollowupQuestionListServiceGetTaskIds() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id集合
     * @type {Array.<Number>}
     * @required true
     */
    this.p_taskIds = null;
    this.url = "/newFollowupQuestionListService/getTaskIds";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            taskIds:this.p_taskIds,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_longs}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_longs(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_longs(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据任务id和坐席id查询有更新的学习资料id
 * @constructor
 */
function RestNewFollowupQuestionListServiceGetStudyIds() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    this.url = "/newFollowupQuestionListService/getStudyIds";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            taskId:this.p_taskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_longs}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_longs(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_longs(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 删除学习资料任务坐席中间表
 * @constructor
 */
function RestNewFollowupQuestionListServiceDeleteMiddleTableRecord() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 学习资料id
     * @type {Number}
     * @required true
     */
    this.p_studyId = null;
    this.url = "/newFollowupQuestionListService/deleteMiddleTableRecord";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            taskId:this.p_taskId,
            studyId:this.p_studyId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 创建华为呼叫
 * @constructor
 */
function RestHuaWeiCECControllerCreateHuaWeiTwoCall() {
    /**
     * parameter 坐席用户名
     * @type {String}
     * @required true
     */
    this.p_userName = null;
    /**
     * parameter 被叫号码
     * @type {String}
     * @required true
     */
    this.p_phone = null;
    this.url = "/huaWeiCECController/createHuaWeiTwoCall";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userName:this.p_userName,
            phone:this.p_phone,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 编辑随访备注
 * @constructor
 */
function RestRemarksCallcenterControllerEditTags() {
    /**
     * parameter id
     * @type {Number}
     * @required false
     */
    this.p_id = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 坐席姓名
     * @type {String}
     * @required true
     */
    this.p_seatName = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    /**
     * parameter 随访患者表姓名
     * @type {String}
     * @required true
     */
    this.p_followUpPatientName = null;
    /**
     * parameter 备注类型
     * @type {Number}
     * @required true
     */
    this.p_remarkType = null;
    /**
     * parameter 随访备注
     * @type {String}
     * @required true
     */
    this.p_tags = null;
    this.url = "/remarksCallcenterController/editTags";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            seatId:this.p_seatId,
            seatName:this.p_seatName,
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientId:this.p_followUpPatientId,
            followUpPatientName:this.p_followUpPatientName,
            remarkType:this.p_remarkType,
            tags:this.p_tags,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访备注
 * @constructor
 */
function RestRemarksCallcenterControllerGetTags() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required false
     */
    this.p_seatId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required false
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    /**
     * parameter 备注类型
     * @type {Number}
     * @required true
     */
    this.p_remarkType = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/remarksCallcenterController/getTags";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientId:this.p_followUpPatientId,
            remarkType:this.p_remarkType,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTags}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTags(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTags(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加交付备注
 * @constructor
 */
function RestRemarksCallcenterControllerEditDeliveryRemark() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 坐席姓名
     * @type {String}
     * @required true
     */
    this.p_seatName = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    /**
     * parameter 随访患者表姓名
     * @type {String}
     * @required true
     */
    this.p_followUpPatientName = null;
    /**
     * parameter 交付备注问题id
     * @type {Number}
     * @required true
     */
    this.p_deliveryQuestionId = null;
    /**
     * parameter 交付备注答案
     * @type {String}
     * @required true
     */
    this.p_answerInfo = null;
    this.url = "/remarksCallcenterController/editDeliveryRemark";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            seatName:this.p_seatName,
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientId:this.p_followUpPatientId,
            followUpPatientName:this.p_followUpPatientName,
            deliveryQuestionId:this.p_deliveryQuestionId,
            answerInfo:this.p_answerInfo,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取交付备注
 * @constructor
 */
function RestRemarksCallcenterControllerGetDeliveryRemark() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required false
     */
    this.p_seatId = null;
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required false
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/remarksCallcenterController/getDeliveryRemark";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientId:this.p_followUpPatientId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupDeliveryQuestions}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupDeliveryQuestions(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupDeliveryQuestions(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 删除随访备注
 * @constructor
 */
function RestRemarksCallcenterControllerDeleteTags() {
    /**
     * parameter 备注id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    /**
     * parameter 用户id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 用户姓名
     * @type {String}
     * @required true
     */
    this.p_userName = null;
    this.url = "/remarksCallcenterController/deleteTags";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            userId:this.p_userId,
            userName:this.p_userName,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 登录
 * @constructor
 */
function RestAuthLogin() {
    /**
     * parameter 手机号
     * @type {String}
     * @required false
     */
    this.p_phone = null;
    /**
     * parameter 验证码
     * @type {Number}
     * @required false
     */
    this.p_code = null;
    /**
     * parameter 用户名
     * @type {String}
     * @required true
     */
    this.p_username = null;
    /**
     * parameter 密码
     * @type {String}
     * @required true
     */
    this.p_password = null;
    /**
     * parameter 外网ip
     * @type {String}
     * @required false
     */
    this.p_outIp = null;
    /**
     * parameter 内网ip
     * @type {String}
     * @required false
     */
    this.p_inIp = null;
    this.url = "/auth/login";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            phone:this.p_phone,
            code:this.p_code,
            username:this.p_username,
            password:this.p_password,
            outIp:this.p_outIp,
            inIp:this.p_inIp,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallCenterUser}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallCenterUser(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallCenterUser(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 退出登录
 * @constructor
 */
function RestAuthLogout() {
    /**
     * parameter id
     * @type {Number}
     * @required true
     */
    this.p_id = null;
    this.url = "/auth/logout";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据标签id查询下拉列表内容
 * @constructor
 */
function RestNewQuestionnaireDesignCallcenterControllerQueryQuestionnaireOptionListByTagId() {
    /**
     * parameter 标签id
     * @type {Array.<Number>}
     * @required true
     */
    this.p_tagIds = null;
    this.url = "/newQuestionnaireDesignCallcenterController/queryQuestionnaireOptionListByTagId";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            tagIds:this.p_tagIds,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_GroupInfoLists}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_GroupInfoLists(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_GroupInfoLists(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加一条选项
 * @constructor
 */
function RestNewQuestionnaireDesignCallcenterControllerAddOneQuestionnaireOption() {
    /**
     * parameter 标签id
     * @type {Number}
     * @required true
     */
    this.p_tagId = null;
    /**
     * parameter 操作人id
     * @type {Number}
     * @required true
     */
    this.p_operatorId = null;
    /**
     * parameter 选项内容
     * @type {String}
     * @required true
     */
    this.p_optionContent = null;
    this.url = "/newQuestionnaireDesignCallcenterController/addOneQuestionnaireOption";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            tagId:this.p_tagId,
            operatorId:this.p_operatorId,
            optionContent:this.p_optionContent,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据选型id查询扩展信息
 * @constructor
 */
function RestNewQuestionnaireDesignCallcenterControllerQueryContentByOptionId() {
    /**
     * parameter 选项id
     * @type {Number}
     * @required true
     */
    this.p_optionInfoId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required false
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required false
     */
    this.p_followupPatientId = null;
    this.url = "/newQuestionnaireDesignCallcenterController/queryContentByOptionId";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            optionInfoId:this.p_optionInfoId,
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 保存选项扩展内容并返回答案信息
 * @constructor
 */
function RestNewQuestionnaireDesignCallcenterControllerSaveOptionExtensionAnswerInfo() {
    /**
     * parameter 选项id
     * @type {Number}
     * @required true
     */
    this.p_optionInfoId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required false
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required false
     */
    this.p_followupPatientId = null;
    /**
     * parameter 内容json
     * @type {String}
     * @required true
     */
    this.p_answerInfo = null;
    this.url = "/newQuestionnaireDesignCallcenterController/saveOptionExtensionAnswerInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            optionInfoId:this.p_optionInfoId,
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
            answerInfo:this.p_answerInfo,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 删除答案
 * @constructor
 */
function RestNewQuestionnaireDesignCallcenterControllerDeleteOptionExtensionAnswerInfo() {
    /**
     * parameter 选项id
     * @type {Number}
     * @required true
     */
    this.p_optionInfoId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/newQuestionnaireDesignCallcenterController/deleteOptionExtensionAnswerInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            optionInfoId:this.p_optionInfoId,
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取专病库服务token
 * @constructor
 */
function RestZhuanBingLibraryServerGetZhuanBingLibraryToken() {
    /**
     * parameter 当前登录人id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    this.url = "/zhuanBingLibraryServer/getZhuanBingLibraryToken";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 患者详情
 * @constructor
 */
function RestReferenceControllerGetPatientInfoManager() {
    /**
     * parameter 随访任务表id
     * @type {Number}
     * @required true
     */
    this.p_followupTaskId = null;
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required true
     */
    this.p_patientId = null;
    this.url = "/referenceController/getPatientInfoManager";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupTaskId:this.p_followupTaskId,
            followupPatientId:this.p_followupPatientId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
            patientId:this.p_patientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupTaskPatientInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupTaskPatientInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者呼叫记录
 * @constructor
 */
function RestReferenceControllerGetPatientCallRecord() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/referenceController/getPatientCallRecord";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_QualityControlCallRecordInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_QualityControlCallRecordInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_QualityControlCallRecordInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 短信发送--患者详情
 * @constructor
 */
function RestReferenceControllerGetSmsSendRecordPatientInfo() {
    /**
     * parameter 随访患者表id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/referenceController/getSmsSendRecordPatientInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TFollowupSmsSendRecordResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TFollowupSmsSendRecordResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TFollowupSmsSendRecordResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取参考信息
 * @constructor
 */
function RestReferenceControllerGetReferenceInfo() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/referenceController/getReferenceInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupReferenceInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupReferenceInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupReferenceInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取历史随访列表
 * @constructor
 */
function RestReferenceControllerGetAllFollowupList() {
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/referenceController/getAllFollowupList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PatientAllFollowupLists}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PatientAllFollowupLists(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PatientAllFollowupLists(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取交付表信息
 * @constructor
 */
function RestReferenceControllerGetDeliver() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/referenceController/getDeliver";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            taskId:this.p_taskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取展示字段
 * @constructor
 */
function RestReferenceControllerGetExhibition() {
    /**
     * parameter 当前用户id
     * @type {Number}
     * @required true
     */
    this.p_nowUserId = null;
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_taskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/referenceController/getExhibition";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            nowUserId:this.p_nowUserId,
            taskId:this.p_taskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupInfoKVs}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupInfoKVs(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupInfoKVs(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 历史抽查记录
 * @constructor
 */
function RestReferenceControllerGetFollowupSpotCheckRemarksList() {
    /**
     * parameter 随访任务ID
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientId = null;
    this.url = "/referenceController/getFollowupSpotCheckRemarksList";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientId:this.p_followUpPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FollowupSpotCheckRecordResps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FollowupSpotCheckRecordResps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FollowupSpotCheckRecordResps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取患者参考信息
 * @constructor
 */
function RestReferenceControllerGetPatientReferenceInfo() {
    /**
     * parameter 随访任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者ID
     * @type {Number}
     * @required true
     */
    this.p_followupPatientId = null;
    this.url = "/referenceController/getPatientReferenceInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
            followupPatientId:this.p_followupPatientId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_PatientReferenceFieldGroupInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_PatientReferenceFieldGroupInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_PatientReferenceFieldGroupInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取参考信息组列表
 * @constructor
 */
function RestReferenceControllerGetReferenceGroupList() {
    /**
     * parameter 随访任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/referenceController/getReferenceGroupList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_StringMaps}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_StringMaps(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_StringMaps(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取错题集
 * @constructor
 */
function RestMistakeCollectionControllerGetSeatMistakeCollection() {
    /**
     * parameter 问卷id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 年月（yyyy-MM）
     * @type {String}
     * @required true
     */
    this.p_yearMonth = null;
    /**
     * parameter 问题题目
     * @type {String}
     * @required false
     */
    this.p_questionTitle = null;
    this.url = "/mistakeCollectionController/getSeatMistakeCollection";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireId:this.p_questionnaireId,
            seatId:this.p_seatId,
            yearMonth:this.p_yearMonth,
            questionTitle:this.p_questionTitle,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SeatMistakeInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SeatMistakeInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SeatMistakeInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取问题批注
 * @constructor
 */
function RestMistakeCollectionControllerGetQuestionAnnotations() {
    /**
     * parameter 问卷id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 题目序号
     * @type {Number}
     * @required true
     */
    this.p_serialNumber = null;
    this.url = "/mistakeCollectionController/getQuestionAnnotations";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireId:this.p_questionnaireId,
            seatId:this.p_seatId,
            serialNumber:this.p_serialNumber,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_strings}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_strings(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_strings(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取呼叫台错题跳转参数
 * @constructor
 */
function RestMistakeCollectionControllerGetCallCenterMistakeJumpParams() {
    /**
     * parameter 问卷id
     * @type {Number}
     * @required true
     */
    this.p_questionnaireId = null;
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    /**
     * parameter 随访患者详情id
     * @type {Number}
     * @required true
     */
    this.p_followUpPatientInfoId = null;
    this.url = "/mistakeCollectionController/getCallCenterMistakeJumpParams";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            questionnaireId:this.p_questionnaireId,
            seatId:this.p_seatId,
            followUpTaskId:this.p_followUpTaskId,
            followUpPatientInfoId:this.p_followUpPatientInfoId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallCenterJumpParams}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallCenterJumpParams(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallCenterJumpParams(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取任务存在呼叫的月份
 * @constructor
 */
function RestMistakeCollectionControllerGetTaskExistCallMonth() {
    /**
     * parameter 年份
     * @type {Number}
     * @required true
     */
    this.p_year = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/mistakeCollectionController/getTaskExistCallMonth";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            year:this.p_year,
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_strings}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_strings(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_strings(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 查询坐席指标核算、预告具体表格信息
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetQuotaTableInfo() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 消息id
     * @type {Number}
     * @required true
     */
    this.p_messageId = null;
    /**
     * parameter 2-指标核算，3-指标预告
     * @type {Number}
     * @required true
     */
    this.p_classification = null;
    this.url = "/callCenterOperationPlatformController/getQuotaTableInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            messageId:this.p_messageId,
            classification:this.p_classification,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SeatQuotaTableInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SeatQuotaTableInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SeatQuotaTableInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 呼叫台确认收到指标核算和预告消息
 * @constructor
 */
function RestCallCenterOperationPlatformControllerUpdateMsgConfirmStatus() {
    /**
     * parameter 用户id
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 消息id
     * @type {Number}
     * @required true
     */
    this.p_messageId = null;
    /**
     * parameter 消息分类：1-常规消息，2-指标核算，3-指标预告
     * @type {Number}
     * @required true
     */
    this.p_classification = null;
    this.url = "/callCenterOperationPlatformController/updateMsgConfirmStatus";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            messageId:this.p_messageId,
            classification:this.p_classification,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取坐席完成和待办信息
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetSeatFinishAndTodoInfo() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterOperationPlatformController/getSeatFinishAndTodoInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FinishAndTodoInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FinishAndTodoInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FinishAndTodoInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取指定月的所有周星
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetMonthAllWeekStar() {
    /**
     * parameter 年月
     * @type {String}
     * @required true
     */
    this.p_yearMonth = null;
    this.url = "/callCenterOperationPlatformController/getMonthAllWeekStar";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            yearMonth:this.p_yearMonth,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_WeekStars}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_WeekStars(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_WeekStars(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取当月最后一周周星
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetCurrentMonthLastWeekStar() {
    this.url = "/callCenterOperationPlatformController/getCurrentMonthLastWeekStar";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
        }
    }
    /**
     * parameter result
     * @type {HttpResult_WeekStars}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_WeekStars(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_WeekStars(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取最后一周周之星消息
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetMessageWeekStar() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterOperationPlatformController/getMessageWeekStar";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_NewMessageMangerInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_NewMessageMangerInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_NewMessageMangerInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 点赞或取消点赞
 * @constructor
 */
function RestCallCenterOperationPlatformControllerClickLikeOrCancel() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 周之星id
     * @type {Number}
     * @required true
     */
    this.p_weekStarId = null;
    /**
     * parameter 是否点赞：true是，false否
     * @type {Boolean}
     * @required true
     */
    this.p_clickLike = null;
    this.url = "/callCenterOperationPlatformController/clickLikeOrCancel";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            weekStarId:this.p_weekStarId,
            clickLike:this.p_clickLike,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_NewMessageMangerInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_NewMessageMangerInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_NewMessageMangerInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取当月所有排行榜
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetCurrentMonthAllRank() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterOperationPlatformController/getCurrentMonthAllRank";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SeatIndexRanks}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SeatIndexRanks(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SeatIndexRanks(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取坐席近一周随访情况
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetSeatRecentDayFollowupCount() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterOperationPlatformController/getSeatRecentDayFollowupCount";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TodayFollowUpCounts}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TodayFollowUpCounts(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TodayFollowUpCounts(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取系统消息
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetSystemMessage() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 是否已读
     * @type {Boolean}
     * @required false
     */
    this.p_isRead = null;
    /**
     * parameter 是否强制推送
     * @type {Boolean}
     * @required false
     */
    this.p_isForceSend = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required false
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/callCenterOperationPlatformController/getSystemMessage";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            isRead:this.p_isRead,
            isForceSend:this.p_isForceSend,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_NewMessageMangerInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_NewMessageMangerInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_NewMessageMangerInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 系统消息已读
 * @constructor
 */
function RestCallCenterOperationPlatformControllerAddSystemMessageRead() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 消息id
     * @type {Number}
     * @required true
     */
    this.p_messageId = null;
    this.url = "/callCenterOperationPlatformController/addSystemMessageRead";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            messageId:this.p_messageId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取坐席时间段统计
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetSeatTimeSectionStatistics() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 数据类型
     * @type {Number}
     * @required true
     */
    this.p_dataType = null;
    this.url = "/callCenterOperationPlatformController/getSeatTimeSectionStatistics";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            dataType:this.p_dataType,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TimeSectionStatisticsInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TimeSectionStatisticsInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TimeSectionStatisticsInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 根据时间筛选获取坐席时间段统计
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetSeatTimeSectionStatisticsByTime() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 开始时间
     * @type {String}
     * @required false
     */
    this.p_startTime = null;
    /**
     * parameter 结束时间
     * @type {String}
     * @required false
     */
    this.p_endTime = null;
    this.url = "/callCenterOperationPlatformController/getSeatTimeSectionStatisticsByTime";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            startTime:this.p_startTime,
            endTime:this.p_endTime,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TimeSectionStatisticsInfo}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TimeSectionStatisticsInfo(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TimeSectionStatisticsInfo(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取最近活跃任务信息
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetRecentActiveTaskInfo() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterOperationPlatformController/getRecentActiveTaskInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_OperationPlatformTaskDatas}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_OperationPlatformTaskDatas(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_OperationPlatformTaskDatas(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取任务数据坐席比较信息
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetTaskDataSeatCompareInfo() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    /**
     * parameter 任务id
     * @type {Number}
     * @required true
     */
    this.p_followUpTaskId = null;
    this.url = "/callCenterOperationPlatformController/getTaskDataSeatCompareInfo";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
            followUpTaskId:this.p_followUpTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_OperationPlatformTaskData}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_OperationPlatformTaskData(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_OperationPlatformTaskData(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取坐席强制推送周之星
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetForcePushWeekStar() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterOperationPlatformController/getForcePushWeekStar";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_bool}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_bool(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_bool(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取坐席月指标
 * @constructor
 */
function RestCallCenterOperationPlatformControllerGetSeatMonthQuota() {
    /**
     * parameter 坐席id
     * @type {Number}
     * @required true
     */
    this.p_seatId = null;
    this.url = "/callCenterOperationPlatformController/getSeatMonthQuota";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            seatId:this.p_seatId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_SeatMonthQuotaInfos}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_SeatMonthQuotaInfos(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_SeatMonthQuotaInfos(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 发送验证码
 * @constructor
 */
function RestVCodeControllerSendVcode() {
    /**
     * parameter 电话号码
     * @type {String}
     * @required true
     */
    this.p_phone = null;
    /**
     * parameter 设备IP
     * @type {String}
     * @required true
     */
    this.p_equipmentIp = null;
    /**
     * parameter 设备ID
     * @type {String}
     * @required true
     */
    this.p_equipmentId = null;
    /**
     * parameter 前端回调函数返回的用户验证票据
     * @type {String}
     * @required true
     */
    this.p_ticket = null;
    /**
     * parameter 前端回调函数返回的随机字符串
     * @type {String}
     * @required true
     */
    this.p_randStr = null;
    this.url = "/vCodeController/sendVcode";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            phone:this.p_phone,
            equipmentIp:this.p_equipmentIp,
            equipmentId:this.p_equipmentId,
            ticket:this.p_ticket,
            randStr:this.p_randStr,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_int}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_int(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_int(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访手机号码匹配患者列表
 * @constructor
 */
function RestIncomingCallControllerGetTelephoneFollowupIncomingCallPatientList() {
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_mobilePhone = null;
    this.url = "/incomingCallController/getTelephoneFollowupIncomingCallPatientList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            mobilePhone:this.p_mobilePhone,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_TelephoneFollowupIncomingCallPatients}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_TelephoneFollowupIncomingCallPatients(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_TelephoneFollowupIncomingCallPatients(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取随访呼入患者详情
 * @constructor
 */
function RestIncomingCallControllerGetFollowupIncomingCallPatientList() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 随访任务详情ID
     * @type {Number}
     * @required true
     */
    this.p_callTaskId = null;
    this.url = "/incomingCallController/getFollowupIncomingCallPatientList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            callTaskId:this.p_callTaskId,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_CallPatient}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_CallPatient(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_CallPatient(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取反馈匹配患者列表
 * @constructor
 */
function RestIncomingCallControllerGetFeedbackPatientInformationList() {
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_mobilePhone = null;
    this.url = "/incomingCallController/getFeedbackPatientInformationList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            mobilePhone:this.p_mobilePhone,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_FeedbackPatientInformations}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_FeedbackPatientInformations(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_FeedbackPatientInformations(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加来电反馈记录
 * @constructor
 */
function RestIncomingCallControllerAddIncomingTelegramAnswerResult() {
    /**
     * parameter 来电记录ID
     * @type {Number}
     * @required false
     */
    this.p_id = null;
    /**
     * parameter 接听用户ID
     * @type {Number}
     * @required true
     */
    this.p_answerUserId = null;
    /**
     * parameter 接听用户姓名
     * @type {String}
     * @required true
     */
    this.p_answerUserName = null;
    /**
     * parameter 患者ID
     * @type {Number}
     * @required false
     */
    this.p_patientId = null;
    /**
     * parameter 患者姓名
     * @type {String}
     * @required false
     */
    this.p_patientUserName = null;
    /**
     * parameter 来电手机号码
     * @type {String}
     * @required true
     */
    this.p_incomingTelegramNumber = null;
    /**
     * parameter 来电诉求：1医学问题，2APP安装问题，3APP下载问题，4APP使用问题，5其他问题
     * @type {String}
     * @required true
     */
    this.p_incomingTelegramAppeal = null;
    /**
     * parameter 备注
     * @type {String}
     * @required false
     */
    this.p_appealRemark = null;
    /**
     * parameter 是否解决问题：false未解决，true已解决
     * @type {Boolean}
     * @required true
     */
    this.p_isSolve = null;
    /**
     * parameter 住院号
     * @type {String}
     * @required false
     */
    this.p_admitNo = null;
    /**
     * parameter 阿里云通话ID
     * @type {String}
     * @required true
     */
    this.p_contactId = null;
    /**
     * parameter 来电时间
     * @type {String}
     * @required true
     */
    this.p_incomingTelegramTime = null;
    this.url = "/incomingCallController/addIncomingTelegramAnswerResult";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            id:this.p_id,
            answerUserId:this.p_answerUserId,
            answerUserName:this.p_answerUserName,
            patientId:this.p_patientId,
            patientUserName:this.p_patientUserName,
            incomingTelegramNumber:this.p_incomingTelegramNumber,
            incomingTelegramAppeal:this.p_incomingTelegramAppeal,
            appealRemark:this.p_appealRemark,
            isSolve:this.p_isSolve,
            admitNo:this.p_admitNo,
            contactId:this.p_contactId,
            incomingTelegramTime:this.p_incomingTelegramTime,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 添加未接来电记录
 * @constructor
 */
function RestIncomingCallControllerAddMissedCallResult() {
    /**
     * parameter 接听用户ID
     * @type {Number}
     * @required true
     */
    this.p_answerUserId = null;
    /**
     * parameter 接听用户姓名
     * @type {String}
     * @required true
     */
    this.p_answerUserName = null;
    /**
     * parameter 来电手机号码
     * @type {String}
     * @required true
     */
    this.p_incomingTelegramNumber = null;
    /**
     * parameter 来电时间
     * @type {String}
     * @required true
     */
    this.p_incomingTelegramTime = null;
    this.url = "/incomingCallController/addMissedCallResult";
    this.type = "POST";
    this.typeEx = "";
    this.data = function(){
        return {
            answerUserId:this.p_answerUserId,
            answerUserName:this.p_answerUserName,
            incomingTelegramNumber:this.p_incomingTelegramNumber,
            incomingTelegramTime:this.p_incomingTelegramTime,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_string}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_string(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_string(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 获取未接来电记录
 * @constructor
 */
function RestIncomingCallControllerGetMissedCallResultList() {
    /**
     * parameter 用户ID
     * @type {Number}
     * @required true
     */
    this.p_userId = null;
    /**
     * parameter 页数
     * @type {Number}
     * @required true
     */
    this.p_pageIndex = null;
    /**
     * parameter 条数
     * @type {Number}
     * @required false
     */
    this.p_pageSize = null;
    this.url = "/incomingCallController/getMissedCallResultList";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            userId:this.p_userId,
            pageIndex:this.p_pageIndex,
            pageSize:this.p_pageSize,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_MissedCallResults}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_MissedCallResults(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_MissedCallResults(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}

/**
 * 删除手机号码未接来电记录
 * @constructor
 */
function RestIncomingCallControllerDelMissedCallResult() {
    /**
     * parameter 手机号码
     * @type {String}
     * @required true
     */
    this.p_mobilePhone = null;
    this.url = "/incomingCallController/delMissedCallResult";
    this.type = "GET";
    this.typeEx = "";
    this.data = function(){
        return {
            mobilePhone:this.p_mobilePhone,
        }
    }
    /**
     * parameter result
     * @type {HttpResult_String}
     */
    this.result = null;
    let self = this;
    this.send = async function () {
        try {
            let data = await sendAjax(self);
            self.result = build.buildHttpResult_String(data.data);
        }catch (e) {
            console.error("[curl error]"+self.url);
            console.error(e);
            self.result = build.buildHttpResult_String(null);
            self.result.status = BaseMarco.CODE_INTER_FAIL;
        }
    }
}


/**
 * 服务对应的操作名字
 */
let PatientRelativeInfo = {
    /**
     * patientName
     * @type {String}
     */
    NAME:"病人姓名",
    /**
     * gender
     * @type {String}
     */
    GENDER:"性别",
    /**
     * telephoneCall
     * @type {String}
     */
    MOBILE:"tel",
    /**
     * inHospitalNum
     * @type {String}
     */
    HOSPITAL_NUMBER:"住院号",
    /**
     * age
     * @type {String}
     */
    AGE:"年龄",
    /**
     * province
     * @type {String}
     */
    PROVINCE:"省",
    /**
     * city
     * @type {String}
     */
    CITY:"市",
    /**
     * hospitalizationNumber
     * @type {String}
     */
    HOSPITALIZATION_NUMBER:"住院流水号",
    /**
     * additionHospitalNumber
     * @type {String}
     */
    ADDITION_HOSPITAL_NUMBER:"另外住院号",
    /**
     * dischargeDeptName
     * @type {String}
     */
    DISCHARGE_DEPT_NAME:"出院科室名称",
    /**
     * patientNatureName
     * @type {String}
     */
    PATIENT_NATURE_NAME:"病人性质名称",
    /**
     * medicalRecordName
     * @type {String}
     */
    MEDICAL_RECORD_NAME:"病案诊断名称",
    /**
     * diagnosisDate
     * @type {String}
     */
    DIAGNOSIS_DATE:"确诊日期",
    /**
     * surgeryDate
     * @type {String}
     */
    SURGERY_DATE:"手术日期",
    /**
     * otherDiagnosis
     * @type {String}
     */
    OTHER_DIAGNOSIS:"其他诊断",
    /**
     * pastMedicalHistory
     * @type {String}
     */
    PAST_MEDICAL_HISTORY:"既往病史",
    /**
     * pathologicalDiagnosis
     * @type {String}
     */
    PATHOLOGICAL_DIAGNOSIS:"病理诊断",
    /**
     * staging
     * @type {String}
     */
    STAGING:"分期",
    /**
     * differentiation
     * @type {String}
     */
    DIFFERENTIATION:"分化",
    /**
     * isOwnHospital
     * @type {String}
     */
    IS_OWN_HOSPITAL:"是否我院病理",
    /**
     * immunohistochemistry
     * @type {String}
     */
    IMMUNOHISTOCHEMISTRY:"免疫组化",
    /**
     * allOperations
     * @type {String}
     */
    ALL_OPERATIONS:"所有手术"
}
export {PatientRelativeInfo}
/**
 * 质控结果动态
 */
let QualityResultDynamicTypeEnum = {
    /**
     * 质控结果已提交（待审核）
     * @type {Number}
     */
    QUALITY_RESULT_SUBMIT:1,
    /**
     * 审核不通过
     * @type {Number}
     */
    EXAMINE_PASS_FAIL:2,
    /**
     * 审核通过（已发送坐席）
     * @type {Number}
     */
    EXAMINE_PASS_SUCCESS:3,
    /**
     * 坐席已读（待跟踪）
     * @type {Number}
     */
    SEAT_READ_TRACK:4,
    /**
     * 坐席已编辑（待跟踪）
     * @type {Number}
     */
    SEAT_EDIT_TRACK:5,
    /**
     * 质控完成
     * @type {Number}
     */
    QUALITY_CONTROL_COMPLETE:6,
    /**
     * 质控结果未提交（待确定）
     * @type {Number}
     */
    QUALITY_RESULT_NO_SUBMIT:7
}
export {QualityResultDynamicTypeEnum}
/**
 * 内容类型
 */
let ContentType = {
    /**
     * 文章
     * @type {Number}
     */
    ARTICLES:1,
    /**
     * 问答
     * @type {Number}
     */
    QUESTION_ANSWERS:2,
    /**
     * banners
     * @type {Number}
     */
    BANNERS:3,
    /**
     * 栏目
     * @type {Number}
     */
    CATEGORIES:4,
    /**
     * 渠道
     * @type {Number}
     */
    CHANNELS:5,
    /**
     * 标签
     * @type {Number}
     */
    TAGS:6,
    /**
     * 按钮
     * @type {Number}
     */
    BUTTON:7
}
export {ContentType}
/**
 * 样本库状态
 */
let SampleState = {
    /**
     * 样本状态 0：待入库
     * @type {Number}
     */
    SAMPLE_STATE_DRAFT:0,
    /**
     * 样本状态 1：已入库
     * @type {Number}
     */
    SAMPLE_STATE_SUBMITTED:1,
    /**
     * 样本状态 2:通过借出申请
     * @type {Number}
     */
    SAMPLE_STATE_PASS_APPLY:2,
    /**
     * 样本状态 3：已借出
     * @type {Number}
     */
    SAMPLE_STATE_WAREHOUSING:3
}
export {SampleState}
/**
 * 分答状态
 */
let ReplyStateType = {
    /**
     * 需支付1元查看
     * @type {Number}
     */
    REPLY_NEED_PAID:0,
    /**
     * 已上传
     * @type {Number}
     */
    REPLY_UPLOADED:1,
    /**
     * 已答复
     * @type {Number}
     */
    REPLIES_ANSWER:2,
    /**
     * 已支付
     * @type {Number}
     */
    REPLY_PAID:3,
    /**
     * 未回答
     * @type {Number}
     */
    REPLY_NO_ANSWER:4
}
export {ReplyStateType}
/**
 * 好物推荐症状
 */
let GoodsRecommendSymptomEnum = {
    /**
     * 感冒
     * @type {Number}
     */
    COMMON_COLD:1,
    /**
     * 发烧
     * @type {Number}
     */
    FEVER:2,
    /**
     * 疼痛
     * @type {Number}
     */
    PAIN:3,
    /**
     * 肠胃
     * @type {Number}
     */
    GASTROINTESTINAL:4,
    /**
     * 过敏
     * @type {Number}
     */
    ALLERGY:5,
    /**
     * 心理
     * @type {Number}
     */
    PSYCHOLOGY:6,
    /**
     * 睡眠
     * @type {Number}
     */
    SLEEP:7,
    /**
     * 口腔
     * @type {Number}
     */
    ORAL_CAVITY:8,
    /**
     * 耳鼻喉
     * @type {Number}
     */
    ENT:9,
    /**
     * 其他
     * @type {Number}
     */
    OTHER:10
}
export {GoodsRecommendSymptomEnum}
/**
 * 宣教操作类型
 */
let PropagandaEducationOperationType = {
    /**
     * 宣教操作类型-撤销
     * @type {Number}
     */
    OPERATION_TYPE_REVOKE:1,
    /**
     * 宣教操作类型-发布
     * @type {Number}
     */
    OPERATION_TYPE_RELEASE:2,
    /**
     * 宣教操作类型-删除
     * @type {Number}
     */
    OPERATION_TYPE_DEL:3
}
export {PropagandaEducationOperationType}
/**
 * 小程序消息发送人类型
 */
let AppletMessageSenderType = {
    /**
     * 管理台
     * @type {Number}
     */
    MANAGER:1,
    /**
     * 医生端
     * @type {Number}
     */
    DOCTOR:2,
    /**
     * 积分
     * @type {Number}
     */
    POINTS:3,
    /**
     * 咨询
     * @type {Number}
     */
    CONSULTATION:4
}
export {AppletMessageSenderType}
/**
 * 数据字典类型
 */
let DataDictionariesType = {
    /**
     * 数据字典类型 ：心外常用药物
     * @type {Number}
     */
    DATA_TYPE_COMMONLY_USED_DRUG:1,
    /**
     * 数据字典类型 ：心外常用检查
     * @type {Number}
     */
    DATA_TYPE_COMMONLY_USED_INSPECT:2,
    /**
     * 数据字典类型 ：并发症
     * @type {Number}
     */
    DATA_TYPE_COMMONLY_USED_COMPLICATION_STATE:3
}
export {DataDictionariesType}
/**
 * 随访状态： 0初始化，1随访中，2成功，3失访，4死亡，5异常呼叫
 */
let FollowupState = {
    /**
     * 0初始化
     * @type {Number}
     */
    FOLLOWUP_STATE_INITIALIZATION:0,
    /**
     * 1随访中
     * @type {Number}
     */
    FOLLOWUP_STATE_FOLLOWUP:1,
    /**
     * 2成功
     * @type {Number}
     */
    FOLLOWUP_STATE_SUCCESS:2,
    /**
     * 3失访
     * @type {Number}
     */
    FOLLOWUP_STATE_BE_MISSING:3,
    /**
     * 4死亡
     * @type {Number}
     */
    FOLLOWUP_STATE_DEATH:4,
    /**
     * 5异常呼叫
     * @type {Number}
     */
    FOLLOWUP_STATE_ABNORMAL:5
}
export {FollowupState}
/**
 * 坐席榜单类型
 */
let SeatRankType = {
    /**
     * 勤奋榜
     * @type {Number}
     */
    INDUSTRIOUS_RANK:1,
    /**
     * 优质榜
     * @type {Number}
     */
    QUALITY_RANK:2,
    /**
     * 效率榜
     * @type {Number}
     */
    EFFECT_RANK:3,
    /**
     * 成功榜
     * @type {Number}
     */
    SUCCESS_RANK:4
}
export {SeatRankType}
/**
 * 推荐治疗方案
 */
let TreatmentProgramsType = {
    /**
     * 定期随访
     * @type {String}
     */
    TREATMENT_PROGRAMS_REGULAR_FOLLOWUP:"定期随访",
    /**
     * 干扰素治疗
     * @type {String}
     */
    TREATMENT_PROGRAMS_INTERFERON_THERAPY:"干扰素治疗",
    /**
     * 介入治疗+干扰素治疗
     * @type {String}
     */
    TREATMENT_PROGRAMS_INTERVENTIONAL_INTERFERON_THERAPY:"介入治疗+干扰素治疗"
}
export {TreatmentProgramsType}
/**
 * 随访组随访状态
 */
let GroupFollowUpState = {
    /**
     * 问卷待填写
     * @type {Number}
     */
    QuestionnaireToBeFilled:1,
    /**
     * 问卷已完成
     * @type {Number}
     */
    Completed:2,
    /**
     * 电话随访进行中
     * @type {Number}
     */
    CallFollowUpIng:3,
    /**
     * 失访
     * @type {Number}
     */
    LostVisit:4,
    /**
     * 死亡
     * @type {Number}
     */
    Die:5,
    /**
     * 逾期
     * @type {Number}
     */
    Over:6
}
export {GroupFollowUpState}
/**
 * 接通状态：1未接听，2已完成
 */
let ConnectType = {
    /**
     * 1未接听
     * @type {Number}
     */
    CONNECT_MISSED_CALLS:1,
    /**
     * 2已完成
     * @type {Number}
     */
    CONNECT_ACCOMPLISH:2
}
export {ConnectType}
/**
 * 质控结果状态: 1质控结果已提交（待审核），2审核不通过，3审核通过（已发送坐席），4坐席已读（待跟踪），5坐席已编辑（待跟踪），6质控完成
 */
let QualityStageTypeEnum = {
    /**
     * 质控结果已提交（待审核）
     * @type {Number}
     */
    TO_AUDIT:1,
    /**
     * 审核不通过
     * @type {Number}
     */
    NOT_THROUGH:2,
    /**
     * 审核通过（已发送坐席）
     * @type {Number}
     */
    HAS_BEEN_SENT:3,
    /**
     * 坐席已读（待跟踪）
     * @type {Number}
     */
    HAS_BEEN_READ:4,
    /**
     * 坐席已编辑（待跟踪）
     * @type {Number}
     */
    HAS_BEEN_EDITOR:5,
    /**
     * 质控完成
     * @type {Number}
     */
    HAS_BEEN_COMPLETED:6,
    /**
     * 质控结果未提交（待确定）
     * @type {Number}
     */
    QUALITY_RESULT_NO_SUBMIT:7
}
export {QualityStageTypeEnum}
/**
 * 质控结果动态
 */
let QualityResultDynamicType = {
    /**
     * 质控结果已提交（待审核）
     * @type {Number}
     */
    QUALITY_RESULT_SUBMIT:1,
    /**
     * 审核不通过
     * @type {Number}
     */
    EXAMINE_PASS_FAIL:2,
    /**
     * 审核通过（已发送坐席）
     * @type {Number}
     */
    EXAMINE_PASS_SUCCESS:3,
    /**
     * 坐席已读（待跟踪）
     * @type {Number}
     */
    SEAT_READ_TRACK:4,
    /**
     * 坐席已编辑（待跟踪）
     * @type {Number}
     */
    SEAT_EDIT_TRACK:5,
    /**
     * 质控完成
     * @type {Number}
     */
    QUALITY_CONTROL_COMPLETE:6,
    /**
     * 质控结果未提交（待确定）
     * @type {Number}
     */
    QUALITY_RESULT_NO_SUBMIT:7
}
export {QualityResultDynamicType}
/**
 * 请假类型
 */
let LeaveTypeEnum = {
    /**
     * 未请假
     * @type {Number}
     */
    NO_LEAVE:0,
    /**
     * 年假
     * @type {Number}
     */
    COMPENSATORY_LEAVE:1,
    /**
     * 事假
     * @type {Number}
     */
    ANNUAL_LEAVE:2,
    /**
     * 病假
     * @type {Number}
     */
    SICK_LEAVE:3,
    /**
     * 调休假
     * @type {Number}
     */
    EVENT_LEAVE:4,
    /**
     * 婚假
     * @type {Number}
     */
    PARENTAL_LEAVE:5,
    /**
     * 产假
     * @type {Number}
     */
    MARRIAGE_LEAVE:6,
    /**
     * 陪产假
     * @type {Number}
     */
    MATERNITY_LEAVE:7,
    /**
     * 育儿假
     * @type {Number}
     */
    PATERNITY_LEAVE:8
}
export {LeaveTypeEnum}
/**
 * 显示草稿箱类型
 */
let DraftType = {
    /**
     * 文章类型
     * @type {Number}
     */
    ARTICLE_TYPE:1,
    /**
     * 随访问卷
     * @type {Number}
     */
    NURSING_QUESTIONNAIRE:2,
    /**
     * 护理问卷
     * @type {Number}
     */
    FOLLOWUP_QUESTIONNAIRE:3,
    /**
     * 电话随访问卷
     * @type {Number}
     */
    CALL_FOLLOWUP_QUESTIONNAIRE:4,
    /**
     * 电话回访问卷
     * @type {Number}
     */
    CALL_BACK_QUESTIONNAIRE:5
}
export {DraftType}
/**
 * 任务类型
 */
let OutCrashResultStatus = {
    /**
     * 未判断之前
     * @type {Number}
     */
    NO_JUDGE_BEFORE:0,
    /**
     * 平台验证不通过
     * @type {Number}
     */
    PLATFORM_NOT_PASS:1,
    /**
     * 用户余额来源不正当
     * @type {Number}
     */
    USER_CRASH_NOT_JUST:2,
    /**
     * 通过验证
     * @type {Number}
     */
    PLATFORM_PASSED_SUCCESS:3,
    /**
     * 手动通过
     * @type {Number}
     */
    MANUAL_PASSED_SUCCESS:4
}
export {OutCrashResultStatus}
/**
 * 任务类型
 */
let TaskType = {
    /**
     * 未开始
     * @type {Number}
     */
    NOT_STARTED:1,
    /**
     * 进行中
     * @type {Number}
     */
    ALREADY_STARTED:2,
    /**
     * 已结束
     * @type {Number}
     */
    FINISHED:3
}
export {TaskType}
/**
 * 随访任务状态
 */
let TaskCallCenterState = {
    /**
     * 1已创建
     * @type {Number}
     */
    TASK_STATE_CREATED:1,
    /**
     * 2进行中
     * @type {Number}
     */
    TASK_STATE_CONDUCT:2,
    /**
     * 3已结束
     * @type {Number}
     */
    TASK_STATE_END:3
}
export {TaskCallCenterState}
/**
 * 患者标签类型
 */
let LabelType = {
    /**
     * 医生添加
     * @type {Number}
     */
    DOCTOR_LABEL_TYPE:1,
    /**
     * 电话随访添加
     * @type {Number}
     */
    CALL_LABEL_TYPE:2
}
export {LabelType}
/**
 * 数据来源枚举
 */
let SdsDataSourceEnum = {
    /**
     * 医院HIS获取
     * @type {Number}
     */
    HIS:1,
    /**
     * Excel导入
     * @type {Number}
     */
    EXCEL_IMPORT:2,
    /**
     * 电话随访获取
     * @type {Number}
     */
    PHONE_FOLLOWUP:3,
    /**
     * 线上随访获取
     * @type {Number}
     */
    ONLINE_FOLLOWUP:4
}
export {SdsDataSourceEnum}
/**
 * 问卷题目分类枚举
 */
let Classification = {
    /**
     * A基本情况
     * @type {String}
     */
    A:"A",
    /**
     * B出生缺陷
     * @type {String}
     */
    B:"B",
    /**
     * C心血管疾病
     * @type {String}
     */
    C:"C",
    /**
     * D过敏性疾病
     * @type {String}
     */
    D:"D",
    /**
     * E居住环境及家庭情况
     * @type {String}
     */
    E:"E",
    /**
     * F新冠感染情况
     * @type {String}
     */
    F:"F"
}
export {Classification}
/**
 * 不纳入类型
 */
let NotIncludedType = {
    /**
     * 随访询问后填写
     * @type {Number}
     */
    FOLLOWUP_AFTER_WRITE:1,
    /**
     * 质控判断错误
     * @type {Number}
     */
    QUALITY_ERROR:2,
    /**
     * 历史信息错误
     * @type {Number}
     */
    HISTORY_INFO_ERROR:3,
    /**
     * 随访录音丢失
     * @type {Number}
     */
    LOST_RECORDING:4
}
export {NotIncludedType}
/**
 * 问卷操作日志类型
 */
let QuestionnaireOperationLogType = {
    /**
     * 日志类型-问卷
     * @type {Number}
     */
    LOG_TYPE_QUESTIONNAIRE:1,
    /**
     * 日志类型-模板
     * @type {Number}
     */
    LOG_TYPE_TEMPLATE:2
}
export {QuestionnaireOperationLogType}
/**
 * 文章状态
 */
let ArticlesStatus = {
    /**
     * 草稿
     * @type {Number}
     */
    ROUGH_DRAFT:1,
    /**
     * 待审核
     * @type {Number}
     */
    TO_BE_REVIEWED:2,
    /**
     * 审核驳回
     * @type {Number}
     */
    APPROVAL_REJECTION:3,
    /**
     * 已发布
     * @type {Number}
     */
    PUBLISHED:4,
    /**
     * 已下架
     * @type {Number}
     */
    UNDERCARRIAGE:5,
    /**
     * 待发布
     * @type {Number}
     */
    TO_BE_RELEASED:6,
    /**
     * 已撤回
     * @type {Number}
     */
    WITHDRAWN:7
}
export {ArticlesStatus}
/**
 * 支付类型
 */
let PayPlatform = {
    /**
     * 支付宝
     * @type {Number}
     */
    AliPay:1,
    /**
     * 微信支付
     * @type {Number}
     */
    WeiChatPay:2,
    /**
     * 荟医支付
     * @type {Number}
     */
    HuiyiPay:3,
    /**
     * 荟医信息-微信小程序支付
     * @type {Number}
     */
    WeiXinSmallProgram:4,
    /**
     * 熙济生物-微信小程序支付
     * @type {Number}
     */
    XiJiWeiXinSmallProgram:5,
    /**
     * 荟亨公众号支付
     * @type {Number}
     */
    HuiHengOfficialAccountPay:6
}
export {PayPlatform}
/**
 * 推送类型
 */
let PushType = {
    /**
     * 订单
     * @type {String}
     */
    Order:"order",
    /**
     * 图文咨询
     * @type {String}
     */
    Consult:"consult",
    /**
     * 随访
     * @type {String}
     */
    FollowUp:"followup",
    /**
     * 药物提醒
     * @type {String}
     */
    DrugRemind:"drugRemind",
    /**
     * 系统消息
     * @type {String}
     */
    SystemMessage:"systemMessage",
    /**
     * 一问医答下单
     * @type {String}
     */
    AskAnswersPlaceOrder:"AskAnswersPlaceOrder",
    /**
     * 社区消息
     * @type {String}
     */
    Community:"community",
    /**
     * 社区互动消息
     * @type {String}
     */
    CommunityInteraction:"communityInteraction"
}
export {PushType}
/**
 * 通过状态
 */
let PassStatus = {
    /**
     * 不通过
     * @type {Number}
     */
    NOT_PASS:1,
    /**
     * 审核中
     * @type {Number}
     */
    UNDER_REVIEW:2,
    /**
     * 审核通过
     * @type {Number}
     */
    PASSED:3
}
export {PassStatus}
/**
 * 问卷数值取值规则类型
 */
let QuestionNumericValueRuleType = {
    /**
     * 最大值
     * @type {Number}
     */
    MAXIMUM_VALUE:1,
    /**
     * 最小值
     * @type {Number}
     */
    MINIMUM_VALUE:2,
    /**
     * 中间值
     * @type {Number}
     */
    MEDIAN:3
}
export {QuestionNumericValueRuleType}
/**
 * 添加方式枚举
 */
let AddWayEnum = {
    /**
     * 录入
     * @type {Number}
     */
    ENTER:2,
    /**
     * 上传
     * @type {Number}
     */
    UPLOAD:3,
    /**
     * 任务同步
     * @type {Number}
     */
    TASK_SYNC:4
}
export {AddWayEnum}
/**
 * 患者池列表类型
 */
let PatientPoolType = {
    /**
     * 患者池所有患者列表
     * @type {Number}
     */
    ALL_LIST:1,
    /**
     * 患者池在院患者列表
     * @type {Number}
     */
    HOSPITALIZATION_LIST:2,
    /**
     * 患者池关注患者列表
     * @type {Number}
     */
    ATTENTION_LIST:3,
    /**
     * 患者池随访患者列表
     * @type {Number}
     */
    FOLLOWUP_LIST:4,
    /**
     * 患者池最近查看患者列表
     * @type {Number}
     */
    RECENTLY_LIST:5
}
export {PatientPoolType}
/**
 * 质控结果枚举
 */
let SpotCheckStateEnum = {
    /**
     * 电话抽查-不合格
     * @type {Number}
     */
    PHONE_SPOT_CHECK_FAILED:0,
    /**
     * 电话抽查-合格
     * @type {Number}
     */
    PHONE_SPOT_CHECK_SUCCESS:1,
    /**
     * 电话抽查-不合格，不需重拨
     * @type {Number}
     */
    PHONE_SPOT_CHECK_FAILED_NOT_REDIAL:2,
    /**
     * 电话抽查-不合格，需重拨
     * @type {Number}
     */
    PHONE_SPOT_CHECK_FAILED_REDIAL:3,
    /**
     * 电话抽查-不合格，其他
     * @type {Number}
     */
    PHONE_SPOT_CHECK_FAILED_OTHER:4,
    /**
     * 线上抽查-合格
     * @type {Number}
     */
    ONLINE_SPOT_CHECK_SUCCESS:5,
    /**
     * 线上抽查-不合格，不需重拨
     * @type {Number}
     */
    ONLINE_SPOT_CHECK_FAILED_NOT_REDIAL:6,
    /**
     * 线上抽查-不合格，需重拨
     * @type {Number}
     */
    ONLINE_SPOT_CHECK_FAILED_REDIAL:7
}
export {SpotCheckStateEnum}
/**
 * 问卷数值类型
 */
let QuestionNumericType = {
    /**
     * 时间点
     * @type {Number}
     */
    TIME_POINT:1,
    /**
     * 数值
     * @type {Number}
     */
    NUMERIC:2
}
export {QuestionNumericType}
/**
 * 宣教类型
 */
let PropagandaEducationType = {
    /**
     * 宣教-入院宣教
     * @type {Number}
     */
    PROPAGANDA_EDUCATION_HOSPITALIZED:1,
    /**
     * 宣教-术前宣教
     * @type {Number}
     */
    PROPAGANDA_EDUCATION_PREOPERATIVE:2,
    /**
     * 宣教-术后宣教
     * @type {Number}
     */
    PROPAGANDA_EDUCATION_POSTOPERATIVE:3,
    /**
     * 宣教-出院宣教
     * @type {Number}
     */
    PROPAGANDA_EDUCATION_LEAVE_HOSPITAL:4,
    /**
     * 宣教-随访宣教
     * @type {Number}
     */
    PROPAGANDA_EDUCATION_FOLLOWUP:5
}
export {PropagandaEducationType}
/**
 * 消息平台id
 */
let MessagePlatformId = {
    /**
     * 患者app
     * @type {String}
     */
    APP_PATIENT:"1",
    /**
     * 医生app
     * @type {String}
     */
    APP_DOCTOR:"2",
    /**
     * 管理台pc
     * @type {String}
     */
    PC_MANAGE:"3",
    /**
     * 呼叫中心pc
     * @type {String}
     */
    PC_CALL_CENTER:"4",
    /**
     * 外部质控pc
     * @type {String}
     */
    PC_EXTERNAL:"5"
}
export {MessagePlatformId}
/**
 * 优惠券状态
 */
let CouponStatus = {
    /**
     * 已使用
     * @type {Number}
     */
    USED:1,
    /**
     * 正常状态
     * @type {Number}
     */
    NORMAL:0
}
export {CouponStatus}
/**
 * 服药提醒推送Extra
 */
let PushRemindExtra = {
    /**
     * 详细参数类型
     * @type {String}
     */
    REMINDS:"reminds",
    /**
     * 标题
     * @type {String}
     */
    TITLE:"title"
}
export {PushRemindExtra}
/**
 * 接听状态：1呼出，2呼入
 */
let AnswerType = {
    /**
     * 1呼出
     * @type {Number}
     */
    ANSWER_CALL_OUT:1,
    /**
     * 2呼入
     * @type {Number}
     */
    ANSWER_INCOMING_CALL:2,
    /**
     * 3App完成随访
     * @type {Number}
     */
    APP_FOLLOWUP_COMPLETE:3
}
export {AnswerType}
/**
 * 联系状态
 */
let ContactStatusEnum = {
    /**
     * 初始化
     * @type {Number}
     */
    CONTACT_STATUS_INITIALIZATION:1,
    /**
     * 稍后拨打
     * @type {Number}
     */
    CONTACT_STATUS_CALL_LATER:2,
    /**
     * 电话随访成功
     * @type {Number}
     */
    CONTACT_STATUS_TELEPHONE_FOLLOWUP_SUCCESS:3,
    /**
     * 电话随访未成功
     * @type {Number}
     */
    CONTACT_STATUS_TELEPHONE_FOLLOWUP_UNSUCCESSFUL:4
}
export {ContactStatusEnum}
/**
 * 平台枚举
 */
let PlatformEnum = {
    /**
     * 管理台
     * @type {Number}
     */
    MANAGER:0,
    /**
     * 监管台
     * @type {Number}
     */
    EXTERNAL:1,
    /**
     * 呼叫台
     * @type {Number}
     */
    CALL_CENTER:2
}
export {PlatformEnum}
/**
 * 核医学筛选类型
 */
let NMScreenType = {
    /**
     * 核医学筛选类型 1：待确认
     * @type {Number}
     */
    NM_SCREEN_TO_BE_CONFIRMED:1,
    /**
     * 核医学筛选类型 2：已确认
     * @type {Number}
     */
    NM_SCREEN_CONFIRMED:2
}
export {NMScreenType}
/**
 * 问卷状态
 */
let QuestionnaireState = {
    /**
     * 问卷状态-已创建
     * @type {Number}
     */
    QUESTIONNAIRE_STATE_CREATE:1,
    /**
     * 问卷状态-编辑中
     * @type {Number}
     */
    QUESTIONNAIRE_STATE_EDITING:2,
    /**
     * 问卷状态-已发布
     * @type {Number}
     */
    QUESTIONNAIRE_STATE_PUBLISHED:3,
    /**
     * 问卷状态-已审核
     * @type {Number}
     */
    QUESTIONNAIRE_STATE_REVIEWED:4,
    /**
     * 问卷状态-已关闭
     * @type {Number}
     */
    QUESTIONNAIRE_STATE_CLOSED:5,
    /**
     * 问卷状态-已删除
     * @type {Number}
     */
    QUESTIONNAIRE_STATE_DELETE:6
}
export {QuestionnaireState}
/**
 * 对接患者分配状态
 */
let AbutmentPatientAllocationStateType = {
    /**
     * 待分配
     * @type {Number}
     */
    UNASSIGNED:1,
    /**
     * 随访中
     * @type {Number}
     */
    ASSIGNED:2,
    /**
     * 失败/错误
     * @type {Number}
     */
    ASSIGN_FAIL_ERROR:4,
    /**
     * 失败/重复
     * @type {Number}
     */
    ASSIGN_FAIL_REPEAT:5,
    /**
     * 失败/异常
     * @type {Number}
     */
    ASSIGN_FAIL_EXCEPTION:6,
    /**
     * 电话随访成功
     * @type {Number}
     */
    CALL_FOLLOWUP_SUCCESS:7,
    /**
     * 失访
     * @type {Number}
     */
    LOST_VISITS:8,
    /**
     * 拒随
     * @type {Number}
     */
    REFUSE_FOLLOWUP:9,
    /**
     * 异常名单
     * @type {Number}
     */
    EXCEPTION_LIST:10
}
export {AbutmentPatientAllocationStateType}
/**
 * 随访配合度：上线完成随访5分，短信完成随访4分，电话完成随访3分，失访2分，拒绝随访1分，死亡0分
 */
let FollowupCoordination = {
    /**
     * 死亡0分
     * @type {Number}
     */
    DEATH_COORDINATION:0,
    /**
     * 拒绝随访1分
     * @type {Number}
     */
    REFUSE_FOLLOWUP_COORDINATION:1,
    /**
     * 失访2分
     * @type {Number}
     */
    LOST_VISIT_COORDINATION:2,
    /**
     * 电话完成随访3分
     * @type {Number}
     */
    CALL_FOLLOWUP_COMPLETE:3,
    /**
     * 短信完成随访4分
     * @type {Number}
     */
    SMS_FOLLOWUP_COMPLETE:4,
    /**
     * 上线完成随访5分
     * @type {Number}
     */
    LINE_FOLLOWUP_COMPLETE:5
}
export {FollowupCoordination}
/**
 * 问卷类型
 */
let QuestionnaireKind = {
    /**
     * 护理问卷
     * @type {Number}
     */
    NURSING_QUESTIONNAIRE:1,
    /**
     * 随访问卷
     * @type {Number}
     */
    FOLLOWUP_QUESTIONNAIRE:2,
    /**
     * 入院问卷
     * @type {Number}
     */
    ADMISSION_QUESTIONNAIRE:3,
    /**
     * 电话随访问卷
     * @type {Number}
     */
    CALL_FOLLOWUP_QUESTIONNAIRE:4,
    /**
     * 电话回访问卷
     * @type {Number}
     */
    CALL_BACK_QUESTIONNAIRE:5,
    /**
     * 药物问卷
     * @type {Number}
     */
    MEDICINE_QUESTIONNAIRE:6,
    /**
     * 生活质量调查问卷
     * @type {Number}
     */
    QUALITY_LIFE_QUESTIONNAIRE:7,
    /**
     * 满意度调查问卷
     * @type {Number}
     */
    SATISFACTION_DEGREE_QUESTIONNAIRE:8
}
export {QuestionnaireKind}
/**
 * 呼叫类型
 */
let CallType = {
    /**
     * 1电话随访
     * @type {Number}
     */
    CALL_TYPE_FOLLOWUP:1,
    /**
     * 2电话通知
     * @type {Number}
     */
    CALL_TYPE_NOTICE:2,
    /**
     * 3电话回访
     * @type {Number}
     */
    CALL_TYPE_RETURN_VISIT:3,
    /**
     * APP转电话随访
     * @type {Number}
     */
    CALL_TYPE_APP_TURN_CALL_FOLLOWUP:4
}
export {CallType}
/**
 * 好物推荐来源
 */
let GoodsRecommendSource = {
    /**
     * 管理台
     * @type {Number}
     */
    MANAGER:1,
    /**
     * 小程序
     * @type {Number}
     */
    APPLET:2
}
export {GoodsRecommendSource}
/**
 * 质控角色
 */
let SpotCheckRole = {
    /**
     * 内部质控
     * @type {Number}
     */
    INNER_SPOT_CHECK:0,
    /**
     * 外部质控
     * @type {Number}
     */
    OUT_SPOT_CHECK:1,
    /**
     * 呼叫平台质控
     * @type {Number}
     */
    CALL_CENTER_SPOT_CHECK:2,
    /**
     * 其它
     * @type {Number}
     */
    OTHER_SPOT_CHECK:3
}
export {SpotCheckRole}
/**
 * 信息终端类型
 */
let MessageTerminalTypeEnum = {
    /**
     * 患者app
     * @type {Number}
     */
    PATIENT_APP:1,
    /**
     * 医生app
     * @type {Number}
     */
    DOCTOR_APP:2,
    /**
     * 管理台
     * @type {Number}
     */
    MANAGER:3,
    /**
     * 呼叫台
     * @type {Number}
     */
    CALL_CENTER:4,
    /**
     * 监管台
     * @type {Number}
     */
    EXTERNAL:5
}
export {MessageTerminalTypeEnum}
/**
 * 跳转类型
 */
let JumpTypeEnum = {
    /**
     * 跳转类型 1:实验室
     * @type {Number}
     */
    LAB:1,
    /**
     * 跳转类型 2:影像
     * @type {Number}
     */
    IMAGE:2,
    /**
     * 跳转类型 3:治疗
     * @type {Number}
     */
    TREATMENT:3
}
export {JumpTypeEnum}
/**
 * 病情状态
 */
let StateOfIllnessEnum = {
    /**
     * 复发
     * @type {Number}
     */
    RELAPSE:1,
    /**
     * 转移
     * @type {Number}
     */
    TRANSFER:2,
    /**
     * 平稳
     * @type {Number}
     */
    STABLE:3,
    /**
     * 复发+转移
     * @type {Number}
     */
    RELAPSE_TRANSFER:4
}
export {StateOfIllnessEnum}
/**
 * 风险等级
 */
let RiskLevelType = {
    /**
     * 低
     * @type {String}
     */
    RISK_LEVEL_LOW:"低",
    /**
     * 中
     * @type {String}
     */
    RISK_LEVEL_IN:"中",
    /**
     * 高
     * @type {String}
     */
    RISK_LEVEL_HIGH:"高"
}
export {RiskLevelType}
/**
 * 交易状态
 */
let OrderStatus = {
    /**
     * 已下单
     * @type {Number}
     */
    AlreadyOrdered:0,
    /**
     * 已确认收货
     * @type {Number}
     */
    AlreadyReceived:3,
    /**
     * 已支付
     * @type {Number}
     */
    AlreadyPaid:1,
    /**
     * 已接单
     * @type {Number}
     */
    AcceptedOrder:2,
    /**
     * 售后中
     * @type {Number}
     */
    InAfterSale:4,
    /**
     * 待评价
     * @type {Number}
     */
    PendingReview:5,
    /**
     * 已评价
     * @type {Number}
     */
    AlreadyReviewed:6,
    /**
     * 套餐完成
     * @type {Number}
     */
    PackageComplete:7,
    /**
     * 已取消
     * @type {Number}
     */
    AlreadyCancel:101,
    /**
     * 已退款
     * @type {Number}
     */
    AlreadyRefunded:102,
    /**
     * 已售后处理
     * @type {Number}
     */
    AlreadyAfterSale:103
}
export {OrderStatus}
/**
 * 新专病库数据同步类型
 */
let ZbrAsyncTypeEnum = {
    /**
     * 上传随访名单
     * @type {Number}
     */
    UPLOAD_LIST:1,
    /**
     * 上传参考信息
     * @type {Number}
     */
    UPLOAD_REFERENCE_INFO:2,
    /**
     * 呼叫记录
     * @type {Number}
     */
    CALL_RECORDS:3,
    /**
     * 随访完成
     * @type {Number}
     */
    FOLLOWUP_COMPLETE:4,
    /**
     * 质控信息
     * @type {Number}
     */
    QUALITY_CONTROL:5,
    /**
     * 新增联系方式
     * @type {Number}
     */
    ADD_CONTACT_INFO:6,
    /**
     * 随访新推送
     * @type {Number}
     */
    FOLLOWUP_NEW_COMPLETE:7,
    /**
     * APP随访登记推送
     * @type {Number}
     */
    APP_FOLLOWUP_REGISTRATION:8,
    /**
     * 录音呼叫记录同步
     * @type {Number}
     */
    RECORDING_CALL_RECORDS:9,
    /**
     * 患者上传报告记录同步
     * @type {Number}
     */
    PATIENT_UPLOAD_REPORT:10,
    /**
     * 线上随访上传报告
     * @type {Number}
     */
    ONLINE_FOLLOW_UPLOAD_REPORT:11
}
export {ZbrAsyncTypeEnum}
/**
 * 宣教发布类型
 */
let PropagandaEducationIssueStatusType = {
    /**
     * 宣教操作类型-待发布
     * @type {Number}
     */
    ISSUE_STATUS_TO_BE_RELEASED:1,
    /**
     * 宣教操作类型-发布
     * @type {Number}
     */
    ISSUE_STATUS_RELEASED:2,
    /**
     * 宣教操作类型-撤回
     * @type {Number}
     */
    ISSUE_STATUS_WITHDRAW:3
}
export {PropagandaEducationIssueStatusType}
/**
 * 随访方式类型：1无特殊要求，2仅电话随访
 */
let FollowupModeType = {
    /**
     * 无特殊要求
     * @type {Number}
     */
    FOLLOWUP_MODE_NO_SPECIAL:1,
    /**
     * 仅电话随访
     * @type {Number}
     */
    FOLLOWUP_MODE_TELEPHONE_ONLY:2
}
export {FollowupModeType}
/**
 * 账务物品类型
 */
let AccountItemType = {
    /**
     * 优惠券
     * @type {Number}
     */
    Coupon:1,
    /**
     * 积分
     * @type {Number}
     */
    Integral:2,
    /**
     * 钱
     * @type {Number}
     */
    Money:3
}
export {AccountItemType}
/**
 * 服药记录表服药状态
 */
let DrugRecordingTaskState = {
    /**
     * 服药状态 ：已服
     * @type {Number}
     */
    DrugRecording_Task_State_Yes:1,
    /**
     * 服药状态 ：未服
     * @type {Number}
     */
    DrugRecording_Task_State_No:2,
    /**
     * 服药状态 ：逾期
     * @type {Number}
     */
    DrugRecording_Task_State_Over:3
}
export {DrugRecordingTaskState}
/**
 * 问题类型枚举
 */
let QuestionTypeEnum = {
    /**
     * 单选
     * @type {Number}
     */
    RADIO:1,
    /**
     * 多选
     * @type {Number}
     */
    MULTIPLE_CHOICE:2,
    /**
     * 下拉
     * @type {Number}
     */
    DROPDOWN:3,
    /**
     * 填空
     * @type {Number}
     */
    FILL_IN_THE_BLANKS:4,
    /**
     * 多项填空
     * @type {Number}
     */
    MULTIPLE_BLANK_FILLING:5,
    /**
     * 段落说明
     * @type {Number}
     */
    PARAGRAPH_DESC:6,
    /**
     * （备注缺失，暂不使用
     * @type {Number}
     */
    NOTES:7,
    /**
     * 时间
     * @type {Number}
     */
    TIME:8,
    /**
     * 标量
     * @type {Number}
     */
    SCALAR:9
}
export {QuestionTypeEnum}
/**
 * 搜索类型
 */
let SearchType = {
    /**
     * 医生端主页搜索
     * @type {Number}
     */
    doctor_point:1,
    /**
     * 患者端搜索
     * @type {Number}
     */
    patient_point:2,
    /**
     * 搜索患者
     * @type {Number}
     */
    patient:3,
    /**
     * 搜索用户
     * @type {Number}
     */
    user:4,
    /**
     * 搜索文章
     * @type {Number}
     */
    article:5,
    /**
     * 搜索分答
     * @type {Number}
     */
    problem:6,
    /**
     * 患者池搜索
     * @type {Number}
     */
    patient_pool:7,
    /**
     * 联系人搜索
     * @type {Number}
     */
    contacts:8
}
export {SearchType}
/**
 * 订单状态
 */
let ResOrderStatus = {
    /**
     * 待支付、审核中
     * @type {Number}
     */
    WaitPaid:1,
    /**
     * 已支付、待发货、处理中
     * @type {Number}
     */
    AlreadyPaid:2,
    /**
     * 申请退款
     * @type {Number}
     */
    Refunded:3,
    /**
     * 已取消
     * @type {Number}
     */
    AlreadyCancel:4,
    /**
     * 已退款
     * @type {Number}
     */
    AlreadyRefunded:5,
    /**
     * 已完成
     * @type {Number}
     */
    AlreadyFinish:6,
    /**
     * 审核未通过
     * @type {Number}
     */
    FailedReview:7,
    /**
     * 审核已通过
     * @type {Number}
     */
    PassReview:8,
    /**
     * 已发货
     * @type {Number}
     */
    Delivered:9,
    /**
     * 已关闭
     * @type {Number}
     */
    Close:10
}
export {ResOrderStatus}
/**
 * 日志类型错误类型
 */
let AbutmentPatientLogType = {
    /**
     * 添加电话号码错误
     * @type {Number}
     */
    ERROR_ONE:1,
    /**
     * 上传文件失败
     * @type {Number}
     */
    ERROR_TWO:2,
    /**
     * 上传问卷失败
     * @type {Number}
     */
    ERROR_THREE:3,
    /**
     * 上传录音失败
     * @type {Number}
     */
    ERROR_FOUR:4,
    /**
     * 录音下载失败
     * @type {Number}
     */
    ERROR_FIVE:5,
    /**
     * 患者code错误
     * @type {Number}
     */
    ERROR_SIX:6,
    /**
     * 推送失败
     * @type {Number}
     */
    ERROR_SEVEN:7,
    /**
     * ftp操作失败
     * @type {Number}
     */
    ERROR_EIGHT:8,
    /**
     * ftp连接关闭失败
     * @type {Number}
     */
    ERROR_NINE:9
}
export {AbutmentPatientLogType}
/**
 * 发布状态
 */
let PublishStatus = {
    /**
     * 待发布
     * @type {Number}
     */
    WAIT_PUBLISH:1,
    /**
     * 已发布
     * @type {Number}
     */
    PUBLISHED:2,
    /**
     * 撤回
     * @type {Number}
     */
    WITHDRAW:3
}
export {PublishStatus}
/**
 * 审核未通过的原因状态
 */
let ReturnReasonStatus = {
    /**
     * 委托书未通过
     * @type {Number}
     */
    CommissionFailed:1,
    /**
     * 身份证未通过
     * @type {Number}
     */
    IDFailed:2,
    /**
     * 身份证和委托书都未通过
     * @type {Number}
     */
    CommissionAndIDFailed:3
}
export {ReturnReasonStatus}
/**
 * 投票内容类型
 */
let VoteContentType = {
    /**
     * 列表
     * @type {Number}
     */
    LIST:0,
    /**
     * 问题
     * @type {Number}
     */
    QUESTION:1,
    /**
     * 文章
     * @type {Number}
     */
    ARTICLE:2,
    /**
     * 好物推荐
     * @type {Number}
     */
    GOODS_RECOMMEND:3
}
export {VoteContentType}
/**
 * 指标类型
 */
let QuotaType = {
    /**
     * 电话随访成功+失访+旧数据（原拒随）
     * @type {Number}
     */
    PHONE_FOLLOWUP_SUCCESS_LOST_REFUSE:1,
    /**
     * 电话随访成功
     * @type {Number}
     */
    PHONE_FOLLOWUP_SUCCESS:2,
    /**
     * 失访
     * @type {Number}
     */
    LOST:3,
    /**
     * 旧数据（原拒随）
     * @type {Number}
     */
    REFUSE:4,
    /**
     * 电话随访成功+失访
     * @type {Number}
     */
    PHONE_FOLLOWUP_SUCCESS_LOST:5,
    /**
     * 电话随访成功+旧数据（原拒随）
     * @type {Number}
     */
    PHONE_FOLLOWUP_SUCCESS_REFUSE:6,
    /**
     * 失访+旧数据（原拒随）
     * @type {Number}
     */
    LOST_REFUSE:7,
    /**
     * 呼叫人数
     * @type {Number}
     */
    CALL_NUMBER:8,
    /**
     * 异常随访成功
     * @type {Number}
     */
    EXCEPTION_FOLLOWUP_SUCCESS:9,
    /**
     * 异常呼叫人数
     * @type {Number}
     */
    EXCEPTION_CALL_NUMBER:10,
    /**
     * 特殊指标
     * @type {Number}
     */
    SPECIAL:11,
    /**
     * 沟通不畅
     * @type {Number}
     */
    UPC:12,
    /**
     * 拒绝随访（有信息）
     * @type {Number}
     */
    URHI:13,
    /**
     * 拒绝随访（无信息）
     * @type {Number}
     */
    URNHI:14,
    /**
     * 沟通不畅+电话随访成功
     * @type {Number}
     */
    UPC_PFS:15,
    /**
     * 沟通不畅+失访
     * @type {Number}
     */
    UPC_LOST:16,
    /**
     * 沟通不畅+拒绝随访（有信息）
     * @type {Number}
     */
    UPC_URHI:17,
    /**
     * 沟通不畅+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_URNHI:18,
    /**
     * 拒绝随访（有信息）+电话随访成功
     * @type {Number}
     */
    URHI_PFS:19,
    /**
     * 拒绝随访（有信息）+失访
     * @type {Number}
     */
    URHI_LOST:20,
    /**
     * 拒绝随访（有信息）+拒绝随访（无信息）
     * @type {Number}
     */
    URHI_URNHI:21,
    /**
     * 拒绝随访（无信息）+电话随访成功
     * @type {Number}
     */
    URNHI_PFS:22,
    /**
     * 拒绝随访（无信息）+失访
     * @type {Number}
     */
    URNHI_LOST:23,
    /**
     * 沟通不畅+电话随访成功+失访
     * @type {Number}
     */
    UPC_PFS_LOST:24,
    /**
     * 沟通不畅+电话随访成功+拒绝随访（有信息）
     * @type {Number}
     */
    UPC_PFS_URHI:25,
    /**
     * 沟通不畅+电话随访成功+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_PFS_URNHI:26,
    /**
     * 沟通不畅+失访+拒绝随访（有信息）
     * @type {Number}
     */
    UPC_LOST_URHI:27,
    /**
     * 沟通不畅+失访+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_LOST_URNHI:28,
    /**
     * 沟通不畅+拒绝随访（有信息）+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_URHI_URNHI:29,
    /**
     * 拒绝随访（有信息）+电话随访成功+失访
     * @type {Number}
     */
    URHI_PFS_LOST:30,
    /**
     * 拒绝随访（有信息）+电话随访成功+拒绝随访（无信息）
     * @type {Number}
     */
    URHI_PFS_URNHI:31,
    /**
     * 拒绝随访（无信息）+电话随访成功+失访
     * @type {Number}
     */
    URNHI_PFS_LOST:32,
    /**
     * 沟通不畅+电话随访成功+失访+拒绝随访（有信息）
     * @type {Number}
     */
    UPC_PFS_LOST_URHI:33,
    /**
     * 沟通不畅+电话随访成功+失访+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_PFS_LOST_URNHI:34,
    /**
     * 沟通不畅+电话随访成功+拒绝随访（有信息）+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_PFS_URHI_URNHI:35,
    /**
     * 沟通不畅+失访+拒绝随访（有信息）+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_LOST_URHI_URNHI:36,
    /**
     * 拒绝随访（有信息）+电话随访成功+失访+拒绝随访（无信息）
     * @type {Number}
     */
    URHI_UPC_LOST_URNHI:37,
    /**
     * 沟通不畅+电话随访成功+失访+拒绝随访（有信息）+拒绝随访（无信息）
     * @type {Number}
     */
    UPC_PFS_LOST_URHI_URNHI:38
}
export {QuotaType}
/**
 * 交付备注日期地理题选择
 */
let SelectTypeStatus = {
    /**
     * 年月日时分
     * @type {Number}
     */
    YEAR_MONTH_DAY_HOUR_MINUTE:1,
    /**
     * 年月日
     * @type {Number}
     */
    YEAR_MONTH_DAY:2,
    /**
     * 年月
     * @type {Number}
     */
    YEAR_MONTH:3,
    /**
     * 时分
     * @type {Number}
     */
    HOUR_MINUTE:4,
    /**
     * 省市
     * @type {Number}
     */
    PROVINCE_CITY:5,
    /**
     * 省市区
     * @type {Number}
     */
    PROVINCE_MUNICIPALITIES:6,
    /**
     * 省市区街道
     * @type {Number}
     */
    PROVINCE_DISTRICT_STREET:7,
    /**
     * 省市区街道详细地址
     * @type {Number}
     */
    DETAILED_ADDRESS:8
}
export {SelectTypeStatus}
/**
 * 提现状态
 */
let CashType = {
    /**
     * 审核中
     * @type {Number}
     */
    Auditing:15,
    /**
     * 审核未通过
     * @type {Number}
     */
    AuditFailure:16,
    /**
     * 提现成功
     * @type {Number}
     */
    AuditSuccess:17
}
export {CashType}
/**
 * 编号枚举
 */
let EditNumberEnum = {
    /**
     * 修改清洗答案
     * @type {Number}
     */
    UPDATE_CLEAN_ANSWER:1,
    /**
     * 修改问卷答案
     * @type {Number}
     */
    UPDATE_QUESTIONNAIRE_ANSWER:2,
    /**
     * 两种答案都修改
     * @type {Number}
     */
    UPDATE_ALL_ANSWER:3,
    /**
     * 修改并新增清洗答案
     * @type {Number}
     */
    UPDATE_ADD_CLEAN_ANSWER:4,
    /**
     * 修改并新增问卷答案
     * @type {Number}
     */
    UPDATE_ADD_QUESTIONNAIRE_ANSWER:5,
    /**
     * 两种答案都修改并新增
     * @type {Number}
     */
    UPDATE_ADD_ALL_ANSWER:6
}
export {EditNumberEnum}
/**
 * 就诊类型筛选
 */
let MedicalRecordScreenType = {
    /**
     * 就诊类型筛选 ：门诊
     * @type {Number}
     */
    MEDICAL_RECORD_SCREEN__M:0,
    /**
     * 就诊类型筛选 ：住院
     * @type {Number}
     */
    MEDICAL_RECORD_SCREEN__Z:1,
    /**
     * 就诊类型筛选 ：体检
     * @type {Number}
     */
    MEDICAL_RECORD_SCREEN__T:2
}
export {MedicalRecordScreenType}
/**
 * 坐席任务操作类型
 */
let PeopleTaskOperatorType = {
    /**
     * 新手保护
     * @type {Number}
     */
    NOVICE_PROTECTION:1,
    /**
     * 上限配置
     * @type {Number}
     */
    LIMIT_CONFIG:2
}
export {PeopleTaskOperatorType}
/**
 * 服务对应的操作名字
 */
let LogServiceToName = {
    /**
     * 商城订单操作
     * @type {String}
     */
    ShopOrderService:"ShopOrderService",
    /**
     * 文章操作
     * @type {String}
     */
    ArticleLibraryService:"ArticleLibraryService",
    /**
     * 文章内容分类操作
     * @type {String}
     */
    ContentKindService:"ContentKindService",
    /**
     * 复印病史订单操作
     * @type {String}
     */
    CopyHistoryOrderService:"CopyHistoryOrderService",
    /**
     * 病灶部位操作
     * @type {String}
     */
    DeptFocusService:"DeptFocusService",
    /**
     * 疾病操作
     * @type {String}
     */
    DiseaseService:"DiseaseService",
    /**
     * 医生管理操作
     * @type {String}
     */
    DoctorManagerService:"DoctorManagerService",
    /**
     * 草稿箱操作
     * @type {String}
     */
    DraftService:"DraftService",
    /**
     * 病灶操作
     * @type {String}
     */
    FocusService:"FocusService",
    /**
     * 医院科室操作
     * @type {String}
     */
    HospitalServcie:"HospitalServcie",
    /**
     * 登录操作
     * @type {String}
     */
    LoginService:"LoginService",
    /**
     * 商城商品操作
     * @type {String}
     */
    MallManagerService:"MallManagerService",
    /**
     * 用户管理操作
     * @type {String}
     */
    ManagerUserService:"ManagerUserService",
    /**
     * 随访用户管理操作
     * @type {String}
     */
    ManagerUserServiceFollowup:"ManagerUserServiceFollowup",
    /**
     * 模块路由操作
     * @type {String}
     */
    ModuleService:"ModuleService",
    /**
     * 日志操作
     * @type {String}
     */
    OperationService:"OperationService",
    /**
     * 问卷操作
     * @type {String}
     */
    QuestionnaireLibraryService:"QuestionnaireLibraryService",
    /**
     * 分答操作
     * @type {String}
     */
    ReplyService:"ReplyService",
    /**
     * 角色操作
     * @type {String}
     */
    RoleService:"RoleService",
    /**
     * 随访角色操作
     * @type {String}
     */
    RoleServiceFollowup:"RoleServiceFollowup",
    /**
     * 手术方式分类操作
     * @type {String}
     */
    SurgeryApproachKind:"SurgeryApproachKind",
    /**
     * 电话随访任务中心
     * @type {String}
     */
    CallTaskCenterService:"CallTaskCenterService",
    /**
     * 电话随访用户管理
     * @type {String}
     */
    CallUserService:"CallUserService",
    /**
     * 电话随访用户管理
     * @type {String}
     */
    StatisticsManagerService:"StatisticsManagerService",
    /**
     * 患者管理
     * @type {String}
     */
    ManagerPatientService:"ManagerPatientService",
    /**
     * 科室管理
     * @type {String}
     */
    DepartmentManagerService:"DepartmentManagerService",
    /**
     * 医院管理
     * @type {String}
     */
    HospitalManagerService:"HospitalManagerService",
    /**
     * 系统服务
     * @type {String}
     */
    SystemManagerService:"SystemManagerService",
    /**
     * 样本库服务
     * @type {String}
     */
    SampleLibraryManagerService:"SampleLibraryManagerService",
    /**
     * banner服务
     * @type {String}
     */
    HomePngService:"HomePngService",
    /**
     * banner服务
     * @type {String}
     */
    ExportExcelService:"ExportExcelService",
    /**
     * 导入骨科服务
     * @type {String}
     */
    FollowupImportService:"FollowupImportService",
    /**
     * 新问卷服务
     * @type {String}
     */
    NewQuestionnaireService:"NewQuestionnaireService",
    /**
     * 交付模板服务
     * @type {String}
     */
    DeliverTemplateService:"DeliverTemplateService",
    /**
     * 线上随访患者服务
     * @type {String}
     */
    LineFollowPatientService:"LineFollowPatientService",
    /**
     * 短信模板服务
     * @type {String}
     */
    SMSTemplateService:"SMSTemplateService",
    /**
     * 内部质控详情服务
     * @type {String}
     */
    InternalQualityControlDetailsService:"InternalQualityControlDetailsService",
    /**
     * 管理台内部接口
     * @type {String}
     */
    ManagerInService:"ManagerInService",
    /**
     * 强迫症超管服务
     * @type {String}
     */
    PCObsessionManagerService:"PCObsessionManagerService",
    /**
     * 消息管理服务
     * @type {String}
     */
    MessageService:"MessageService",
    /**
     * 质控
     * @type {String}
     */
    FollowUpQualityControlManagerService:"FollowUpQualityControlManagerService",
    /**
     * 备注
     * @type {String}
     */
    FollowUpTaskTagsService:"FollowUpTaskTagsService"
}
export {LogServiceToName}
/**
 * 坐席任务操作内容
 */
let PeopleTaskOperatorContentEnum = {
    /**
     * 加入新手保护
     * @type {Number}
     */
    ADD_NOVICE_PROTECTION:1,
    /**
     * 移除新手保护
     * @type {Number}
     */
    REMOVE_NOVICE_PROTECTION:2,
    /**
     * 重置新手保护
     * @type {Number}
     */
    RESET_NOVICE_PROTECTION:3,
    /**
     * 修改新手保护
     * @type {Number}
     */
    UPDATE_NOVICE_PROTECTION:4,
    /**
     * 修改异常上限
     * @type {Number}
     */
    UPDATE_EXCEPTION_LIMIT:5,
    /**
     * 修改稍后拨打上限
     * @type {Number}
     */
    UPDATE_LATER_LIMIT:6
}
export {PeopleTaskOperatorContentEnum}
/**
 * 薪资公式类型
 */
let SalaryFormulaType = {
    /**
     * 总时长薪资
     * @type {Number}
     */
    TOTAL_TIME_SALARY:1,
    /**
     * 出勤薪资
     * @type {Number}
     */
    ATTENDANCE_SALARY:2,
    /**
     * 培训薪资
     * @type {Number}
     */
    STUDY_SALARY:3,
    /**
     * 介绍奖励
     * @type {Number}
     */
    INTRODUCE_REWARD:4,
    /**
     * 不合格扣除
     * @type {Number}
     */
    UNQUALIFIED_DEDUCT:5
}
export {SalaryFormulaType}
/**
 * 审核目标类型
 */
let ReviewTargetType = {
    /**
     * 文章
     * @type {Number}
     */
    ARTICLES:1,
    /**
     * 问题
     * @type {Number}
     */
    QUESTION:2,
    /**
     * 答案
     * @type {Number}
     */
    ANSWER:3,
    /**
     * 帮助/反馈
     * @type {Number}
     */
    HELP_FEEDBACK:4,
    /**
     * 解决方案
     * @type {Number}
     */
    SOLUTION:5,
    /**
     * 代理处理
     * @type {Number}
     */
    AGENT_HANDLER:6,
    /**
     * 好物推荐
     * @type {Number}
     */
    GOODS_RECOMMEND:7,
    /**
     * 商品评价
     * @type {Number}
     */
    GOODS_COMMENT:8,
    /**
     * 患者圈文章
     * @type {Number}
     */
    PATIENT_CIRCLE_ARTICLE:9
}
export {ReviewTargetType}
/**
 * 联系情况
 */
let ContactInformationEnum = {
    /**
     * 初始化
     * @type {Number}
     */
    CONTACT_INFORMATION_INITIALIZATION:11,
    /**
     * 沟通顺畅
     * @type {Number}
     */
    CONTACT_INFORMATION_SMOOTH_COMMUNICATION:12,
    /**
     * 拒绝随访
     * @type {Number}
     */
    CONTACT_INFORMATION_REFUSE:13,
    /**
     * 沟通不畅
     * @type {Number}
     */
    CONTACT_INFORMATION_POOR_COMMUNICATION:14,
    /**
     * 错号
     * @type {Number}
     */
    CONTACT_INFORMATION_WRONG_NUMBER:15,
    /**
     * 不知情
     * @type {Number}
     */
    CONTACT_INFORMATION_INNOCENTLY:16,
    /**
     * 无
     * @type {Number}
     */
    CONTACT_INFORMATION_NONE:18,
    /**
     * 空号
     * @type {Number}
     */
    CONTACT_INFORMATION_EMPTY_NUMBER:19,
    /**
     * 停机
     * @type {Number}
     */
    CONTACT_INFORMATION_SHUTDOWN:20,
    /**
     * 关机
     * @type {Number}
     */
    CONTACT_INFORMATION_POWER_OFF:21
}
export {ContactInformationEnum}
/**
 * 物品组
 */
let GoodsGroupType = {
    /**
     * 病史复印
     * @type {Number}
     */
    Copy:1,
    /**
     * 咨询
     * @type {Number}
     */
    Consultation:2,
    /**
     * 邮费
     * @type {Number}
     */
    Postage:3,
    /**
     * 分答
     * @type {Number}
     */
    Reply:4,
    /**
     * 荟医商城
     * @type {Number}
     */
    Mall:5,
    /**
     * 一问医答
     * @type {Number}
     */
    Ask_Answers:6
}
export {GoodsGroupType}
/**
 * 渠道类型枚举
 */
let ChannelTypeEnum = {
    /**
     * app
     * @type {Number}
     */
    APP:1,
    /**
     * 小程序
     * @type {Number}
     */
    APPLET:2,
    /**
     * 公众号
     * @type {Number}
     */
    OFFICIAL_ACCOUNT:3
}
export {ChannelTypeEnum}
/**
 * 新随访类型
 */
let NewFollowupType = {
    /**
     * 短信电话随访
     * @type {Number}
     */
    SMS_CALL_FOLLOWUP:11,
    /**
     * 电话随访
     * @type {Number}
     */
    TELEPHONE_FOLLOWUP:12,
    /**
     * 线上随访
     * @type {Number}
     */
    ON_LINE_FOLLOWUP:21,
    /**
     * 无
     * @type {Number}
     */
    NOTHING:22
}
export {NewFollowupType}
/**
 * 样本类型
 */
let SampleType = {
    /**
     * 癌组织
     * @type {Number}
     */
    SAMPLE_TYPE_CT:1,
    /**
     * 癌旁组织
     * @type {Number}
     */
    SAMPLE_TYPE_PT:2,
    /**
     * 术前血清
     * @type {Number}
     */
    SAMPLE_TYPE_PRS:3,
    /**
     * 术前血浆
     * @type {Number}
     */
    SAMPLE_TYPE_PRP:4,
    /**
     * 术前血细胞
     * @type {Number}
     */
    SAMPLE_TYPE_BBO:5,
    /**
     * 术前尿液
     * @type {Number}
     */
    SAMPLE_TYPE_PRU:6,
    /**
     * 术后血清
     * @type {Number}
     */
    SAMPLE_TYPE_POS:7,
    /**
     * 术后血浆
     * @type {Number}
     */
    SAMPLE_TYPE_POP:8,
    /**
     * 术后血细胞
     * @type {Number}
     */
    SAMPLE_TYPE_BAO:9,
    /**
     * 术后尿液
     * @type {Number}
     */
    SAMPLE_TYPE_POU:10,
    /**
     * 癌栓
     * @type {Number}
     */
    SAMPLE_TYPE_AS:11
}
export {SampleType}
/**
 * 问卷统计类型
 */
let QuestionnaireStatisticKind = {
    /**
     * 按科室统计
     * @type {Number}
     */
    DEPT_KIND:1,
    /**
     * 按病区统计
     * @type {Number}
     */
    WARD_KIND:2,
    /**
     * 按护士统计
     * @type {Number}
     */
    NURSE_KIND:3
}
export {QuestionnaireStatisticKind}
/**
 * 申请联系人状态
 */
let ContactsStatus = {
    /**
     * 联系人状态 0：已申请
     * @type {Number}
     */
    CONTACTS_STATUS_APPLYING:0,
    /**
     * 联系人状态 1：已接受
     * @type {Number}
     */
    CONTACTS_STATUS_ACCEPT:1,
    /**
     * 联系人状态 2：已拒绝
     * @type {Number}
     */
    CONTACTS_STATUS_REFUSE:2,
    /**
     * 联系人状态：已拒绝并重新申请
     * @type {Number}
     */
    CONTACTS_STATUS_REFUSE_REAPPLY:3
}
export {ContactsStatus}
/**
 * 医生端随访池时间筛选
 */
let FollowUpScreenType = {
    /**
     * 一个月
     * @type {Number}
     */
    ONE_MONTH:1,
    /**
     * 半年内
     * @type {Number}
     */
    WITHIN_HALF_YEAR:2,
    /**
     * 半年外
     * @type {Number}
     */
    HALF_YEAR_AWAY:3
}
export {FollowUpScreenType}
/**
 * 图文咨询状态
 */
let ConsultStatus = {
    /**
     * 未开通
     * @type {Number}
     */
    Not_Open:1,
    /**
     * 已开通
     * @type {Number}
     */
    Already_Opened:2,
    /**
     * 今天咨询达到上限
     * @type {Number}
     */
    Full_Consultation:3
}
export {ConsultStatus}
/**
 * 提现导出的题目
 */
let CallFollowUpTitleENUM = {
    /**
     * 病人姓名
     * @type {String}
     */
    patientName:"patientName",
    /**
     * 性别
     * @type {String}
     */
    gender:"gender",
    /**
     * 年龄
     * @type {String}
     */
    age:"age",
    /**
     * 省
     * @type {String}
     */
    province:"province",
    /**
     * 市
     * @type {String}
     */
    city:"city",
    /**
     * 住院流水号
     * @type {String}
     */
    hospitalizationNumber:"hospitalizationNumber",
    /**
     * 住院号
     * @type {String}
     */
    inHospitalNum:"inHospitalNum",
    /**
     * 另外住院号
     * @type {String}
     */
    additionHospitalNumber:"additionHospitalNumber",
    /**
     * 出院科室名称
     * @type {String}
     */
    dischargeDeptName:"dischargeDeptName",
    /**
     * 病人性质名称
     * @type {String}
     */
    patientNatureName:"patientNatureName",
    /**
     * 病案诊断名称
     * @type {String}
     */
    medicalRecordName:"medicalRecordName",
    /**
     * 联系电话1
     * @type {String}
     */
    telephoneCall1:"telephoneCall",
    /**
     * 联系电话2
     * @type {String}
     */
    telephoneCall2:"telephoneCall2",
    /**
     * 联系电话3
     * @type {String}
     */
    telephoneCall3:"telephoneCall3",
    /**
     * 联系电话4
     * @type {String}
     */
    telephoneCall4:"telephoneCall4",
    /**
     * 确诊日期
     * @type {String}
     */
    diagnosisDate:"diagnosisDate",
    /**
     * 其他诊断
     * @type {String}
     */
    otherDiagnosis:"otherDiagnosis",
    /**
     * 病理诊断
     * @type {String}
     */
    pathologicalDiagnosis:"pathologicalDiagnosis",
    /**
     * 分期
     * @type {String}
     */
    staging:"staging",
    /**
     * 分化
     * @type {String}
     */
    differentiation:"differentiation",
    /**
     * 是否我院病理
     * @type {String}
     */
    isOwnHospital:"isOwnHospital",
    /**
     * 免疫组化
     * @type {String}
     */
    immunohistochemistry:"immunohistochemistry",
    /**
     * 所有手术
     * @type {String}
     */
    allOperations:"allOperations",
    /**
     * 手术日期
     * @type {String}
     */
    surgeryDate:"surgeryDate"
}
export {CallFollowUpTitleENUM}
/**
 * 超过多少时间
 */
let OverTime = {
    /**
     * 超过一天
     * @type {Number}
     */
    OVER_ONE_DAY:1,
    /**
     * 超过两天
     * @type {Number}
     */
    OVER_TWO_DAY:2,
    /**
     * 不超过5分钟
     * @type {Number}
     */
    NOT_OVER_FIVE_MINUTE:4,
    /**
     * 超过5分钟
     * @type {Number}
     */
    OVER_FIVE_MINUTE:5
}
export {OverTime}
/**
 * 消息推送pc端id
 */
let PCMessageId = {
    /**
     * 管理台
     * @type {String}
     */
    MANAGE:"manage",
    /**
     * 呼叫中心
     * @type {String}
     */
    CALL_CENTER:"callCenter",
    /**
     * 外部质控
     * @type {String}
     */
    EXTERNAL_QUALITY_CONTROL:"externalQualityControl"
}
export {PCMessageId}
/**
 * 关联内容类型
 */
let AssociatedContentType = {
    /**
     * 文章
     * @type {Number}
     */
    ARTICLES:1,
    /**
     * 问题
     * @type {Number}
     */
    QUESTION:2,
    /**
     * 答案
     * @type {Number}
     */
    ANSWER:3,
    /**
     * 商品
     * @type {Number}
     */
    GOODS:4,
    /**
     * 问卷
     * @type {Number}
     */
    QUESTIONNAIRE:5
}
export {AssociatedContentType}
/**
 * 报告类型
 */
let RecordsType = {
    /**
     * 报告类型 ：入院报告
     * @type {String}
     */
    ADMISSION_RECORD:"admission_record",
    /**
     * 报告类型 ：出院报告
     * @type {String}
     */
    DISCHARGE_RECORD:"discharge_record",
    /**
     * 报告类型 ：手术报告
     * @type {String}
     */
    OPERATION_RECORD:"operation_record"
}
export {RecordsType}
/**
 * 就诊点筛选
 */
let HospitalScreenType = {
    /**
     * 就诊点筛选 ：本人
     * @type {String}
     */
    HOSPITAL_SCREEN_A:"1",
    /**
     * 就诊点筛选 ：本科室其他医生
     * @type {String}
     */
    HOSPITAL_SCREEN_B:"2",
    /**
     * 就诊点筛选 ：本医其他科室
     * @type {String}
     */
    HOSPITAL_SCREEN_C:"3",
    /**
     * 就诊点筛选 ：外院同科室
     * @type {String}
     */
    HOSPITAL_SCREEN_D:"4",
    /**
     * 就诊点筛选 ：外院其他科室
     * @type {String}
     */
    HOSPITAL_SCREEN_E:"5"
}
export {HospitalScreenType}
/**
 * 问题类型
 */
let HZQuestionType = {
    /**
     * 常规
     * @type {Number}
     */
    CONVENTION:1,
    /**
     * 我要说(留言板)
     * @type {Number}
     */
    MESSAGE_BOARD:2
}
export {HZQuestionType}
/**
 * 想要类型
 */
let WantType = {
    /**
     * 代理处理
     * @type {Number}
     */
    AGENT_HANDLER:1,
    /**
     * 好物推荐
     * @type {Number}
     */
    GOODS_RECOMMEND:2
}
export {WantType}
/**
 * 比较符号: 1 大于，2 大于等于， 3 等于，4 小于，5 小于等于
 */
let ComparisonSymbolType = {
    /**
     * 大于
     * @type {Number}
     */
    GREATER_THAN:1,
    /**
     * 大于等于
     * @type {Number}
     */
    GREATER_THAN_OR_EQUAL_TO:2,
    /**
     * 等于
     * @type {Number}
     */
    EQUAL_TO:3,
    /**
     * 小于
     * @type {Number}
     */
    LESS_THAN:4,
    /**
     * 小于等于
     * @type {Number}
     */
    LESS_THAN_OR_EQUAL_TO:5
}
export {ComparisonSymbolType}
/**
 * 复核状态
 */
let ReviewStatusEnum = {
    /**
     * 取消需复核
     * @type {Number}
     */
    DEFAULT:0,
    /**
     * 需复核
     * @type {Number}
     */
    NEED_REVIEWED:1,
    /**
     * 已复核
     * @type {Number}
     */
    REVIEWED:2,
    /**
     * 复核池
     * @type {Number}
     */
    REVIEW_POOL:3
}
export {ReviewStatusEnum}
/**
 * 问卷题目类型枚举
 */
let QuestionInfoTypeEnum = {
    /**
     * 单选
     * @type {Number}
     */
    SINGLE_CHOICE:1,
    /**
     * 多选
     * @type {Number}
     */
    MULTIPLE_CHOICE:2,
    /**
     * 下拉
     * @type {Number}
     */
    DROP_DOWN:3,
    /**
     * 填空
     * @type {Number}
     */
    FILL_BLANK:4,
    /**
     * 多项填空
     * @type {Number}
     */
    MULTIPLE_FILL_BLANK:5,
    /**
     * 段落说明
     * @type {Number}
     */
    PARAGRAPH_DESCRIPTION:6,
    /**
     * （备注缺失，暂不使用）
     * @type {Number}
     */
    NOT_USE:7,
    /**
     * 时间
     * @type {Number}
     */
    TIME:8,
    /**
     * 量表
     * @type {Number}
     */
    GAUGE:9,
    /**
     * 时间点
     * @type {Number}
     */
    TIME_POINT:10,
    /**
     * 数值
     * @type {Number}
     */
    NUMERIC:11
}
export {QuestionInfoTypeEnum}
/**
 * 提醒时间类型
 */
let RemindTimeType = {
    /**
     * 特定时间类型
     * @type {Number}
     */
    TIME_TYPE_GIVEN:1,
    /**
     * 固定间隔时间类型
     * @type {Number}
     */
    TIME_TYPE_FIXED:2
}
export {RemindTimeType}
/**
 * 用户来源
 */
let UserSource = {
    /**
     * 管理台
     * @type {Number}
     */
    MANAGER:0,
    /**
     * 内容平台
     * @type {Number}
     */
    CONTENTBASE:1
}
export {UserSource}
/**
 * 显示类型
 */
let PatientShowType = {
    /**
     * 该报告患者是否显示 1显示
     * @type {Number}
     */
    PATIENT_SHOW_Y:1,
    /**
     * 该报告患者是否显示 2不显示
     * @type {Number}
     */
    PATIENT_SHOW_N:2
}
export {PatientShowType}
/**
 * 随访任务抽查状态
 */
let CallCenterSpotCheckState = {
    /**
     * 电话抽查-不合格
     * @type {Number}
     */
    SPOT_CHECK_STATE_ZERO:0,
    /**
     * 电话抽查-合格
     * @type {Number}
     */
    SPOT_CHECK_STATE_ONE:1,
    /**
     * 电话抽查-不合格，不需重拨（提醒坐席）
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWO:2,
    /**
     * 电话抽查-不合格，需重拨 （重新拨打）
     * @type {Number}
     */
    SPOT_CHECK_STATE_THREE:3,
    /**
     * 电话抽查-不合格，其他（平台相关）
     * @type {Number}
     */
    SPOT_CHECK_STATE_FOUR:4,
    /**
     * 线上抽查-合格
     * @type {Number}
     */
    SPOT_CHECK_STATE_FIVE:5,
    /**
     * 线上抽查-不合格，不需重拨
     * @type {Number}
     */
    SPOT_CHECK_STATE_SIX:6,
    /**
     * 线上抽查-不合格，需重拨
     * @type {Number}
     */
    SPOT_CHECK_STATE_SEVEN:7,
    /**
     * 电话抽查，不合格，收集不足
     * @type {Number}
     */
    SPOT_CHECK_STATE_EIGHT:8,
    /**
     * 电话抽查，不合格，态度欠佳
     * @type {Number}
     */
    SPOT_CHECK_STATE_NINE:9,
    /**
     * 电话抽查，不合格，录音缺失
     * @type {Number}
     */
    SPOT_CHECK_STATE_TEN:10,
    /**
     * 电话抽查，不合格，记录有误
     * @type {Number}
     */
    SPOT_CHECK_STATE_ELEVEN:11,
    /**
     * 电话抽查，不合格，其他
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWELVE:12,
    /**
     * 线上抽查，不合格，需转电
     * @type {Number}
     */
    SPOT_CHECK_STATE_THIRTEEN:13,
    /**
     * 线上抽查，不合格，不需转电
     * @type {Number}
     */
    SPOT_CHECK_STATE_FOURTEEN:14,
    /**
     * 电话抽查，合格，逻辑清晰
     * @type {Number}
     */
    SPOT_CHECK_STATE_FIFTEEN:15,
    /**
     * 电话抽查，合格，收集完整
     * @type {Number}
     */
    SPOT_CHECK_STATE_SIXTEEN:16,
    /**
     * 电话抽查，合格，态度良好
     * @type {Number}
     */
    SPOT_CHECK_STATE_SEVENTEEN:17,
    /**
     * 电话抽查，合格，记录准确
     * @type {Number}
     */
    SPOT_CHECK_STATE_EIGHTEEN:18,
    /**
     * 电话抽查，合格，其他
     * @type {Number}
     */
    SPOT_CHECK_STATE_NINETEEN:19,
    /**
     * 线上抽查，合格
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY:20,
    /**
     * 电话抽查，不合格，混乱无序
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_ONE:21,
    /**
     * 电话抽查，合格，清楚流利
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_TWO:22,
    /**
     * 电话抽查，不合格，生疏含混
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_THREE:23,
    /**
     * 电话抽查，合格，积极灵活
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_FOUR:24,
    /**
     * 电话抽查，不合格，刻板迟钝
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_FIVE:25
}
export {CallCenterSpotCheckState}
/**
 * 呼叫状态: 1稍后拨打，2仅随访该患者，             3短信随访成功，4电话随访成功，5初始化，6挂断（接通），7无人接听，8挂断（未接通），9停机，10关机，11拒随，12空号，13错号，14不知情，15沟通不畅
 */
let NewCallStateEnum = {
    /**
     * 稍后拨打
     * @type {Number}
     */
    CALL_STATE_CALL_LATER:1,
    /**
     * 仅随访该患者
     * @type {Number}
     */
    CALL_STATE_ONLY_PATIENT:2,
    /**
     * 短信随访成功
     * @type {Number}
     */
    CALL_STATE_MESSAGE_FOLLOWUP_SUCCESS:3,
    /**
     * 电话随访成功
     * @type {Number}
     */
    CALL_STATE_TELEPHONE_FOLLOWUP_SUCCESS:4,
    /**
     * 初始化
     * @type {Number}
     */
    CALL_STATE_INITIALIZATION:5,
    /**
     * 挂断（接通）
     * @type {Number}
     */
    CALL_STATE_HANG_UP_CONNECT:6,
    /**
     * 无人接听
     * @type {Number}
     */
    CALL_STATE_NO_ANSWER:7,
    /**
     * 挂断（未接通）
     * @type {Number}
     */
    CALL_STATE_HANG_UP_NOT_CONNECT:8,
    /**
     * 停机
     * @type {Number}
     */
    CALL_STATE_SHUTDOWN:9,
    /**
     * 关机
     * @type {Number}
     */
    CALL_STATE_SHUT_DOWN:10,
    /**
     * 拒随
     * @type {Number}
     */
    CALL_STATE_REFUSE_TO_FOLLOW:11,
    /**
     * 空号
     * @type {Number}
     */
    CALL_STATE_EMPTY_NUMBER:12,
    /**
     * 错号
     * @type {Number}
     */
    CALL_STATE_WRONG_NUMBER:13,
    /**
     * 不知情
     * @type {Number}
     */
    CALL_STATE_INNOCENTLY:14,
    /**
     * 沟通不畅
     * @type {Number}
     */
    CALL_STATE_COMMUNICATION_POOR:15,
    /**
     * 无
     * @type {Number}
     */
    CALL_STATE_NONE:16
}
export {NewCallStateEnum}
/**
 * 服药管理-药品服用频次
 */
let TMTakeFrequencyType = {
    /**
     * 每天
     * @type {Number}
     */
    EVERY:1,
    /**
     * 每2天
     * @type {Number}
     */
    EVERY_TWO_DAYS:2,
    /**
     * 每3天
     * @type {Number}
     */
    EVERY_THREE_DAYS:3,
    /**
     * 每4天
     * @type {Number}
     */
    EVERY_FOUR_DAYS:4,
    /**
     * 每5天
     * @type {Number}
     */
    EVERY_FIVE_DAYS:5,
    /**
     * 每周
     * @type {Number}
     */
    EVERY_WEEK:6,
    /**
     * 每2周
     * @type {Number}
     */
    EVERY_TWO_WEEK:7,
    /**
     * 每3周
     * @type {Number}
     */
    EVERY_THREE_WEEK:8,
    /**
     * 每月
     * @type {Number}
     */
    EVERY_MONTH:9,
    /**
     * 每2月
     * @type {Number}
     */
    EVERY_TWO_MONTH:10,
    /**
     * 每3月
     * @type {Number}
     */
    EVERY_THREE_MONTH:11
}
export {TMTakeFrequencyType}
/**
 * 病灶或术中拍照
 */
let FocusType = {
    /**
     * 病灶
     * @type {Number}
     */
    TYPE_FOCUS:1,
    /**
     * 术中拍照
     * @type {Number}
     */
    TYPE_INTRAOPERATIVE_PHOTOGRAPHY:2,
    /**
     * 备注
     * @type {Number}
     */
    TYPE_REMARKS:3,
    /**
     * 病情思考
     * @type {Number}
     */
    TYPE_THINKING_ILLNESS:4
}
export {FocusType}
/**
 * 冰箱状态
 */
let RefrigeratorState = {
    /**
     * 不显示、不可用
     * @type {Number}
     */
    R_STATE_UNSEE_UNABLE:0,
    /**
     * 显示、不可用
     * @type {Number}
     */
    R_STATE_SEE_UNABLE:1,
    /**
     * 显示、可用
     * @type {Number}
     */
    R_STATE_SEE_ABLE:2
}
export {RefrigeratorState}
/**
 * 页面类型
 */
let PageType = {
    /**
     * 患者页面
     * @type {Number}
     */
    PATIENT_PAGE:1,
    /**
     * 医生页面
     * @type {Number}
     */
    DOCTOR_PAGE:2
}
export {PageType}
/**
 * 借出状态
 */
let ApplyState = {
    /**
     * 已申请
     * @type {Number}
     */
    APPLY_STATE_ING:1,
    /**
     * 已通过
     * @type {Number}
     */
    APPLY_STATE_AGREE:2,
    /**
     * 已拒接
     * @type {Number}
     */
    APPLY_STATE_REFUSE:3,
    /**
     * 已领取
     * @type {Number}
     */
    APPLY_STATE_RECEIVE:4,
    /**
     * 逾期未领取
     * @type {Number}
     */
    APPLY_STATE_OVERDUE:5
}
export {ApplyState}
/**
 * 文章类型
 */
let ArticleKind = {
    /**
     * 健康咨询
     * @type {Number}
     */
    HealthConsult:0,
    /**
     * 入院宣教
     * @type {Number}
     */
    Mission:1
}
export {ArticleKind}
/**
 * 随访状态: 0数据初始化，1短信随访待开始，2短信发送1次，3短信发送2次，4短信随访失败，5短信随访成功，6电话随访待开始，7电话随访进行中，8稍后呼叫，9电话随访成功，10失访，11拒绝随访，12死亡，13异常号码，14重拨
 */
let NewFollowupState = {
    /**
     * 0数据初始化
     * @type {Number}
     */
    DATA_INITIALIZATION:0,
    /**
     * 1短信随访待开始
     * @type {Number}
     */
    SMS_FOLLOWUP_NOT_STARTED:1,
    /**
     * 2短信发送1次
     * @type {Number}
     */
    SMS_SEND_OUT_ONE_SECOND:2,
    /**
     * 3短信发送2次
     * @type {Number}
     */
    SMS_SEND_OUT_TWO_SECOND:3,
    /**
     * 4短信随访失败
     * @type {Number}
     */
    SMS_TURN_CALL_FOLLOWUP:4,
    /**
     * 5短信随访成功
     * @type {Number}
     */
    SMS_FOLLOWUP_SUCCESS:5,
    /**
     * 6电话随访待开始
     * @type {Number}
     */
    FOLLOWUP_NOT_STARTED:6,
    /**
     * 7电话随访进行中
     * @type {Number}
     */
    CALL_FOLLOWUP_INCOMPLETE:7,
    /**
     * 8稍后呼叫
     * @type {Number}
     */
    CALL_FOLLOWUP_LATER_DIAL:8,
    /**
     * 9电话随访成功
     * @type {Number}
     */
    CALL_FOLLOWUP_SUCCESS:9,
    /**
     * 10失访
     * @type {Number}
     */
    FOLLOWUP_LOST_VISIT:10,
    /**
     * 11旧数据（原拒随）
     * @type {Number}
     */
    REFUSE_FOLLOWUP:11,
    /**
     * 12死亡
     * @type {Number}
     */
    DEATH:12,
    /**
     * 13异常号码
     * @type {Number}
     */
    ABNORMAL_NUMBER:13,
    /**
     * 14重拨
     * @type {Number}
     */
    REPLAY:14,
    /**
     * 15随访过期
     * @type {Number}
     */
    FOLLOWUP_OVERDUE:15,
    /**
     * 16沟通不畅
     * @type {Number}
     */
    UNDONE_POOR_COMMUNICATION:16,
    /**
     * 17拒绝随访（有信息）
     * @type {Number}
     */
    UNDONE_REFUSE_HAVE_INFO:17,
    /**
     * 18拒绝随访（无信息）
     * @type {Number}
     */
    UNDONE_REFUSE_NOT_HAVE_INFO:18
}
export {NewFollowupState}
/**
 * 患者动态类型
 */
let PatientDynamicType = {
    /**
     * 注册
     * @type {Number}
     */
    Register:1,
    /**
     * 提醒预约挂号
     * @type {Number}
     */
    RemindAppointmentRegistration:2,
    /**
     * 短信提醒按时随访
     * @type {Number}
     */
    SMSReminderFollowUp:3,
    /**
     * 提交问卷
     * @type {Number}
     */
    SubmissionQuestionnaire:4,
    /**
     * 上传就诊记录
     * @type {Number}
     */
    UploadingMedicalRecords:5,
    /**
     * 填写逾期原因
     * @type {Number}
     */
    FillLateCause:6,
    /**
     * 到对接医院就诊
     * @type {Number}
     */
    ToHospitalDocking:7,
    /**
     * 精卫建立就诊关系
     * @type {Number}
     */
    MentalEstablishSeekMedicalAdviceRelationship:8,
    /**
     * 精卫提交心里自测问卷
     * @type {Number}
     */
    MentalPsychologicalSelfTestQuestionnaire:9,
    /**
     * 患者提交随访报到
     * @type {Number}
     */
    FollowUpReport:10,
    /**
     * 图文咨询
     * @type {Number}
     */
    Consult:11
}
export {PatientDynamicType}
/**
 * 提现导出的题目
 */
let ExportUtilOutCrashTitleENUM = {
    /**
     * 账号
     * @type {String}
     */
    AccountMobile:"accountMobile",
    /**
     * 角色
     * @type {String}
     */
    BuyerRelationId:"buyerRelationId",
    /**
     * 账号名字
     * @type {String}
     */
    AccountName:"accountName",
    /**
     * 支付平台
     * @type {String}
     */
    PayPlatformKind:"payPlatformKind",
    /**
     * 提现金额
     * @type {String}
     */
    OrderPrice:"orderPrice",
    /**
     * 收款姓名
     * @type {String}
     */
    PayeeRealName:"payeeRealName",
    /**
     * 收款账户
     * @type {String}
     */
    PayAccount:"payAccount",
    /**
     * 平台验证
     * @type {String}
     */
    IsPlatformPass:"isPlatformPass",
    /**
     * 申请时间
     * @type {String}
     */
    CreateTime:"createTime",
    /**
     * 审核时间
     * @type {String}
     */
    PayTime:"payTime",
    /**
     * 审核人
     * @type {String}
     */
    Reviewer:"reviewer",
    /**
     * 审核结果
     * @type {String}
     */
    ReturnReason:"returnReason"
}
export {ExportUtilOutCrashTitleENUM}
/**
 * 专病库配置类型
 */
let SdsConfigType = {
    /**
     * 时间轴配置
     * @type {Number}
     */
    TIME_AXIS:1,
    /**
     * 统计项配置
     * @type {Number}
     */
    STATISTICS:2
}
export {SdsConfigType}
/**
 * 商品操作类型
 */
let CommodityOperationType = {
    /**
     * 上架操作
     * @type {Number}
     */
    UPPER_SHELF:1,
    /**
     * 下架操作
     * @type {Number}
     */
    LOWER_SHELF:2,
    /**
     * 删除商品
     * @type {Number}
     */
    DELETE:3
}
export {CommodityOperationType}
/**
 * 销售记录类型
 */
let GoodsSaleRecordType = {
    /**
     * 卖出
     * @type {Number}
     */
    SellOut:1,
    /**
     * 取消
     * @type {Number}
     */
    Cancel:2,
    /**
     * 退回
     * @type {Number}
     */
    Return:3
}
export {GoodsSaleRecordType}
/**
 * 问卷复制状态
 */
let QuestionnaireCopyStatus = {
    /**
     * 1复制完成
     * @type {Number}
     */
    COPY_COMPLETE:1,
    /**
     * 2复制中
     * @type {Number}
     */
    COPY_HAVE_IN_HAND:2,
    /**
     * 3（1小时还未复制完成，复制失败）
     * @type {Number}
     */
    COPY_FAIL:3
}
export {QuestionnaireCopyStatus}
/**
 * 电话随访结果科室解类型
 */
let CallFollowupResultDepartmentType = {
    /**
     * 中山医院-肝肿瘤内科
     * @type {Number}
     */
    ZS_LIVER_NEOPLASMS_INTERNAL_MEDICINE:65,
    /**
     * 中山医院-肝肿瘤外科
     * @type {Number}
     */
    ZS_LIVER_SURGERY:71,
    /**
     * 中山医院-骨科
     * @type {Number}
     */
    ZS_RECORD_ORTHOPAEDICS:72,
    /**
     * 中山医院-病理科
     * @type {Number}
     */
    ZS_PATHOLOGY_DEPARTMENT:104,
    /**
     * 东方肝胆医院-肝外科
     * @type {Number}
     */
    DFGD_LIVER_SURGERY:380880
}
export {CallFollowupResultDepartmentType}
/**
 * 随访任务抽查状态
 */
let CallCenterSpotCheckStateEnum = {
    /**
     * 不合格
     * @type {Number}
     */
    SPOT_CHECK_STATE_ZERO:0,
    /**
     * 合格
     * @type {Number}
     */
    SPOT_CHECK_STATE_ONE:1,
    /**
     * 不合格，不需重拨
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWO:2,
    /**
     * 不合格，需重拨
     * @type {Number}
     */
    SPOT_CHECK_STATE_THREE:3,
    /**
     * 不合格，其他
     * @type {Number}
     */
    SPOT_CHECK_STATE_FOUR:4,
    /**
     * 合格
     * @type {Number}
     */
    SPOT_CHECK_STATE_FIVE:5,
    /**
     * 不合格，不需重拨
     * @type {Number}
     */
    SPOT_CHECK_STATE_SIX:6,
    /**
     * 不合格，需重拨
     * @type {Number}
     */
    SPOT_CHECK_STATE_SEVEN:7,
    /**
     * 收集不足
     * @type {Number}
     */
    SPOT_CHECK_STATE_EIGHT:8,
    /**
     * 态度欠佳
     * @type {Number}
     */
    SPOT_CHECK_STATE_NINE:9,
    /**
     * 录音缺失
     * @type {Number}
     */
    SPOT_CHECK_STATE_TEN:10,
    /**
     * 记录有误
     * @type {Number}
     */
    SPOT_CHECK_STATE_ELEVEN:11,
    /**
     * 其他
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWELVE:12,
    /**
     * 需转电
     * @type {Number}
     */
    SPOT_CHECK_STATE_THIRTEEN:13,
    /**
     * 不需转电
     * @type {Number}
     */
    SPOT_CHECK_STATE_FOURTEEN:14,
    /**
     * 逻辑清晰
     * @type {Number}
     */
    SPOT_CHECK_STATE_FIFTEEN:15,
    /**
     * 收集完整
     * @type {Number}
     */
    SPOT_CHECK_STATE_SIXTEEN:16,
    /**
     * 态度良好
     * @type {Number}
     */
    SPOT_CHECK_STATE_SEVENTEEN:17,
    /**
     * 记录准确
     * @type {Number}
     */
    SPOT_CHECK_STATE_EIGHTEEN:18,
    /**
     * 其他
     * @type {Number}
     */
    SPOT_CHECK_STATE_NINETEEN:19,
    /**
     * 无
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY:20,
    /**
     * 混乱无序
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_ONE:21,
    /**
     * 清楚流利
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_TWO:22,
    /**
     * 生疏含混
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_THREE:23,
    /**
     * 积极灵活
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_FOUR:24,
    /**
     * 刻板迟钝
     * @type {Number}
     */
    SPOT_CHECK_STATE_TWENTY_FIVE:25
}
export {CallCenterSpotCheckStateEnum}
/**
 * 随访状态: 0数据初始化，1短信随访待开始，2短信发送1次，3短信发送2次，4短信随访失败，5短信随访成功，6电话随访待开始，7电话随访进行中，8稍后呼叫，9电话随访成功，10失访，11拒绝随访，12死亡，13异常号码，14重拨
 */
let NewFollowupStateEnum = {
    /**
     * 数据初始化
     * @type {Number}
     */
    DATA_INITIALIZATION:0,
    /**
     * 短信随访待开始
     * @type {Number}
     */
    SMS_FOLLOWUP_NOT_STARTED:1,
    /**
     * 短信发送1次
     * @type {Number}
     */
    SMS_SEND_OUT_ONE_SECOND:2,
    /**
     * 短信发送2次
     * @type {Number}
     */
    SMS_SEND_OUT_TWO_SECOND:3,
    /**
     * 短信随访失败
     * @type {Number}
     */
    SMS_TURN_CALL_FOLLOWUP:4,
    /**
     * 短信随访成功
     * @type {Number}
     */
    SMS_FOLLOWUP_SUCCESS:5,
    /**
     * 电话随访待开始
     * @type {Number}
     */
    FOLLOWUP_NOT_STARTED:6,
    /**
     * 电话随访进行中
     * @type {Number}
     */
    CALL_FOLLOWUP_INCOMPLETE:7,
    /**
     * 稍后呼叫
     * @type {Number}
     */
    CALL_FOLLOWUP_LATER_DIAL:8,
    /**
     * 电话随访成功
     * @type {Number}
     */
    CALL_FOLLOWUP_SUCCESS:9,
    /**
     * 失访
     * @type {Number}
     */
    FOLLOWUP_LOST_VISIT:10,
    /**
     * 旧数据（原拒随）
     * @type {Number}
     */
    REFUSE_FOLLOWUP:11,
    /**
     * 死亡
     * @type {Number}
     */
    DEATH:12,
    /**
     * 异常号码
     * @type {Number}
     */
    ABNORMAL_NUMBER:13,
    /**
     * 重拨
     * @type {Number}
     */
    REPLAY:14,
    /**
     * 随访过期
     * @type {Number}
     */
    FOLLOWUP_OVERDUE:15,
    /**
     * 沟通不畅
     * @type {Number}
     */
    UNDONE_POOR_COMMUNICATION:16,
    /**
     * 拒绝随访（有信息）
     * @type {Number}
     */
    UNDONE_REFUSE_HAVE_INFO:17,
    /**
     * 拒绝随访（无信息）
     * @type {Number}
     */
    UNDONE_REFUSE_NOT_HAVE_INFO:18
}
export {NewFollowupStateEnum}
/**
 * 药物类型
 */
let PrescriptionTyp = {
    /**
     * 药物
     * @type {Number}
     */
    PRESCRIPTION_TYPE_DRUG:1,
    /**
     * 检查
     * @type {Number}
     */
    PRESCRIPTION_TYPE_INSPECT:2
}
export {PrescriptionTyp}
/**
 * 操作日志动作
 */
let OperationLogAction = {
    /**
     * 操作日志动作-创建
     * @type {Number}
     */
    OPERATION_LOG_CREATE:1,
    /**
     * 操作日志动作-编辑
     * @type {Number}
     */
    OPERATION_LOG_EDITING:2,
    /**
     * 操作日志动作-发布
     * @type {Number}
     */
    OPERATION_LOG_PUBLISHED:3,
    /**
     * 操作日志动作-审核
     * @type {Number}
     */
    OPERATION_LOG_REVIEWED:4,
    /**
     * 操作日志动作-关闭
     * @type {Number}
     */
    OPERATION_LOG_CLOSED:5,
    /**
     * 操作日志动作-删除
     * @type {Number}
     */
    OPERATION_LOG_DELETE:6,
    /**
     * 操作日志动作-恢复
     * @type {Number}
     */
    OPERATION_LOG_RECOVERY:7,
    /**
     * 操作日志动作-驳回
     * @type {Number}
     */
    OPERATION_LOG_REJECT:8
}
export {OperationLogAction}
/**
 * 样本库列表筛选类型
 */
let SampleListFilterType = {
    /**
     * 筛选类型 1：所有
     * @type {Number}
     */
    FILTER_TYPE_ALL:1,
    /**
     * 筛选类型 2：入库
     * @type {Number}
     */
    FILTER_TYPE_STORAGE:2,
    /**
     * 筛选类型3：待入库
     * @type {Number}
     */
    FILTER_TYPE_WAIT_STORAGE:3,
    /**
     * 筛选类型4：昨日借出
     * @type {Number}
     */
    FILTER_TYPE_YESTERDAY_LEND:4
}
export {SampleListFilterType}
/**
 * 随访任务状态
 */
let FollowupTaskStatus = {
    /**
     * 未开始
     * @type {Number}
     */
    TASK_NOT_START:1,
    /**
     * 进行中
     * @type {Number}
     */
    TASK_ONGOING:2,
    /**
     * 已暂停
     * @type {Number}
     */
    TASK_STOP:3,
    /**
     * 已完成
     * @type {Number}
     */
    TASK_FINISH:4,
    /**
     * 异常
     * @type {Number}
     */
    TASK_EXCEPTION:5
}
export {FollowupTaskStatus}
/**
 * 商城订单状态名字
 */
let ShopOrderStatusName = {
    /**
     * 未支付
     * @type {String}
     */
    UNPAID:"未支付",
    /**
     * 已关闭
     * @type {String}
     */
    CLOSED:"已关闭",
    /**
     * 待发货
     * @type {String}
     */
    DELIVERED:"待发货",
    /**
     * 物流中
     * @type {String}
     */
    IN_LOGISTICS:"物流中",
    /**
     * 已退款
     * @type {String}
     */
    REFUND:"已退款",
    /**
     * 已完成
     * @type {String}
     */
    FINISH:"已完成",
    /**
     * 已取消
     * @type {String}
     */
    CANCEL:"已取消",
    /**
     * 已支付
     * @type {String}
     */
    PAID:"已支付",
    /**
     * 已接单
     * @type {String}
     */
    ACCEPTED:"已接单"
}
export {ShopOrderStatusName}
/**
 * 展示字段
 */
let ExhibitionIds = {
    /**
     * 年龄
     * @type {Number}
     */
    ID_ONE:3,
    /**
     * 住院号
     * @type {Number}
     */
    ID_TWO:5,
    /**
     * 疾病名称
     * @type {Number}
     */
    ID_THREE:6,
    /**
     * 诊断日期
     * @type {Number}
     */
    ID_FOUR:7,
    /**
     * 治疗方式
     * @type {Number}
     */
    ID_FIVE:8,
    /**
     * 主诊医生
     * @type {Number}
     */
    ID_SIX:9,
    /**
     * 治疗日期
     * @type {Number}
     */
    ID_SEVEN:10,
    /**
     * 出院日期
     * @type {Number}
     */
    ID_EIGHT:11,
    /**
     * 出院带药
     * @type {Number}
     */
    ID_NINE:12,
    /**
     * 上次随访时间
     * @type {Number}
     */
    ID_TEN:18
}
export {ExhibitionIds}
/**
 * 抗癌日志推送类型
 */
let CommunityPushType = {
    /**
     * 点赞推送
     * @type {Number}
     */
    PUSH_TYPE_LIKE:101,
    /**
     * 收藏推送
     * @type {Number}
     */
    PUSH_TYPE_COLLECTION:102,
    /**
     * 评论推送
     * @type {Number}
     */
    PUSH_TYPE_COMMENT:103,
    /**
     * 关注推送
     * @type {Number}
     */
    PUSH_TYPE_ATTENTION:104,
    /**
     * 抗癌日志系统消息推送
     * @type {Number}
     */
    PUSH_TYPE_SYSTEM:105
}
export {CommunityPushType}
/**
 * 冰箱类型
 */
let refrigeratorType = {
    /**
     * 术前血液科研
     * @type {Number}
     */
    BLOOD_RESEARCH_BEFORE_OPERATION:1,
    /**
     * 术前血液留备
     * @type {Number}
     */
    PREOPERATIVE_BLOOD_RESERVE:2,
    /**
     * 术后血液科研
     * @type {Number}
     */
    BLOOD_RESEARCH_AFTER_OPERATION:3,
    /**
     * 术后血液留备
     * @type {Number}
     */
    BLOOD_RESERVE_AFTER_OPERATION:4,
    /**
     * 组织科研
     * @type {Number}
     */
    ORGANIZE_SCIENTIFIC_RESEARCH:5,
    /**
     * 组织留备
     * @type {Number}
     */
    TISSUE_RESERVE:6
}
export {refrigeratorType}
/**
 * 代理处理服务类型
 */
let AgentHandlerServiceType = {
    /**
     * 代复印病史
     * @type {Number}
     */
    COPY_MEDICAL_HISTORY:1,
    /**
     * 代开发票
     * @type {Number}
     */
    ISSUE_INVOICE:2,
    /**
     * 代挂号
     * @type {Number}
     */
    REGISTER:3,
    /**
     * 代问诊
     * @type {Number}
     */
    MEDICAL_CONSULTATION:4,
    /**
     * 代购药
     * @type {Number}
     */
    PURCHASE_DRUG:5,
    /**
     * 检查报告代取
     * @type {Number}
     */
    TAKE_INSPECTION_REPORT:6,
    /**
     * 代预约（门诊、检查）
     * @type {Number}
     */
    RESERVATION:7
}
export {AgentHandlerServiceType}
/**
 * 反馈状态
 */
let FeedbackStatus = {
    /**
     * 1：已提交
     * @type {Number}
     */
    FEEDBACK_STATUS_SUBMITTED:1,
    /**
     * 2：已处理
     * @type {Number}
     */
    FEEDBACK_STATUS_PROCESSED:2
}
export {FeedbackStatus}
/**
 * 问卷数值频率类型
 */
let QuestionNumericFrequencyTypeEnum = {
    /**
     * 每日
     * @type {Number}
     */
    DAILY:1,
    /**
     * 每周
     * @type {Number}
     */
    WEEKLY:2,
    /**
     * 每月
     * @type {Number}
     */
    MONTHLY:3,
    /**
     * 每年
     * @type {Number}
     */
    ANNUALLY:4
}
export {QuestionNumericFrequencyTypeEnum}
/**
 * 联系人请求状态
 */
let ContactsApplyType = {
    /**
     * 接受联系人申请
     * @type {Number}
     */
    Accept:12,
    /**
     * 拒绝联系人申请
     * @type {Number}
     */
    Refuse:13,
    /**
     * 发送申请
     * @type {Number}
     */
    Apply:14
}
export {ContactsApplyType}
/**
 * 样本库导入错误类型
 */
let ExcelErrorType = {
    /**
     * 该样本已入库，如需增加样本数量，请手动入库
     * @type {Number}
     */
    ERROR_TYPE_REPEAT:1,
    /**
     * 数据格式或者字段为空
     * @type {Number}
     */
    ERROR_TYPE_FORMAT:2,
    /**
     * 其他错误
     * @type {Number}
     */
    ERROR_TYPE_OTHER:3
}
export {ExcelErrorType}
/**
 * 有无备注状态
 */
let RemarkStatus = {
    /**
     * 无备注
     * @type {Number}
     */
    Not_Exist:1,
    /**
     * 有备注
     * @type {Number}
     */
    Exist:2
}
export {RemarkStatus}
/**
 * 符号类型
 */
let SymbolType = {
    /**
     * 小于
     * @type {Number}
     */
    LESS_THAN:1,
    /**
     * 小于等于
     * @type {Number}
     */
    LESS_THAN_BE_EQUAL_TO:2,
    /**
     * 等于
     * @type {Number}
     */
    BE_EQUAL_TO:3,
    /**
     * 大于
     * @type {Number}
     */
    GREATER_THAN:4,
    /**
     * 大于等于
     * @type {Number}
     */
    GREATER_THAN_BE_EQUAL_TO:5,
    /**
     * 在...范围之内
     * @type {Number}
     */
    WITHIN_THE_SCOPE:6
}
export {SymbolType}
/**
 * 用户类别：0远程，1全职，2测试
 */
let UserSortEnum = {
    /**
     * 远程
     * @type {String}
     */
    PART_TIME:"0",
    /**
     * 全职
     * @type {String}
     */
    FULL_TIME:"1",
    /**
     * 测试
     * @type {String}
     */
    TEST:"2"
}
export {UserSortEnum}
/**
 * 收藏类型
 */
let CollectionDataType = {
    /**
     * 患者
     * @type {Number}
     */
    PatientID:1,
    /**
     * 文章
     * @type {Number}
     */
    ArticleType:2
}
export {CollectionDataType}
/**
 * 随访类型
 */
let FollowupSourceType = {
    /**
     * 第一次随访完成
     * @type {Number}
     */
    FIRST_FOLLOWUP_COMPLETE:1,
    /**
     * 质控
     * @type {Number}
     */
    SPOT_CHECK:2,
    /**
     * 异常号码
     * @type {Number}
     */
    EXCEPTION_NUMBER:3,
    /**
     * 稍后拨打
     * @type {Number}
     */
    LATER_CALL:4
}
export {FollowupSourceType}
/**
 * 处理结果类型
 */
let HandleResultTypeEnum = {
    /**
     * 需重拨
     * @type {Number}
     */
    REQUIRE_REDIAL:1,
    /**
     * 需注意
     * @type {Number}
     */
    REQUIRE_ATTENTION:2,
    /**
     * 平台相关（已废弃）
     * @type {Number}
     */
    PLATFORM_RELATED:3,
    /**
     * 需修改问卷
     * @type {Number}
     */
    REQUIRE_CHANGE_QUESTIONNAIRE:4,
    /**
     * 无
     * @type {Number}
     */
    NONE:5
}
export {HandleResultTypeEnum}
/**
 * 关系等级枚举
 */
let RelationshipLevelEnum = {
    /**
     * 一级联系人
     * @type {Number}
     */
    ONE:1,
    /**
     * 二级联系人
     * @type {Number}
     */
    TWO:2,
    /**
     * 三级联系人
     * @type {Number}
     */
    THREE:3
}
export {RelationshipLevelEnum}
/**
 * 核医学问卷状态
 */
let HQState = {
    /**
     * 状态 1：已提交
     * @type {Number}
     */
    HQ_SUBMISSION:1,
    /**
     * 状态 2：已核对
     * @type {Number}
     */
    HQ_CHECK:2
}
export {HQState}
/**
 * 药物参数
 */
let DrugType = {
    /**
     * 剂型代码过滤
     * @type {String}
     */
    DOSAGE_FORM_NOT_EQUAL:"大输液"
}
export {DrugType}
/**
 * 生存状态
 */
let SurvivalStatusEnum = {
    /**
     * 生存
     * @type {Number}
     */
    LIVE:1,
    /**
     * 死亡
     * @type {Number}
     */
    DEATH:2,
    /**
     * 未知
     * @type {Number}
     */
    UNKNOWN:3
}
export {SurvivalStatusEnum}
/**
 * 病史类型
 */
let RecordType = {
    /**
     * 出院小结
     * @type {String}
     */
    RECORD_DISCHARGE:"出院小结",
    /**
     * 手术记录
     * @type {String}
     */
    RECORD_OPERATION:"手术记录",
    /**
     * 入院记录
     * @type {String}
     */
    RECORD_ADMISSION:"入院记录"
}
export {RecordType}
/**
 * 红房子随访患者分配状态
 */
let RedHouseFollowPatientAllocationState = {
    /**
     * 未分配
     * @type {Number}
     */
    UNASSIGNED:1,
    /**
     * 已分配
     * @type {Number}
     */
    ASSIGNED:2,
    /**
     * 分配中
     * @type {Number}
     */
    ASSIGNING:3,
    /**
     * 失败/错误
     * @type {Number}
     */
    ASSIGN_FAIL_ERROR:4,
    /**
     * 失败/重复
     * @type {Number}
     */
    ASSIGN_FAIL_REPEAT:5,
    /**
     * 失败/异常
     * @type {Number}
     */
    ASSIGN_FAIL_EXCEPTION:6
}
export {RedHouseFollowPatientAllocationState}
/**
 * 点赞内容类型
 */
let EndorseContentType = {
    /**
     * 文章
     * @type {Number}
     */
    ARTICLES:1,
    /**
     * 问题
     * @type {Number}
     */
    QUESTION:2,
    /**
     * 代理处理
     * @type {Number}
     */
    AGENT_HANDLER:3,
    /**
     * 答案
     * @type {Number}
     */
    ANSWER:4,
    /**
     * 患者圈文章
     * @type {Number}
     */
    PATIENT_CIRCLE_ARTICLE:5
}
export {EndorseContentType}
/**
 * 医生团队角色枚举
 */
let DoctorTeamRoleEnum = {
    /**
     * 主诊医生
     * @type {Number}
     */
    ATTENDING_PHYSICIAN:1,
    /**
     * 营养师
     * @type {Number}
     */
    DIETITIAN:2,
    /**
     * 心理咨询师
     * @type {Number}
     */
    PSYCHOLOGICAL_COUNSELOR:3,
    /**
     * 疼痛舒缓师
     * @type {Number}
     */
    PAIN_RELIEF_SPECIALIST:4,
    /**
     * 康复指导
     * @type {Number}
     */
    REHABILITATION_GUIDE:5,
    /**
     * 临床药师
     * @type {Number}
     */
    TEMPORARY_PHARMACIST:6
}
export {DoctorTeamRoleEnum}
/**
 * 答案类型
 */
let HcbAnswersType = {
    /**
     * 普通答案
     * @type {Number}
     */
    REGULAR_ANSWER:1,
    /**
     * 医生建议
     * @type {Number}
     */
    DOCTOR_ADVICE:2,
    /**
     * 荟医建议
     * @type {Number}
     */
    HUIYI_ADVICE:3,
    /**
     * 追问
     * @type {Number}
     */
    CHASE_ASK:4,
    /**
     * 答案补充
     * @type {Number}
     */
    ANSWER_SUPPLEMENT:5
}
export {HcbAnswersType}
/**
 * 问答首页排序
 */
let HomeQuestionSortType = {
    /**
     * 默认排序
     * @type {Number}
     */
    DEFAULT:1,
    /**
     * 浏览量高到低
     * @type {Number}
     */
    PAGE_VIEW_HIGH:2,
    /**
     * 浏览量低到高
     * @type {Number}
     */
    PAGE_VIEW_LOW:3,
    /**
     * 发布时间高到低
     * @type {Number}
     */
    RELEASE_TIME_HIGH:4,
    /**
     * 发布时间低到高
     * @type {Number}
     */
    RELEASE_TIME_LOW:5
}
export {HomeQuestionSortType}
/**
 * 呼叫状态： 1稍后拨打，2空号，3停机，4关机，5拒接，6无人接听，7挂断，8拒聊，9错号，10成功
 */
let CallState = {
    /**
     * 1稍后拨打
     * @type {Number}
     */
    CALL_STATE_CALL_LATER:1,
    /**
     * 2空号
     * @type {Number}
     */
    CALL_STATE_SPACE_NUMBER:2,
    /**
     * 3停机
     * @type {Number}
     */
    CALL_STATE_SHUTDOWN:3,
    /**
     * 4关机
     * @type {Number}
     */
    CALL_STATE_POWER_OFF:4,
    /**
     * 5拒接
     * @type {Number}
     */
    CALL_STATE_REFUSE_TO_ACCEPT:5,
    /**
     * 6无人接听
     * @type {Number}
     */
    CALL_STATE_NO_ANSWER:6,
    /**
     * 7挂断
     * @type {Number}
     */
    CALL_STATE_HANG_UP:7,
    /**
     * 8拒聊
     * @type {Number}
     */
    CALL_STATE_REFUSE_TO_TALK:8,
    /**
     * 9错号
     * @type {Number}
     */
    CALL_STATE_WRONG_NUMBER:9,
    /**
     * 10成功
     * @type {Number}
     */
    CALL_STATE_SUCCESS:10
}
export {CallState}
/**
 * 提醒状态
 */
let RemindStates = {
    /**
     * 已推送
     * @type {Number}
     */
    REMIND_STATES_PUSH:0,
    /**
     * 已提醒
     * @type {Number}
     */
    REMIND_STATES_ALREADY:1,
    /**
     * 已服用
     * @type {Number}
     */
    REMIND_STATES_TAKE:2
}
export {RemindStates}
/**
 * 呼叫状态: 1稍后拨打，2仅随访该患者，             3短信随访成功，4电话随访成功，5初始化，6挂断（接通），7无人接听，8挂断（未接通），9停机，10关机，11拒随，12空号，13错号，14不知情，15沟通不畅
 */
let NewCallState = {
    /**
     * 1稍后拨打
     * @type {Number}
     */
    CALL_STATE_CALL_LATER:1,
    /**
     * 2仅随访该患者
     * @type {Number}
     */
    CALL_STATE_ONLY_PATIENT:2,
    /**
     * 3短信随访成功
     * @type {Number}
     */
    CALL_STATE_MESSAGE_FOLLOWUP_SUCCESS:3,
    /**
     * 4电话随访成功
     * @type {Number}
     */
    CALL_STATE_TELEPHONE_FOLLOWUP_SUCCESS:4,
    /**
     * 5初始化
     * @type {Number}
     */
    CALL_STATE_INITIALIZATION:5,
    /**
     * 6挂断（接通）
     * @type {Number}
     */
    CALL_STATE_HANG_UP_CONNECT:6,
    /**
     * 7无人接听
     * @type {Number}
     */
    CALL_STATE_NO_ANSWER:7,
    /**
     * 8挂断（未接通）
     * @type {Number}
     */
    CALL_STATE_HANG_UP_NOT_CONNECT:8,
    /**
     * 9停机
     * @type {Number}
     */
    CALL_STATE_SHUTDOWN:9,
    /**
     * 10关机
     * @type {Number}
     */
    CALL_STATE_SHUT_DOWN:10,
    /**
     * 11拒随
     * @type {Number}
     */
    CALL_STATE_REFUSE_TO_FOLLOW:11,
    /**
     * 12空号
     * @type {Number}
     */
    CALL_STATE_EMPTY_NUMBER:12,
    /**
     * 13错号
     * @type {Number}
     */
    CALL_STATE_WRONG_NUMBER:13,
    /**
     * 14不知情
     * @type {Number}
     */
    CALL_STATE_INNOCENTLY:14,
    /**
     * 15沟通不畅
     * @type {Number}
     */
    CALL_STATE_COMMUNICATION_POOR:15,
    /**
     * 无
     * @type {Number}
     */
    CALL_STATE_NONE:16
}
export {NewCallState}
/**
 * 搜索的QueryTag
 */
let SearchQueryTag = {
    /**
     * 医生端搜索
     * @type {String}
     */
    DoctorPoint:"doctor_point",
    /**
     * 患者端搜索
     * @type {String}
     */
    PatientPoint:"patient_point",
    /**
     * 搜索患者
     * @type {String}
     */
    Patient:"patient",
    /**
     * 搜索用户
     * @type {String}
     */
    User:"user",
    /**
     * 搜索文章
     * @type {String}
     */
    Article:"article",
    /**
     * 搜索分答
     * @type {String}
     */
    Problem:"problem"
}
export {SearchQueryTag}
/**
 * 问卷题目类型
 */
let QuestionInfoType = {
    /**
     * 单选
     * @type {Number}
     */
    SINGLE_CHOICE:1,
    /**
     * 多选
     * @type {Number}
     */
    MULTIPLE_CHOICE:2,
    /**
     * 下拉
     * @type {Number}
     */
    DROP_DOWN:3,
    /**
     * 填空
     * @type {Number}
     */
    FILL_BLANK:4,
    /**
     * 多项填空
     * @type {Number}
     */
    MULTIPLE_FILL_BLANK:5,
    /**
     * 段落说明
     * @type {Number}
     */
    PARAGRAPH_DESCRIPTION:6,
    /**
     * （备注缺失，暂不使用）
     * @type {Number}
     */
    NOT_USE:7,
    /**
     * 时间
     * @type {Number}
     */
    TIME:8,
    /**
     * 量表
     * @type {Number}
     */
    GAUGE:9,
    /**
     * 时间点
     * @type {Number}
     */
    TIME_POINT:10,
    /**
     * 数值
     * @type {Number}
     */
    NUMERIC:11
}
export {QuestionInfoType}
/**
 * 日志权限
 */
let JurisdictionState = {
    /**
     * 仅自己可看
     * @type {Number}
     */
    LOG_J_STATE_PRIVATE:0,
    /**
     * 仅粉丝可看
     * @type {Number}
     */
    LOG_J_STATE_FANS:1,
    /**
     * 全部人可看
     * @type {Number}
     */
    LOG_J_STATE_PUBLIC:2
}
export {JurisdictionState}
/**
 * 统计类型
 */
let StatisticsType = {
    /**
     * 注册统计
     * @type {Number}
     */
    STATISTICS_TYPE_REGISTER:1,
    /**
     * 登录统计
     * @type {Number}
     */
    STATISTICS_TYPE_LOGIN:2
}
export {StatisticsType}
/**
 * 医院
 */
let HospitalType = {
    /**
     * 对接医院
     * @type {Number}
     */
    DOCKING_HOSPITAL:1,
    /**
     * 合作医院
     * @type {Number}
     */
    COOPERATION_HOSPITAL:2,
    /**
     * 非合作医院
     * @type {Number}
     */
    WRONG_COOPERATION_HOSPITAL:3
}
export {HospitalType}
/**
 * 题目类型
 */
let QuestionType = {
    /**
     * 单选题
     * @type {String}
     */
    OPTION:"OPTION",
    /**
     * 多选题
     * @type {String}
     */
    MULTI_OPTION:"MULTI_OPTION",
    /**
     * 问题
     * @type {String}
     */
    FREETEXT:"FREETEXT",
    /**
     * 时间下拉框
     * @type {String}
     */
    TIME:"TIME",
    /**
     * 时间下拉框 + INPUT输入框
     * @type {String}
     */
    TIME_TEXT:"TIME_TEXT"
}
export {QuestionType}
/**
 * 订单主题
 */
let OrderTopic = {
    /**
     * 复印病史下单
     * @type {String}
     */
    COPY_MEDICAL_HISTORY_ORDER:"复印病史下单",
    /**
     * 图文咨询
     * @type {String}
     */
    CONSULTATION:"图文咨询",
    /**
     * 充值
     * @type {String}
     */
    RECHARGE:"充值",
    /**
     * 分答下单
     * @type {String}
     */
    REPLY_ORDER:"分答下单",
    /**
     * 商城商品下单
     * @type {String}
     */
    SHOPPING_MALL_ORDER:"商城商品下单",
    /**
     * 商城订单
     * @type {String}
     */
    SHOPPING_MALL:"商城订单",
    /**
     * 提现
     * @type {String}
     */
    CASH_WITHDRAWAL:"提现",
    /**
     * 一元查看
     * @type {String}
     */
    ONE_DOLLAR_LOOK:"一元查看",
    /**
     * 感谢医生
     * @type {String}
     */
    THANK_DOCTOR:"感谢医生",
    /**
     * 一问医答提问
     * @type {String}
     */
    ONT_ASK_DOCTOR_ANSWER:"一问医答提问",
    /**
     * 积分商城订单
     * @type {String}
     */
    POINTS_MALL_ORDER:"积分商城订单"
}
export {OrderTopic}
/**
 * 账务类型
 */
let AccountType = {
    /**
     * 支出
     * @type {Number}
     */
    Expenditure:1,
    /**
     * 收入
     * @type {Number}
     */
    Income:2
}
export {AccountType}
/**
 * 样本库统计类型
 */
let SampleStatisticsType = {
    /**
     * 入库操作
     * @type {Number}
     */
    STATISTICS_TYPE_WAREHOUSING:1,
    /**
     * 借出操作
     * @type {Number}
     */
    STATISTICS_TYPE_LEND:2
}
export {SampleStatisticsType}
/**
 * 随访状态
 */
let PatientDoctorFollowupState = {
    /**
     * 随访状态 1：已申请
     * @type {Number}
     */
    FOLLOWUP_STATE_ALREADY_APPLY:1,
    /**
     * 随访状态 2：已接受
     * @type {Number}
     */
    FOLLOWUP_STATE_ALREADY_ACCEPT:2,
    /**
     * 随访状态 3：已拒绝
     * @type {Number}
     */
    FOLLOWUP_STATE_ALREADY_REFUSE:3
}
export {PatientDoctorFollowupState}
/**
 * 显示类型
 */
let ManagerRedisType = {
    /**
     * 管理台用户角色
     * @type {String}
     */
    MANAGER_USER_ROLE:"MANAGER_USER_ROLE_",
    /**
     * 管理台用户权限
     * @type {String}
     */
    MANAGER_USER_MENU:"MANAGER_USER_MENU_",
    /**
     * 用户权限与角色
     * @type {String}
     */
    MANAGER_USER_MENU_ROLE:"MANAGER_USER_MENU_ROLE_"
}
export {ManagerRedisType}
/**
 * 医院级别
 */
let HospitalLevel = {
    /**
     * 一级甲等
     * @type {Number}
     */
    FIRST_CLASS_A:1,
    /**
     * 二级甲等
     * @type {Number}
     */
    SECOND_CLASS_A:2,
    /**
     * 三级甲等
     * @type {Number}
     */
    THIRD_CLASS_A:3,
    /**
     * 一级乙等
     * @type {Number}
     */
    FIRST_CLASS_B:4,
    /**
     * 二级乙等
     * @type {Number}
     */
    SECOND_CLASS_B:5,
    /**
     * 三级乙等
     * @type {Number}
     */
    THIRD_CLASS_B:6,
    /**
     * 一级丙等
     * @type {Number}
     */
    FIRST_CLASS_C:7,
    /**
     * 二级丙等
     * @type {Number}
     */
    SECOND_CLASS_C:8,
    /**
     * 三级丙等
     * @type {Number}
     */
    THIRD_CLASS_C:9,
    /**
     * 三级特等
     * @type {Number}
     */
    TERTIARY_SPECIAL:10
}
export {HospitalLevel}
/**
 * 订单类型
 */
let OrderKind = {
    /**
     * 复印病史
     * @type {Number}
     */
    COPY_MEDICAL:1,
    /**
     * 图文咨询
     * @type {Number}
     */
    CONSULT:2,
    /**
     * 提现
     * @type {Number}
     */
    OUT_CASH:3,
    /**
     * 充值
     * @type {Number}
     */
    OUT_RECHARGE:4,
    /**
     * 分答
     * @type {Number}
     */
    OUT_REPLY:5,
    /**
     * 商城产品
     * @type {Number}
     */
    MALL:6,
    /**
     * 一问医答
     * @type {Number}
     */
    ASK_ANSWERS:7,
    /**
     * 预约体检
     * @type {Number}
     */
    APPOINTMENT_EXAMINATION:8,
    /**
     * 积分商城
     * @type {Number}
     */
    POINTS_MALL:9,
    /**
     * 荟亨
     * @type {Number}
     */
    HUI_HENG:10,
    /**
     * 医生咨询
     * @type {Number}
     */
    DOCTOR_CONSULTATION:11
}
export {OrderKind}
/**
 * 无能力状态枚举
 */
let IncapableStateEnum = {
    /**
     * 疑似无能力
     * @type {Number}
     */
    SUSPECTED:1,
    /**
     * 确认无能力
     * @type {Number}
     */
    CONFIRM:2
}
export {IncapableStateEnum}
/**
 * 代理处理状态
 */
let AgentHandlerState = {
    /**
     * 已提交
     * @type {Number}
     */
    SUBMIT:1,
    /**
     * 待处理
     * @type {Number}
     */
    PENDING:2,
    /**
     * 已处理
     * @type {Number}
     */
    PROCESSED:3
}
export {AgentHandlerState}
/**
 * 疾病处方药类型
 */
let PatientDiseasesAndPrescriptionType = {
    /**
     * 疾病类型
     * @type {Number}
     */
    DISEASE_TYPE:3,
    /**
     * 处方药类型
     * @type {Number}
     */
    PRESCRIPTION_TYPE:2
}
export {PatientDiseasesAndPrescriptionType}
/**
 * 消息分类
 */
let MessageClassify = {
    /**
     * 常规消息
     * @type {Number}
     */
    CONVENTION:1,
    /**
     * 核算消息
     * @type {Number}
     */
    CALCULATE:2,
    /**
     * 预告消息
     * @type {Number}
     */
    PREDICTION:3
}
export {MessageClassify}
/**
 * 电话随访抽查类型
 */
let CallTaskSpotCheckType = {
    /**
     * 荟医管理台抽查
     * @type {Number}
     */
    SPOT_CHECK_TYPE_MANAGER:1,
    /**
     * 电话随访外抽查
     * @type {Number}
     */
    SPOT_CHECK_TYPE_EXTERNAL:2
}
export {CallTaskSpotCheckType}
/**
 * 日志状态
 */
let LogState = {
    /**
     * 审核中
     * @type {Number}
     */
    LOG_STATE_EXAMINE:0,
    /**
     * 审核未通过
     * @type {Number}
     */
    LOG_STATE_REFUSE:1,
    /**
     * 审核私密通过
     * @type {Number}
     */
    R_STATE_SEE_PRIVATE_PASS:2,
    /**
     * 审核通过
     * @type {Number}
     */
    R_STATE_SEE_PASS:3
}
export {LogState}
/**
 * 质控跟踪状态
 */
let QualityTrackState = {
    /**
     * 待跟踪
     * @type {Number}
     */
    TO_BE_TRACK:1,
    /**
     * 跟踪完成
     * @type {Number}
     */
    TRACK_COMPLETE:2
}
export {QualityTrackState}
/**
 * 条件类型枚举
 */
let ConditionEnum = {
    /**
     * =
     * @type {String}
     */
    A:"1",
    /**
     * !=
     * @type {String}
     */
    B:"2",
    /**
     * =null
     * @type {String}
     */
    C:"3",
    /**
     * !=null
     * @type {String}
     */
    D:"4",
    /**
     * >
     * @type {String}
     */
    E:"5",
    /**
     * >=
     * @type {String}
     */
    F:"6",
    /**
     * <
     * @type {String}
     */
    G:"7",
    /**
     * <=
     * @type {String}
     */
    H:"8",
    /**
     * like
     * @type {String}
     */
    I:"9",
    /**
     * not like
     * @type {String}
     */
    J:"10",
    /**
     * in
     * @type {String}
     */
    K:"11"
}
export {ConditionEnum}
/**
 * 阿里微信交易状态
 */
let AWOrderStatus = {
    /**
     * 阿里付款成功
     * @type {Number}
     */
    ALIPAY_TRADE_SUCCESS:3,
    /**
     * 微信付款成功
     * @type {Number}
     */
    WEIXIN_TRADE_SUCCESS:3
}
export {AWOrderStatus}
/**
 * 强迫症问卷类型
 */
let ObsessionQuestionnaireType = {
    /**
     * 强迫症程度如何
     * @type {Number}
     */
    OBSESSION_DEGREE:1,
    /**
     * 强迫类型是什么
     * @type {Number}
     */
    OBSESSION_TYPE:2,
    /**
     * 抑郁程度如何
     * @type {Number}
     */
    DEPRESSION_DEGREE:3,
    /**
     * 焦虑程度如何
     * @type {Number}
     */
    ANXIOUS_DEGREE:4,
    /**
     * 服药依从性
     * @type {Number}
     */
    TAKING_MEDICINE_COMPLIANCE:5,
    /**
     * 生活受到了多大影响
     * @type {Number}
     */
    LIFE_INFLUENCE:6
}
export {ObsessionQuestionnaireType}
/**
 * 这里是预定义变量
 */
let BaseMarco = {
    /**
     * 荟医系统用户
     * @type {Number}
     */
    USER_HUIYI_SYSTEM:10000,
    /**
     * 荟医系统用户需要分成
     * @type {Number}
     */
    OTHER_USER_HUIYI_SYSTEM:10001,
    /**
     * CODE-成功
     * @type {Number}
     */
    CODE_SUCCESS:0,
    /**
     * CODE-服务器内部错误
     * @type {Number}
     */
    CODE_INTER_FAIL:-1,
    /**
     * CODE-失败
     * @type {Number}
     */
    CODE_FAIL:-2,
    /**
     * CODE-需要重新登录
     * @type {Number}
     */
    CODE_NEED_RELOGIN:-3,
    /**
     * CODE-需要设置支付密码
     * @type {Number}
     */
    CODE_NEED_SETPAYPASSWORD:-4,
    /**
     * CODE-需要输入支付密码
     * @type {Number}
     */
    CODE_NEED_PAYPASSWORD:-5,
    /**
     * CODE-匹配错误
     * @type {Number}
     */
    CODE_MATCHING_ERROR:-6,
    /**
     * 校验随访错误
     * @type {Number}
     */
    CODE_CHECKING_FOLLOWUP_ERROR:-7,
    /**
     * CODE-重试
     * @type {Number}
     */
    CODE_RETRY:-8,
    /**
     * 家庭
     * @type {Number}
     */
    USER_TYPE_F:1,
    /**
     * 医生
     * @type {Number}
     */
    USER_TYPE_D:2,
    /**
     * 样本库
     * @type {Number}
     */
    USER_TYPE_Y:3,
    /**
     * 精卫
     * @type {Number}
     */
    USER_TYPE_M:4,
    /**
     * 胰腺
     * @type {Number}
     */
    USER_TYPE_YX:5,
    /**
     * 设备型号-安卓
     * @type {String}
     */
    OS_NAME_ANDROID:"Android",
    /**
     * 设备型号-苹果
     * @type {String}
     */
    OS_NAME_IOS:"iOS",
    /**
     * 设备型号-微信
     * @type {String}
     */
    OS_NAME_WEIXIN:"WEIXIN",
    /**
     * 设备型号-样本库
     * @type {String}
     */
    OS_NAME_YBK:"YBK",
    /**
     * 权限-患者
     * @type {String}
     */
    ROLE_PATIENT:"ROLE_PATIENT",
    /**
     * 权限-医生
     * @type {String}
     */
    ROLE_DOCTOR:"ROLE_DOCTOR",
    /**
     * 权限-样本库
     * @type {String}
     */
    ROLE_YBK:"ROLE_YBK",
    /**
     * 权限-胰腺
     * @type {String}
     */
    ROLE_YX:"ROLE_YX",
    /**
     * 卡类别-身份证
     * @type {Number}
     */
    CARD_TYPE_ID:1,
    /**
     * 卡类别-护照
     * @type {Number}
     */
    CARD_TYPE_PASSPORT:2,
    /**
     * 卡类别-住院号
     * @type {Number}
     */
    CARD_TYPE_HOSPITAL:3,
    /**
     * 性别-男
     * @type {Number}
     */
    SEX_MAN:1,
    /**
     * 性别-女
     * @type {Number}
     */
    SEX_WOMAN:2,
    /**
     * 性别-不祥
     * @type {Number}
     */
    SEX_OMINOUS:3,
    /**
     * 报告类型-检验报告
     * @type {Number}
     */
    REPORT_TYPE_LAB:1,
    /**
     * 报告类型-检查报告
     * @type {Number}
     */
    REPORT_TYPE_IMAGE:2,
    /**
     * 数据来源-同步更新
     * @type {Number}
     */
    REPORT_SOURCE_ASYNC:1,
    /**
     * 数据来源-手动上传
     * @type {Number}
     */
    REPORT_SOURCE_MANUAL:2,
    /**
     * 数据来源-电话随访表格导入
     * @type {Number}
     */
    REPORT_SOURCE_CALL_CENTER:3,
    /**
     * 就诊类型-门诊
     * @type {Number}
     */
    VISITING_TYPE_OD:0,
    /**
     * 就诊类型-住院
     * @type {Number}
     */
    VISITING_TYPE_H:1,
    /**
     * 就诊类型-体检
     * @type {Number}
     */
    VISITING_TYPE_PE:2,
    /**
     * 就诊类型-其他
     * @type {Number}
     */
    VISITING_TYPE_OTHER:3,
    /**
     * 是否是专家门诊-是
     * @type {Number}
     */
    SPECIALIST_CLINIC_Y:1,
    /**
     * 是否是专家门诊-否
     * @type {Number}
     */
    SPECIALIST_CLINIC_N:2,
    /**
     * 服药提醒，稍后提醒最大次数
     * @type {Number}
     */
    MAX_LATER_FREQUENCY:4,
    /**
     * 登录次数校验KEY
     * @type {String}
     */
    LOGIN_TIMES_CHECK_KEY:"LOGIN_TIMES_CHECK_",
    /**
     * 登录次数
     * @type {Number}
     */
    LOGIN_TIMES_CHECK_VALUE:4
}
export {BaseMarco}
/**
 * 交易状态动作
 */
let OrderStatusAction = {
    /**
     * 买家下单
     * @type {Number}
     */
    BuyerOrder:0,
    /**
     * 买家支付
     * @type {Number}
     */
    BuyerPay:1,
    /**
     * 买家取消订单
     * @type {Number}
     */
    BuyerCancelOrder:2,
    /**
     * 商家接受
     * @type {Number}
     */
    SellerAcceptedOrder:3,
    /**
     * 商家拒绝
     * @type {Number}
     */
    SellerNoAccepted:4,
    /**
     * 买家确认收货
     * @type {Number}
     */
    BuyerReceived:5,
    /**
     * 买家申请售后
     * @type {Number}
     */
    BuyerApplyAfterSale:6,
    /**
     * 商家同意退款
     * @type {Number}
     */
    SellerAcceptedRefunded:7,
    /**
     * 商家线下处理
     * @type {Number}
     */
    SellerUnderLineTreatment:8,
    /**
     * 自动取消
     * @type {Number}
     */
    AutoCancel:9,
    /**
     * 需要买家重新填写
     * @type {Number}
     */
    NeedBuyerRefill:10,
    /**
     * 买家重新填写
     * @type {Number}
     */
    BuyerRefill:11,
    /**
     * 自动确认收货
     * @type {Number}
     */
    AutoReceived:12,
    /**
     * 过期自动拒绝
     * @type {Number}
     */
    AutoNoAccepted:13,
    /**
     * 已发货
     * @type {Number}
     */
    AlreadyDeliverGoods:14,
    /**
     * 修改价格
     * @type {Number}
     */
    ChangePrice:15,
    /**
     * 运输中
     * @type {Number}
     */
    OnRoad:16,
    /**
     * 买家评价
     * @type {Number}
     */
    BuyerComment:17,
    /**
     * 套餐全部核销
     * @type {Number}
     */
    PackageAllSettlement:18
}
export {OrderStatusAction}
/**
 * 时间轴类型枚举
 */
let SdsTimeAxisTypeEnum = {
    /**
     * 门诊
     * @type {Number}
     */
    OUTPATIENT:0,
    /**
     * 入院
     * @type {Number}
     */
    IN_HOSPITAL:1,
    /**
     * 手术
     * @type {Number}
     */
    OPERATION:3,
    /**
     * 随访详情
     * @type {Number}
     */
    FOLLOWUP:4,
    /**
     * 复发
     * @type {Number}
     */
    RELAPSE:5,
    /**
     * 转移
     * @type {Number}
     */
    TRANSFER:6,
    /**
     * 出院
     * @type {Number}
     */
    OUT_HOSPITAL:7,
    /**
     * 死亡
     * @type {Number}
     */
    DEATH:8
}
export {SdsTimeAxisTypeEnum}

//  [新随访呼叫中心]     查询患者标签
export {RestNewFollowupCallCenterServiceQueryTagByPatient}
//  [新随访呼叫中心]     查询任务标签
export {RestNewFollowupCallCenterServiceQueryTaskTag}
//  [新随访呼叫中心]     呼叫台添加患者标签
export {RestNewFollowupCallCenterServiceAddPatientTag}
//  [新随访呼叫中心]     呼叫台删除患者标签
export {RestNewFollowupCallCenterServiceDeletePatientTag}
//  [新随访呼叫中心]     获取当前任务添加的学习文件
export {RestNewFollowupCallCenterServiceGetFileListByTaskId}
//  [新随访呼叫中心]     获取文件夹名称
export {RestNewFollowupCallCenterServiceGetFolderNameList}
//  [新随访呼叫中心]     获取预览文件的url
export {RestNewFollowupCallCenterServiceGetPreviewFileUrl}
//  [新随访呼叫中心]     问卷录入页面的患者详情
export {RestNewFollowupCallCenterServiceGetPatientInfoQuestionnaire}
//  [新随访呼叫中心]     提交问卷录入记录
export {RestNewFollowupCallCenterServiceAddSubmitRecord}
//  [新随访呼叫中心]     稍后拨打提示
export {RestNewFollowupCallCenterServiceGetCallReminderLater}
//  [新随访呼叫中心]     添加或选择手机标签
export {RestNewFollowupCallCenterServiceAddOrSelectPhoneLabel}
//  [新随访呼叫中心]     获取手机号标签列表
export {RestNewFollowupCallCenterServiceGetPhoneLabelList}
//  [新随访呼叫中心]     获取今日随访完成的患者详情
export {RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo}
//  [新随访呼叫中心]     获取今日随访完成
export {RestNewFollowupCallCenterServiceGetFollowUpTodayComplete}
//  [新随访呼叫中心]     获取今日完成随访的数量
export {RestNewFollowupCallCenterServiceGetFollowUpTodayCompleteCount}
//  [新随访呼叫中心]     根据随访id和患者id查询随访情况
export {RestNewFollowupCallCenterServiceGetFollowUpPatientCondition}
//  [新随访呼叫中心]     添加通话的等待时间
export {RestNewFollowupCallCenterServiceAddRecordWaitingTime}
//  [新随访呼叫中心]     获取任务下的学习模块
export {RestNewFollowupCallCenterServiceGetStudyListByTask}
//  [新随访呼叫中心]     获取一条学习
export {RestNewFollowupCallCenterServiceGetStudyById}
//  [新随访呼叫中心]     该坐席今日已随访
export {RestNewFollowupCallCenterServiceGetTodayFollowupCount}
//  [新随访呼叫中心]     更改坐席随访权限
export {RestNewFollowupCallCenterServiceUpdateSeatFollowUpPermission}
//  [新随访呼叫中心]     查询随访任务池列表
export {RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskList}
//  [新随访呼叫中心]     查询坐席是否允许随访
export {RestNewFollowupCallCenterServiceGetSeatsIsAllowFollowup}
//  [新随访呼叫中心]     根据坐席号查询随访任务池列表
export {RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskListByUserId}
//  [新随访呼叫中心]     根据任务状态查询随访任务池列表
export {RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskListByStatus}
//  [新随访呼叫中心]     获取疾病分类 有字段的
export {RestNewFollowupCallCenterServiceGetDiseaseClassificationList}
//  [新随访呼叫中心]     获取统计任务详情
export {RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo}
//  [新随访呼叫中心]     获取短信发送记录
export {RestNewFollowupCallCenterServiceGetSmsSendRecord}
//  [新随访呼叫中心]     获取随访任务患者信息
export {RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo}
//  [新随访呼叫中心]     获取未完成随访任务患者信息
export {RestNewFollowupCallCenterServiceGetIncompleteFollowupTaskPatientInfo}
//  [新随访呼叫中心]     获取该任务下该坐席所有复核池患者信息
export {RestNewFollowupCallCenterServiceGetReviewFollowupTaskPatientInfoList}
//  [新随访呼叫中心]     获取异常随访任务患者信息
export {RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfo}
//  [新随访呼叫中心]     获取该任务下该坐席所有异常随访任务患者信息
export {RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList}
//  [新随访呼叫中心]     获取稍后拨打随访任务患者信息
export {RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfo}
//  [新随访呼叫中心]     获取该任务下该坐席所有稍后拨打随访任务患者信息
export {RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList}
//  [新随访呼叫中心]     获取该任务下该坐席所有稍后拨打、异常随访任务患者信息
export {RestNewFollowupCallCenterServiceGetAllFollowupTaskPatientInfoList}
//  [新随访呼叫中心]     获取随访患者备注
export {RestNewFollowupCallCenterServiceGetFollowupPatientRemarks}
//  [新随访呼叫中心]     更新随访患者备注
export {RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks}
//  [新随访呼叫中心]     获取随访患者联系方式
export {RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList}
//  [新随访呼叫中心]     获取获取荟茁注册状态
export {RestNewFollowupCallCenterServiceGetHuiZhuoRegisterState}
//  [新随访呼叫中心]     根据联系方式获取通话记录
export {RestNewFollowupCallCenterServiceGetPhoneRecordInfoListByPhoneNumber}
//  [新随访呼叫中心]     添加随访患者联系方式
export {RestNewFollowupCallCenterServiceAddFollowupPatientContactInformation}
//  [新随访呼叫中心]     批量添加随访患者联系方式
export {RestNewFollowupCallCenterServiceBatchAddFollowupPatientContactInformation}
//  [新随访呼叫中心]     编辑随访患者联系方式
export {RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation}
//  [新随访呼叫中心]     发送随访短信
export {RestNewFollowupCallCenterServiceSendingFollowupSms}
//  [新随访呼叫中心]     发送随访短信2
export {RestNewFollowupCallCenterServiceSendingFollowupSmsTask}
//  [新随访呼叫中心]     根据短信code查询短信模板
export {RestNewFollowupCallCenterServiceGetSmsTemplateByCode}
//  [新随访呼叫中心]     获取子短信模板列表
export {RestNewFollowupCallCenterServiceGetSonSmsTemplateList}
//  [新随访呼叫中心]     第一次保存呼叫记录
export {RestNewFollowupCallCenterServiceFirstUpdatePhoneNumberCallState}
//  [新随访呼叫中心]     第二次保存呼叫记录
export {RestNewFollowupCallCenterServiceUpdatePhoneNumberCallState}
//  [新随访呼叫中心]     更新随访任务异常呼叫或稍后拨打
export {RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater}
//  [新随访呼叫中心]     更新随访患者信息
export {RestNewFollowupCallCenterServiceUpdateFollowupPatient}
//  [新随访呼叫中心]     获取最后随访问卷历史
export {RestNewFollowupCallCenterServiceGetLastFollowupQuestionnaireHistory}
//  [新随访呼叫中心]     获取疾病短信模板列表
export {RestNewFollowupCallCenterServiceGetDiseaseSmsTemplateList}
//  [新随访呼叫中心]     获取随访短信模板列表
export {RestNewFollowupCallCenterServiceGetSmsTemplateTaskList}
//  [新随访呼叫中心]     获取住院号获取历史随访数据
export {RestNewFollowupCallCenterServiceGetAdmitNoAndHistoryFollowupData}
//  [新随访呼叫中心]     获取随访任务抽查统计
export {RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckStatistics}
//  [新随访呼叫中心]     获取随访任务抽查列表
export {RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckList}
//  [新随访呼叫中心]     获取随访任务重播患者详情
export {RestNewFollowupCallCenterServiceGetFollowupTaskReplayPatientInfo}
//  [新随访呼叫中心]     得到录音列表
export {RestNewFollowupCallCenterServiceGetALiRecording}
//  [新随访呼叫中心]     获取合格的抽查记录
export {RestNewFollowupCallCenterServiceGetQualifiedSpotCheckList}
//  [新随访呼叫中心]     获取学习页面随访任务所有抽查记录
export {RestNewFollowupCallCenterServiceGetFollowUpTaskAllSpotCheck}
//  [新随访呼叫中心]     根据任务id获取该任务下的坐席
export {RestNewFollowupCallCenterServiceGetSeatsByTaskId}
//  [新随访呼叫中心]     根据质检id当前质检的结果动态
export {RestNewFollowupCallCenterServiceUpdateQualityResultDynamicById}
//  [新随访呼叫中心]     根据参数修改随访患者信息
export {RestNewFollowupCallCenterServiceUpdateFollowUpPatientInfoByParams}
//  [新随访呼叫中心]     获取全部任务抽查待完成列表
export {RestNewFollowupCallCenterServiceGetAllTaskSpotCheckToDoList}
//  [新随访呼叫中心]     获取等级关系
export {RestNewFollowupCallCenterServiceGetLevelRelationship}
//  [新随访呼叫中心]     获取全部等级关系
export {RestNewFollowupCallCenterServiceGetAllRelationshipLevel}
//  [新随访呼叫中心]     修改录音分割点
export {RestNewFollowupCallCenterServiceUpdateRecordingSplitPoint}
//  [新随访呼叫中心]     取消录音分割点
export {RestNewFollowupCallCenterServiceCancellationRecordingSplitPoint}
//  [新随访呼叫中心]     修改随访患者无能力状态
export {RestNewFollowupCallCenterServiceUpdateSuspectedIncapableState}
//  [新随访呼叫中心]     获取随访任务开关标记
export {RestNewFollowupCallCenterServiceGetFollowUpTaskSwitchMark}
//  [新随访呼叫中心]     获取随访任务复杂重拨列表
export {RestNewFollowupCallCenterServiceGetFollowUpTaskComplexReplayList}
//  [新随访呼叫中心]     获取新手保护结束时间
export {RestNewFollowupCallCenterServiceGetNoviceProtectionEndTime}
//  [新随访呼叫中心]     校验电话号码
export {RestNewFollowupCallCenterServiceCheckPhoneNumber}
//  [新随访呼叫中心]     获取号码运营商
export {RestNewFollowupCallCenterServiceGetPhoneNumberOperator}
//  [新随访呼叫中心]     获取呼叫记录挂断方
export {RestNewFollowupCallCenterServiceGetCallRecordReleaseInitiator}
//  [新随访呼叫中心]     获取号码情况
export {RestNewFollowupCallCenterServiceGetPhoneNumberStatus}
//  [新随访呼叫中心]     添加号码状态异常呼叫记录
export {RestNewFollowupCallCenterServiceAddPhoneNumberStateAbnormalCallRecord}
//  [最佳随访案例]     最佳随访案例列表
export {RestBestFollowupCaseCallcenterControllerQueryBestFollowupCaseList}
//  [最佳随访案例]     根据推送月份获取截止时间
export {RestBestFollowupCaseCallcenterControllerQueryEndTimeInfoByPullMonth}
//  [最佳随访案例]     根据案例id获取录音
export {RestBestFollowupCaseCallcenterControllerQueryBestRecordByCaseId}
//  [最佳随访案例]     更改录音状态
export {RestBestFollowupCaseCallcenterControllerUpdateStatus}
//  [最佳随访案例]     投票机制
export {RestBestFollowupCaseCallcenterControllerVote}
//  [最佳随访案例]     历史榜单
export {RestBestFollowupCaseCallcenterControllerHistoricalList}
//  [最佳随访案例]     最佳随访案例消息
export {RestBestFollowupCaseCallcenterControllerRecentNews}
//  [最佳随访案例]     获取要投票的月份
export {RestBestFollowupCaseCallcenterControllerQueryPullMonth}
//  [呼叫中心平台pc展示消息]     展示最新消息
export {RestPCMessageCallcenterControllerGetNewestMessage}
//  [异常随访自定义文件夹]     添加或修改异常随访文件夹
export {RestAbnormalFollowupFileControllerEditExceptionFile}
//  [异常随访自定义文件夹]     删除异常随访文件夹
export {RestAbnormalFollowupFileControllerDeleteExceptionFile}
//  [异常随访自定义文件夹]     查询异常随访文件夹
export {RestAbnormalFollowupFileControllerGetExceptionFile}
//  [异常随访自定义文件夹]     根据文件夹id获取患者信息
export {RestAbnormalFollowupFileControllerGetExceptionPatient}
//  [异常随访自定义文件夹]     将患者添加到文件夹
export {RestAbnormalFollowupFileControllerAddPatientToFile}
//  [异常随访自定义文件夹]     获取下一个异常患者id
export {RestAbnormalFollowupFileControllerGetNextExceptionFollowupPatientId}
//  [呼叫中心]     获取坐席的外呼号码
export {RestCallCenterServiceGetPhoneNumber}
//  [呼叫中心]     电话任务统计数
export {RestCallCenterServiceGetCallTaskStatistics}
//  [呼叫中心]     添加患者手机号码
export {RestCallCenterServiceAddPatientPhoneNumber}
//  [呼叫中心]     更新患者手机号码或状态
export {RestCallCenterServiceUpdatePatientPhoneNumber}
//  [呼叫中心]     电话随访为患者添加备注
export {RestCallCenterServiceAddPatientLabel}
//  [呼叫中心]     电话随访获取患者备注
export {RestCallCenterServiceGetPatientLabel}
//  [呼叫中心]     获取呼叫患者信息
export {RestCallCenterServiceGetCallPatient}
//  [呼叫中心]     添加本次呼叫状态(是否已失访)
export {RestCallCenterServiceAddCallRecord}
//  [呼叫中心]     批量发送短信
export {RestCallCenterServiceSendingBatchSms}
//  [呼叫中心]     获取异常随访人
export {RestCallCenterServiceGetAbnormalCallPatient}
//  [呼叫中心]     随访成功
export {RestCallCenterServiceFollowupSuccess}
//  [呼叫中心]     获取所有关系列表
export {RestCallCenterServiceGetAllRelationship}
//  [呼叫中心]     获取随访任务主节点
export {RestCallCenterServiceGetVisitingRootTasks}
//  [呼叫中心]     获取随访任务
export {RestCallCenterServiceGetVisitingTasks}
//  [呼叫中心]     分页获取患者就诊记录列表
export {RestCallCenterServiceGetCallPatientVisitingRecords}
//  [呼叫中心]     获取周期统计数
export {RestCallCenterServiceGetCallPeriodicStatistics}
//  [呼叫中心]     按照任务状态获取任务列表
export {RestCallCenterServiceGetTaskCenterList}
//  [呼叫中心]     分页获取患者检查记录列表
export {RestCallCenterServiceGetCallPatientInspectionReportList}
//  [呼叫中心]     获取任务医院列表
export {RestCallCenterServiceGetCallTaskHospitalNameList}
//  [呼叫中心]     获取任务科室列表
export {RestCallCenterServiceGetCallTaskDeptNameList}
//  [呼叫中心]     获取重播患者信息
export {RestCallCenterServiceGetReplayCallPatient}
//  [呼叫中心]     获取患者更多信息
export {RestCallCenterServiceGetPatientMoreInformation}
//  [呼叫中心]     获取用户任务抽查统计数
export {RestCallCenterServiceGetUserTaskSpotCheckStatistics}
//  [呼叫中心]     获取抽查记录
export {RestCallCenterServiceGetUserTaskSpotCheckList}
//  [呼叫中心]     获取录音列表
export {RestCallCenterServiceGetCallSoundRecording}
//  [随访任务标签]     获取任务标签
export {RestCallCenterPersonTagsControllerGetTags}
//  [随访任务标签]     获取患者任务标签
export {RestCallCenterPersonTagsControllerGetPatientTags}
//  [随访任务标签]     修改患者任务标签
export {RestCallCenterPersonTagsControllerEditPatientTags}
//  [呼叫平台反馈]     添加意见反馈
export {RestFeedbackOutControllerAddFeedBack}
//  [呼叫平台反馈]     分页获取患者就诊信息
export {RestFeedbackOutControllerGetPatientMedicalRecordList}
//  [呼叫平台反馈]     根据VisitingNo获取就诊详细信息
export {RestFeedbackOutControllerGetVisitingNoMedicalRecordDetail}
//  [呼叫平台反馈]     获取就诊报告明细
export {RestFeedbackOutControllerGetInspectionReportDetailed}
//  [呼叫平台反馈]     获取是否全读状态-0：未全读，1-已全读
export {RestFeedbackOutControllerGetIsAllRead}
//  [呼叫平台反馈]     获取反馈列表
export {RestFeedbackOutControllerGetFeedbackList}
//  [呼叫平台反馈]     确认反馈消息
export {RestFeedbackOutControllerConfirmFeedbackById}
//  [呼叫平台反馈]     呼叫平台-质控主页面
export {RestFeedbackOutControllerMainOfController}
//  [呼叫平台反馈]     获取随访任务患者信息
export {RestFeedbackOutControllerGetFollowupTaskPatientInfo}
//  [呼叫平台反馈]     质控开始时间
export {RestFeedbackOutControllerAddFollowupQualityTime}
//  [呼叫平台反馈]     质控结束时间
export {RestFeedbackOutControllerUpdateFollowupQualityTime}
//  [呼叫平台反馈]     得到录音列表
export {RestFeedbackOutControllerGetALiRecording}
//  [呼叫平台反馈]     获取患者随访任务当前状态
export {RestFeedbackOutControllerGetFollowupTaskCurrentState}
//  [呼叫平台反馈]     只查询题目和答案
export {RestFeedbackOutControllerQueryOnlyQuestionAndAnswer}
//  [呼叫平台反馈]     获取随访任务患者呼叫记录列表
export {RestFeedbackOutControllerGetFollowUpTaskPatientCallRecordList}
//  [呼叫平台反馈]     添加随访抽查记录
export {RestFeedbackOutControllerAddFollowupSpotCheckRemarks}
//  [呼叫平台反馈]     更新抽查记录
export {RestFeedbackOutControllerUpdateFollowupSpotCheck}
//  [呼叫平台反馈]     获取随访抽查记录
export {RestFeedbackOutControllerGetFollowupSpotCheckRemarksList}
//  [呼叫平台反馈]     获取质控时间阶段
export {RestFeedbackOutControllerGetQualityTimeStage}
//  [呼叫平台反馈]     获取可抽查的用户列表
export {RestFeedbackOutControllerGetAbleSpotCheckUserList}
//  [呼叫平台反馈]     获取今日质控人数
export {RestFeedbackOutControllerGetTodayQualityCount}
//  [呼叫平台反馈]     查询任务坐席列表
export {RestFeedbackOutControllerQueryFollowUpPeopleTaskList}
//  [呼叫平台反馈]     获取重播不合格任务启用坐席列表
export {RestFeedbackOutControllerGetReplayUnqualifiedTaskEnableSeatsList}
//  [呼叫平台反馈]     获取质控规则
export {RestFeedbackOutControllerGetQualityRule}
//  [呼叫平台反馈]     获取呼叫记录
export {RestFeedbackOutControllerGetRecordList}
//  [呼叫平台反馈]     是否提醒去听录音
export {RestFeedbackOutControllerIsRemind}
//  [呼叫平台反馈]     更新呼叫记录
export {RestFeedbackOutControllerUpdateRecordList}
//  [呼叫平台反馈]     判断质控员是否在关联任务下
export {RestFeedbackOutControllerIsInRelationTask}
//  [呼叫平台反馈]     根据id集合删除质控提醒
export {RestFeedbackOutControllerDeleteRemindByIds}
//  [呼叫平台反馈]     获取审核不通过反馈列表
export {RestFeedbackOutControllerGetPassFailFeedBackList}
//  [呼叫平台反馈]     获取随访患者复核
export {RestFeedbackOutControllerGetFollowupPatientReview}
//  [呼叫平台反馈]     分页获取患者就诊信息
export {RestFeedbackOutControllerGetPatientMedicalRecordNewList}
//  [呼叫平台反馈]     获取患者入院报告
export {RestFeedbackOutControllerGetPatientAdmissionRecord}
//  [呼叫平台反馈]     获取患者出院报告
export {RestFeedbackOutControllerGetPatientDischargeRecord}
//  [呼叫平台反馈]     获取患者手术记录
export {RestFeedbackOutControllerGetPatientSurgeryRecord}
//  [新随访问卷服务]     获取问卷质控规则更新提示
export {RestNewFollowupQuestionListServiceGetUpdateTips}
//  [新随访问卷服务]     更新是否已读
export {RestNewFollowupQuestionListServiceUpdateIsRead}
//  [新随访问卷服务]     根据问题获取规则
export {RestNewFollowupQuestionListServiceQueryRuleByCondition}
//  [新随访问卷服务]     查询问卷标记
export {RestNewFollowupQuestionListServiceGetTips}
//  [新随访问卷服务]     获取随访任务问卷ID
export {RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId}
//  [新随访问卷服务]     查询页码和题目标题属性列表
export {RestNewFollowupQuestionListServiceQueryPageAndQuestionList}
//  [新随访问卷服务]     查询下一页上一页页码和题目信息列表
export {RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePage}
//  [新随访问卷服务]     查询下一页上一页页码和题目信息列表
export {RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePageNew}
//  [新随访问卷服务]     新增患者答题信息
export {RestNewFollowupQuestionListServiceAddPatientAnswerInfo}
//  [新随访问卷服务]     保存患者答题信息（正常和异常）
export {RestNewFollowupQuestionListServiceUpdatePatientAnswerInfoById}
//  [新随访问卷服务]     查询页码信息
export {RestNewFollowupQuestionListServiceQueryQuestionPageList}
//  [新随访问卷服务]     新增患者问卷答题表
export {RestNewFollowupQuestionListServiceAddPatientQuestionnaireAnswer}
//  [新随访问卷服务]     修改患者问卷答题表
export {RestNewFollowupQuestionListServiceUpdatePatientQuestionnaireAnswer}
//  [新随访问卷服务]     查询患者问卷答题表
export {RestNewFollowupQuestionListServiceQueryPatientQuestionnaireAnswer}
//  [新随访问卷服务]     填充电话问卷答案
export {RestNewFollowupQuestionListServiceFillTelQuestionnaireNewAnswer}
//  [新随访问卷服务]     获取问卷分页列表
export {RestNewFollowupQuestionListServiceGetQuestionnairePageList}
//  [新随访问卷服务]     根据ID删除答案选项信息
export {RestNewFollowupQuestionListServiceDelAnswerOptionById}
//  [新随访问卷服务]     批量添加患者答题信息
export {RestNewFollowupQuestionListServiceBatchAddPatientAnswerInfo}
//  [新随访问卷服务]     预览问卷
export {RestNewFollowupQuestionListServicePreviewQuestionnaire}
//  [新随访问卷服务]     预览任务
export {RestNewFollowupQuestionListServicePreviewTask}
//  [新随访问卷服务]     根据任务id集合和坐席id查询有学习资料更新的任务id
export {RestNewFollowupQuestionListServiceGetTaskIds}
//  [新随访问卷服务]     根据任务id和坐席id查询有更新的学习资料id
export {RestNewFollowupQuestionListServiceGetStudyIds}
//  [新随访问卷服务]     删除学习资料任务坐席中间表
export {RestNewFollowupQuestionListServiceDeleteMiddleTableRecord}
//  [华为云客服服务]     创建华为呼叫
export {RestHuaWeiCECControllerCreateHuaWeiTwoCall}
//  [备注优化]     编辑随访备注
export {RestRemarksCallcenterControllerEditTags}
//  [备注优化]     获取随访备注
export {RestRemarksCallcenterControllerGetTags}
//  [备注优化]     添加交付备注
export {RestRemarksCallcenterControllerEditDeliveryRemark}
//  [备注优化]     获取交付备注
export {RestRemarksCallcenterControllerGetDeliveryRemark}
//  [备注优化]     删除随访备注
export {RestRemarksCallcenterControllerDeleteTags}
//  [登录]     登录
export {RestAuthLogin}
//  [登录]     退出登录
export {RestAuthLogout}
//  [问卷优化设计]     根据标签id查询下拉列表内容
export {RestNewQuestionnaireDesignCallcenterControllerQueryQuestionnaireOptionListByTagId}
//  [问卷优化设计]     添加一条选项
export {RestNewQuestionnaireDesignCallcenterControllerAddOneQuestionnaireOption}
//  [问卷优化设计]     根据选型id查询扩展信息
export {RestNewQuestionnaireDesignCallcenterControllerQueryContentByOptionId}
//  [问卷优化设计]     保存选项扩展内容并返回答案信息
export {RestNewQuestionnaireDesignCallcenterControllerSaveOptionExtensionAnswerInfo}
//  [问卷优化设计]     删除答案
export {RestNewQuestionnaireDesignCallcenterControllerDeleteOptionExtensionAnswerInfo}
//  [专病库服务]     获取专病库服务token
export {RestZhuanBingLibraryServerGetZhuanBingLibraryToken}
//  [随访历史数据查询]     患者详情
export {RestReferenceControllerGetPatientInfoManager}
//  [随访历史数据查询]     获取患者呼叫记录
export {RestReferenceControllerGetPatientCallRecord}
//  [随访历史数据查询]     短信发送--患者详情
export {RestReferenceControllerGetSmsSendRecordPatientInfo}
//  [随访历史数据查询]     获取参考信息
export {RestReferenceControllerGetReferenceInfo}
//  [随访历史数据查询]     获取历史随访列表
export {RestReferenceControllerGetAllFollowupList}
//  [随访历史数据查询]     获取交付表信息
export {RestReferenceControllerGetDeliver}
//  [随访历史数据查询]     获取展示字段
export {RestReferenceControllerGetExhibition}
//  [随访历史数据查询]     历史抽查记录
export {RestReferenceControllerGetFollowupSpotCheckRemarksList}
//  [随访历史数据查询]     获取患者参考信息
export {RestReferenceControllerGetPatientReferenceInfo}
//  [随访历史数据查询]     获取参考信息组列表
export {RestReferenceControllerGetReferenceGroupList}
//  [错题集]     获取错题集
export {RestMistakeCollectionControllerGetSeatMistakeCollection}
//  [错题集]     获取问题批注
export {RestMistakeCollectionControllerGetQuestionAnnotations}
//  [错题集]     获取呼叫台错题跳转参数
export {RestMistakeCollectionControllerGetCallCenterMistakeJumpParams}
//  [错题集]     获取任务存在呼叫的月份
export {RestMistakeCollectionControllerGetTaskExistCallMonth}
//  [呼叫中心操作台]     查询坐席指标核算、预告具体表格信息
export {RestCallCenterOperationPlatformControllerGetQuotaTableInfo}
//  [呼叫中心操作台]     呼叫台确认收到指标核算和预告消息
export {RestCallCenterOperationPlatformControllerUpdateMsgConfirmStatus}
//  [呼叫中心操作台]     获取坐席完成和待办信息
export {RestCallCenterOperationPlatformControllerGetSeatFinishAndTodoInfo}
//  [呼叫中心操作台]     获取指定月的所有周星
export {RestCallCenterOperationPlatformControllerGetMonthAllWeekStar}
//  [呼叫中心操作台]     获取当月最后一周周星
export {RestCallCenterOperationPlatformControllerGetCurrentMonthLastWeekStar}
//  [呼叫中心操作台]     获取最后一周周之星消息
export {RestCallCenterOperationPlatformControllerGetMessageWeekStar}
//  [呼叫中心操作台]     点赞或取消点赞
export {RestCallCenterOperationPlatformControllerClickLikeOrCancel}
//  [呼叫中心操作台]     获取当月所有排行榜
export {RestCallCenterOperationPlatformControllerGetCurrentMonthAllRank}
//  [呼叫中心操作台]     获取坐席近一周随访情况
export {RestCallCenterOperationPlatformControllerGetSeatRecentDayFollowupCount}
//  [呼叫中心操作台]     获取系统消息
export {RestCallCenterOperationPlatformControllerGetSystemMessage}
//  [呼叫中心操作台]     系统消息已读
export {RestCallCenterOperationPlatformControllerAddSystemMessageRead}
//  [呼叫中心操作台]     获取坐席时间段统计
export {RestCallCenterOperationPlatformControllerGetSeatTimeSectionStatistics}
//  [呼叫中心操作台]     根据时间筛选获取坐席时间段统计
export {RestCallCenterOperationPlatformControllerGetSeatTimeSectionStatisticsByTime}
//  [呼叫中心操作台]     获取最近活跃任务信息
export {RestCallCenterOperationPlatformControllerGetRecentActiveTaskInfo}
//  [呼叫中心操作台]     获取任务数据坐席比较信息
export {RestCallCenterOperationPlatformControllerGetTaskDataSeatCompareInfo}
//  [呼叫中心操作台]     获取坐席强制推送周之星
export {RestCallCenterOperationPlatformControllerGetForcePushWeekStar}
//  [呼叫中心操作台]     获取坐席月指标
export {RestCallCenterOperationPlatformControllerGetSeatMonthQuota}
//  [短信验证码登录]     发送验证码
export {RestVCodeControllerSendVcode}
//  [回拨服务]     获取随访手机号码匹配患者列表
export {RestIncomingCallControllerGetTelephoneFollowupIncomingCallPatientList}
//  [回拨服务]     获取随访呼入患者详情
export {RestIncomingCallControllerGetFollowupIncomingCallPatientList}
//  [回拨服务]     获取反馈匹配患者列表
export {RestIncomingCallControllerGetFeedbackPatientInformationList}
//  [回拨服务]     添加来电反馈记录
export {RestIncomingCallControllerAddIncomingTelegramAnswerResult}
//  [回拨服务]     添加未接来电记录
export {RestIncomingCallControllerAddMissedCallResult}
//  [回拨服务]     获取未接来电记录
export {RestIncomingCallControllerGetMissedCallResultList}
//  [回拨服务]     删除手机号码未接来电记录
export {RestIncomingCallControllerDelMissedCallResult}